import {
    Breadcrumbs,
    Button,
    Chip,
    CircularProgress,
    Grid,
    MenuItem,
    Select,
    TextField,
    Typography,
    Radio,
    Tooltip,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import classnames from 'classnames';
import Moment from 'moment/moment';
import React, { Component, Fragment } from 'react';
import { Animated } from 'react-animated-css';
import Zoom from 'react-medium-image-zoom';
import { connect } from 'react-redux';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import ErrorIcon from '@material-ui/icons/Error';
import { Link, withRouter } from 'react-router-dom';
import Url from 'url';
import join from 'url-join';
import axios, { safeGet } from '../axios-default';
import ConfirmDialog from '../components/Dialog/ConfirmDialog';
import WarningDialog from '../components/Dialog/WarningDialog';
import Loader from '../components/Loader';
import LoadingSpinner from '../components/Loader/LoadingSpinner';
import Modal from '../components/Modal/modal';
import Refinement from '../components/NewPatient/Photos/NewPatientPhotos';
import NewPatientPhotosStyle from '../components/NewPatient/Photos/NewPatientPhotos.module.css';
import Treatment from '../components/NewPatient/Photos/TreatmentPlan';
import PrescriptionNotes from '../components/NewPatient/PrescriptionNotes/NewPatientPrescriptionNotes';
import Aligner from '../components/PatientInfo/Aligner';
import { ApiServerUrl } from '../config.json';
import * as newPatientActionTypes from '../store/NewPatient/actionType';

import { easySnackbar } from '../store/Noti/noti.actions';
import { withLang, getFromObj, useLang } from '../util/lang';
import Log from '../util/log';
import { buildSetList, computeDeliveredRange, parseStages } from '../util/selfDesignSets';
import * as saveAction from '../store/NewPatient/NewPatient.action';
import NewPatientQuestionnaire, { teethGraph } from '../components/NewPatient/Questionnaire/NewPatientQuestionnaire';
import '../util/object';
import { fromJS } from 'immutable';
import { initialState as NewPatientInitialState } from '../store/NewPatient/NewPatient.reducer';
import { initialState as FinishingRetainerInitialState } from '../store/FinishingRetainer/FinishingRetainer.reducer';
// import './patientInfo.module.css';
import externalCss from './css/patientInfo.module.css';
import ImpressionViewer from '../components/PatientInfo/ImpressionViewer';
import NewPatientInfo from '../components/NewPatient/Info/NewPatientInfo';
import PercentageProgressRing from '../components/PercentageProgressRing';
import { GetDates } from '../util/date';
import Badge from '@material-ui/core/Badge';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { getWebAbsPath } from '../util/path';
import { updateRes } from '../store/res/res.action';
import { styles } from './PaitentInfo/styles';
import ReplaceMyp from '../components/NewPatient/Photos/ReplaceMyp';
import DialogTitle from '@material-ui/core/DialogTitle';
import Defect from '../components/NewPatient/Photos/Defect';

import { uiStartLoading } from '../store/loading/actions';
import { uiStopLoading } from '../store/loading/actions';

import NewAcceptNotAcceptDialog from '../components/Dialog/NewAcceptNotAcceptDialog';
import {
    requestFinishingRetainerChangeTab,
    requestFinishingRetainerSelectOpts,
    requestFinishingRetainerSelectOptsB,
} from '../store/FinishingRetainer/FinishingRetainer.action';
import FinishingRetainerTabs from '../components/FinishingRetainer/FinishingRetainerTabs';
// import FinishingRetainerOptions from '../components/FinishingRetainer/FinishingRetainerOptions';
import FinishingRetainerPhotos from '../components/NewPatient/Photos/PhotosFinishingRetainer';
import NewPatientHandleUpload from '../util/NewPatientHandleUpload';
import ImpressionTabs from '../components/NewPatient/Photos/ImpressionTabs';
import FinishingRetainerSummary from '../components/FinishingRetainer/FinishingRetainerSummary/FinishingRetainerSummary'; //2277
import { getFormToken } from '../util/file';
import AlertDialog from '../components/Dialog/Dialog';
import { MyCheckBox } from '../components/CheckBox/MyCheckBox';
//import NewPatientSummary from '../components/NewPatient/NewPatientSummary/NewPatientSummary';
import NewErrorMessageDialog from '../components/Dialog/NewErrorMessageDialog';
import { RetrackModal } from '../components/NewPatient/Retrack/RetrackModal';
import { initialState } from '../store/lang/lang.reducer';
import { postTraceLog } from '../store/TraceLog/tracelog.reducer';
import { CaseLogInfo } from '../components/Modal/CaseLogModal';
import { getCBCT } from '../util/file';
// import { RetrackContinueModal } from '../components/NewPatient/Retrack/RetrackContinueModal'
import RetrackReport from '../components/NewPatient/Retrack/RetrackReport/RetrackReport';
import { setRetrackEndReasonData, setRetrackReportFormData } from '../store/Retrack/RetrackSlice';
import ViewRetrackReportModal from '../components/NewPatient/Retrack/ViewRetrackReportModal';
import Banner from '../components/Banner';
import RetrackEndReasonInput from '../components/NewPatient/Retrack/RetrackReport/RetrackEndReasonInput';
import {
    setCaseType,
    setProductMatrixArray,
    smileDesignProductList,
    smileDesignProductListArray,
} from '../store/SmileDesign/SmileDesignSlice';
import SmileDesignPrescriptionNotesModalButton from './SmileDesign/SmileDesignPrescriptionNotesModalButton';
import NewCaseModalContent from '../components/NewCase/NewCaseContent';
import RestorativePhaseButton from './SmileDesign/RestorativePhaseButton/RestorativePhaseButton';
import ViewRestorationFormModal from './SmileDesign/RestorativePhaseButton/ViewRestorationFormModal';
import ViewRestorationFormFirstFitModal from './SmileDesign/RestorativePhaseButton/ViewRestorationFormFirstFitModal';
import RestorationToolFormModal, {
    UPSELL_RESTORATION_TOOL_FORM_TYPE,
} from './SmileDesign/RestorativePhaseButton/RestorationToolFormModal';
import CreateNewCaseModalButton from '../components/Button/CreateNewCaseModalButton';
import ViewPrescriptionModal from '../components/DifferentRetainer/components/ViewPrescriptionModal/viewPrescriptionModal';
import { FORM_TYPE } from '../components/NewPatient/PrescriptionNotes/type';
import TeethSelect from '../components/Teeth/TeethSelect/TeethSelect';
import { teethGapConfig } from '../components/Teeth/TeethGapConfig';
import { teethConfig } from '../components/Teeth/TeethConfig';
import { openModal, setDisplayFirstFitFlag } from '../store/Global/global';
import { ERROR, PACKAGE_VERSION, ROLE_NAMES } from '../util/const';
import ReSubmitRetainerFormModal from '../components/DifferentRetainer/components/ReSubmitRetainerFormModal/reSubmitRetainerFormModal';
import { downloadFilesAsZip, updateParams } from '../util/function';
import {
    baseSupportImgObj,
    getPhotosWithRadiographs,
    initCaseSupportingImgs,
    progress_photo_angles,
} from './pagesUtils';
import ProgressPhotosCard from '../components/ProgressPhotosCard/progressPhotosCard';
import { fetchConnectPlatformData } from '../store/ConnectPlatform/connectPlatform';
import { IMPRESSION_TYPE } from './hooks/DiffRetainerHooks/useRetainerRequestForm';
import AwaitingGrid from './PaitentInfo/StatusGrid/AwaitingGrid';
import { retainer_statusList, statusList } from './PatientInfo_util';
import ExpandText from '../components/PatientInfo/ExpandText';
import ReceivedGrid from './PaitentInfo/StatusGrid/ReceivedGrid';
import ViewCaseSupportingFileModal from '../components/ViewCaseSupportingFileModal/ViewCaseSupportingFileModal';
import { alignerPrescriptionFormValidation } from '../util/alignerPrescriptionFormHelper';
import { renderToothMarkers, validateImpressionFiles } from '../components/NewPatient/NewPatientUtill';
import { ALIGNER_CASE_TYPE, CASE_STATUS, CASE_TYPE } from '../store/NewPatient/utils';
import InfoIcon from '@material-ui/icons/Info';
import RetrackField from '../components/PatientInfo/RetrackField';
import moment from 'moment/moment';
import ViewRestorativeOptions from '../components/NewPatient/PrescriptionNotes/RestorativeOptions/ViewRestorativeOptions';
import WaitingUploadIdesignGrid from '../components/WaitingUploadIdesignGrid/WaitingUploadIdesignGrid';
import SmileDesignPrescriptionNotesPreviewMap from './SmileDesign/SmileDesignPrescriptionNotesPreviewMap';
import { createStaticSmileDesignQuestionSchema } from './SmileDesign/SmileDesignQuestions';
import {
    setUpsellPlanId,
    setUpsellRestorationFormData,
    UPSELL_TYPE,
} from '../store/TreatmentPlanApproval/TreatmentPlanApprovalSlice';

const PLATFORM = 'platform';
const MODULE = 'PatientInfo';
const ACTION = 'Delete Retainer Request / Reuqest Next Set Log';

const CASE_TYPE_FOR_RETRACK = ['SIMPLE', 'TOUCH_UP', 'TOUCHUP_PLUS', 'COMPLETE', 'FLEX', 'ULTRA'];
const CASE_STATUS_ALLOW_UPLOAD_SUPPORTING_IMGS = [
    'AWAITING',
    'RECEIVED',
    'RETRACK_AWAITING',
    'RETRACK_ALL_MATERIAL_RECEIVED',
];

const REMARKS_MAX_LENGTH = 60;

const MOCKUP_ORDER_OPTION_LABELS = {
    'option.fit': '@PatientInfo.smileDesign.prescriptionNotes.option.fit',
    'option.flowableInjectionTechnique': '@PatientInfo.smileDesign.prescriptionNotes.option.flowableInjectionTechniqueFirstFit',
    'option.formaInjectionTechnique': '@PatientInfo.smileDesign.prescriptionNotes.option.formaInjectionTechniqueFirstFit',
    'option.ceramicVeneersCrowns': '@PatientInfo.smileDesign.prescriptionNotes.option.ceramicVeneersCrownsFirstFit',
    'option.guidedVeneerTreatment': '@PatientInfo.smileDesign.prescriptionNotes.option.guidedVeneerTreatment',
    'option.mockupKey': '@PatientInfo.smileDesign.clinicalApprovement.Restoration.mockUpKeyOnly',
    'option.mockupKeyAndMaterial': '@PatientInfo.smileDesign.clinicalApprovement.Restoration.mockUpKeyAndMaterial',
    'option.yes': '@PatientInfo.smileDesign.clinicalApprovement.Restoration.yes',
    'option.no': '@PatientInfo.smileDesign.clinicalApprovement.Restoration.no',
};

const MOCKUP_ORDER_FIT_RESTORATION_TYPES = [
    'option.flowableInjectionTechnique',
    'option.formaInjectionTechnique',
    'option.fit',
];

export const initAlignerOption = [
    // remove flag is for enable or disable delete button for aligner(lost/replace), the first aligner should not be removed
    { step_no: null, arch: null, remove: false },
    { step_no: null, arch: null, remove: true },
];

const CbctDownloadButton = ({ folderValue, caseId, showSnackbar, downloading, addDownloading, removeDownloading }) => {
    const get = useLang('PatientInfo');

    const handleClick = async () => {
        if (downloading) return;
        addDownloading(folderValue);
        showSnackbar(get('msg.cbctDownloadPreparing'), 'info');
        try {
            await getCBCT(
                `CBCT_${caseId}.zip`,
                join(ApiServerUrl, '/api/dropbox/downloadFile', folderValue.replace('dbx::', ''), caseId)
            );
        } catch (e) {
            console.error('Error downloading CBCT zip', e);
            const status = e && e.response && e.response.status;
            let message = get('msg.cbctDownloadFailed');
            if (status === 404) {
                message = get('msg.cbctDownloadNotFound');
            } else if (status === 403) {
                message = get('msg.cbctDownloadForbidden');
            } else if (status >= 500) {
                message = get('msg.cbctDownloadServerError');
            }
            showSnackbar(message, 'error');
        } finally {
            removeDownloading(folderValue);
        }
    };

    return (
        <Button
            disabled={downloading}
            onClick={handleClick}
            startIcon={downloading ? <CircularProgress color="inherit" size={16} /> : null}
            style={{ textTransform: 'none' }}
        >
            Download Zip
        </Button>
    );
};

class PatientInfo extends Component {
    gainingSpaceCheckBox = [
        { name: 'crowding', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.crowding') },
        { name: 'deepBite', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.deepBite') },
        { name: 'spacing', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.spacing') },
        { name: 'classII', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.classII') },
        { name: 'ClassIIDivI', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.ClassIIDivI') },
        { name: 'classIII', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.classIII') },
        { name: 'unevenSmile', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.unevenSmile') },
        { name: 'openBite', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.openBite') },
        { name: 'overbite', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.overbite') },
        { name: 'other', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.other') },
    ];

    questionnaireTeethRadio = [
        { value: 'none', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.none') },
        { value: 'upper', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.upper') },
        { value: 'lower', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.lower') },
        { value: 'anterior', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.anterior') },
        { value: 'posterior', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.posterior') },
    ];

    gainingSpace = [
        { value: 'primary', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.primary') },
        { value: 'secondary', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.secondary') },
        { value: 'none', label: getFromObj(this.props.lang, 'dict.NewPatient.:const.none') },
    ];

    gainingSpaceRadioButtons = [
        { value: 'primary', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.primary') },
        { value: 'secondary', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.secondary') },
        { value: 'none', label: getFromObj(this.props.lang, 'dict.NewPatient.:const.none') },
        {
            value: 'clinicalSimulation',
            label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.referToClinicalSimulation'),
        },
    ];

    gainingSpaceListExpansion = [
        { value: 'primary', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.primary') },
        { value: 'secondary', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.secondary') },
        { value: 'none', label: getFromObj(this.props.lang, 'dict.NewPatient.:const.none') },
    ];

    overJetListButtons = [
        { value: 'maintain', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.maintain') },
        { value: 'improve1mm', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.improve1mm') },
        { value: 'improve2mm', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.improve2mm') },
        { value: 'improve3mm', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.improve3mm') },
        { value: 'improve4mm', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.improve4mm') },
        { value: 'improve5mm', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.improve5mm') },
        {
            value: 'clinicalSimulation',
            label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.referToClinicalSimulation'),
        },
    ];

    overBiteListButtons = [
        { value: 'maintain', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.maintain') },
        { value: 'improve1mm', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.improve1mm') },
        { value: 'improve2mm', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.improve2mm') },
        { value: 'improve3mm', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.improve3mm') },
        { value: 'improve4mm', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.improve4mm') },
        { value: 'improve5mm', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.improve5mm') },
        {
            value: 'clinicalSimulation',
            label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.referToClinicalSimulation'),
        },
    ];

    midLineListButtons = [
        {
            value: 'clinicalSimulation',
            label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.referToClinicalSimulation'),
        },
        { value: 'maintain', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.maintain') },
        { value: 'correctUpper', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.correctUpper') },
        { value: 'correctLower', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.correctLower') },
    ];

    crossBiteRadioButtons = [
        { value: 'maintain', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.maintain') },
        { value: 'improve', label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.improve') },
        {
            value: 'clinicalSimulation',
            label: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.referToClinicalSimulation'),
        },
    ];

    questionnaire_attr_name = {
        attr0: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.extraction'),
        attr1: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.expansion'),
        attr2: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.interproximalReduction'), //"Interproximal Reduction",
        attr3: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.distalization'), //"Distalization",
        attr4: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.proclination'), //"Proclination",
        attr6: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.overjet'), //"Over Jet",
        attr7: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.overbite'), //"Over Bite",
        attr8: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.midline'), //"Mid Line",
        attr9: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.crossbite'), //"Cross Bite",
        attr12: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.comment'), //"Cross Bite",
        clinical_cond_comment: getFromObj(this.props.lang, 'dict.NewPatient.questionnaire.clinicalConditionComment'), //"Clinical Condition Other Comment",
    };

    attrLabelMapping = {
        attr0: this.gainingSpace,
        attr1: this.gainingSpaceListExpansion,
        attr2: this.gainingSpaceRadioButtons,
        attr3: this.gainingSpaceRadioButtons,
        attr4: this.gainingSpaceRadioButtons,
        attr6: this.overJetListButtons,
        attr7: this.overJetListButtons,
        attr8: this.midLineListButtons,
        attr9: this.crossBiteRadioButtons,
    };

    constructor(props) {
        super(props);
        this.retrackReportFormDataRef = React.createRef();
        this.ReplaceMypDialogRef = React.createRef();
        this.statusTitleRef = React.createRef();
        this.pageVisible = 0;
        this.state = {
            currentStatus: '',
            current: this.props.lang.current,
            patientInfo: null,
            loading: false,
            stls: [],
            logs: [],
            treatmentPlanApproval: [],
            newStatus: '',
            statusListItemName: '',
            param1: 1,
            param2: 2,
            approvedPlanCount: 0,
            selfDesignDeliveredSets: null,
            selfDesignDeliveredLoading: false,
            selectedExpectedTxDate: GetDates(new Date(), 10)[0],
            selectedAmPmTxDate: 'AM',
            modalError: '',
            doctorName: '',
            awaitingRemarks: '',
            remakeSets: 'FILL',
            onlyRetrackProductionInProgress: false,
            caseId: this.props.match.params.id,
            patientId: this.props.match.params.patientsid,
            AlignerModal: false,
            StatusModal: false,
            RetrackModal: false,
            ViewRetrackDataModal: false,
            ViewRetrackReportModal: false,
            ViewFinishingRetainerModal: false,
            ViewRetrackQuotaReminderModal: false,
            ViewRefinementQuotaReminderModal: false,
            ViewRestorationToolFormModal: false,
            viewRestorationFormFirstFitModal:false,
            ViewMockupOrderModal: false,
            RetrackOldCaseModal: false,
            RefinementOldCaseModal: false,
            CaseExpireModal: false,
            CaseExpireText: false,
            isFirstProductIsNewProduct: false,
            ViewPrescriptionModal: false,
            ReSubmitRetainerFormModal: false,

            caseType: '',
            // for retainer request after 'ALL_DELIVERED', use caseLog's retainerRequestId to fetch data
            retainerRequestId: 0,
            // this retainerRequestData is for new case and case type === 'RETAINER'
            retainerRequestData: null,

            isOldCaseBeforeRetrackRefinementDemployment: true,
            isShowChargeableRetrackButton: false,
            draftFileList: '',
            chosenDraftFile: '',
            isShowSmileDesignFeature: false,

            /* AdditionalInformationModal: false,
      emailToDoctor: true,
      additionalInformationInputMessage: "", */
            deliveryAddressModal: false,
            selectedDeliveryAddress: '',
            getDeliveryAddress: [],
            RefinementModal: false,
            PhotoModal: false,
            DefectModal: false,
            RadiographsModal: false,
            ImpressionsModal: false,
            QuestionnaireModal: false,
            PrescriptionNotesModal: false,
            smileDesignPrescriptionFallback: null,
            TreatmentModal: false,
            ReplaceMypModal: false,
            InfoModal: false,
            DrRemarksModal: false,
            RFSModal: false,
            RequestRetainerModal: false,
            RequestRetainerMessage: false,
            RequestRetainerCheckBox: false,
            RequestFinishingRetainerStep1Modal: false,
            RequestFinishingRetainerStep2Modal: false, //Photo
            RequestFinishingRetainerStep3Modal: false, //Impression
            RequestFinishingRetainerStep4Modal: false, //Summary
            RequestFinishingRetainerSubStep4Modal: false, //Sub Step4 Summary
            RequestFinishingRetainerSubmitWarning: false,

            retrackDataArray: [],
            finishingRetainerArray: [],
            // retrackHasFile: false,
            // retrackHasDetail: false,
            // retrackHasimpression: false,
            retrackId: '',
            caseRetrackReportId: '',
            retrackReportFormData: {},
            finishingRetainerId: '',
            withinTreatmentPeriod: false,
            enableRetrack: true,
            case_activity_log_id: '',
            restorationFormId: '',
            restorativePhaseCaseImpressionId: null,
            restorativePhaseViewType: 'prescription',
            hasMockupOrder: null,
            mockupOrderId: '',
            mockupRequestId: '',
            mockupOrderData: null,
            mockupOrderLoading: false,

            refinementHasDetail: false,
            refinementHasFile: false,
            refinementHasImpression: false,
            refinementHasComment: false,
            refinementNewPrescriptionNotesFlag: false,
            requestRetainerQuantity: 1,
            ModalState: '',
            tcCheckbox: false,
            targetId: null,
            PhotoUploadLoadingStatus: false,
            replaceMypLoadingStatus: false,
            isDownloading: false,
            defect: {
                spic1: null,
                spic2: null,
                spic3: null,
                spic4: null,
                mpic1: null,
                mpic2: null,
                mpic3: null,
                mpic4: null,
                severely_or_moderately: 'moderately',
            },
            treatmentPlan: {
                pdf1: null,
                pdf1_label: '',
                pdf2: null,
                pdf2_label: '',
                video1: null,
                video1_label: '',
                video2: null,
                video2_label: '',
                smile_3d: '',
                treatment_approval: true,
                upper_cycle: null,
                lower_cycle: null,
                new_product: null,
                smileDesignPPT: null,
                smileDesignPPT_label: '',
                smileDesign_exocad_pre: null,
                smileDesign_exocad_pre_label: '',
                smileDesign_exocad_post: null,
                smileDesign_exocad_post_label: '',
            },
            numberOfTreatmentPlan: 0,

            retrackReport: {
                retrack0: null,
                retrack0_name: '',
            },

            deliveredOrAllDeliveredStatusBeforeRetrack: '',

            isShowFinishingRetainer: false,
            showBleachRetainerButtonByDistributor: false,
            replaceTreatmentPlan: {
                smile_3d: '',
                myo_oid: null,
                myo_pid: null,
                myo_id: null,
                myo_token: null,
                planid: 0,
            },
            aligner: [...initAlignerOption],
            alignertype: null,
            role: this.props.auth.user.role,
            confirmDefectResubmit: false,
            confirmOpenNextAligner: false,
            confirmOpenEndCase: false,
            confirmOpenArchiveCase: false,
            opendMarkReadConfirm: false,
            unreadStatusCount: 0,
            unreadChatCount: 0,
            clientCode: '',
            refCode: null,
            internalRemarks: '',
            progress_photos: [],
            defectCurrentStatus: {
                currentDefectFlow: {
                    dr_response: null,
                    defect_type: null,
                    haveRequireNextSet: null,
                },
            },
            confirmDrResponse: false,
            DrResponse: {
                stateType: null,
                distorted: null,
                defect_id: null,
            },

            threeshapeConnected: false,
            OpenDefectCategory: false,
            enable_requestFinishingRetainer_button: true,

            enableOrderDifferentRetainer: this.props.diffRetainer.enableOrderDifferentRetainer,
            modalOpen: false,
            productMatrix: [],
            selectCaseOptionType: null,
            OpenCaseOptionTypeDialog: null,
            caseOptionTypeArr: [],
            isDisableCreateNewCaseForPatient: null,
            determineWhatCaseCanCreate: {
                canCreateAlignerCase: false,
                canCreateSmileDesignCase: false,
                canCreateRetainerCase: false,
            },

            patientCases: [],
            latestTreatmentPlan: {},
            treatmentPlanData: null,
            isSmileDesign: false,
            treatmentTypes: null,
            isNoNeedUploadIDesign: false,

            caseImpressionId: null,
            caseCreatedDate: null,
            caseSupportingImgs: initCaseSupportingImgs,
            caseSupportingModalOpen: false,
            viewCaseSupportingFileCaseActivityLogId: null,
            caseLogCreatedDate: null,
            caseLogStatus: null,
            isMarieGroup: JSON.parse(localStorage.getItem('isMarieGroup')) || false,
            isSEAGroup: JSON.parse(localStorage.getItem('isSEAGroup')) || false,
            upsellOperationData: {
                shouldSubmitRestorationFormWithNewScan: false,
                shouldWaitIdesignTp: false,
                allowUploadExocad: false,
                plan_id: null,
                option_approvement: null,
                allowUploadSmilePPT: false,
            },
            openUpsellRestorationToolFormModal: false,
            archivedFlag: false,
            manufactureDetailError: null,
            manufactureDetailLoading: false,
            manufactureDetailData: null,
            manufactureDetailPlanId: null,
            manufactureDetailCaseId: null,
            manufactureDetailStages: null,
            viewManufactureDetailModal: false,
            archivedFlag: false,
            cbctDownloading: [],
        };

        this.progressBarRef = React.createRef(null);
        this.handleOpen = this.handleOpen.bind(this);
        this.setConfirmOpenNextAligner = this.setConfirmOpenNextAligner.bind(this);
        this.setConfirmOpenEndCase = this.setConfirmOpenEndCase.bind(this);
        this.setConfirmOpenArchiveCase = this.setConfirmOpenArchiveCase.bind(this);
        this.setConfirmDefectResubmit = this.setConfirmDefectResubmit.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleMypDataSave = this.handleMypDataSave.bind(this);
        this.handleDrResponse = this.handleDrResponse.bind(this);
        this.handleInformation = this.handleInformation.bind(this);
        this._case = null;
        this.markAsRead = this.markAsRead.bind(this);
        this.handleDeliveryAddress = this.handleDeliveryAddress.bind(this);
        this.deliveryAddressChangeModalOpen = this.deliveryAddressChangeModalOpen.bind(this);
        this.setConfirmDrResponse = this.setConfirmDrResponse.bind(this);
        this.handleOpenDefectCategory = this.handleOpenDefectCategory.bind(this);
        this.handleCloseDefectCategory = this.handleCloseDefectCategory.bind(this);
        this.getDefectCatalog = this.getDefectCatalog.bind(this);
        this.checkIfImageExists = this.checkIfImageExists.bind(this);
        this.handleFinishingRetainerSelectOptsB = this.handleFinishingRetainerSelectOptsB.bind(this);
        this.handleRequestFinishingRetainerStep2Save = this.handleRequestFinishingRetainerStep2Save.bind(this); //Photos
        this.handleRequestFinishingRetainerStep3Save = this.handleRequestFinishingRetainerStep3Save.bind(this); //Impression
        this.handleRequestFinishingRetainerStep4Save = this.handleRequestFinishingRetainerStep4Save.bind(this); //Summary
        this.handlePresDialog = this.handlePresDialog.bind(this);
        this.teeth = {
            topRight: {
                maxX: 400,
                maxY: 58,
                minX: 30,
                minY: 5,
                values: [
                    { value: 0, positionX: 59, positionY: 33, boundX: 90 },
                    { value: 1, positionX: 117, positionY: 33, boundX: 145 },
                    { value: 2, positionX: 172, positionY: 33, boundX: 200 },
                    { value: 3, positionX: 226, positionY: 33, boundX: 250 },
                    { value: 4, positionX: 272, positionY: 33, boundX: 295 },
                    { value: 5, positionX: 313, positionY: 33, boundX: 335 },
                    { value: 6, positionX: 350, positionY: 33, boundX: 370 },
                    { value: 7, positionX: 386, positionY: 33, boundX: 405 },
                ],
            },
            topLeft: {
                maxX: 780,
                maxY: 58,
                minX: 405,
                minY: 5,
                values: [
                    { value: 8, positionX: 424, positionY: 33, boundX: 440 },
                    { value: 9, positionX: 458, positionY: 33, boundX: 447 },
                    { value: 10, positionX: 494, positionY: 33, boundX: 514 },
                    { value: 11, positionX: 536, positionY: 33, boundX: 559 },
                    { value: 12, positionX: 581, positionY: 33, boundX: 605 },
                    { value: 13, positionX: 631, positionY: 33, boundX: 662 },
                    { value: 14, positionX: 690, positionY: 33, boundX: 719 },
                    { value: 15, positionX: 746, positionY: 33, boundX: 773 },
                ],
            },
            bottomRight: {
                maxX: 400,
                maxY: 170,
                minX: 30,
                minY: 125,
                values: [
                    { value: 16, positionX: 60, positionY: 148, boundX: 90 },
                    { value: 17, positionX: 120, positionY: 148, boundX: 145 },
                    { value: 18, positionX: 174, positionY: 148, boundX: 200 },
                    { value: 19, positionX: 224, positionY: 148, boundX: 250 },
                    { value: 20, positionX: 272, positionY: 148, boundX: 295 },
                    { value: 21, positionX: 314, positionY: 148, boundX: 335 },
                    { value: 22, positionX: 348, positionY: 148, boundX: 370 },
                    { value: 23, positionX: 386, positionY: 148, boundX: 405 },
                ],
            },
            bottomLeft: {
                maxX: 780,
                maxY: 170,
                minX: 405,
                minY: 125,
                values: [
                    { value: 24, positionX: 420, positionY: 148, boundX: 440 },
                    { value: 25, positionX: 456, positionY: 148, boundX: 447 },
                    { value: 26, positionX: 493, positionY: 148, boundX: 514 },
                    { value: 27, positionX: 535, positionY: 148, boundX: 559 },
                    { value: 28, positionX: 582, positionY: 148, boundX: 605 },
                    { value: 29, positionX: 632, positionY: 148, boundX: 662 },
                    { value: 30, positionX: 690, positionY: 148, boundX: 719 },
                    { value: 31, positionX: 745, positionY: 148, boundX: 773 },
                ],
            },
        };
    }

    getNotes = (title) => {
        return (
            getFromObj(this.props.lang, `dict.NewPatient.prescriptionNotes.${title}`) ??
            getFromObj(initialState.dict, `NewPatient.prescriptionNotes.${title}`) ??
            ''
        );
    };

    getMockupOrderOptionLabel = (value) => {
        const translationKey = MOCKUP_ORDER_OPTION_LABELS[value];
        return translationKey ? this.get(translationKey) : value;
    };

    handleRequestFinishingRetainerStep2Save() {
        //requestFinishingRetainerDataOptA
        let defaultState = { modalError: '', targetId: null };

        //if (this.props.requestFinishingRetainerData.request_finishing_retainerOptA==="0" ){
        defaultState = { ...defaultState, RequestFinishingRetainerStep2Modal: false };
        this.handleChangeTab('1');
        this.props.requestFinishingRetainerChangeTab('1');
        defaultState = { ...defaultState, RequestFinishingRetainerStep3Modal: true };
        //}
        /*
  if (this.props.requestFinishingRetainerData.request_finishing_retainerOptA==="1" ){

      this.handleChangeTab('2')
      this.props.requestFinishingRetainerChangeTab('2');
      defaultState = { ...defaultState, RequestFinishingRetainerStep2Modal: false,RequestFinishingRetainerStep3Modal: false, RequestFinishingRetainerStep4Modal: true  }
  }*/

        this.setState(defaultState);
    }

    checkIfImageExists(image_id) {
        let image_data = this.props.newPatientData.files.filter((imageObj) => {
            return imageObj.id == image_id;
        });

        return image_data[0].uploaded;
    }

    async setConfirmDrResponse(val) {
        this.setState({ confirmDrResponse: val });
    }

    handleOpenDefectCategory() {
        this.setState({ OpenDefectCategory: true });
    }

    handleFinishingRetainerSelectOptsB(event) {
        this.props.updateStep3SelectOpts(event.target.value);
        //this.setState({request_finishing_retainerOptB:event.target.value})
    }

    getDefectCatalog() {
        const defectCatelog = this.get('defect.defectCatelog');
        const defectCatalogArr = Object.values(defectCatelog);
        return defectCatalogArr.map((catalog, index) => <div key={index}>{catalog}</div>);
    }
    handleChangeTab(tab) {
        let defaultState = { modalError: '', targetId: null };
        if (tab == '0') {
            this.props.requestFinishingRetainerChangeTab('0');
            defaultState = {
                ...defaultState,
                RequestFinishingRetainerStep2Modal: true,
                RequestFinishingRetainerStep3Modal: false,
                RequestFinishingRetainerStep4Modal: false,
            };
        }
        if (tab == '1') {
            this.props.requestFinishingRetainerChangeTab('1');
            defaultState = {
                ...defaultState,
                RequestFinishingRetainerStep2Modal: false,
                RequestFinishingRetainerStep4Modal: false,
                RequestFinishingRetainerStep3Modal: true,
            };
        }
        if (tab == '2') {
            this.props.requestFinishingRetainerChangeTab('2');
            defaultState = {
                ...defaultState,
                RequestFinishingRetainerStep2Modal: false,
                RequestFinishingRetainerStep3Modal: false,
                RequestFinishingRetainerStep4Modal: true,
            };
        }
        this.setState(defaultState);
        let errors = [],
            photo_counter = 0,
            radio_counter = 0,
            impression_counter = 0;

        this.props.newPatientData.files.forEach((v, index) => {
            if (index < 6 && !v.data && !v.upload_later && !v.will_not_upload) {
                photo_counter += 1;
            }

            if (
                v.category === 'stl_file' &&
                !v.data &&
                !(v.id === 'impression_scan_two' && (v.data === null || v.data === '')) &&
                !v.upload_later &&
                !v.will_not_upload
            ) {
                impression_counter += 1;
            }
        });

        if (photo_counter) {
            let obj = { id: 'photo', msg: this.get('@NewPatient.warning.mandatoryPhoto'), valid: false };
            this.props.ErrorData(obj);
        } else {
            this.props.ErrorData({ id: 'photo', msg: '', valid: true });
        }
        if (radio_counter) {
            let obj = { id: 'radiograph', msg: this.get('@NewPatient.warning.mandatoryRadiograph'), valid: false };
            this.props.ErrorData(obj);
        }

        switch (this.props.newPatientData.impressionType) {
            case 'FILE': {
                const impressions = this.props.newPatientData.files.filter((v) => v.category === 'stl_file');
                const impressionErrList = validateImpressionFiles(impressions);
                if (impressionErrList.length > 0) {
                    this.props.ErrorData({
                        id: 'impression',
                        msg: this.get('@NewPatient.warning.allStl'),
                        valid: false,
                    });
                } else {
                    this.props.ErrorData({ id: 'impression', msg: '', valid: true });
                }
                break;
            }
            // this.props.newPatientData.modernCode && this.props.newPatientData.modernCode.waybillNumber &&this.props.newPatientData.courierCompany
            case 'COURIER': {
                if (String.isBlank(this.props.newPatientData.modernCode)) {
                    this.props.ErrorData({
                        id: 'impression',
                        msg: this.get('@NewPatient.warning.courier'),
                        valid: false,
                    });
                } else {
                    this.props.ErrorData({ id: 'impression', msg: '', valid: true });
                }
                break;
            }
            case 'SCANNER': {
                if (
                    String.isBlank(this.props.newPatientData.scannerBrand) ||
                    String.isBlank(this.props.newPatientData.doctorId)
                ) {
                    this.props.ErrorData({
                        id: 'impression',
                        msg: this.get('@NewPatient.warning.scanner'),
                        valid: false,
                    });
                } else {
                    this.props.ErrorData({ id: 'impression', msg: '', valid: true });
                }
                break;
            }
        }
    }
    handleCloseDefectCategory() {
        this.setState({ OpenDefectCategory: false });
    }

    async handleMyoFileUploaded(res) {
        let newReplaceTreatmentPlan = { ...this.state.replaceTreatmentPlan };

        newReplaceTreatmentPlan.smile_3d = res.data.url;
        newReplaceTreatmentPlan.myo_oid = res.data.oid;
        newReplaceTreatmentPlan.myo_pid = res.data.pid;
        newReplaceTreatmentPlan.myo_id = res.data.id;
        newReplaceTreatmentPlan.myo_token = res.data.token;

        this.setState({ replaceTreatmentPlan: newReplaceTreatmentPlan });
    }

    handleChangeTreatmentPlanId(value) {
        let newReplaceTreatmentPlan = { ...this.state.replaceTreatmentPlan };
        newReplaceTreatmentPlan.planid = value;
        this.setState({ replaceTreatmentPlan: newReplaceTreatmentPlan });
    }

    handleChangeSmile3d() {
        let newReplaceTreatmentPlan = { ...this.state.replaceTreatmentPlan };
        newReplaceTreatmentPlan.smile_3d = '';
        this.setState({ replaceTreatmentPlan: newReplaceTreatmentPlan });
    }
    async handleMypDataSave() {
        try {
            if (this.state.replaceTreatmentPlan.planid === 0 || this.state.replaceTreatmentPlan.smile_3d === '') {
                alert('Please select treatment Plan and upload myp file!');
                return;
            }
            this.setState({ replaceMypLoadingStatus: true, loading: true });
            await axios.post(
                `case/treatment_plan_replacemyp/${this.state.caseId}`,
                {
                    plan_id: this.state.replaceTreatmentPlan.planid,
                    url: this.state.replaceTreatmentPlan.smile_3d,
                    myo_oid: this.state.replaceTreatmentPlan.myo_oid,
                    myo_pid: this.state.replaceTreatmentPlan.myo_pid,
                    myo_id: this.state.replaceTreatmentPlan.myo_id,
                    myo_token: this.state.replaceTreatmentPlan.myo_token,
                },
                {
                    onUploadProgress: this.progressBarRef.current?.onProgressChange,
                }
            );
            await this.props.showSnackbar('Treatment Plan updated', 'success', true);
            this.reloadPage();
        } catch (err) {
            const errMsg = this.getErrorMsg(err, 'Could Not update the Treatment Plan');
            this.setState({ modalError: errMsg });
            console.error(err.response);
        } finally {
            this.setState({ replaceMypLoadingStatus: false, loading: false });
        }
    }
    async handleDefectSave() {
        const form = new FormData();
        if (this.state.defect.severely_or_moderately === 'severely') {
            if (
                this.state.defect.spic1 === null &&
                this.state.defect.spic2 === null &&
                this.state.defect.spic3 === null &&
                this.state.defect.spic4 === null
            ) {
                await this.props.showSnackbar('Please upload image', 'error');
                return;
            }
        }
        if (this.state.defect.severely_or_moderately === 'moderately') {
            if (
                this.state.defect.mpic1 === null &&
                this.state.defect.mpic2 === null &&
                this.state.defect.mpic3 === null &&
                this.state.defect.mpic4 === null
            ) {
                await this.props.showSnackbar('Please upload image', 'error');
                return;
            }
        }
        let defectData = {
            case_id: this.state.caseId,
            spic0: this.state.defect.spic1 ? '$$FILE:spic0' : null,
            spic1: this.state.defect.spic2 ? '$$FILE:spic1' : null,
            spic2: this.state.defect.spic3 ? '$$FILE:spic2' : null,
            spic3: this.state.defect.spic4 ? '$$FILE:spic3' : null,
            mpic0: this.state.defect.mpic1 ? '$$FILE:mpic0' : null,
            mpic1: this.state.defect.mpic2 ? '$$FILE:mpic1' : null,
            mpic2: this.state.defect.mpic3 ? '$$FILE:mpic2' : null,
            mpic3: this.state.defect.mpic4 ? '$$FILE:mpic3' : null,
            distorted: this.state.defect.severely_or_moderately,
        };

        if (this.state.defect.spic1) {
            form.append('$$FILE:spic0', this.state.defect.spic1);
        }
        if (this.state.defect.spic2) {
            form.append('$$FILE:spic1', this.state.defect.spic2);
        }
        if (this.state.defect.spic3) {
            form.append('$$FILE:spic2', this.state.defect.spic3);
        }
        if (this.state.defect.spic4) {
            form.append('$$FILE:spic3', this.state.defect.spic4);
        }

        if (this.state.defect.mpic1) {
            form.append('$$FILE:mpic0', this.state.defect.mpic1);
        }
        if (this.state.defect.mpic2) {
            form.append('$$FILE:mpic1', this.state.defect.mpic2);
        }
        if (this.state.defect.mpic3) {
            form.append('$$FILE:mpic2', this.state.defect.mpic3);
        }
        if (this.state.defect.mpic4) {
            form.append('$$FILE:mpic3', this.state.defect.mpic4);
        }
        form.append('body', JSON.stringify(defectData));

        try {
            //case/defect/${this.state.caseId}
            this.setState({ PhotoUploadLoadingStatus: true, loading: true });
            await axios.post(`case/defect/${this.state.caseId}`, form, {
                onUploadProgress: this.progressBarRef.current?.onProgressChange,
            });
            await this.props.showSnackbar('Defect Image uploaded', 'success', true);
            this.reloadPage();
        } catch (err) {
            const errMsg = this.getErrorMsg(
                err,
                'Something went Wrong. Please make sure you raised a Defect change request. If the problem happen again, please connect with admin'
            );

            // this.setState({ modalError: errMsg})
            await this.props.showSnackbar(errMsg, 'error');
            console.error(err.response);
        } finally {
            this.setState({ PhotoUploadLoadingStatus: false, loading: false });
        }
    }

    async handleDefectData(data = null, stateType, fileName) {
        let newdefect = { ...this.state.defect };
        switch (stateType) {
            case 'spic1':
                newdefect.spic1 = data;
                this.setState({ defect: newdefect });
                break;
            case 'spic2':
                newdefect.spic2 = data;
                this.setState({ defect: newdefect });
                break;
            case 'spic3':
                newdefect.spic3 = data;
                this.setState({ defect: newdefect });
                break;
            case 'spic4':
                newdefect.spic4 = data;
                this.setState({ defect: newdefect });
                break;
            case 'mpic1':
                newdefect.mpic1 = data;
                this.setState({ defect: newdefect });
                break;
            case 'mpic2':
                newdefect.mpic2 = data;
                this.setState({ defect: newdefect });
                break;
            case 'mpic3':
                newdefect.mpic3 = data;
                this.setState({ defect: newdefect });
                break;
            case 'mpic4':
                newdefect.mpic4 = data;
                this.setState({ defect: newdefect });
                break;
        }
    }
    async handleRequestFinishingRetainerStep4Save() {
        try {
            this.setState({
                uploading: true,
            });
            this.setState({
                savingData: true,
            });
            const form = new FormData();
            const formCheckPromotionCode = new FormData();

            let newState = { ...this.props.newPatientData };
            let finishingRetainerState = this.props.requestFinishingRetainerData;
            delete finishingRetainerState.tab;

            let modifiedKey,
                modifiedState = {},
                case_file = {},
                case_impression = {},
                stlCounter = 0; //case_detail = {}, radioCounter = 0 questionnaire_teeth_array,

            let files = newState['files'];
            modifiedState['finishing_retainer'] = finishingRetainerState;
            files.forEach((value, index) => {
                if (value.category === 'stl_file') {
                    const fileName = `$$FILE:stl_file${stlCounter}`;
                    case_impression['stl_file' + stlCounter] = {
                        data: getFormToken(form, value.data, fileName),
                        rotate: value.rotate,
                        upload_later: value.upload_later,
                    };
                    // case_impression['stl_file' + stlCounter] = await fileToBase64(value.data)
                    case_impression['stl_files_later'] = value.upload_later
                        ? true
                        : value.will_not_upload
                          ? null
                          : false;
                    // case_impression['type'] = "FILE"
                    stlCounter++;
                } else {
                    const fileName = `$$FILE:photo${index}`;
                    //case_file[value.category+index] = {data:value.data,flipped:value.flipped,rotate:value.rotate,upload_later:value.upload_later}
                    case_file['photo' + index] = {
                        data: getFormToken(form, value.data, fileName),
                        flipped: value.flipped,
                        rotate: value.rotate,
                    };
                    case_file['photo' + index + '_later'] = value.upload_later
                        ? true
                        : value.will_not_upload
                          ? null
                          : false;
                }
            });

            case_impression.type = newState.impressionType;

            Object.entries(newState).forEach(([key, value]) => {
                modifiedKey = key
                    .replace(/(?:^|\.?)([A-Z])/g, function (x, y) {
                        return '_' + y.toLowerCase();
                    })
                    .replace(/^_/, '');

                if (
                    modifiedKey === 'scanner_brand' ||
                    modifiedKey === 'doctor_id' ||
                    modifiedKey === 'modern_code' ||
                    modifiedKey === 'waybill_number' ||
                    modifiedKey === 'courier_company'
                ) {
                    if (value.length > 0) {
                        case_impression[modifiedKey] = value;
                    }
                } else if (modifiedKey === 'patient_photo') {
                    const fileName = '$$FILE:profile_pic';
                    modifiedState['profile_pic'] = {
                        data: getFormToken(form, value.data, fileName),
                        rotate: value.rotate,
                    };
                }
            });
            modifiedState['case_file'] = case_file;

            modifiedState['case_impression'] = case_impression;
            try {
                form.append('body', JSON.stringify(modifiedState));

                if (!this.state.showAlert) {
                    this.setState({ PhotoUploadLoadingStatus: true, loading: true });
                    await axios.post(`case/finishing_retainer/${this.state.caseId}`, form, {
                        onUploadProgress: this.progressBarRef.current?.onProgressChange,
                    });
                    this.setState({
                        saved: true,
                    });
                    if (modifiedState.case_status === 'DRAFT') {
                        this.props.showSnackbar('Draft saved', 'success', true);
                    } else {
                        this.props.showSnackbar('Case submitted', 'success', true);
                    }
                    this.reloadPage();
                }
            } catch (err) {
                this.setState({
                    savingData: false,
                });
                console.error(err);
                this.props.showSnackbar(err.response?.data?.message ?? err.message ?? err, 'error');
            } finally {
                this.props.requestFinishingRetainerChangeTab('0');
                this.setState({ PhotoUploadLoadingStatus: false, loading: false });
            }
        } finally {
            this.setState({
                uploading: false,
                savingData: true,
            });
        }
    }
    handleRequestFinishingRetainerStep3Save() {
        this.handleChangeTab('2');
        this.props.requestFinishingRetainerChangeTab('2');
        let defaultState = { modalError: '', targetId: null };
        defaultState = {
            ...defaultState,
            RequestFinishingRetainerStep3Modal: false,
            RequestFinishingRetainerStep4Modal: true,
        };
        this.setState(defaultState);
    }

    handleSelect(val) {
        let newdefect = { ...this.state.defect };

        newdefect.severely_or_moderately = val;
        this.setState({ defect: newdefect });
    }

    removeAligner(index, e) {
        let newAligner = [...this.state.aligner];
        let modifiedAligner = newAligner.splice(index, 1);
        this.setState({ aligner: newAligner });
    }

    handleChnageAlignerType(value) {
        this.setState({ alignertype: value });
    }
    setConfirmOpenNextAligner(val) {
        this.setState({ confirmOpenNextAligner: val });
    }
    setConfirmDefectResubmit(val) {
        this.setState({ confirmDefectResubmit: val });
    }
    setConfirmOpenEndCase(val) {
        this.setState({ confirmOpenEndCase: val });
    }
    setConfirmOpenArchiveCase(val) {
        this.setState({ confirmOpenArchiveCase: val });
    }
    addAligner() {
        let newAligner = this.state.aligner.map((option) => ({ ...option }));
        newAligner.push({ step_no: null, arch: '', remove: true });
        this.setState({ aligner: newAligner });
    }

    handleChnageSizeAligner(step, index) {
        let newAligner = this.state.aligner.map((option) => ({ ...option }));
        newAligner[index]['step_no'] = step;
        this.setState({ aligner: newAligner });
    }

    handleChangeArch(index, arch) {
        let newAligner = this.state.aligner.map((option) => ({ ...option }));
        newAligner[index]['arch'] = arch;
        this.setState({ aligner: newAligner });
    }

    async handleChangeStatus(value) {
        this.setState({ newStatus: value, selfDesignDeliveredSets: null, selfDesignDeliveredLoading: false });
        if (value === CASE_STATUS.DELIVERED && this.state.patientInfo.case_type === CASE_TYPE.SELF_DESIGN) {
            this.setState({ selfDesignDeliveredLoading: true });
            try {
                await this.fillSelfDesignDeliveredSteps();
                if (this.state.newStatus !== CASE_STATUS.DELIVERED) return;
                this.setState({ selfDesignDeliveredLoading: false });
            } catch (err) {
                if (this.state.newStatus !== CASE_STATUS.DELIVERED) return;
                this.setState({
                    selfDesignDeliveredLoading: false,
                    param1: null,
                    param2: null,
                    approvedPlanCount: null,
                    modalError:
                        err.response?.data?.message || err?.message || 'Failed to load self-design aligner steps',
                });
            }
        }
    }

    // SELF_DESIGN: delivered set range is derived from the latest APPROVED
    // treatment plan's upper/lower stages — always "Set 1 to last set", where
    // each contiguous run of step numbers within an arch counts as one set.
    async fillSelfDesignDeliveredSteps() {
        const approvedPlanNo = this.getLatestApprovedPlanNo();
        if (approvedPlanNo == null) {
            throw new Error('No approved treatment plan found');
        }
        const { data } = await axios.get(`/case/self-design/${this.state.caseId}`, {
            params: { planNo: approvedPlanNo },
        });
        const upperStages = parseStages(data?.self_design?.upper_stages);
        const lowerStages = parseStages(data?.self_design?.lower_stages);
        const approvedPlanCount = data?.approvedPlanCount;
        if (!upperStages.length && !lowerStages.length) {
            throw new Error('No aligner steps found for the current treatment plan');
        }
        const deliveredSets = computeDeliveredRange(upperStages, lowerStages);
        if (this.state.newStatus !== CASE_STATUS.DELIVERED) return deliveredSets;
        this.setState({
            param1: deliveredSets.param1,
            param2: deliveredSets.param2,
            selfDesignDeliveredSets: deliveredSets,
            modalError: '',
            approvedPlanCount: approvedPlanCount,
        });
        return deliveredSets;
    }

    disabledNewPatientInfoInputObj() {
        const isDisabled = false;
        const disabledObj = {
            firstName: isDisabled,
            lastName: isDisabled,
            gender: isDisabled,
            dateOfBirth: isDisabled,
            remarks: isDisabled,
            dr_remark: isDisabled,
            profilePic: isDisabled,
        };
        return disabledObj;
    }

    scrollToStatus() {
        if (this.statusTitleRef.current) {
            this.statusTitleRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    async handleStatusUpdate() {
        // dev commment
        // console.log('handleStatusUpdate')
        // console.log('this.state.newStatus', this.state.newStatus)
        try {
            this.setState({ PhotoUploadLoadingStatus: true, loading: true });

            let param1 = this.state.param1;
            let param2 = this.state.param2;
            let remarks = this.state.awaitingRemarks;
            switch (this.state.newStatus) {
                case 'RECEIVED':
                    param1 = this.state.selectedExpectedTxDate;
                    param2 = this.state.selectedAmPmTxDate;
                    break;
                case 'PRODUCTION':
                    if (this.state.patientInfo.case_type === 'RETAINER') {
                        param1 = this.state.selectedExpectedTxDate;
                        param2 = this.state.selectedAmPmTxDate;
                    }
                    break;
                case 'DELIVERED':
                    break;
                case 'RETRACK_END': {
                    await this.props.retrack.handleValidateRetrackEndReason();
                    await this.props.retrack.handleValidateRetrackReport();
                    let retrackEndReasonData = await this.props.retrack.retrackEndReasonData;
                    let retrackReportFormData = await this.props.retrack.retrackReportFormData;

                    if (Object.keys(retrackEndReasonData).length === 0) {
                        return this.setState({ modalError: 'Please fill in Retrack End Reason' });
                    }
                    if (Object.keys(retrackReportFormData).length === 0) {
                        return this.setState({ modalError: 'Please submit all necessary data' });
                    }

                    //Purpose: save retrack report
                    //Remark: build an api including post retrack report and update status at the sametime
                    const form = new FormData();
                    const retrackReportUpdateStatusData = {
                        caseId: this.state.caseId,
                        newStatus: this.state.newStatus,
                        param1: this.state.param1,
                        param2: this.state.param2,
                        remarks: retrackEndReasonData ?? null,
                        retrackReport: retrackReportFormData ?? null,
                    };

                    if (Object.keys(retrackReportFormData).length !== 0) {
                        Object.keys(retrackReportFormData).forEach((key) => {
                            if (key.includes('_image')) {
                                // Purpose: the file will be uploaded as req.file to server side, similar to case_file (old code practice)
                                form.append(key, retrackReportFormData[key]);
                            }
                        });
                        form.append('body', JSON.stringify(retrackReportUpdateStatusData));
                        // Purpose: reset retrackReportFormData after successful submit for validate retrackReport next submit if changing data
                        this.props.setRetrackReportFormData(null);
                        this.setState({ modalError: '' });
                    }
                    if (Object.keys(retrackEndReasonData).length !== 0) {
                        this.props.setRetrackEndReasonData(null);
                        this.setState({ modalError: '' });
                    }
                    // Debug
                    // console.log('log: ', JSON.parse((Object.fromEntries(form).body)))
                    await axios.post(`case/status/${this.state.caseId}/${this.state.newStatus}`, form, {
                        onUploadProgress: this.progressBarRef.current?.onProgressChange,
                    });
                    await this.props.showSnackbar('Case status updated', 'success', true);
                    this.reloadPage();
                    return;
                }
                case 'RETRACK_REPORT': {
                    await this.props.retrack.handleValidateRetrackReport();
                    let retrackReportFormData = await { ...this.props.retrack.retrackReportFormData };

                    // !stop using retrackReportIsValid by isValid in react hook form cos bug existed if using UploadImageRhf
                    // let retrackReportIsValid = await this.props.retrack.retrackReportIsValid
                    //Purpose: validate retrack data about RETRACK_REPORT
                    switch (this.state.remakeSets) {
                        case 'NULL': {
                            if (Object.keys(retrackReportFormData).length === 0) {
                                return this.setState({ modalError: 'Please submit all necessary data' });
                            }
                            break;
                        }
                        case 'FILL': {
                            if (
                                typeof this.state.param1 !== 'number' ||
                                typeof this.state.param2 !== 'number' ||
                                Object.keys(retrackReportFormData).length === 0
                                // !retrackReportIsValid
                                // !stop using retrackReportIsValid by isValid in react hook form cos bug existed if using UploadImageRhf
                            ) {
                                return this.setState({ modalError: 'Please submit all necessary data' });
                            }
                            break;
                        }
                    }

                    // Add track_status to cae_retrack_report table
                    retrackReportFormData.track_status = this.state.remakeSets;

                    //Purpose: save retrack report
                    //Remark: build an api including post retrack report and update status at the sametime
                    const form = new FormData();
                    const retrackReportUpdateStatusData = {
                        caseId: this.state.caseId,
                        newStatus: this.state.newStatus,
                        param1: this.state.param1,
                        param2: this.state.param2,
                        // remarks: this.state.awaitingRemarks,
                        retrackReport: retrackReportFormData ?? null,
                    };

                    if (Object.keys(retrackReportFormData).length !== 0) {
                        console.log('retrackReportFormData', retrackReportFormData);
                        Object.keys(retrackReportFormData).forEach((key) => {
                            if (key.includes('_image')) {
                                // Purpose: the file will be uploaded as req.file to server side, similar to case_file (old code practice)
                                form.append(key, retrackReportFormData[key]);
                            }
                        });

                        form.append('body', JSON.stringify(retrackReportUpdateStatusData));

                        // Purpose: reset retrackReportFormData after successful submit for validate retrackReport next submit if changing data
                        this.props.setRetrackReportFormData(null);
                        this.setState({ modalError: '' });
                    }
                    // Debug
                    // console.log('log: ', JSON.parse((Object.fromEntries(form).body)))

                    await axios.post(`case/status/${this.state.caseId}/${this.state.newStatus}`, form, {
                        onUploadProgress: this.progressBarRef.current?.onProgressChange,
                    });
                    await this.props.showSnackbar('Case status updated', 'success', true);
                    this.reloadPage();
                    return;
                }
            }

            if (
                (this.state.newStatus === 'DELIVERED' || this.state.newStatus === 'ALL_DELIVERED') &&
                (this.state.currentStatus === 'RETRACK_PRODUCTION_IN_PROGRESS' ||
                    this.state.currentStatus === 'RETRACK_REPORT')
            ) {
                await axios.post(
                    `case/status/${this.state.caseId}/${this.state.newStatus}`,
                    {
                        caseId: this.state.caseId,
                        newStatus: this.state.newStatus,
                        param1: this.state.param1,
                        param2: this.state.param2,
                        remarks: 'RETRACK_DELIVERED',
                    },
                    {
                        onUploadProgress: this.progressBarRef.current?.onProgressChange,
                    }
                );
                await this.props.showSnackbar('Case status updated', 'success', true);
                this.reloadPage();
                return;
            }

            // base update status
            // any not specified status will use below handling
            let baseParam1 = this.state.param1;
            let baseParam2 = this.state.param2;
            let baseRemark = this.state.awaitingRemarks;

            // reset param values for new retainer case log display
            if (this.state.newStatus === 'DELIVERED' && this.state.patientInfo.case_type === 'RETAINER') {
                baseRemark = null;
                baseParam1 = null;
                baseParam2 = null;
            }

            // SELF_DESIGN: recompute delivered sets at submit time so the submitted
            // values always match what was derived from the current treatment plan
            if (this.state.newStatus === 'DELIVERED' && this.state.patientInfo.case_type === CASE_TYPE.SELF_DESIGN) {
                const deliveredSets = await this.fillSelfDesignDeliveredSteps();
                baseParam1 = deliveredSets.param1;
                baseParam2 = deliveredSets.param2;
            }

            let updateStatusReq = {
                caseId: this.state.caseId,
                newStatus: this.state.newStatus,
                param1: baseParam1,
                param2: baseParam2,
                remarks: baseRemark,
            };

            // case status that allows uploading case supporting files
            if (CASE_STATUS_ALLOW_UPLOAD_SUPPORTING_IMGS.includes(this.state.newStatus)) {
                const formData = new FormData();
                formData.append('caseId', this.state.caseId);
                formData.append('newStatus', this.state.newStatus);
                formData.append('remarks', baseRemark);

                if (this.state.newStatus === 'RECEIVED' || this.state.newStatus === 'RETRACK_ALL_MATERIAL_RECEIVED') {
                    baseParam1 = this.state.selectedExpectedTxDate;
                    baseParam2 = this.state.selectedAmPmTxDate;
                    formData.append('param1', baseParam1);
                    formData.append('param2', baseParam2);
                }

                let caseSupportFileCount = 0;
                this.state.caseSupportingImgs.forEach((value) => {
                    if (value.subject.length > 0) {
                        if (!value.imgData) {
                            this.scrollToStatus();
                            throw new Error('Please upload supporting images that are needed');
                        }
                    }
                    if (value.imgData) {
                        if (!value.subject.length) {
                            this.scrollToStatus();
                            throw new Error('Please input a subject for all supporting images');
                        }
                    }

                    if (value.imgData && value.subject.length) {
                        const fileName = `$$FILE:case_supporting_file${caseSupportFileCount}`; // ensure input data name in sequential order
                        formData.append(fileName, value.imgData);
                        formData.append(`subject${caseSupportFileCount}`, value.subject); // ensure input data name in sequential order
                        caseSupportFileCount += 1;
                    }
                });
                formData.append('caseSupportFileCount', caseSupportFileCount);
                updateStatusReq = formData;
            }

            await axios.post(`case/status/${this.state.caseId}/${this.state.newStatus}`, updateStatusReq, {
                onUploadProgress: this.progressBarRef.current?.onProgressChange,
            });
            await this.props.showSnackbar('Case status updated', 'success', true);
            this.reloadPage();
        } catch (err) {
            if (err.response?.data.message) {
                const errMsg = this.getErrorMsg(err, err.response.data.message);
                this.setState({ modalError: errMsg });
            } else {
                // console.log("err", err)
                // console.log("err.msg", err?.message)
                // console.log("err.res", err?.response)
                if (err?.message) {
                    this.setState({ modalError: err?.message });
                } else {
                    this.setState({ modalError: 'Could Not update the status' });
                }
            }
        } finally {
            this.setState({ PhotoUploadLoadingStatus: false, loading: false });
        }
    }

    handleOpen(modalType, ModalTypeState = 'view', args) {
        this.props.initData();
        switch (modalType) {
            case 'refinement':
                if (args.refinement_no) {
                    const case_detail = this._case.case_detail.find(
                        (item) => item[0].refinement_no === args.refinement_no
                    );
                    const case_file = this._case.case_file.find((item) => item[0].refinement_no === args.refinement_no);
                    const case_impression = this._case.case_impression.find(
                        (item) => item[0].refinement_no === args.refinement_no
                    );
                    if (case_detail[0].new_prescription_notes_flag) {
                        try {
                            var newExcludedDentitionArray = [],
                                doNotPlaceArray = [],
                                placeArray = [],
                                teethArray = [];
                            if (case_detail?.[0]?.new_excluded_dentition) {
                                newExcludedDentitionArray = case_detail?.[0]?.new_excluded_dentition.split(',');
                                for (var a in newExcludedDentitionArray) {
                                    newExcludedDentitionArray[a] = parseInt(newExcludedDentitionArray[a], 10);
                                }
                            }
                            if (case_detail?.[0]?.new_excluded_attachments) {
                                doNotPlaceArray = case_detail?.[0]?.new_excluded_attachments.split(',');
                                for (var a in doNotPlaceArray) {
                                    doNotPlaceArray[a] = parseInt(doNotPlaceArray[a], 10);
                                }
                            }
                            if (case_detail?.[0]?.new_included_attachments) {
                                placeArray = case_detail?.[0]?.new_included_attachments.split(',');
                                for (var a in placeArray) {
                                    placeArray[a] = parseInt(placeArray[a], 10);
                                }
                            }
                        } catch (err) {}
                    } else {
                        try {
                            case_detail[0].attr8 = case_detail[0].attr8 ? JSON.parse(case_detail[0].attr8) : [];
                        } catch (err) {}
                    }
                    const newPatientInitialStateCopy = JSON.parse(JSON.stringify(NewPatientInitialState));
                    let modifiedTeethData = [...newPatientInitialStateCopy.teeth];
                    const teethData = modifiedTeethData.filter((v, index) => {
                        if (
                            case_detail?.[0]?.excluded_dentition
                                ?.split(',')
                                ?.map((v) => parseInt(v))
                                ?.includes(index)
                        ) {
                            return (v['checked'] = true);
                        } else {
                            return v;
                        }
                    });
                    let modifiedFilesData = [...newPatientInitialStateCopy.files];
                    let radioKey = 0,
                        stlKey = 0,
                        key = '';
                    modifiedFilesData.forEach((v, index) => {
                        if (v.category === 'photo' || v.category === 'radio') {
                            key = v.category === 'radio' ? v.category + radioKey : v.category + index;
                            radioKey = v.category === 'radio' ? radioKey + 1 : 0;
                            let filePath = case_file?.[0]?.[key];
                            v['data'] = filePath
                                ? /^dbx::/.test(filePath)
                                    ? filePath
                                    : join(ApiServerUrl, filePath)
                                : '';
                            v['uploaded'] = filePath ? true : false;
                            v['upload_later'] = case_file?.[0]?.[`${key}_later`] === true;
                            v['will_not_upload'] = case_file?.[0]?.[`${key}_later`] === null;
                        } else {
                            key = v.category + stlKey;
                            stlKey = stlKey + 1;
                            v['data'] = case_impression?.[0]?.[key] ? join(ApiServerUrl, case_impression[0][key]) : '';
                            v['uploaded'] = case_impression?.[0]?.[key] ? true : false;
                            v['upload_later'] = case_impression?.[0]?.stl_files_later === true;
                            v['will_not_upload'] = case_impression?.[0]?.stl_files_later === null;
                        }
                    });
                    let initObj = {};
                    if (case_detail[0].new_prescription_notes_flag === true) {
                        initObj = {
                            archToTreat: case_detail?.[0].attr0 ? case_detail[0].attr0 : 'both',
                            notToTreat1: newExcludedDentitionArray,
                            attachments1: {
                                value: case_detail?.[0].attr1 ? case_detail[0].attr1 : 'placeAttachmentsAsNeeded',
                                doNotPlace: doNotPlaceArray,
                                place: placeArray,
                                delay: {
                                    value: case_detail?.[0].attr2 ? case_detail[0].attr2 : 'delayToStage',
                                    stage: case_detail?.[0].attr63 ? case_detail[0].attr63 : '',
                                },
                            },
                            alignersMarginPlacement1: case_detail?.[0].attr3
                                ? case_detail[0].attr3
                                : 'coverageExtending',
                            anteriorPosteriorRelationship1: {
                                r: case_detail?.[0].attr4 ? case_detail[0].attr4 : 'maintain',
                                l: case_detail?.[0].attr5 ? case_detail[0].attr5 : 'maintain',
                            },
                            spacingAndCrowding1: {
                                spacing: {
                                    value: case_detail?.[0].attr6 ? case_detail[0].attr6 : 'closeAllSpaces',
                                    location: case_detail?.[0].attr64 ? case_detail[0].attr64 : '',
                                },
                                crowding: {
                                    resolveUpper: {
                                        expand: {
                                            value: case_detail?.[0].attr7 ? case_detail[0].attr7 : 'asNeed',
                                            teeth: case_detail?.[0].attr48 ? case_detail[0].attr48 : '',
                                        },
                                        procline: {
                                            value: case_detail?.[0].attr8 ? case_detail[0].attr8 : 'asNeed',
                                            teeth: case_detail?.[0].attr49 ? case_detail[0].attr49 : '',
                                        },
                                        IPRAnterior: {
                                            value: case_detail?.[0].attr9 ? case_detail[0].attr9 : 'asNeed',
                                            teeth: case_detail?.[0].attr50 ? case_detail[0].attr50 : '',
                                        },
                                        IPRPosteriorRight: {
                                            value: case_detail?.[0].attr10 ? case_detail[0].attr10 : 'asNeed',
                                            teeth: case_detail?.[0].attr51 ? case_detail[0].attr51 : '',
                                        },
                                        IPRPosteriorLeft: {
                                            value: case_detail?.[0].attr11 ? case_detail[0].attr11 : 'asNeed',
                                            teeth: case_detail?.[0].attr52 ? case_detail[0].attr52 : '',
                                        },
                                        extraction: {
                                            value: case_detail?.[0].attr12 ? case_detail[0].attr12 : 'asNeed',
                                            teeth: case_detail?.[0].attr53 ? case_detail[0].attr53 : '',
                                        },
                                    },
                                    resolveLower: {
                                        expand: {
                                            value: case_detail?.[0].attr13 ? case_detail[0].attr13 : 'asNeed',
                                            teeth: case_detail?.[0].attr54 ? case_detail[0].attr54 : '',
                                        },
                                        procline: {
                                            value: case_detail?.[0].attr14 ? case_detail[0].attr14 : 'asNeed',
                                            teeth: case_detail?.[0].attr55 ? case_detail[0].attr55 : '',
                                        },
                                        IPRAnterior: {
                                            value: case_detail?.[0].attr15 ? case_detail[0].attr15 : 'asNeed',
                                            teeth: case_detail?.[0].attr56 ? case_detail[0].attr56 : '',
                                        },
                                        IPRPosteriorRight: {
                                            value: case_detail?.[0].attr16 ? case_detail[0].attr16 : 'asNeed',
                                            teeth: case_detail?.[0].attr57 ? case_detail[0].attr57 : '',
                                        },
                                        IPRPosteriorLeft: {
                                            value: case_detail?.[0].attr17 ? case_detail[0].attr17 : 'asNeed',
                                            teeth: case_detail?.[0].attr58 ? case_detail[0].attr58 : '',
                                        },
                                        extraction: {
                                            value: case_detail?.[0].attr18 ? case_detail[0].attr18 : 'asNeed',
                                            teeth: case_detail?.[0].attr59 ? case_detail[0].attr59 : '',
                                        },
                                    },
                                },
                            },
                            overJet1: {
                                value: case_detail?.[0].attr19 ? case_detail[0].attr19 : 'maintainInitialOverjet',
                                subValue: case_detail?.[0].attr20 ? case_detail[0].attr20 : '',
                            },
                            openbite1: {
                                value: case_detail?.[0].attr21 ? case_detail[0].attr21 : 'maintainInitialOpenbite',
                                subValue: {
                                    value: case_detail?.[0].attr22 ? case_detail[0].attr22 : null,
                                    extrudeAnteriorTeeth: {
                                        value: case_detail[0].attr23.includes('extrudeAnteriorTeeth') ? true : false,
                                        upper: case_detail[0].attr24.includes('upper') ? true : false,
                                        lower: case_detail[0].attr24.includes('lower') ? true : false,
                                    },
                                    intrudePosteriorTeeth: {
                                        value: case_detail[0].attr23.includes('intrudePosteriorTeeth') ? true : false,
                                        upper: case_detail[0].attr25.includes('upper') ? true : false,
                                        lower: case_detail[0].attr25.includes('lower') ? true : false,
                                    },
                                    placeMiniImplantsTAD: {
                                        value: case_detail[0].attr23.includes('placeMiniImplantsTAD') ? true : false,
                                        input: case_detail?.[0].attr60 ? case_detail[0].attr60 : '',
                                    },
                                },
                            },
                            deepBite1: {
                                value: case_detail?.[0].attr26 ? case_detail[0].attr26 : 'maintainExistingDeepBite',
                                subValue: {
                                    value: case_detail?.[0].attr27 ? case_detail[0].attr27 : null,
                                    intrudeAnteriorTeeth: {
                                        value: case_detail[0].attr28.includes('intrudeAnteriorTeeth') ? true : false,
                                        upper: case_detail[0].attr29.includes('upper') ? true : false,
                                        lower: case_detail[0].attr29.includes('lower') ? true : false,
                                    },
                                    extrudePosteriorTeeth: {
                                        value: case_detail[0].attr28.includes('extrudePosteriorTeeth') ? true : false,
                                        upper: case_detail[0].attr30.includes('upper') ? true : false,
                                        lower: case_detail[0].attr30.includes('lower') ? true : false,
                                    },
                                    placeMiniImplantsTAD: {
                                        value: case_detail[0].attr28.includes('placeMiniImplantsTAD') ? true : false,
                                        input: case_detail?.[0].attr61 ? case_detail[0].attr61 : '',
                                    },
                                },
                            },
                            midline1: {
                                value: case_detail?.[0].attr31 ? case_detail[0].attr31 : 'maintainInitialMidline',
                                subValue: {
                                    value: case_detail?.[0].attr32 ? case_detail[0].attr32 : '',
                                    upper: {
                                        checked: case_detail[0].attr33.includes('upper') ? true : false,
                                        value: case_detail?.[0].attr34 ? case_detail[0].attr34 : '',
                                    },
                                    lower: {
                                        checked: case_detail[0].attr33.includes('lower') ? true : false,
                                        value: case_detail?.[0].attr35 ? case_detail[0].attr35 : '',
                                    },
                                },
                            },
                            posteriorCrossbite1: {
                                value: case_detail?.[0].attr36 ? case_detail[0].attr36 : 'maintainInitialCrossbite',
                                subValue: {
                                    value: case_detail?.[0].attr37
                                        ? case_detail[0].attr37
                                        : 'noPreferenceShowResultsInSimulator',
                                    subValue: {
                                        value: case_detail?.[0].attr38 ? case_detail[0].attr38 : null,
                                        buttonPressedDirectlyOnAligner: {
                                            maxillaryTeeth: case_detail[0].attr39.includes('maxillaryTeeth')
                                                ? true
                                                : false,
                                            mandibularTeeth: case_detail[0].attr39.includes('mandibularTeeth')
                                                ? true
                                                : false,
                                        },
                                        cutoutToBondButtonDirectlyOnTeeth: {
                                            maxillaryTeeth: case_detail[0].attr40.includes('maxillaryTeeth')
                                                ? true
                                                : false,
                                            mandibularTeeth: case_detail[0].attr40.includes('mandibularTeeth')
                                                ? true
                                                : false,
                                        },
                                        otherMethod: case_detail[0].attr46 || '',
                                    },
                                },
                            },
                            auxiliaries1: {
                                classIIElastics: case_detail?.[0].attr41 ? case_detail[0].attr41 : 'No',
                                classIIIElastics: case_detail?.[0].attr42 ? case_detail[0].attr42 : 'No',
                                subValue: {
                                    upper: {
                                        value: case_detail[0].attr43.includes('upperFabricate')
                                            ? 'upperFabricate'
                                            : case_detail[0].attr43.includes('upperCutout')
                                              ? 'upperCutout'
                                              : 'upperSlipCut',
                                    },
                                    lower: {
                                        value: case_detail[0].attr43.includes('lowerFabricate')
                                            ? 'lowerFabricate'
                                            : case_detail[0].attr43.includes('lowerCutout')
                                              ? 'lowerCutout'
                                              : 'lowerSlipCut',
                                    },
                                },
                                otherElastics: {
                                    value: case_detail?.[0].attr44 ? case_detail[0].attr44 : 'No',
                                    comment: case_detail?.[0].attr62 ? case_detail[0].attr62 : '',
                                },
                            },
                            trioDimForce: case_detail[0].trio_dim_force,
                            specialInstructions1: case_detail?.[0].attr47 ? case_detail[0].attr47 : '',
                            files: modifiedFilesData,
                            impressionType: case_impression?.[0]?.type ?? 'FILE',
                            scannerBrand: case_impression?.[0]?.['scanner_brand']
                                ? case_impression[0]['scanner_brand']
                                : '',
                            doctorId: case_impression?.[0]?.['doctor_id'] ? case_impression[0]['doctor_id'] : '',
                            modernCode: case_impression?.[0]?.['modern_code'] ? case_impression[0]['modern_code'] : '',
                            waybillNumber: case_impression?.[0]?.['waybill_number']
                                ? case_impression[0]['waybill_number']
                                : '',
                            courierCompany: case_impression?.[0]?.['courier_company']
                                ? case_impression[0]['courier_company']
                                : '',
                        };
                    } else {
                        initObj = {
                            clinical_cond: case_detail?.[0]?.clinical_cond ? case_detail[0].clinical_cond : [],
                            clinicalConditionComment:
                                case_detail?.[0].clinical_cond_comment || args?.clinicalConditionComment || '',
                            extraction: case_detail?.[0].attr0 || 'primary',
                            expansion: case_detail?.[0].attr1 ? case_detail[0].attr1 : 'primary',
                            interproximalReduction: case_detail?.[0].attr2 ? case_detail[0].attr2 : 'primary',
                            distalization: case_detail?.[0].attr3 ? case_detail[0].attr3 : 'primary',
                            proclination: case_detail?.[0].attr4 ? case_detail[0].attr4 : 'primary',
                            treatmentSimulation: case_detail?.[0].attr5 ? case_detail[0].attr5 : 'primary',
                            overJet: case_detail?.[0].attr6 ? case_detail[0].attr6 : 'maintain',
                            overBite: case_detail?.[0].attr7 ? case_detail[0].attr7 : 'maintain',
                            midLine: case_detail?.[0].attr8 || [],
                            crossBite: case_detail?.[0].attr9 ? case_detail[0].attr9 : 'maintain',
                            teeth: teethData,
                            comment: case_detail?.[0].attr12 || args?.comment || '',
                            extractionConcat: case_detail?.[0].attr10 ? case_detail[0].attr10 : '',
                            expansionConcat: case_detail?.[0].attr11 ? case_detail[0].attr11 : '',
                            excluded_dentition: case_detail?.[0].excluded_dentition
                                ? case_detail[0].excluded_dentition
                                : '',
                            files: modifiedFilesData,
                            impressionType: case_impression?.[0]?.type ?? 'FILE',
                            scannerBrand: case_impression?.[0]?.['scanner_brand']
                                ? case_impression[0]['scanner_brand']
                                : '',
                            doctorId: case_impression?.[0]?.['doctor_id'] ? case_impression[0]['doctor_id'] : '',
                            modernCode: case_impression?.[0]?.['modern_code'] ? case_impression[0]['modern_code'] : '',
                            waybillNumber: case_impression?.[0]?.['waybill_number']
                                ? case_impression[0]['waybill_number']
                                : '',
                            courierCompany: case_impression?.[0]?.['courier_company']
                                ? case_impression[0]['courier_company']
                                : '',
                        };
                    }
                    if (args.defect_resubmit === true) {
                        this.setState({ defect_resubmit: true });
                    }
                    initObj['archToTreatUpperStep'] = '';
                    initObj['archToTreatLowerStep'] = '';
                    if (case_detail?.[0]) {
                        const caseDetail = case_detail[0];
                        initObj['archToTreatUpperStep'] = caseDetail?.refinement_arch_to_treat_upper_step
                            ? caseDetail.refinement_arch_to_treat_upper_step
                            : '';
                        initObj['archToTreatLowerStep'] = caseDetail?.refinement_arch_to_treat_lower_step
                            ? caseDetail.refinement_arch_to_treat_lower_step
                            : '';
                    }
                    this.props.setTempData(initObj);
                    this.setState({
                        RefinementModal: true,
                        ModalState: ModalTypeState,
                        refinementHasDetail: !!case_detail,
                        refinementNewPrescriptionNotesFlag: case_detail?.[0].new_prescription_notes_flag
                            ? case_detail[0].new_prescription_notes_flag
                            : false,
                        refinementHasFile: !!case_file,
                        refinementHasImpression: !!case_impression,
                        refinementHasComment: String.isNotBlank(args?.comment),
                        currentRefinementNo: args.refinement_no,
                    });
                }
                break;
            case 'replaceMyp':
                this.setState({ ReplaceMypModal: true, ModalState: ModalTypeState, targetId: args?.id });
                break;

            case 'defect':
                this.setState({ DefectModal: true, ModalState: ModalTypeState, targetId: args?.id });
                break;
            case 'photo':
                this.setState({ PhotoModal: true, ModalState: ModalTypeState, targetId: args?.id });
                break;
            case 'radiograph':
                this.setState({ RadiographsModal: true, ModalState: ModalTypeState, targetId: args?.id });
                break;
            case 'retrack':
                const newDentitionArray = [];
                this.setState({ RetrackModal: true, ModalState: ModalTypeState, targetId: args?.id });
                break;
            case 'retrackOldCaseModal':
                this.setState({ RetrackOldCaseModal: true, ModalState: ModalTypeState, targetId: args?.id });
                break;
            case 'refinementOldCaseModal':
                this.setState({ RefinementOldCaseModal: true, ModalState: ModalTypeState, targetId: args?.id });
                break;
            case 'caseExpireModal':
                this.setState({ CaseExpireModal: true, ModalState: ModalTypeState });
                break;
            case 'viewRetrackDataModal':
                this.setState({ retrackId: args.retrack_id });
                this.setState({ case_activity_log_id: args.case_activity_log_id });
                this.setState({ ViewRetrackDataModal: true, ModalState: ModalTypeState });
                break;
            case 'viewRetrackReportModal':
                this.setState({ retrackId: args.retrack_id });
                this.setState({ caseRetrackReportId: args.case_retrack_report_id });
                this.setState({ case_activity_log_id: args.case_activity_log_id });
                this.setState({ ViewRetrackReportModal: true, ModalState: ModalTypeState });
                break;
            case 'viewFinishingRetainerModal':
                this.setState({ finishingRetainerId: args.finishing_retainer_id });
                this.setState({ case_activity_log_id: args.case_activity_log_id });
                this.setState({ ViewFinishingRetainerModal: true, ModalState: ModalTypeState });
                break;
            case 'viewRetrackQuotaReminderModal':
                this.setState({ ViewRetrackQuotaReminderModal: true, ModalState: ModalTypeState });
                break;
            case 'viewRefinementQuotaReminderModal':
                this.setState({ ViewRefinementQuotaReminderModal: true, ModalState: ModalTypeState });
                break;
            case 'viewRestorationToolFormModal':
                this.setState({ restorationFormId: args.restorationFormId });
                this.setState({ ViewRestorationToolFormModal: true, ModalState: ModalTypeState });
                break;
            case 'viewRestorationFormFirstFitModal':
                this.setState({
                    restorationFormId: args.restorationFormId,
                    restorativePhaseCaseImpressionId: args.caseImpressionId || null,
                    restorativePhaseViewType: args.viewType || 'prescription',
                });
                this.setState({ ViewRestorationFormFirstFitModal: true, ModalState: ModalTypeState });
                break;
            case 'viewMockupOrderModal':
                this.setState({
                    ViewMockupOrderModal: true,
                    ModalState: ModalTypeState,
                    mockupOrderId: args.mockupOrderId,
                    mockupRequestId: args.mockupRequestId,
                    mockupOrderData: null,
                    mockupOrderLoading: true,
                });
                this.loadMockupOrder(args.mockupOrderId);
                break;
            case 'RFS':
                this.setState({ RFSModal: true, ModalState: ModalTypeState, targetId: args?.id });
                break;
            case 'impression':
                this.setState({ ImpressionsModal: true, ModalState: ModalTypeState, targetId: args?.id });
                break;
            case 'aligner':
                this.setState({ AlignerModal: true, ModalState: ModalTypeState });
                break;
            case 'status':
                // For SELF_DESIGN only: reset the previously selected status on
                // every open so the delivered-sets auto-fill always starts fresh
                // and re-triggers on selection. Other case types keep the
                // pre-existing behavior (selection persists across open/close).
                this.setState({
                    StatusModal: true,
                    ModalState: ModalTypeState,
                    newStatus:
                        this.state.patientInfo.case_type === CASE_TYPE.SELF_DESIGN ? '' : this.state.newStatus,
                });
                break;
            /* case 'additional_information':
        this.setState({ AdditionalInformationModal: true, ModalState: ModalTypeState });
        break */
            case 'prescriptionNotes':
                this.setState({ PrescriptionNotesModal: true, ModalState: ModalTypeState });
                // Converted SD -> aligner cases have no case_detail rows; fall back to the SD prescription.
                if (ModalTypeState !== 'update') {
                    const hasCaseDetail = this.state.patientInfo?.case_detail?.some(
                        (group) => group && group.length
                    );
                    if (!hasCaseDetail) {
                        safeGet(`case/smileDesignPrescriptionNotes/${this.state.caseId}`)
                            .then(({ result }) => this.setState({ smileDesignPrescriptionFallback: result || null }))
                            .catch(() => this.setState({ smileDesignPrescriptionFallback: null }));
                    } else {
                        this.setState({ smileDesignPrescriptionFallback: null });
                    }
                }
                break;
            case 'treatment':
                this.setState({ TreatmentModal: true, ModalState: ModalTypeState });
                break;
            case 'request_retainer':
                const patientId = this.state.patientInfo.id;
                this.props.history.push(`/patients/${patientId}/differentRatiner`);
                // this.setState({ RequestRetainerModal: true, ModalState: ModalTypeState });
                break;
            case 'request_finishing_retainer_step1':
                this.setState({ RequestFinishingRetainerStep1Modal: true, ModalState: ModalTypeState });
                break;
            case 'retainer_request_prescription':
                const retainerRequestId = args?.id ? args.id : 0;
                this.setState({
                    ViewPrescriptionModal: true,
                    ModalState: ModalTypeState,
                    retainerRequestId: retainerRequestId,
                });
                break;
            case 'resubmit_retainer_request':
                this.setState({
                    ReSubmitRetainerFormModal: true,
                    ModalState: ModalTypeState,
                    retainerRequestId: args?.id ? args.id : null,
                });
                break;
            case 'info':
                const [, day, month, year] = this.state.patientInfo.dateOfBirth.match(
                    /([0-9]{1,2})-([0-9]{1,2})-([0-9]{4})/
                );
                const oldPatientInfo = {
                    gender:
                        this.state.patientInfo.gender === 'Male'
                            ? 'M'
                            : this.state.patientInfo.gender === 'Female'
                              ? 'F'
                              : 'O',
                    lastName: this.state.patientInfo.lastName,
                    firstName: this.state.patientInfo.firstName,
                    day: parseInt(day),
                    month: parseInt(month),
                    year: parseInt(year),
                    refCode: this.state.patientInfo.refCode,
                    remarks: this.state.patientInfo.remarks,
                    internalRemarks: this.state.patientInfo.internalRemarks,
                    dr_remark: this.state.patientInfo.dr_remark,
                    patientPhoto: { id: 'profile_pic', uploaded: false, data: this.state.patientInfo.image, rotate: 0 },
                };
                this.props.setTempData(oldPatientInfo);
                this.setState({ InfoModal: true, ModalState: ModalTypeState });
                break;
            case 'view_case_supporting_file_modal':
                this.setState({
                    caseSupportingModalOpen: true,
                    viewCaseSupportingFileCaseActivityLogId: args?.id ? args.id : null,
                    caseLogCreatedDate: args?.caseLogCreatedDate ? args.caseLogCreatedDate : null,
                    caseLogStatus: args?.caseLogStatus ? args.caseLogStatus : null,
                });
                break;
            case 'drRemarks':
                const [, day2, month2, year2] = this.state.patientInfo.dateOfBirth.match(
                    /([0-9]{1,2})-([0-9]{1,2})-([0-9]{4})/
                );
                const oldPatientInfo2 = {
                    gender:
                        this.state.patientInfo.gender === 'Male'
                            ? 'M'
                            : this.state.patientInfo.gender === 'Female'
                              ? 'F'
                              : 'O',
                    lastName: this.state.patientInfo.lastName,
                    firstName: this.state.patientInfo.firstName,
                    day: parseInt(day2),
                    month: parseInt(month2),
                    year: parseInt(year2),
                    refCode: this.state.patientInfo.refCode,
                    remarks: this.state.patientInfo.remarks,
                    internalRemarks: this.state.patientInfo.internalRemarks,
                    dr_remark: this.state.patientInfo.dr_remark,
                    patientPhoto: { id: 'profile_pic', uploaded: false, data: this.state.patientInfo.image, rotate: 0 },
                };
                this.props.setTempData(oldPatientInfo2);
                this.setState({
                    dr_remark: this.state.patientInfo.dr_remark,
                    DrRemarksModal: true,
                    ModalState: ModalTypeState,
                });
                break;
            case 'viewManufactureDetailModal':
                this.setState({
                    manufactureDetailPlanId: args.planId,
                    manufactureDetailCaseId: args.caseId,
                    viewManufactureDetailModal: true,
                    manufactureDetailData: null,
                    manufactureDetailStages: null,
                    manufactureDetailError: null,
                    manufactureDetailLoading: true,
                });
                // Manufacture summary + stage arrays are fetched together and applied
                // in one setState so the dialog never flashes an intermediate view
                // (e.g. the count-based fallback) while only one of them has resolved.
                Promise.all([
                    axios.get(`/case/self-design/${args.caseId}/manufacture-summary`, {
                        params: { planId: args.planId },
                    }),
                    args.planNo != null
                        ? axios
                              .get(`/case/self-design/${args.caseId}`, {
                                  params: { planNo: args.planNo },
                              })
                              .catch(() => null)
                        : Promise.resolve(null),
                ])
                    .then(([summaryRes, selfDesignRes]) => {
                        const selfDesign = selfDesignRes?.data?.self_design;
                        const upper = parseStages(selfDesign?.upper_stages);
                        const lower = parseStages(selfDesign?.lower_stages);
                        this.setState({
                            manufactureDetailData: summaryRes.data.summary,
                            manufactureDetailStages:
                                selfDesignRes && (upper.length || lower.length) ? { upper, lower } : null,
                            manufactureDetailLoading: false,
                        });
                    })
                    .catch((err) => {
                        const errMsg =
                            err.response?.data?.message || this.get('case_info.manufactureDetail.loadingFailed');
                        this.setState({
                            manufactureDetailError: errMsg,
                            manufactureDetailLoading: false,
                        });
                        this.props.showSnackbar(errMsg, 'error');
                    });
                break;
            default:
                break;
        }
        this.props.handleInitDraftFileList(this.state.draftFileList, this.state.chosen_draft_file);
    }

    getTrimlineLabel(trimmingLineType) {
        const keyMap = {
            scallopCutting: 'case_info.manufactureDetail.trimlineScallopCutting',
            gingivalCoverCutting: 'case_info.manufactureDetail.trimlineGingivalCoverCutting',
        };
        return keyMap[trimmingLineType] ? this.get(keyMap[trimmingLineType]) : trimmingLineType;
    }

    handleClose(modalType) {
        let defaultState = { modalError: '', targetId: null };
        switch (modalType) {
            case 'moderateInformationPop':
                defaultState = { ...defaultState, moderateInformationPop: false };
            case 'severeInformationPop':
                defaultState = { ...defaultState, severeInformationPop: false };
            case 'refinement':
                defaultState = { ...defaultState, RefinementModal: false, defect_resubmit: false };
                break;
            case 'replaceMyp':
                defaultState = { ...defaultState, ReplaceMypModal: false };
                break;
            case 'photo':
                defaultState = { ...defaultState, PhotoModal: false };
                break;
            case 'rfs':
                defaultState = { ...defaultState, RFSModal: false };
                break;
            case 'defect':
                defaultState = { ...defaultState, DefectModal: false };
                break;
            case 'radiograph':
                defaultState = { ...defaultState, RadiographsModal: false };
                break;
            case 'impression':
                defaultState = { ...defaultState, ImpressionsModal: false, stls: [] };
                break;
            case 'aligner':
                defaultState = { ...defaultState, AlignerModal: false, aligner: [...initAlignerOption] };
                break;
            case 'status':
                if (CASE_STATUS_ALLOW_UPLOAD_SUPPORTING_IMGS.includes(this.state.newStatus)) {
                    defaultState = { ...defaultState, caseSupportingImgs: initCaseSupportingImgs }; // reset data when close modal
                }
                defaultState = {
                    ...defaultState,
                    StatusModal: false,
                    selfDesignDeliveredSets: null,
                    selfDesignDeliveredLoading: false,
                };
                break;
            case 'retrack':
                defaultState = { ...defaultState, RetrackModal: false };
                break;
            case 'retrackOldCaseModal':
                defaultState = { ...defaultState, RetrackOldCaseModal: false };
                break;
            case 'refinementOldCaseModal':
                defaultState = { ...defaultState, RefinementOldCaseModal: false };
                break;
            case 'caseExpireModal':
                defaultState = { ...defaultState, CaseExpireModal: false };
                break;
            case 'viewRetrackDataModal':
                defaultState = { ...defaultState, ViewRetrackDataModal: false };
                break;
            case 'viewRetrackReportModal':
                defaultState = { ...defaultState, ViewRetrackReportModal: false };
                break;
            case 'viewFinishingRetainerModal':
                defaultState = { ...defaultState, ViewFinishingRetainerModal: false };
                break;
            case 'viewRetrackQuotaReminderModal':
                defaultState = { ...defaultState, ViewRetrackQuotaReminderModal: false };
                break;
            case 'viewRefinementQuotaReminderModal':
                defaultState = { ...defaultState, ViewRefinementQuotaReminderModal: false };
                break;
            case 'viewRestorationToolFormModal':
                defaultState = { ...defaultState, ViewRestorationToolFormModal: false };
                break;
            case 'viewRestorationFormFirstFitModal':
                defaultState = {
                    ...defaultState,
                    ViewRestorationFormFirstFitModal: false,
                    restorativePhaseCaseImpressionId: null,
                    restorativePhaseViewType: 'prescription',
                };
                break;
            case 'viewMockupOrderModal':
                defaultState = {
                    ...defaultState,
                    ViewMockupOrderModal: false,
                    mockupOrderId: '',
                    mockupRequestId: '',
                    mockupOrderData: null,
                    mockupOrderLoading: false,
                };
                break;
            case 'viewManufactureDetailModal':
                // Note: data/stages are intentionally NOT cleared here — the MUI
                // Dialog stays mounted during its exit transition, so clearing
                // them would flash the fallback view. Everything is reset on open.
                defaultState = { ...defaultState, viewManufactureDetailModal: false };
                break;
            /* case 'additional_information':
        defaultState = { ...defaultState, AdditionalInformationModal: false }
        break */
            case 'questionnaire':
                defaultState = { ...defaultState, QuestionnaireModal: false };
                break;
            case 'prescriptionNotes':
                defaultState = {
                    ...defaultState,
                    PrescriptionNotesModal: false,
                    smileDesignPrescriptionFallback: null,
                };
                break;
            case 'treatment':
                defaultState = { ...defaultState, TreatmentModal: false };
                break;
            case 'request_retainer':
                defaultState = { ...defaultState, RequestRetainerModal: false };
                break;
            case 'request_finishing_retainer_step1':
                defaultState = { ...defaultState, RequestFinishingRetainerStep1Modal: false };
                break;
            case 'request_finishing_retainer_step2':
                defaultState = { ...defaultState, RequestFinishingRetainerStep2Modal: false };
                //this.props.updateStep2SelectOpts('0');
                //this.props.updateStep3SelectOpts('0');
                break;
            case 'request_finishing_retainer_step3':
                defaultState = { ...defaultState, RequestFinishingRetainerStep3Modal: false };
                //this.props.updateStep2SelectOpts('0');
                //this.props.updateStep3SelectOpts('0');
                break;
            case 'request_finishing_retainer_step4':
                defaultState = { ...defaultState, RequestFinishingRetainerStep4Modal: false };
                //this.props.updateStep2SelectOpts('0');
                //this.props.updateStep3SelectOpts('0');
                break;
            case 'info':
                defaultState = { ...defaultState, InfoModal: false };
                break;
            case 'deliveryAddress':
                defaultState = { ...defaultState, deliveryAddressModal: false };
                break;
            case 'drRemarks':
                defaultState = { ...defaultState, DrRemarksModal: false };
                break;
            default:
                break;
        }
        this.setState(defaultState);
    }

    handleInformation(type) {
        switch (type) {
            case 'severeInformationPop':
                if (this.state.severeInformationPop) {
                    this.setState({ severeInformationPop: false });
                } else {
                    this.setState({ severeInformationPop: true });
                }
                break;
            case 'moderateInformationPop':
                if (this.state.moderateInformationPop) {
                    this.setState({ moderateInformationPop: false });
                } else {
                    this.setState({ moderateInformationPop: true });
                }
                break;
        }
    }
    async handleDrResponse(stateType, distorted, defect_id) {
        if (this.props.isLoading) {
            return;
        }

        this.setState({
            DrResponse: {
                stateType: stateType,
                distorted: distorted,
                defect_id: defect_id,
            },
        });
        try {
            let url =
                '/case/defect/drResponse/' + this.state.caseId + '/' + distorted + '/' + defect_id + '/' + stateType;
            if (stateType === 'rescan' || (stateType === 'sendcycle1' && distorted !== 'severely')) {
                this.props.startLoading();
                const { data } = await axios.post(url, '', {
                    onUploadProgress: this.progressBarRef.current?.onProgressChange,
                });
                if (data.success) {
                    this.props.stopLoading();
                    this.reloadPage();
                } else {
                    window.alert(data.message);
                }
                //  this.setState({ drResponse: 'rescan' })
            }
            if ((stateType === 'sendcycle1' && distorted === 'severely') || stateType === 'sendcycle1to6') {
                this.setConfirmDrResponse(true);
            }
        } catch (error) {
            const errMsg = this.getErrorMsg(error, 'Something went wrong , Please connect with admin');
            await this.props.showSnackbar(errMsg, 'error');
        }
    }

    async submitDrResponse() {
        if (this.props.isLoading) {
            return;
        }

        try {
            let url =
                '/case/defect/drResponse/' +
                this.state.caseId +
                '/' +
                this.state.DrResponse.distorted +
                '/' +
                this.state.DrResponse.defect_id +
                '/' +
                this.state.DrResponse.stateType;
            switch (this.state.DrResponse.stateType) {
                case 'rescan': ///defect/drResponse/:caseId/:distorted/:defectId
                    break;
                case 'sendcycle1':
                    this.props.startLoading();
                    const { sendcycle1Data } = await axios.post(url, '', {
                        onUploadProgress: this.progressBarRef.current?.onProgressChange,
                    });
                    if (sendcycle1Data.success) {
                        this.props.stopLoading();
                        this.reloadPage();
                    } else {
                        window.alert(sendcycle1Data.message);
                    }

                    break;
                case 'sendcycle1to6':
                    this.props.startLoading();
                    const { sendcycle1to6Data } = await axios.post(url, '', {
                        onUploadProgress: this.progressBarRef.current?.onProgressChange,
                    });
                    if (sendcycle1to6Data.success) {
                        this.props.stopLoading();
                        this.reloadPage();
                    } else {
                        window.alert(sendcycle1to6Data.message);
                    }

                    break;
            }
        } catch (error) {
            const errMsg = this.getErrorMsg(error, 'Something went wrong , Please connect with admin');
            await this.props.showSnackbar(errMsg, 'error');
        }
    }

    handleChangeInputData(stateType, value) {
        switch (stateType) {
            case 'awaitingRemarks':
                this.setState({ awaitingRemarks: value });
                break;
            case 'requestRetainerQuantity':
                this.setState({ requestRetainerQuantity: value });

                break;
        }
    }

    async getProductMatrixForDr() {
        const {
            data: { pm },
        } = await axios.get(`/productmatrix/productmatrixForDr`);
        const result = await axios.get(`/productmatrix/productmatrixForDr/SMILE_DESIGN`); // Purpose: get product matrix for smile design
        this.props.setProductMatrixArray(result.data.pm);

        this.setState({ productMatrix: pm });
    }

    async getNewCaseOptionType() {
        const result = await axios.get(`/case/getcaseoption/${JSON.parse(localStorage.getItem('doctor_dist_id'))}`);
        if (result.data.case_options.length > 0) {
            this.setState({ caseOptionTypeArr: result.data.case_options });
            // for default value
            this.setState({ selectCaseOptionType: result.data.case_options[0].opt1 });
        }
    }

    formatNewCaseLink(v, selectCaseOptionType, currentPatientId) {
        return selectCaseOptionType
            ? `/patients/${currentPatientId}/newCase/${v['case_type']}/${selectCaseOptionType}`
            : `/patients/${currentPatientId}/newCase/${v['case_type']}`;
    }

    handleCaseOptionTypeChange = (event) => {
        this.setState({ selectCaseOptionType: event.target.value });
    };

    getImage(image_id) {
        let image_data = this.props.newPatientData.files.filter((imageObj) => {
            return imageObj.id == image_id;
        });
        return image_data?.[0];
    }

    handlePresDialog() {
        this.setState({ presDialogOpen: !this.state.presDialogOpen });
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.lang.current != nextProps.lang.current) {
            this.mount_init();
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.pageVisible === 0) {
            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
            this.pageVisible += 1;
        }
    }

    checkInvalid() {}
    async checkRequestFinishingRetainerButton() {
        let { data } = await axios.get(`/case/retainer_exist/` + this.state.caseId);
        if (data.success && !data.caseExist) {
            this.setState({ enable_requestFinishingRetainer_button: true });
        } else {
            this.setState({ enable_requestFinishingRetainer_button: false });
        }
    }

    /** Loads the restoration form version for the current case. */
    async getRestorationFormVersion() {
        const { data: formVersionData } = await axios.get(`case/restorationForm/version/${this.state.caseId}`);
        this.props.setDisplayFirstFitFlag(formVersionData?.result?.formVersion === 'v2');
    }

    async componentDidMount() {
        try {
            //Purpose: Set default value to 1 and pass this state to FinishingRetainerSummary
            this.props.requestFinishingRetainerData.request_finishing_retainerOptB = '1';
            this.props.updateStep3SelectOpts('1');
            if (this.state.role === ROLE_NAMES.admin || this.state.role === ROLE_NAMES.super_admin) {
                await this.getRestorationFormVersion();
            }
            const isMountSuccess = await this.mount_init();
            if (!isMountSuccess) {
                return;
            }
            this.checkRequestFinishingRetainerButton();
            this.getProductMatrixForDr();
            if (this.state.role === 'DR') {
                this.getNewCaseOptionType();
            }
            if (['DR'].includes(this.state.role)) {
                if (!this.state.threeshapeConnected) {
                    let { data } = await axios.get(`/threeshape/check_connect`);
                    if (data.success) {
                        this.setState({ threeshapeConnected: true });
                    } else {
                        this.setState({ threeshapeConnected: false });
                    }
                }
                this.props.fetchScannerPlatform();
            }
        } catch (error) {
            console.error(error);
            this.props.showSnackbar('Access denied / Cannot retrieve this case');
        }
    }

    /** Initialize the patient information page data. */
    async mount_init() {
        let caseData = undefined;
        const id = parseInt(this.state.caseId, 10);
        if (Number.isNaN(id)) {
            this.props.openRedirectUserModal({
                title: this.get('@PatientInfo.msg.invalidCaseIdTitle'),
                message: this.get('@PatientInfo.msg.invalidCaseIdMessage'),
                modalOnCloseCallbackFunc: () => this.props.history.push('/'),
                showOk: false,
            });
            return false;
        }
        try {
            caseData = await safeGet(`case/${id}`);
            if (!caseData.success && caseData.message === ERROR.CASE_CANCELLED) {
                this.props.openRedirectUserModal({
                    title: this.get('@PatientInfo.msg.caseCancelledTitle'),
                    message: this.get('@PatientInfo.msg.caseCancelledMessage'),
                    modalOnCloseCallbackFunc: () => this.props.history.push('/'),
                    showOk: false,
                });
                return false;
            }
            let patientId = this.state.patientId;
            if (caseData.case.length === 1 && (patientId === undefined || patientId === null || patientId === '')) {
                this.setState({ patientId: caseData.case[0].patient_id });
                patientId = caseData.case[0].patient_id;
            }
            // Explain: Only CaseType exact the same as FULL_SMILE_DESIGN, that means before upgrade
            const isShowSmileDesignFeature =
                smileDesignProductListArray.includes(caseData.case[0].case_type) && caseData.case[0].isSmileDesign;
            this.setState({ isShowSmileDesignFeature: isShowSmileDesignFeature });
            this.setState({ isSmileDesign: caseData.case[0].isSmileDesign });
            this.setState({ treatmentTypes: caseData.case[0].treatment_types });

            this.setState({ archivedFlag: caseData.case[0].archived_flag });

            await this.getPatientCasesInfo(this.state.patientId);
        } catch (error) {
            console.error(error);
            this.props.showSnackbar('Access denied / Cannot retrieve this case');
            return false;
        }
        try {
            if (!caseData) throw new Error('Cannot retrieve case data');
            // redirect
            if (caseData.case?.[0]?.case_status === 'DRAFT') {
                this.props.history.replace(`/patients/${id}/edit`);
                return true;
            }
            await safeGet(`/case/getrfsFile/${id}`).then(({ rfsFiles, success }) => {
                if (success) {
                    this.setState({ rfsFiles });
                }
            });
            this.setState({ unreadStatusCount: caseData.case[0]?.unread_status_count ?? 0 });
            this.setState({
                unreadChatCount:
                    (caseData.case[0]?.unread_chat_count ?? 0) +
                    (caseData.case[0]?.unread_private_chat_count ?? 0) +
                    (caseData.case[0]?.unread_intl_chat_count ?? 0),
            });

            const [_case] = caseData.case;

            const [
                deliveryAddressData,
                treatmentPlanData,
                logData,
                {
                    user: { first_name: doc_first_name, last_name: doc_last_name, client_code: user_client_code },
                },
                defectCurrentStatus,
                // isShowFinishingRetainer,
                release_bleaching_retainer,

                {
                    retrack_quota_total,
                    retrack_quota_remaining,
                    retrack_steps,
                    refinement_quota_total,
                    refinement_quota_remaining,
                    refinement_steps,
                    refinement_expiration_date,
                    withinTreatmentPeriod,
                    isOldCaseBeforeRetrackRefinementDemployment,
                    enableRetrack,
                },
                gallery,
                upsellOperationData,
            ] = await Promise.all([
                safeGet(`case/address/${_case.delivery_address_id}?view=1`),
                safeGet(`case/treatment_plan/${id}/patients`),
                safeGet(`case/log/${id}`),
                safeGet(`user/${_case.created_by}`),
                safeGet(`case/defect/flow/${id}`),
                // safeGet(`case/treatment_plan_new_product/${id}`),
                safeGet(`res/distrgroup/release_bleaching_retainer`),
                safeGet(`retrack/getRetrackRefinementQuota/${this.state.caseId}`),
                safeGet(`mobile_app/doctor/draft_file_list`),
                safeGet(`case/upsellOperation/${this.state.caseId}`),
            ]);

            if (_case.case_status === 'DELIVERED' || _case.case_status === 'ALL_DELIVERED') {
                const { results } = await safeGet(`case/isFirstProductIsNewProduct/${id}`);
                this.setState({ isFirstProductIsNewProduct: results?.new_product });
            }

            if (upsellOperationData?.success && upsellOperationData?.data) {
                console.log('upsellOperationData => ', upsellOperationData);
                console.log('upsellOperationData.data => ', upsellOperationData.data);
                this.setState({ upsellOperationData: upsellOperationData.data });
            }

            // if status is before plan_approved
            const allowedUpgradeResponse = await safeGet(`/case/smileDesign/allowedUpgrade/${id}`);

            if (allowedUpgradeResponse?.result?.comprehensive && allowedUpgradeResponse?.result?.twelveStep) {
                this.setState({
                    isNoNeedUploadIDesign: true,
                });
            }

            if (
                _case.case_status === 'RETRACK_PRODUCTION_IN_PROGRESS' ||
                (_case.case_status === 'RETRACK_REPORT' && _case.status_param1 === null && _case.status_param2 === null) //Purpose: check remake step null
            ) {
                let largestDateItem = {
                    state: null,
                    date: null,
                };

                let isDeliveredAfterRefinement = false;
                let maxRefinementNo = 0;

                logData.log.forEach((item) => {
                    const refinementNo = item?.refinement_no;
                    const status = item?.status?.status;

                    if (refinementNo !== undefined && refinementNo !== null) {
                        maxRefinementNo = Math.max(maxRefinementNo, refinementNo);
                    }

                    if ((status === 'DELIVERED' || status === 'ALL_DELIVERED') && refinementNo > 0) {
                        isDeliveredAfterRefinement = true;
                    }
                });

                if (maxRefinementNo === 0 || maxRefinementNo === undefined || maxRefinementNo === null) {
                    isDeliveredAfterRefinement = false;
                }

                if (isDeliveredAfterRefinement && maxRefinementNo > 0) {
                    logData.log.forEach((item) => {
                        console.log(item);
                        if (
                            (item?.status?.status === 'DELIVERED' || item?.status?.status === 'ALL_DELIVERED') &&
                            item?.refinement_no === maxRefinementNo
                        ) {
                            //Using "?" because  type maybe upload or status
                            const currentDate = new Date(item.created_date);
                            if (
                                (largestDateItem.state === null && largestDateItem.date === null) ||
                                currentDate > largestDateItem.date
                            ) {
                                largestDateItem = {
                                    state: item.status.status,
                                    date: currentDate,
                                };
                            }
                        }
                    });
                } else {
                    logData.log.forEach((item) => {
                        console.log(item);
                        if (item?.status?.status === 'DELIVERED' || item?.status?.status === 'ALL_DELIVERED') {
                            //Using "?" because  type maybe upload or status
                            const currentDate = new Date(item.created_date);
                            if (
                                (largestDateItem.state === null && largestDateItem.date === null) ||
                                currentDate > largestDateItem.date
                            ) {
                                largestDateItem = {
                                    state: item.status.status,
                                    date: currentDate,
                                };
                            }
                        }
                    });
                }
                console.log(largestDateItem);
                this.setState({ deliveredOrAllDeliveredStatusBeforeRetrack: largestDateItem.state });
                this.setState({ currentStatus: _case.case_status });
            }
            if (
                _case.case_status === 'RETRACK_REPORT' &&
                _case.status_param1 !== null &&
                _case.status_param2 !== null
            ) {
                this.setState({ onlyRetrackProductionInProgress: true });
            }

            if (release_bleaching_retainer.distr_group) {
                const str = localStorage.getItem('doctor_dist_id');
                const doctorDistributorId = parseInt(str?.replace(/"/g, ''));
                const result =
                    release_bleaching_retainer.distr_group.find(
                        (item) => item.distr_group_id === doctorDistributorId && item.release_bleaching_retainer
                    ) != undefined;
                this.setState({ showBleachRetainerButtonByDistributor: result });
            }

            let isShowFinishingRetainer = null;
            if (caseData.case[0].case_status === 'ALL_DELIVERED') {
                isShowFinishingRetainer = await safeGet(`case/treatment_plan_new_product/${id}`);
                if (isShowFinishingRetainer.treatment_plan) {
                    this.setState({
                        isShowFinishingRetainer: isShowFinishingRetainer.treatment_plan.isShowFinishingRetainer,
                    });
                }
            }

            if (gallery) {
                this.setState({ draftFileList: gallery.draft_file_list });
                this.setState({ choseDraftFile: caseData.case?.[0]?.chosen_draft_file });
            }

            if (logData) {
                const { log } = logData;
                const retrackData = log.filter((log) => log.hasOwnProperty('case_retrack'));
                const finishingRetainerData = log.filter((log) => log.hasOwnProperty('case_finishing_retainer'));

                this.setState({ retrackDataArray: retrackData });
                this.setState({ finishingRetainerArray: finishingRetainerData });
            }

            const expiration_date = caseData.case?.[0]?.expiration_date;

            if (expiration_date) {
                const currentDate = new Date();
                const beforeOneMonthExpire = new Date(expiration_date);
                beforeOneMonthExpire.setMonth(beforeOneMonthExpire.getMonth() - 1);
                if (currentDate < new Date(expiration_date) && currentDate > beforeOneMonthExpire) {
                    this.setState({
                        CaseExpireModal: true,
                        CaseExpireText: false,
                    });
                } else if (currentDate > new Date(expiration_date)) {
                    this.setState({
                        CaseExpireModal: true,
                        CaseExpireText: true,
                    });
                }
            }

            this.setState({
                doctorName: [doc_first_name, doc_last_name].join(' '),
                clientCode: user_client_code,
                withinTreatmentPeriod: withinTreatmentPeriod,
                isOldCaseBeforeRetrackRefinementDemployment: isOldCaseBeforeRetrackRefinementDemployment,
                enableRetrack: enableRetrack === true || Number(enableRetrack) === 1,
            });

            this.setState({
                defectCurrentStatus: defectCurrentStatus,
            });
            let caseStatusOptions;
            if (_case.case_type === 'RETAINER') {
                caseStatusOptions = {
                    SUBMITTED: this.get('retainer_caseStatusLabel.SUBMITTED'),
                    AWAITING: this.get('retainer_caseStatusLabel.AWAITING'),
                    RECEIVED: this.get('retainer_caseStatusLabel.RECEIVED'),
                    CHANGE_REQUEST: this.get('retainer_caseStatusLabel.CHANGE_REQUEST'),
                    PLAN_UPLOADED: this.get('retainer_caseStatusLabel.PLAN_UPLOADED'),
                    PLAN_APPROVED: this.get('retainer_caseStatusLabel.PLAN_APPROVED'),
                    PRODUCTION: this.get('retainer_caseStatusLabel.PRODUCTION'),
                    DELIVERED: this.get('retainer_caseStatusLabel.DELIVERED'),
                    // this new msg will be added through handleRemarkParam1Param2 function
                    // DELIVERED_V2: this.get('retainer_caseStatusLabel.DELIVERED_V2'),
                    NEXT_SET_REQUEST: this.get('retainer_caseStatusLabel.NEXT_SET_REQUEST'),
                    ALL_DELIVERED: this.get('retainer_caseStatusLabel.ALL_DELIVERED'),
                    ALIGNER_REQUEST: this.get('retainer_caseStatusLabel.ALIGNER_REQUEST'),
                    RETAINER_REQUEST: this.get('retainer_caseStatusLabel.RETAINER_REQUEST'),
                    REFINEMENT: this.get('retainer_caseStatusLabel.REFINEMENT'),
                    ENDED: this.get('retainer_caseStatusLabel.ENDED'),
                };
            } else if (_case.case_type === CASE_TYPE.SELF_DESIGN) {
                caseStatusOptions = {
                    SUBMITTED: this.get('caseStatusLabel.SELF_DESIGN_SUBMITTED'),
                    AWAITING: this.get('caseStatusLabel.AWAITING'),
                    RECEIVED: this.get('caseStatusLabel.RECEIVED'),
                    CHANGE_REQUEST: this.get('caseStatusLabel.CHANGE_REQUEST'),
                    PLAN_UPLOADED: this.get('caseStatusLabel.PLAN_UPLOADED'),
                    PLAN_APPROVED: this.get('caseStatusLabel.PLAN_APPROVED'),
                    PRODUCTION: this.get('caseStatusLabel.PRODUCTION'),
                    DELIVERED: this.get('caseStatusLabel.SELF_DESIGN_DELIVERED'),
                    NEXT_SET_REQUEST: this.get('caseStatusLabel.NEXT_SET_REQUEST'),
                    ALL_DELIVERED: this.get('caseStatusLabel.ALL_DELIVERED'),
                    ALIGNER_REQUEST: this.get('caseStatusLabel.ALIGNER_REQUEST'),
                    RETAINER_REQUEST: this.get('caseStatusLabel.RETAINER_REQUEST'),
                    REFINEMENT: this.get('caseStatusLabel.REFINEMENT'),
                    ENDED: this.get('caseStatusLabel.ENDED'),
                    DEFECT_UPLOADED: this.get('caseStatusLabel.DEFECT_UPLOADED'),
                    DEFECT_RESPONDED: this.get('caseStatusLabel.DEFECT_RESPONDED'),
                    DEFECT_RESUBMIT: this.get('caseStatusLabel.DEFECT_RESUBMIT'),
                    RETRACK: this.get('caseStatusLabel.RETRACK'),
                    RETRACK_END: this.get('@global.caseStatus.RETRACK_END'),
                    RETRACK_REPORT: this.get('@global.caseStatus.RETRACK_REPORT'),
                    RETRACK_PRODUCTION_IN_PROGRESS: this.get('@global.caseStatus.RETRACK_PRODUCTION_IN_PROGRESS'),
                    RETRACK_CONTINUE: this.get('@global.caseStatus.RETRACK_CONTINUE'),
                    RETRACK_AWAITING: this.get('@global.caseStatus.RETRACK_AWAITING'),
                    RETRACK_ALL_MATERIAL_RECEIVED: this.get('@global.caseStatus.RETRACK_ALL_MATERIAL_RECEIVED'),
                    RESTORATION_TOOL_FORM_SUBMITTED: this.get(this.props.displayFirstFitFlag ? '@global.caseStatus.RESTORATION_TOOL_FORM_SUBMITTED_FIRSTFIT' : '@global.caseStatus.RESTORATION_TOOL_FORM_SUBMITTED'),
                    UPGRADE_REQUEST: this.get('@global.caseStatus.UPGRADE_REQUEST'),
                };
            } else {
                caseStatusOptions = {
                    SUBMITTED: this.get('caseStatusLabel.SUBMITTED'),
                    AWAITING: this.get('caseStatusLabel.AWAITING'),
                    RECEIVED: this.get('caseStatusLabel.RECEIVED'),
                    CHANGE_REQUEST: this.get('caseStatusLabel.CHANGE_REQUEST'),
                    PLAN_UPLOADED: this.get('caseStatusLabel.PLAN_UPLOADED'),
                    PLAN_APPROVED: this.get('caseStatusLabel.PLAN_APPROVED'),
                    PRODUCTION: this.get('caseStatusLabel.PRODUCTION'),
                    DELIVERED: this.get('caseStatusLabel.DELIVERED'),
                    NEXT_SET_REQUEST: this.get('caseStatusLabel.NEXT_SET_REQUEST'),
                    ALL_DELIVERED: this.get('caseStatusLabel.ALL_DELIVERED'),
                    ALIGNER_REQUEST: this.get('caseStatusLabel.ALIGNER_REQUEST'),
                    RETAINER_REQUEST: this.get('caseStatusLabel.RETAINER_REQUEST'),
                    REFINEMENT: this.get('caseStatusLabel.REFINEMENT'),
                    ENDED: this.get('caseStatusLabel.ENDED'),
                    DEFECT_UPLOADED: this.get('caseStatusLabel.DEFECT_UPLOADED'),
                    DEFECT_RESPONDED: this.get('caseStatusLabel.DEFECT_RESPONDED'),
                    DEFECT_RESUBMIT: this.get('caseStatusLabel.DEFECT_RESUBMIT'),
                    RETRACK: this.get('caseStatusLabel.RETRACK'),
                    RETRACK_END: this.get('@global.caseStatus.RETRACK_END'),
                    RETRACK_REPORT: this.get('@global.caseStatus.RETRACK_REPORT'),
                    RETRACK_PRODUCTION_IN_PROGRESS: this.get('@global.caseStatus.RETRACK_PRODUCTION_IN_PROGRESS'),
                    RETRACK_CONTINUE: this.get('@global.caseStatus.RETRACK_CONTINUE'),
                    RETRACK_AWAITING: this.get('@global.caseStatus.RETRACK_AWAITING'),
                    RETRACK_ALL_MATERIAL_RECEIVED: this.get('@global.caseStatus.RETRACK_ALL_MATERIAL_RECEIVED'),
                    RESTORATION_TOOL_FORM_SUBMITTED: this.get(this.props.displayFirstFitFlag ? '@global.caseStatus.RESTORATION_TOOL_FORM_SUBMITTED_FIRSTFIT' : '@global.caseStatus.RESTORATION_TOOL_FORM_SUBMITTED'),
                    UPGRADE_REQUEST: this.get('@global.caseStatus.UPGRADE_REQUEST'),
                };
            }

            let caseStatuText = this.handleRemarkParam1Param2(caseStatusOptions, _case);
            let patientInfoData = {
                // distr: distributor_info,
                gender: _case.gender === 'M' ? 'Male' : _case.gender === 'F' ? 'Female' : 'Other',
                id: _case.case_id,
                firstName: _case.first_name,
                lastName: _case.last_name,
                case_type: _case.case_type,
                product_name: _case.product_name === '' ? _case.default_product_name : _case.product_name,
                caseStatus: _case.case_status,
                delivery_address: ((deliveryAddressData && deliveryAddressData.address) || [])[0],
                caseStatusLabel: caseStatuText,
                drName: 'Business Analyst',
                drID: _case.case_impression.doctor_id,
                dateOfBirth: _case.date_of_birth,
                promotionCode: _case.promotion_code,
                refCode: _case.ref_code,
                remarks: _case.remarks ? _case.remarks : this.get(':const.non'),
                internalRemarks: _case.internal_remarks,
                dr_remark: _case.dr_remark,
                case_file: _case.case_file,
                created_by: _case.created_by,
                case_detail: _case.case_detail,
                distrName: _case.distr_name,
                country_name: _case.country_name,
                approvalDate: !_case.approval_date ? 'N/A' : Moment(_case.approval_date).format('DD-MMM-YYYY'),
                treatmentEndDate: !expiration_date ? 'N/A' : Moment(expiration_date).format('DD-MMM-YYYY'),
                case_defect: _case.case_defect,
                new_case_option: _case.new_case_option,
                case_impression: _case.case_impression,
                treatment_plan: treatmentPlanData && treatmentPlanData.treatment_plan,
                image: _case.profile_pic
                    ? join(ApiServerUrl, _case.profile_pic)
                    : _case.gender === 'M'
                      ? getWebAbsPath('/img/front_smile.png')
                      : _case.gender === 'F'
                        ? getWebAbsPath('/img/front_smile_female.png')
                        : getWebAbsPath('/img/front_smile_other.png'),
                ray_info: _case.ray_info,
                ray_draft_changed: _case.ray_draft_changed,
                patientId: _case.patient_id,
                case_smile_design: _case?.case_smile_design || null,
                retrack_quota_total,
                retrack_quota_remaining,
                retrack_steps,
                refinement_quota_total,
                refinement_quota_remaining,
                refinement_steps,
                refinement_expiration_date: refinement_expiration_date
                    ? moment(refinement_expiration_date).format('DD-MMM-YYYY')
                    : 'N/A',
                package_version: _case.package_version,
            };

            console.log('treatmentPlan: ', treatmentPlanData);

            this.setState({ numberOfTreatmentPlan: treatmentPlanData && treatmentPlanData.treatment_plan[0].length });

            if (this.state.role === 'DR') {
                if (
                    patientInfoData.patientId != undefined &&
                    patientInfoData.patientId != null &&
                    !['RETAINER'].includes(patientInfoData.case_type)
                ) {
                    this.getIsDisableCreateNewCaseForPatient(patientInfoData.patientId);
                }
            }

            if (logData) {
                const { log: logs } = logData;
                let translatedLogs = [];
                try {
                    translatedLogs = Log.translateLogs.bind(this)(
                        logs,
                        _case.case_type,
                        true,
                        true,
                        false,
                        Object.fromEntries(
                            Object.entries(MOCKUP_ORDER_OPTION_LABELS).map(([value, translationKey]) => [
                                value,
                                this.get(translationKey),
                            ])
                        ),
                        this.props.displayFirstFitFlag
                    );
                } catch (err) {
                    console.error(err);
                } finally {
                    this.setState({ logs: translatedLogs });
                }
                if (logs.some((log) => log.status?.status === 'RESTORATION_TOOL_FORM_SUBMITTED')) {
                    this.loadRestorativeMockupOrderStatus();
                }
            }
            if (_case?.retainer_request && _case?.retainer_request?.retainer_request_id) {
                this.setState({ retainerRequestData: _case?.retainer_request });
            }
            if (_case?.case_type) {
                this.setState({ caseType: _case?.case_type });
            }
            this.setState({
                patientInfo: patientInfoData,
                currentStatus: patientInfoData && patientInfoData.caseStatus,
                latestTreatmentPlan: this.latestTreatmentPlan(treatmentPlanData && treatmentPlanData.treatment_plan[0]),
                treatmentPlanData,
            });

            if (_case?.created_date) {
                this.setState({ caseCreatedDate: _case?.created_date });
            }

            this._case = _case;
            console.log(_case);

            this.props.setCaseType(patientInfoData.case_type);

            if (['SADMIN', 'ADMIN', 'DISTR'].includes(this.state.role)) {
                // non blocking
                safeGet(`user/distr/${_case.created_by}`).then(({ distr, success }) => {
                    if (success) {
                        this.setState(({ patientInfo }) => ({
                            patientInfo: {
                                ...patientInfo,
                                distr: distr?.map(({ email, phone }) => ({ email, phone })) ?? [],
                            },
                        }));
                    }
                });
            }
            let bool = false;
            if (
                this.props.diffRetainer.enableOrderDifferentRetainer !== undefined &&
                this.props.diffRetainer.enableOrderDifferentRetainer !== null
            ) {
                bool = this.props.diffRetainer.enableOrderDifferentRetainer;
            }
            this.setState({ enableOrderDifferentRetainer: bool });
            let caseImpressionId = null;
            if (patientInfoData?.case_impression) {
                const caseImpressions = patientInfoData.case_impression;
                const firstImpressionArray = caseImpressions[0];
                if (firstImpressionArray) {
                    const firstImpression = firstImpressionArray[0];
                    if (firstImpression) {
                        caseImpressionId = firstImpression.case_impression_id ?? null;
                    }
                }
            }
            this.setState({ caseImpressionId });
            return true;
        } catch (err) {
            console.error(err);
            this.props.showSnackbar('Access denied / Cannot retrieve this case');
            return false;
        }
    }

    async handleInstantUpdate(url, msg) {
        if (window.confirm(msg)) {
            try {
                let { data } = await axios.post(url);
                if (data.success) {
                    this.reloadPage();
                } else {
                    window.alert(data.message);
                }
            } catch (error) {
                window.alert(error);
            }
        }
    }

    invert(image_id, invert) {
        this.props.handleInvertImage(image_id, invert);
    }
    handleRoatate(image_id, degree) {
        this.props.handleRoatateImage(image_id, degree);
    }

    async handleRollbackUpdate(url, msg) {
        const userInput = window.prompt(msg);

        if (userInput !== null) {
            // Check if the user pressed 'Cancel'
            this.props.tracelog(
                PLATFORM,
                MODULE,
                ACTION,
                JSON.parse(`{ "Reason": "${userInput}"}`),
                `${this.state.patientInfo.id}`
            );
            try {
                let { data } = await axios.post(url);

                if (data.success) {
                    this.reloadPage();
                } else {
                    window.alert(data.message);
                }
            } catch (error) {
                console.error('Error:', error);
            }
        }
    }

    handleUpload(image_id, file) {
        NewPatientHandleUpload(image_id, file, this.props.handleDataFileUpload);

        this.checkInvalid();

        this.forceUpdate();
    }

    async handleRadioDataSave() {
        const form = new FormData();
        let newRadioUpload = {};

        this.props.files
            .filter((v) => {
                return v.category === 'radio';
            })
            .forEach((radio, index) => {
                const fileName = `$$FILE:radio${index}`;
                newRadioUpload['radio' + index] = radio.data
                    ? /^dbx::/.test(radio.data)
                        ? radio.data
                        : fileName
                    : null;
                newRadioUpload['radio' + index + '_later'] = radio.upload_later;
                if (radio.data) {
                    form.append(fileName, radio.data);
                }
            });

        newRadioUpload['case_id'] = this.state.caseId;

        form.append('body', JSON.stringify(newRadioUpload));

        try {
            this.setState({ PhotoUploadLoadingStatus: true, loading: true });
            if (Object.keys(newRadioUpload).length) {
                await axios.post(`case/file/${this.state.caseId}`, form, {
                    onUploadProgress: this.progressBarRef.current?.onProgressChange,
                });
                await this.props.showSnackbar('Radiographs uploaded', 'success', true);
                this.reloadPage();
            }
        } catch (err) {
            const errMsg = this.getErrorMsg(err, 'All Images are required');
            this.setState({ modalError: errMsg });
            console.error(err.response);
        } finally {
            this.setState({ PhotoUploadLoadingStatus: false, loading: false });
        }
    }

    async getImpressionData() {
        const form = new FormData();
        let newImpressionUpload = {};

        this.props.files
            .filter((v) => {
                return v.category === 'stl_file';
            })
            .forEach(async (v, index) => {
                const fileName = '$$FILE:stl_file' + index;
                newImpressionUpload['stl_file' + index] = v.data ? fileName : null;
                if (v.data) {
                    form.append(fileName, v.data);
                }
                if (v?.upload_later) {
                    newImpressionUpload['stl_files_later'] = true;
                }
            });
        // newImpressionUpload['stl_files_later'] = caseImpressionRadio?.[0]?.['upload_later']

        newImpressionUpload['case_id'] = this.state.caseId;
        newImpressionUpload['modern_code'] = this.props.newPatientData.modernCode;
        newImpressionUpload['waybill_number'] = this.props.newPatientData.waybillNumber;
        newImpressionUpload['courier_company'] = this.props.newPatientData.courierCompany;
        newImpressionUpload['scanner_brand'] = this.props.newPatientData.scannerBrand;
        newImpressionUpload['doctor_id'] = this.props.newPatientData.doctorId;
        newImpressionUpload['type'] = this.props.newPatientData.impressionType;

        return [form, newImpressionUpload];
    }

    async handleImpressionDataSave() {
        let [form, newImpressionUpload] = await this.getImpressionData();

        form.append('body', JSON.stringify(newImpressionUpload));

        try {
            this.setState({ PhotoUploadLoadingStatus: true, loading: true });
            await axios.post(`case/impression/${this.state.caseId}`, form, {
                onUploadProgress: this.progressBarRef.current?.onProgressChange,
            });
            await this.props.showSnackbar('Impression uploaded', 'success', true);
            this.reloadPage();
        } catch (err) {
            const errMsg = this.getErrorMsg(err, 'Something went wrong , Please connect with admin');
            this.setState({ modalError: errMsg });
            console.error(err.response);
        } finally {
            this.setState({ PhotoUploadLoadingStatus: false, loading: false });
        }
    }
    handleFinishingRetainerMessageStep1(value) {
        //close dialog then pop up step2
        this.setState({ RequestFinishingRetainerStep2Modal: true });
        this.setState({ RequestFinishingRetainerStep1Modal: false });
    }

    async handleChangeStatusUpdate(value) {
        try {
            this.setState({ loading: true });
            await axios.post(`case/status/${this.state.caseId}/${value}`, {
                caseId: this.state.caseId,
                param1: this.state.param1,
                param2: this.state.param2,
                newStatus: value,
                remarks: null,
            });
            await this.props.showSnackbar('Case status updated', 'success', true);
            this.reloadPage();
        } catch (err) {
            if (err.response.data.message) {
                const errMsg = this.getErrorMsg(err, err.response.data.message);
                await this.props.showSnackbar(errMsg, 'error', true);
            } else {
                await this.props.showSnackbar('Could Not update the status', 'error', true);
            }
        }
    }

    async handleArchiveCaseUpdate() {
        try {
            this.setState({ loading: true });
            if (this.state.archivedFlag) {
                await axios.post(`case/${this.state.caseId}/archived/undo`);
            } else {
                await axios.post(`case/${this.state.caseId}/archived`);
            }
            await this.props.showSnackbar('Case archive status updated', 'success', true);
            this.reloadPage();
        } catch (err) {
            if (err?.response?.data?.message) {
                const errMsg = this.getErrorMsg(err, err.response.data.message);
                await this.props.showSnackbar(errMsg, 'error', true);
            } else {
                await this.props.showSnackbar('Could Not update the archive status', 'error', true);
            }
            console.error(err.response);
            this.reloadPage();
        } finally {
            this.setState({ loading: false });
        }
    }

    async handleArchiveCaseUpdate() {
        try {
            this.setState({ loading: true });
            if (this.state.archivedFlag) {
                await axios.post(`case/${this.state.caseId}/archived/undo`);
            } else {
                await axios.post(`case/${this.state.caseId}/archived`);
            }
            await this.props.showSnackbar('Case archive status updated', 'success', true);
            this.reloadPage();
        } catch (err) {
            if (err?.response?.data?.message) {
                const errMsg = this.getErrorMsg(err, err.response.data.message);
                await this.props.showSnackbar(errMsg, 'error', true);
            } else {
                await this.props.showSnackbar('Could Not update the archive status', 'error', true);
            }
            console.error(err.response);
            this.reloadPage();
        } finally {
            this.setState({ loading: false });
        }
    }

    async handleEnterDefectResubmit() {
        window.location.href = `/patients/${this.state.caseId}/defect_resubmit`;
        // return <Link to={`/patients/${this.state.caseId}/defect_resubmit`}></Link>
    }

    async handleAlignerSave() {
        this.setState({ loading: true });
        if (this.state.aligner.some((a) => !a.step_no || !a.arch)) {
            await this.props.showSnackbar('Please fill in missing data', 'error');
            this.setState({ loading: false });
            return;
        }
        let alignerObj = {
            case_id: this.state.caseId,
            type: 'REQUEST',
            detail: this.state.aligner,
        };
        try {
            this.setState({ PhotoUploadLoadingStatus: true });
            await axios.post(`case/aligner_request/${this.state.caseId}`, alignerObj);
            await this.props.showSnackbar('Aligner Request sent', 'success', true);
            this.reloadPage();
        } catch (err) {
            const errMsg = this.getErrorMsg(err, 'Could Not Update , Please try again later');
            this.setState({ modalError: errMsg });
            console.error(err.response);
        } finally {
            this.setState({ PhotoUploadLoadingStatus: false, loading: false });
        }
    }

    async handleTreatmentSave() {
        const form = new FormData();
        let treatmentData = {
            case_id: this.state.caseId,
            pdf0: this.state.treatmentPlan.pdf1 ? '$$FILE:pdf0' : null,
            pdf0_name: this.state.treatmentPlan.pdf1_label,
            pdf1: this.state.treatmentPlan.pdf2 ? '$$FILE:pdf1' : null,
            pdf1_name: this.state.treatmentPlan.pdf2_label,
            video0: this.state.treatmentPlan.video1 ? '$$FILE:video0' : null,
            video0_name: this.state.treatmentPlan.video1_label,
            video1: this.state.treatmentPlan.video2 ? '$$FILE:video1' : null,
            video1_name: this.state.treatmentPlan.video2_label,
            upper_cycle: this.state.treatmentPlan.upper_cycle ? this.state.treatmentPlan.upper_cycle : null,
            lower_cycle: this.state.treatmentPlan.lower_cycle ? this.state.treatmentPlan.lower_cycle : null,
            new_product: this.state.treatmentPlan.new_product ? this.state.treatmentPlan.new_product : null,
            url: this.state.treatmentPlan.smile_3d,
            myo_oid: this.state.treatmentPlan.myo_oid,
            myo_pid: this.state.treatmentPlan.myo_pid,
            myo_id: this.state.treatmentPlan.myo_id,
            myo_token: this.state.treatmentPlan.myo_token,

            smileDesignPPT: this.state.treatmentPlan.smileDesignPPT ? '$$FILE:smileReport' : null,
            smileDesignPPT_name: this.state.treatmentPlan.smileDesignPPT_label,
            smileDesign_exocad_pre: this.state.treatmentPlan.smileDesign_exocad_pre
                ? '$$FILE:smileDesign_exocad_pre'
                : null,
            smileDesign_exocad_pre_name: this.state.treatmentPlan.smileDesign_exocad_pre_label,

            created_by: this.state.patientInfo.created_by,
            finished_flag: true,
        };
        let isFileUploaded = false;
        if (this.state.treatmentPlan.pdf1) {
            form.append('$$FILE:pdf0', this.state.treatmentPlan.pdf1);
            isFileUploaded = true;
        }
        if (this.state.treatmentPlan.pdf2) {
            form.append('$$FILE:pdf1', this.state.treatmentPlan.pdf2);
            isFileUploaded = true;
        }

        if (this.state.treatmentPlan.video1) {
            form.append('$$FILE:video0', this.state.treatmentPlan.video1);
            isFileUploaded = true;
        }
        if (this.state.treatmentPlan.video2) {
            form.append('$$FILE:video1', this.state.treatmentPlan.video2);
            isFileUploaded = true;
        }
        if (this.state.treatmentPlan.smile_3d && this.state.treatmentPlan.smile_3d != '~pending upload~') {
            //if smile 3d have value
            isFileUploaded = true;
        }

        switch (this.state.patientInfo.case_type) {
            case smileDesignProductList.full.type: {
                if (
                    // Purpose: validation
                    this.state.treatmentPlan.smileDesignPPT &&
                    this.state.treatmentPlan.smileDesign_exocad_pre
                ) {
                    form.append('$$FILE:smileReport', this.state.treatmentPlan.smileDesignPPT);
                    form.append('$$FILE:smileDesign_exocad_pre', this.state.treatmentPlan.smileDesign_exocad_pre);
                    isFileUploaded = true;
                    break;
                }
                break;
            }
            case smileDesignProductList.simple.type: {
                if (
                    // Purpose: validation
                    this.state.treatmentPlan.smileDesign_exocad_pre
                ) {
                    form.append('$$FILE:smileReport', this.state.treatmentPlan.smileDesignPPT);
                    form.append('$$FILE:smileDesign_exocad_pre', this.state.treatmentPlan.smileDesign_exocad_pre);
                    isFileUploaded = true;
                    break;
                }
                break;
            }
            // 处理需要上传 Exocad 或 ISD Report 的 upsell 类型
            default:
                // 校验 upsell 场景下实际上传的 ISD 文件，避免误判为没有上传文件
                let exocadUploaded = false;
                let smilePPTUploaded = false;
                if (this.state.upsellOperationData.allowUploadExocad) {
                    if (this.state.treatmentPlan.smileDesign_exocad_pre) {
                        form.append('$$FILE:smileDesign_exocad_pre', this.state.treatmentPlan.smileDesign_exocad_pre);
                        exocadUploaded = true;
                        // Q14 仅需上传 Exocad 文件
                        if (this._case?.upsell_type === UPSELL_TYPE.PRE_ALIGNMENT_FIRST_Q14 && exocadUploaded) {
                            isFileUploaded = true;
                            break;
                        }
                    }
                }
                if (this.state.upsellOperationData.allowUploadSmilePPT) {
                    if (this.state.treatmentPlan.smileDesignPPT) {
                        form.append('$$FILE:smileReport', this.state.treatmentPlan.smileDesignPPT);
                        smilePPTUploaded = true;
                    }
                }
                isFileUploaded = exocadUploaded && smilePPTUploaded;
                break;
        }

        if (!isFileUploaded) {
            alert('The URL is not valid or does not upload the file, please check and save again.');
            return;
        }

        form.append('body', JSON.stringify(treatmentData));
        // Debug
        // console.log("form: ", Object.fromEntries(form.entries()));

        try {
            this.setState({ PhotoUploadLoadingStatus: true, loading: true });
            const latestTreatmentPlan = this.state.latestTreatmentPlan;
            const allowUploadSmileDesign =
                smileDesignProductListArray.includes(this.state.patientInfo.case_type) ||
                this.state.upsellOperationData.allowUploadExocad;

            if (
                allowUploadSmileDesign &&
                latestTreatmentPlan?.smileDesign_exocad_pre === null &&
                latestTreatmentPlan?.url
            ) {
                console.log('update this treatmentplan not insert');
                await axios.post(
                    `case/treatment_plan/uploadWhenSmileDesign/${latestTreatmentPlan.case_id}/${latestTreatmentPlan.plan_id}`,
                    form,
                    {
                        onUploadProgress: this.progressBarRef.current?.onProgressChange,
                    }
                );
            } else {
                await axios.post(`case/treatment_plan/${this.state.caseId}`, form, {
                    onUploadProgress: this.progressBarRef.current?.onProgressChange,
                });
            }
            await this.props.showSnackbar('Treatment plan uploaded', 'success', true);
            this.reloadPage();
        } catch (err) {
            const errMsg = this.getErrorMsg(
                err,
                'Something went Wrong. Please make sure you raised a treatment plan change request. If the problem happen again, please connect with admin'
            );
            this.setState({ modalError: errMsg });
            console.error(err.response);
        } finally {
            this.setState({ PhotoUploadLoadingStatus: false, loading: false });
        }
    }
    async handleInfoSave() {
        try {
            this.setState({ loading: true });
            const form = new FormData();
            let profilePic = this.props.newPatientData.patientPhoto.data;
            if (this.props.newPatientData.patientPhoto.data) {
                if (typeof this.props.newPatientData.patientPhoto.data === 'object') {
                    profilePic = '$$FILE:profile_pic';
                } else if (this.props.newPatientData.patientPhoto.data.startsWith('/')) {
                    profilePic = null;
                }
            } else {
                profilePic = null;
            }
            const json = {
                gender: this.props.newPatientData.gender,
                first_name: this.props.newPatientData.firstName,
                last_name: this.props.newPatientData.lastName,
                date_of_birth: `${this.props.newPatientData.day}-${this.props.newPatientData.month}-${this.props.newPatientData.year}`,
                profile_pic: {
                    data: profilePic,
                    rotate: this.props.newPatientData.patientPhoto.rotate,
                },
                ref_code: this.props.newPatientData.refCode,
                remarks: this.props.newPatientData.remarks,
                internal_remarks: this.props.newPatientData.internalRemarks,
                dr_remark: this.props.newPatientData.dr_remark,
            };
            if (
                this.props.newPatientData.patientPhoto.data &&
                typeof this.props.newPatientData.patientPhoto.data === 'object'
            ) {
                form.append('$$FILE:profile_pic', this.props.newPatientData.patientPhoto.data);
            }
            form.append('body', JSON.stringify(json));
            await axios.post(`case/info/${this.state.caseId}`, form, {
                onUploadProgress: this.progressBarRef.current?.onProgressChange,
            });
            await this.props.showSnackbar('Patient info updated', 'success', true);
            this.reloadPage();
        } catch (err) {
            this.setState({ modalError: 'Something Went Wrong Please Connect With Admin' });
            console.error(err.response ?? err);
        } finally {
            this.setState({ loading: false });
        }
    }

    async handleTreatmentData(data = null, stateType, fileName) {
        let newtreatmentPlan = { ...this.state.treatmentPlan };
        switch (stateType) {
            case 'pdf1':
                newtreatmentPlan.pdf1 = data;
                newtreatmentPlan.pdf1_label = fileName;
                break;
            case 'pdf2':
                newtreatmentPlan.pdf2 = data;
                newtreatmentPlan.pdf2_label = fileName;
                break;
            case 'video1':
                newtreatmentPlan.video1 = data;
                newtreatmentPlan.video1_label = fileName;
                break;
            case 'video2':
                newtreatmentPlan.video2 = data;
                newtreatmentPlan.video2_label = fileName;
                break;
            case 'smile_3d':
                newtreatmentPlan.smile_3d = data;
                break;
            case 'treatment_approval':
                newtreatmentPlan.treatment_approval = data;
                break;
            case 'upper_cycle':
                newtreatmentPlan.upper_cycle = data;
                break;
            case 'lower_cycle':
                newtreatmentPlan.lower_cycle = data;
                break;
            case 'new_product':
                newtreatmentPlan.new_product = data;
                break;
            case 'smileDesignPPT':
                newtreatmentPlan.smileDesignPPT = data;
                newtreatmentPlan.smileDesignPPT_label = fileName;
                break;
            case 'smileDesign_exocad_pre':
                newtreatmentPlan.smileDesign_exocad_pre = data;
                newtreatmentPlan.smileDesign_exocad_pre_label = fileName;
                break;
        }
        this.setState({ treatmentPlan: newtreatmentPlan });
    }

    handleRetrackReport = (data = null, stateType, fileName = '') => {
        const myData = {
            retrack0: data,
            retrack0_name: fileName,
        };
        this.setState({
            retrackReport: myData,
        });
    };

    async handleRequestRetainerSave() {
        let [form, impressionData] = await this.getImpressionData();

        form.append(
            'body',
            JSON.stringify({
                case_impression: impressionData,
                quantity: this.state.requestRetainerQuantity,
            })
        );

        try {
            this.setState({ PhotoUploadLoadingStatus: true, loading: true });
            await axios.post(`case/retainer/${this.state.caseId}`, form, {
                onUploadProgress: this.progressBarRef.current?.onProgressChange,
            });
            await this.props.showSnackbar('Retainer request sent', 'success', true);
            this.reloadPage();
        } catch (err) {
            this.setState({ modalError: 'Something went wrong , Please connect with admin' });
            console.error(err.response);
        } finally {
            this.setState({ PhotoUploadLoadingStatus: false, loading: false });
        }
    }

    async handleQuestionnaireSave() {
        let newPatientData = { ...this.props.newPatientData };
        let ModifiedName = {
            extraction: 'attr0',
            expansion: 'attr1',
            interproximalReduction: 'attr2',
            distalization: 'attr3',
            proclination: 'attr4',
            treatmentSimulation: 'attr5',
            overJet: 'attr6',
            overBite: 'attr7',
            midLine: 'attr8',
            crossBite: 'attr9',
            comment: 'attr12',
            clinicalConditionComment: 'clinical_cond_comment',
        };

        let questionnaire_teeth_array_filtered = newPatientData.teeth
            .map((value, index) => {
                if (value.checked) {
                    return index;
                }
                return null;
            })
            .filter(function (el) {
                return el != null;
            });

        let newQuestionnaireObj = {};

        newQuestionnaireObj['case_id'] = this.state.caseId;
        newQuestionnaireObj['excluded_dentition'] = questionnaire_teeth_array_filtered + '';
        newQuestionnaireObj['clinical_cond'] = newPatientData['clinical_cond'];

        Object.keys(ModifiedName).forEach((key) => {
            if (ModifiedName[key] === 'attr8') {
                newQuestionnaireObj[ModifiedName[key]] = JSON.stringify(newPatientData[key]);
            } else {
                newQuestionnaireObj[ModifiedName[key]] = newPatientData[key];
            }
        });

        this.setState({ PhotoUploadLoadingStatus: true });
        try {
            await axios.post(`case/detail/${this.state.caseId}`, newQuestionnaireObj);
            await this.props.showSnackbar('Questionnaire updated', 'success', true);
            this.reloadPage();
        } catch (err) {
            this.setState({ modalError: 'Something went wrong , Please connect with admin' });
            console.error(err.response);
        }
        this.setState({ PhotoUploadLoadingStatus: false });
    }

    async handlePrescriptionNotesSave() {
        let newPatientData = { ...this.props.newPatientData };
        const { attachments1, spacingAndCrowding1, openbite1, deepBite1, midline1, posteriorCrossbite1, auxiliaries1 } =
            this.props.newPatientData;

        const {
            condition1,
            condition3,
            condition4,
            condition5,
            condition6,
            condition7,
            condition8,
            condition9,
            condition10,
            condition11,
            condition12,
            condition13,
            condition14,
            condition16,
            condition17,
        } = alignerPrescriptionFormValidation({
            attachments: attachments1,
            spacingAndCrowding: spacingAndCrowding1,
            openbite: openbite1,
            deepBite: deepBite1,
            midline: midline1,
            posteriorCrossbite: posteriorCrossbite1,
            auxiliaries: auxiliaries1,
        });

        if (condition1) {
            this.props.handlePrescriptionErrorQuestion(1);
            this.props.handlePrescriptionErrorScrollId('Q3');
        } //else if (condition2) {
        //this.props.handlePrescriptionErrorQuestion(2);
        //this.props.handlePrescriptionErrorScrollId('Q3');
        //}
        else if (condition3) {
            this.props.handlePrescriptionErrorQuestion(3);
            this.props.handlePrescriptionErrorScrollId('Q3');
        } else if (condition4) {
            this.props.handlePrescriptionErrorQuestion(4);
            this.props.handlePrescriptionErrorScrollId('Q6');
        } else if (condition5) {
            this.props.handlePrescriptionErrorQuestion(5);
            this.props.handlePrescriptionErrorScrollId('Q8');
        } else if (condition6) {
            this.props.handlePrescriptionErrorQuestion(6);
            this.props.handlePrescriptionErrorScrollId('Q8');
        } else if (condition7) {
            this.props.handlePrescriptionErrorQuestion(7);
            this.props.handlePrescriptionErrorScrollId('Q8');
        } else if (condition9) {
            this.props.handlePrescriptionErrorQuestion(9);
            this.props.handlePrescriptionErrorScrollId('Q9');
        } else if (condition8) {
            this.props.handlePrescriptionErrorQuestion(8);
            this.props.handlePrescriptionErrorScrollId('Q9');
        } else if (condition10) {
            this.props.handlePrescriptionErrorQuestion(10);
            this.props.handlePrescriptionErrorScrollId('Q9');
        } else if (condition12) {
            this.props.handlePrescriptionErrorQuestion(12);
            this.props.handlePrescriptionErrorScrollId('Q10');
        } else if (condition11) {
            this.props.handlePrescriptionErrorQuestion(11);
            this.props.handlePrescriptionErrorScrollId('Q10');
        } else if (condition16) {
            this.props.handlePrescriptionErrorQuestion(16);
            this.props.handlePrescriptionErrorScrollId('Q11');
        } else if (condition13) {
            this.props.handlePrescriptionErrorQuestion(13);
            this.props.handlePrescriptionErrorScrollId('Q11');
        } else if (condition17) {
            this.props.handlePrescriptionErrorQuestion(17);
            this.props.handlePrescriptionErrorScrollId('Q11');
        } else if (condition14) {
            this.props.handlePrescriptionErrorQuestion(14);
            this.props.handlePrescriptionErrorScrollId('Q12');
        }

        if (condition1) {
            this.props.handlePrescriptionError(getFromObj(this.props.lang, 'dict.NewPatient.warning.tooth'));
            this.setState({ presDialogOpen: true });
            return;
        } else if (condition3) {
            this.props.handlePrescriptionError(getFromObj(this.props.lang, 'dict.NewPatient.warning.value'));
            this.setState({ presDialogOpen: true });
            return;
        } else if (condition4) {
            this.props.handlePrescriptionError(
                getFromObj(this.props.lang, 'dict.NewPatient.warning.locationOfTheSpace')
            );
            this.setState({ presDialogOpen: true });
            return;
        } else if (condition5 || condition6 || condition8 || condition9 || condition13 || condition16) {
            this.props.handlePrescriptionError(getFromObj(this.props.lang, 'dict.NewPatient.warning.checkbox'));
            this.setState({ presDialogOpen: true });
            return;
        } else if (condition7 || condition10) {
            this.props.handlePrescriptionError(getFromObj(this.props.lang, 'dict.NewPatient.warning.specifyArea'));
            this.setState({ presDialogOpen: true });
            return;
        } else if (condition11 || condition12) {
            this.props.handlePrescriptionError(getFromObj(this.props.lang, 'dict.NewPatient.warning.option'));
            this.setState({ presDialogOpen: true });
            return;
        } else if (condition14 || condition17) {
            this.props.handlePrescriptionError(
                getFromObj(this.props.lang, 'dict.NewPatient.prescriptionNotes.otherElasticsHintText')
            );
            this.setState({ presDialogOpen: true });
            return;
        }

        let newPrescriptionNotesObj = {};
        let extrudeIntrudePlace = [],
            extrudeAnteriorTeeth = [],
            intrudePosteriorTeeth = [];
        let intrudeExtrudePlace = [],
            intrudeAnteriorTeeth = [],
            extrudePosteriorTeeth = [];
        let upperLowerChecked = [];
        let buttonPressedDirectlyOnAlignerSubValue = [],
            cutoutToBondButtonDirectlyOnTeethSubValue = [];
        let auxiliaries1SubValue = [];

        newPrescriptionNotesObj['case_id'] = this.state.caseId;
        // Arch to treat
        newPrescriptionNotesObj['attr0'] =
            typeof newPatientData === 'object' ? JSON.stringify(newPatientData.archToTreat).replace(/\"/g, '') : 'both';
        // Not To Treat
        newPrescriptionNotesObj['new_excluded_dentition'] = JSON.parse(
            JSON.stringify(newPatientData.notToTreat1.sort())
        ).toString();
        // Attachments
        newPrescriptionNotesObj['attr1'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.attachments1.value).replace(/\"/g, '')
                : 'placeAttachmentsAsNeeded';
        newPrescriptionNotesObj['attr2'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.attachments1.delay.value).replace(/\"/g, '')
                : 'delayToStage';
        newPrescriptionNotesObj['attr63'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.attachments1.delay.stage).replace(/\"/g, '')
                : '';
        newPrescriptionNotesObj['new_excluded_attachments'] = JSON.parse(
            JSON.stringify(newPatientData.attachments1.doNotPlace.sort())
        ).toString();
        newPrescriptionNotesObj['new_included_attachments'] = JSON.parse(
            JSON.stringify(newPatientData.attachments1.place.sort())
        ).toString();
        // Aligners margin placement
        newPrescriptionNotesObj['attr3'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.alignersMarginPlacement1).replace(/\"/g, '')
                : 'coverageExtending';
        // Anterior-Posterior (A-P) Relationship
        newPrescriptionNotesObj['attr4'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.anteriorPosteriorRelationship1.r).replace(/\"/g, '')
                : 'maintain';
        newPrescriptionNotesObj['attr5'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.anteriorPosteriorRelationship1.l).replace(/\"/g, '')
                : 'maintain';
        // Spacing & Crowding
        newPrescriptionNotesObj['attr6'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.spacingAndCrowding1.spacing.value).replace(/\"/g, '')
                : 'closeAllSpaces';
        newPrescriptionNotesObj['attr64'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.spacingAndCrowding1.spacing.location).replace(/\"/g, '')
                : '';
        newPrescriptionNotesObj['attr7'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.spacingAndCrowding1.crowding.resolveUpper.expand.value).replace(
                      /\"/g,
                      ''
                  )
                : 'asNeeded';
        newPrescriptionNotesObj['attr48'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.spacingAndCrowding1.crowding.resolveUpper.expand.teeth).replace(
                      /\"/g,
                      ''
                  )
                : '';
        newPrescriptionNotesObj['attr8'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.spacingAndCrowding1.crowding.resolveUpper.procline.value).replace(
                      /\"/g,
                      ''
                  )
                : 'asNeeded';
        newPrescriptionNotesObj['attr49'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.spacingAndCrowding1.crowding.resolveUpper.procline.teeth).replace(
                      /\"/g,
                      ''
                  )
                : '';
        newPrescriptionNotesObj['attr9'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.spacingAndCrowding1.crowding.resolveUpper.IPRAnterior.value).replace(
                      /\"/g,
                      ''
                  )
                : 'asNeeded';
        newPrescriptionNotesObj['attr50'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.spacingAndCrowding1.crowding.resolveUpper.IPRAnterior.teeth).replace(
                      /\"/g,
                      ''
                  )
                : '';
        newPrescriptionNotesObj['attr10'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(
                      newPatientData.spacingAndCrowding1.crowding.resolveUpper.IPRPosteriorRight.value
                  ).replace(/\"/g, '')
                : 'asNeeded';
        newPrescriptionNotesObj['attr51'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(
                      newPatientData.spacingAndCrowding1.crowding.resolveUpper.IPRPosteriorRight.teeth
                  ).replace(/\"/g, '')
                : '';
        newPrescriptionNotesObj['attr11'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(
                      newPatientData.spacingAndCrowding1.crowding.resolveUpper.IPRPosteriorLeft.value
                  ).replace(/\"/g, '')
                : 'asNeeded';
        newPrescriptionNotesObj['attr52'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(
                      newPatientData.spacingAndCrowding1.crowding.resolveUpper.IPRPosteriorLeft.teeth
                  ).replace(/\"/g, '')
                : '';
        newPrescriptionNotesObj['attr12'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.spacingAndCrowding1.crowding.resolveUpper.extraction.value).replace(
                      /\"/g,
                      ''
                  )
                : 'asNeeded';
        newPrescriptionNotesObj['attr53'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.spacingAndCrowding1.crowding.resolveUpper.extraction.teeth).replace(
                      /\"/g,
                      ''
                  )
                : '';
        newPrescriptionNotesObj['attr13'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.spacingAndCrowding1.crowding.resolveLower.expand.value).replace(
                      /\"/g,
                      ''
                  )
                : 'asNeeded';
        newPrescriptionNotesObj['attr54'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.spacingAndCrowding1.crowding.resolveLower.expand.teeth).replace(
                      /\"/g,
                      ''
                  )
                : '';
        newPrescriptionNotesObj['attr14'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.spacingAndCrowding1.crowding.resolveLower.procline.value).replace(
                      /\"/g,
                      ''
                  )
                : 'asNeeded';
        newPrescriptionNotesObj['attr55'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.spacingAndCrowding1.crowding.resolveLower.procline.teeth).replace(
                      /\"/g,
                      ''
                  )
                : '';
        newPrescriptionNotesObj['attr15'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.spacingAndCrowding1.crowding.resolveLower.IPRAnterior.value).replace(
                      /\"/g,
                      ''
                  )
                : 'asNeeded';
        newPrescriptionNotesObj['attr56'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.spacingAndCrowding1.crowding.resolveLower.IPRAnterior.teeth).replace(
                      /\"/g,
                      ''
                  )
                : '';
        newPrescriptionNotesObj['attr16'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(
                      newPatientData.spacingAndCrowding1.crowding.resolveLower.IPRPosteriorRight.value
                  ).replace(/\"/g, '')
                : 'asNeeded';
        newPrescriptionNotesObj['attr57'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(
                      newPatientData.spacingAndCrowding1.crowding.resolveLower.IPRPosteriorRight.teeth
                  ).replace(/\"/g, '')
                : '';
        newPrescriptionNotesObj['attr17'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(
                      newPatientData.spacingAndCrowding1.crowding.resolveLower.IPRPosteriorLeft.value
                  ).replace(/\"/g, '')
                : 'asNeeded';
        newPrescriptionNotesObj['attr58'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(
                      newPatientData.spacingAndCrowding1.crowding.resolveLower.IPRPosteriorLeft.teeth
                  ).replace(/\"/g, '')
                : '';
        newPrescriptionNotesObj['attr18'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.spacingAndCrowding1.crowding.resolveLower.extraction.value).replace(
                      /\"/g,
                      ''
                  )
                : 'asNeeded';
        newPrescriptionNotesObj['attr59'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.spacingAndCrowding1.crowding.resolveLower.extraction.teeth).replace(
                      /\"/g,
                      ''
                  )
                : '';
        // Overjet
        newPrescriptionNotesObj['attr19'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.overJet1.value).replace(/\"/g, '')
                : 'maintainInitialOverjet';
        newPrescriptionNotesObj['attr20'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.overJet1.subValue).replace(/\"/g, '') === 'null'
                    ? ''
                    : JSON.stringify(newPatientData.overJet1.subValue).replace(/\"/g, '')
                : '';
        // Openbite
        if (newPatientData.openbite1.subValue.extrudeAnteriorTeeth.value === true)
            extrudeIntrudePlace.push('extrudeAnteriorTeeth');
        if (newPatientData.openbite1.subValue.intrudePosteriorTeeth.value === true)
            extrudeIntrudePlace.push('intrudePosteriorTeeth');
        if (newPatientData.openbite1.subValue.placeMiniImplantsTAD.value === true)
            extrudeIntrudePlace.push('placeMiniImplantsTAD');
        if (newPatientData.openbite1.subValue.extrudeAnteriorTeeth.upper === true) extrudeAnteriorTeeth.push('upper');
        if (newPatientData.openbite1.subValue.extrudeAnteriorTeeth.lower === true) extrudeAnteriorTeeth.push('lower');
        if (newPatientData.openbite1.subValue.intrudePosteriorTeeth.upper === true) intrudePosteriorTeeth.push('upper');
        if (newPatientData.openbite1.subValue.intrudePosteriorTeeth.lower === true) intrudePosteriorTeeth.push('lower');
        newPrescriptionNotesObj['attr21'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.openbite1.value).replace(/\"/g, '')
                : 'maintainInitialOpenbite';
        newPrescriptionNotesObj['attr22'] =
            typeof newPatientData === 'object' && newPatientData.openbite1.subValue.value !== null
                ? JSON.stringify(newPatientData.openbite1.subValue.value).replace(/\"/g, '')
                : '';
        newPrescriptionNotesObj['attr23'] = JSON.stringify(extrudeIntrudePlace);
        newPrescriptionNotesObj['attr24'] = JSON.stringify(extrudeAnteriorTeeth);
        newPrescriptionNotesObj['attr25'] = JSON.stringify(intrudePosteriorTeeth);
        newPrescriptionNotesObj['attr60'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.openbite1.subValue.placeMiniImplantsTAD.input).replace(/\"/g, '')
                : '';
        // Deep bite
        if (newPatientData.deepBite1.subValue.intrudeAnteriorTeeth.value === true)
            intrudeExtrudePlace.push('intrudeAnteriorTeeth');
        if (newPatientData.deepBite1.subValue.extrudePosteriorTeeth.value === true)
            intrudeExtrudePlace.push('extrudePosteriorTeeth');
        if (newPatientData.deepBite1.subValue.placeMiniImplantsTAD.value === true)
            intrudeExtrudePlace.push('placeMiniImplantsTAD');
        if (newPatientData.deepBite1.subValue.intrudeAnteriorTeeth.upper === true) intrudeAnteriorTeeth.push('upper');
        if (newPatientData.deepBite1.subValue.intrudeAnteriorTeeth.lower === true) intrudeAnteriorTeeth.push('lower');
        if (newPatientData.deepBite1.subValue.extrudePosteriorTeeth.upper === true) extrudePosteriorTeeth.push('upper');
        if (newPatientData.deepBite1.subValue.extrudePosteriorTeeth.lower === true) extrudePosteriorTeeth.push('lower');
        newPrescriptionNotesObj['attr26'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.deepBite1.value).replace(/\"/g, '')
                : 'maintainExistingDeepBite';
        newPrescriptionNotesObj['attr27'] =
            typeof newPatientData === 'object' && newPatientData.deepBite1.subValue.value !== null
                ? JSON.stringify(newPatientData.deepBite1.subValue.value).replace(/\"/g, '')
                : '';
        newPrescriptionNotesObj['attr28'] = JSON.stringify(intrudeExtrudePlace);
        newPrescriptionNotesObj['attr29'] = JSON.stringify(intrudeAnteriorTeeth);
        newPrescriptionNotesObj['attr30'] = JSON.stringify(extrudePosteriorTeeth);
        newPrescriptionNotesObj['attr61'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.deepBite1.subValue.placeMiniImplantsTAD.input).replace(/\"/g, '')
                : '';
        // Midline
        if (newPatientData.midline1.subValue.upper.checked === true) upperLowerChecked.push('upper');
        if (newPatientData.midline1.subValue.lower.checked === true) upperLowerChecked.push('lower');
        newPrescriptionNotesObj['attr31'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.midline1.value).replace(/\"/g, '')
                : 'maintainInitialMidline';
        newPrescriptionNotesObj['attr32'] =
            typeof newPatientData === 'object' && newPatientData.midline1.subValue.value !== null
                ? JSON.stringify(newPatientData.midline1.subValue.value).replace(/\"/g, '')
                : '';
        newPrescriptionNotesObj['attr34'] =
            typeof newPatientData === 'object' && newPatientData.midline1.subValue.upper.value !== null
                ? JSON.stringify(newPatientData.midline1.subValue.upper.value).replace(/\"/g, '')
                : '';
        newPrescriptionNotesObj['attr35'] =
            typeof newPatientData === 'object' && newPatientData.midline1.subValue.lower.value !== null
                ? JSON.stringify(newPatientData.midline1.subValue.lower.value).replace(/\"/g, '')
                : '';
        newPrescriptionNotesObj['attr33'] = JSON.stringify(upperLowerChecked);
        // Posterior Crossbite
        if (newPatientData.posteriorCrossbite1.subValue.subValue.buttonPressedDirectlyOnAligner.maxillaryTeeth === true)
            buttonPressedDirectlyOnAlignerSubValue.push('maxillaryTeeth');
        if (
            newPatientData.posteriorCrossbite1.subValue.subValue.buttonPressedDirectlyOnAligner.mandibularTeeth === true
        )
            buttonPressedDirectlyOnAlignerSubValue.push('mandibularTeeth');
        if (
            newPatientData.posteriorCrossbite1.subValue.subValue.cutoutToBondButtonDirectlyOnTeeth.maxillaryTeeth ===
            true
        )
            cutoutToBondButtonDirectlyOnTeethSubValue.push('maxillaryTeeth');
        if (
            newPatientData.posteriorCrossbite1.subValue.subValue.cutoutToBondButtonDirectlyOnTeeth.mandibularTeeth ===
            true
        )
            cutoutToBondButtonDirectlyOnTeethSubValue.push('mandibularTeeth');
        newPrescriptionNotesObj['attr36'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.posteriorCrossbite1.value).replace(/\"/g, '')
                : 'maintainInitialCrossbite';
        newPrescriptionNotesObj['attr37'] =
            typeof newPatientData === 'object' && newPatientData.posteriorCrossbite1.subValue.value !== null
                ? JSON.stringify(newPatientData.posteriorCrossbite1.subValue.value).replace(/\"/g, '')
                : 'noPreferenceShowResultsInSimulator';
        newPrescriptionNotesObj['attr38'] =
            typeof newPatientData === 'object' && newPatientData.posteriorCrossbite1.subValue.subValue.value !== null
                ? JSON.stringify(newPatientData.posteriorCrossbite1.subValue.subValue.value).replace(/\"/g, '')
                : '';
        newPrescriptionNotesObj['attr39'] = JSON.stringify(buttonPressedDirectlyOnAlignerSubValue);
        newPrescriptionNotesObj['attr40'] = JSON.stringify(cutoutToBondButtonDirectlyOnTeethSubValue);
        newPrescriptionNotesObj['attr46'] =
            typeof value === 'object'
                ? JSON.stringify(newPatientData.posteriorCrossbite1.subValue.subValue.otherMethod).replace(/\"/g, '')
                : '';
        // Auxiliaries
        auxiliaries1SubValue.push(newPatientData.auxiliaries1.subValue.upper.value);
        auxiliaries1SubValue.push(newPatientData.auxiliaries1.subValue.lower.value);
        newPrescriptionNotesObj['attr41'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.auxiliaries1.classIIElastics).replace(/\"/g, '')
                : 'No';
        newPrescriptionNotesObj['attr42'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.auxiliaries1.classIIIElastics).replace(/\"/g, '')
                : 'No';
        if (newPrescriptionNotesObj['attr41'] === 'No' && newPrescriptionNotesObj['attr42'] === 'No') {
            auxiliaries1SubValue = [];
        }
        newPrescriptionNotesObj['attr43'] = JSON.stringify(auxiliaries1SubValue);
        newPrescriptionNotesObj['attr44'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.auxiliaries1.otherElastics.value).replace(/\"/g, '')
                : 'No';
        newPrescriptionNotesObj['attr62'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.auxiliaries1.otherElastics.comment).replace(/\"/g, '')
                : '';

        // Use TrioDim Force
        newPrescriptionNotesObj['trio_dim_force'] = newPatientData?.trioDimForce || '';

        // Special Instructions
        newPrescriptionNotesObj['attr47'] =
            typeof newPatientData === 'object'
                ? JSON.stringify(newPatientData.specialInstructions1).replace(/\"/g, '')
                : '';

        newPrescriptionNotesObj = Object.fromEntries(
            Object.entries(newPrescriptionNotesObj).map(([key, value]) => {
                if (String.isBlank(value)) {
                    return [key, null];
                }
                return [key, value];
            })
        );

        try {
            await axios.post(`case/detail/${this.state.caseId}`, newPrescriptionNotesObj);
            await this.props.showSnackbar('Prescription Notes updated', 'success', true);
            this.reloadPage();
        } catch (err) {
            const errMsg = this.getErrorMsg(err, 'Something went wrong , Please connect with admin');
            this.setState({ modalError: errMsg });
            console.error(err.response);
        }
    }

    handleChangetcBox() {
        this.setState({ tcCheckbox: !this.state.tcCheckbox });
    }

    downloadImages(caseFile, type) {
        let photosList = [],
            date = null;
        Object.entries(caseFile).map(([key, value]) => {
            if (key.includes(type) && !key.endsWith('later') && value && !/^dbx::/.test(value)) {
                photosList.push(join(ApiServerUrl, value));
            }
        });
        date = Moment(caseFile.created_date).format('YYYY-MM-DD');
        for (let i = 0; i < photosList.length; i++) {
            this.downloadFile(photosList[i], date);
        }
    }

    /** Downloads photo files and the 3D facial scan as a ZIP archive. */
    downloadPhotosAsZip(caseFile) {
        const fileUrls = Object.entries(caseFile)
            .filter(
                ([key, value]) =>
                    (key.includes('photo') || key === 'facial_scan_file') &&
                    !key.endsWith('later') &&
                    value &&
                    !/^dbx::/.test(value)
            )
            .map(([, value]) => join(ApiServerUrl, value));
        const date = Moment(caseFile.created_date).format('YYYY-MM-DD');

        return downloadFilesAsZip(fileUrls, `${date}-photos.zip`);
    }

    /* Bug Fix for Firefox RFS download. Content type and file name should be explicitly defined to avoid default to HTML */
    downloadRFSFile(case_id, ray_id) {
        axios
            .get(join(ApiServerUrl, '/api/rayface/getrfs', case_id, ray_id), { responseType: 'blob' })
            .then(({ data }) => {
                const url = window.URL.createObjectURL(new Blob([data], { type: 'application/octet-stream' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'rayface.rfs'); // Force download with correct name
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url); // Clean up the URL object
            })
            .catch((error) => console.error('Download failed:', error));
    }

    downloadFile(file, date, type = 'image/*') {
        axios.get(file, { responseType: 'blob' }).then(({ data }) => {
            let url = window.URL.createObjectURL(data);

            var newImageName = file.split('/')[file.split('\/').length - 1]; //using the server image name

            Object.assign(document.createElement('a'), { download: `${date}-${newImageName}`, href: url }).click();
            window.URL.revokeObjectURL(url);
        });
    }

    /** Saves selected photo files and the optional 3D facial scan. */
    async handlePhotoDataSave() {
        const form = new FormData();
        let newPhotoUpload = {};

        this.props.files
            .filter((v) => {
                return v.category === 'photo';
            })
            .forEach((v, index) => {
                if (v.data) {
                    const fileName = '$$FILE:photo' + index;
                    newPhotoUpload['photo' + index] = v.data ? fileName : null;
                    newPhotoUpload['photo' + index + '_later'] = v.upload_later;
                    if (v.data) {
                        form.append(fileName, v.data);
                    }
                }
            });

        const facialScan = this.props.newPatientData?.facialScan?.data;
        if (facialScan) {
            const fileName = '$$FILE:facial_scan_file';
            newPhotoUpload.facial_scan_file = fileName;
            form.append(fileName, facialScan);
        }

        form.append('body', JSON.stringify(newPhotoUpload));

        try {
            this.setState({ PhotoUploadLoadingStatus: true, loading: true });
            if (Object.keys(newPhotoUpload).length) {
                await axios.post(`case/file/${this.state.caseId}`, form, {
                    onUploadProgress: this.progressBarRef.current?.onProgressChange,
                });
                await this.props.showSnackbar('Photos uploaded', 'success', true);
                this.reloadPage();
            } else {
                await this.props.showSnackbar('No photo to upload', 'error');
            }
        } catch (err) {
            const errMsg = this.getErrorMsg(err, 'All Images are required');
            this.setState({ modalError: errMsg });
            console.error(err.response);
        } finally {
            this.setState({ PhotoUploadLoadingStatus: false, loading: false });
        }
    }

    renderLogMessage(log, msg) {
        const style = {
            color: msg && !msg.external ? 'white' : '#444444',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
        };
        return log?.isRenderDangerouslySetInnerHtml ? (
            <p style={style} dangerouslySetInnerHTML={{ __html: log?.msg }}></p>
        ) : (
            <p style={style}>{msg?.msg || msg}</p>
        );
    }

    returnLogs() {
        let { classes } = this.props,
            { logs } = this.state;

        return logs.map(({ msg, btn, date }, i) => (
            <Grid container key={i} style={{ borderTop: '#f2f2f2 1px solid' }}>
                <Grid
                    item
                    xs={12}
                    sm={2}
                    className={msg && !msg.external ? classes.logDateContainer : classes.logDateContainer2}
                >
                    <div>
                        <p className={classes.logDate}>
                            {['sec', 'min', 'hour', 'day'].find((s) => date.friendly.includes(s))
                                ? date.friendly
                                : date.formal}
                        </p>
                        <p style={{ fontSize: 12, textAlign: 'center' }}>{date.formal}</p>
                    </div>
                </Grid>
                <Grid item xs={12} sm={6} className={msg && !msg.external ? classes.logMsg : classes.logMsg2}>
                    {this.renderLogMessage(logs[i], msg)}
                </Grid>
                <Grid item xs={12} sm={4} className={msg && !msg.external ? classes.logBtns : classes.logBtns2}>
                    {btn
                        .filter(({ requiresMockupOrder }) => !requiresMockupOrder || this.state.hasMockupOrder !== false)
                        .map(({ url, onClick, value, id, newtab }, j) => {
                        if (url) {
                            let aAttr = {
                                href: url,
                                ...(newtab ? { target: '_blank' } : null),
                            };
                            return (
                                <a id={`${j}_${id}`} {...aAttr} style={{ textDecoration: 'none' }}>
                                    <Button className={!msg.external ? classes.caseBtn : classes.caseBtn2}>
                                        {value}
                                    </Button>
                                </a>
                            );
                        } else if (value === 'Noted') {
                            return (
                                <Button
                                    id={`${j}_${id}`}
                                    className={!msg.external ? classes.caseBtn : classes.caseBtn2}
                                    disabled
                                    style={{ color: 'white' }}
                                >
                                    {value}
                                </Button>
                            );
                        } else {
                            return (
                                <Button
                                    id={`${j}_${id}`}
                                    className={!msg?.external ? classes.caseBtn : classes.caseBtn2}
                                    onClick={onClick}
                                >
                                    {value}
                                </Button>
                            );
                        }
                        })}
                </Grid>
            </Grid>
        ));
    }
    handleRemarkParam1Param2 = (caseOptions, _case) => {
        let param1 = _case.status_param1;
        let caseStatus = _case.case_status;
        // not adding break for falling to default if condition is not met
        switch (_case.case_status) {
            case CASE_STATUS.RETRACK_END:
                if (['FINISH', 'CANCEL'].includes(param1)) {
                    // handle old retrack case
                    return this.get(`@global.caseStatus.RETRACK_${param1}`);
                } else {
                    // handle retrack enhancement status
                    return this.get(`@global.caseStatus.${caseStatus}`);
                }
            case CASE_STATUS.DELIVERED:
                if (_case?.case_type === CASE_TYPE.RETAINER) {
                    if (!_case?.status_param1 || !_case?.status_param2) {
                        return this.get('@PatientInfo.retainer_caseStatusLabel.DELIVERED_V2');
                    }
                }
            default:
                try {
                    const param1 = _case.case_type === CASE_TYPE.SELF_DESIGN ? _case.approvedPlanCount : _case.status_param1;
                    const adjectiveMap = { Moderately: 'Moderate', Severely: 'Severe' };
                    const param2 = adjectiveMap[_case.status_param2] || _case.status_param2;
                    return getFromObj(caseOptions, _case.case_status)
                        .replace(/\{No\.1[^\}]*\?\}/, param1)
                        .replace(/\{No\.2[^\}]*\?\}/, param2)
                        .replace(/\{No\.?[^\}]*\?\}/, param1)
                        .replace(/\{Remark:[^\}]*\}/, _case.status_remarks ? `(${_case.status_remarks})` : '');
                } catch (err) {
                    console.error(err);
                    console.error('Try to add caseOption in patientInfo \"caseStatusOptions\"');
                }
                break;
        }
        return '';
    };

    returnSteps() {
        const countArray = [];
        for (let i = 1; i <= 150; i++) {
            countArray.push(
                <MenuItem value={i} key={i}>
                    {i}
                </MenuItem>
            );
        }
        return countArray;
    }

    reloadPage() {
        // Force a real page reload instead of routing through /blank, which can leave the UI stuck on an empty page.
        window.location.replace(`/patients/${this.state.caseId}`);
    }
    handleClickOpen = () => {
        this.setState({ opendMarkReadConfirm: true });
    };
    markAsReadClose = () => {
        this.setState({ opendMarkReadConfirm: false });
    };
    async markAsRead() {
        let readAPI = await axios.post(`/case/${parseInt(this.state.caseId)}/read`);
        if (readAPI.data.success) {
            this.setState({ opendMarkReadConfirm: false });

            await this.mount_init();
        }
    }

    clinicalSimulaitonLiveSupportButton(linkedButtonClass) {
        return (
            <a
                href={getWebAbsPath(
                    this.state.patientInfo.case_type === CASE_TYPE.SELF_DESIGN
                        ? `/meditReview/${this.state.caseId}`
                        : `/clinicalSimulation/${this.state.caseId}`
                )}
                target="_blank"
                style={{ textDecoration: 'none', width: '100%' }}
            >
                <Button className={linkedButtonClass}>
                    {this.state.patientInfo.case_type === CASE_TYPE.SELF_DESIGN
                        ? this.get('case_info.documentsList.clinicalSimulationSelfDesign')
                        : this.state.isShowSmileDesignFeature
                            ? this.get('case_info.documentsList.iDesignSimulation')
                            : this.get('case_info.documentsList.clinicalSimulation')}
                </Button>
            </a>
        );
    }
    async deliveryAddressChangeModalOpen() {
        this.setState({ deliveryAddressModal: true });
        try {
            const addressList = (
                await axios.get(`case/address?case_id=${this.state.caseId}`, {
                    onUploadProgress: this.progressBarRef.current?.onProgressChange,
                })
            ).data.address;
            this.setState({ getDeliveryAddress: addressList });
        } catch (err) {
            console.error(err);
        }
    }
    handleDeliveryAddress(event) {
        this.setState({ selectedDeliveryAddress: event.target.value });
    }
    async DeliveryAddressSave() {
        try {
            const selectedAddress = await axios.post(
                `case/address/${this.state.caseId}/${this.state.selectedDeliveryAddress}`,
                {
                    onUploadProgress: this.progressBarRef.current?.onProgressChange,
                }
            );

            if (selectedAddress.data.success) {
                await this.props.showSnackbar('Delivery Address Changed', 'success', true);
                this.reloadPage();
            }
        } catch (err) {
            this.setState({ modalError: 'Something went wrong, Please contact to Admin' });
            console.error(err);
        }
    }
    // SELF_DESIGN: show the actual delivered set numbers (e.g. "1-2") in the status
    // option label once they have been derived from the current treatment plan
    formatStatusOptionLabel(value, label) {
        const batch = this.state.approvedPlanCount;
        if (value === CASE_STATUS.DELIVERED && this.state.patientInfo.case_type === CASE_TYPE.SELF_DESIGN && batch) {
            return label.replace(/\{No\.1[^\}]*\?\}/, batch);
        }
        return label;
    }

    progressUpdate(props) {
        if (this.state.patientInfo.case_type != 'RETAINER') {
            return (
                this.state.currentStatus &&
                statusList[this.state.currentStatus] &&
                statusList[this.state.currentStatus].map((v, i) => {
                    if (v.value === 'DELIVERED' && v.selfDesign && this.state.patientInfo.case_type !== CASE_TYPE.SELF_DESIGN) return;
                    if (v.value === 'DELIVERED' && !v.selfDesign && this.state.patientInfo.case_type === CASE_TYPE.SELF_DESIGN) return;
                    if (this.state.onlyRetrackProductionInProgress) {
                        if (v.value === 'RETRACK_PRODUCTION_IN_PROGRESS') {
                            return (
                                <MenuItem disabled={v.value === 'none'} value={v.value} key={v.value} selected>
                                    {this.formatStatusOptionLabel(v.value, v.label)}
                                </MenuItem>
                            );
                        }
                    } else {
                        return (
                            <MenuItem disabled={v.value === 'none'} value={v.value} key={v.value} selected>
                                {this.formatStatusOptionLabel(v.value, v.label)}
                            </MenuItem>
                        );
                    }
                })
            );
        } else {
            return (
                this.state.currentStatus &&
                retainer_statusList[this.state.currentStatus] &&
                retainer_statusList[this.state.currentStatus].map((v, i) => (
                    <MenuItem disabled={v.value === 'none'} value={v.value} key={v.value} selected>
                        {v.label}
                    </MenuItem>
                ))
            );
        }
    }

    async getPhotos(ModalTypeState = 'view') {
        let result = await axios.get(`case/progress_photos/${this.state.caseId}`);
        this.setState({ PhotoModal: true, ModalState: ModalTypeState, progress_photos: result.data.progress_photos });
    }

    /** Loads the selected Mock-up Order for the Case Log modal. */
    loadMockupOrder = async (mockupOrderId) => {
        const result = await safeGet(`/case/mockup_order/${mockupOrderId}`);

        if (result?.success === false) {
            this.props.showSnackbar(result?.message || 'Failed to load mock-up order', 'error');
            this.setState({ mockupOrderLoading: false });
            return;
        }

        this.setState({
            mockupOrderData: result?.case_mockup_order || result,
            mockupOrderLoading: false,
        });
    };

    /** Loads whether this case includes a mock-up order for restorative phase views. */
    loadRestorativeMockupOrderStatus = async () => {
        const result = await safeGet(`/case/mockup_order/exists/${this.state.caseId}`);
        if (result?.success) this.setState({ hasMockupOrder: result.hasMockupOrder !== false });
    };

    // Opens the Mock-up Ordering page for the current case.
    openMockupOrdering = () => {
        this.props.history.push({
            pathname: `/patients/${this.state.caseId}/mockup-ordering`,
            state: {
                patientId: this.state.patientId,
                isMarieGroup: this.state.isMarieGroup,
            },
        });
    };

    async getIsDisableCreateNewCaseForPatient(patientId) {
        let isCanSubmitSmileDesignOrAlignerCase = await axios.get(
            `patient/${patientId}/IsCaseCanSubmitSmileDesignOrAlignerCase`
        );
        const {data: { pm },} = await axios.get(`/productmatrix/productmatrixForDr`);
        const isCanCreateRetainerCase = pm?.find((v) => v.case_type === 'RETAINER');

        if (isCanSubmitSmileDesignOrAlignerCase.data.success && isCanCreateRetainerCase) {
            let value = {
                canCreateAlignerCase: isCanSubmitSmileDesignOrAlignerCase.data.result.canCreateAlignerCase,
                canCreateSmileDesignCase: isCanSubmitSmileDesignOrAlignerCase.data.result.canCreateSmileDesignCase,
                canCreateRetainerCase: !!isCanCreateRetainerCase
            };
            this.setState({
                isDisableCreateNewCaseForPatient: value.canCreateAlignerCase || value.canCreateSmileDesignCase || value.canCreateRetainerCase,
            });
            this.setState({ determineWhatCaseCanCreate: value });
        }
    }

    async getPatientCasesInfo(patientId) {
        let queryResult = await axios.get(`patient/${patientId}/GetAllCaseInfo`);
        if (queryResult.data?.success) {
            this.setState({ patientCases: queryResult.data.result });
        }
    }

    isShowEndCaseButton() {
        if (this.state.isSmileDesign) return false;

        const isRoleAllowed = !['SADMIN', 'ADMIN', 'DISTR'].includes(this.state.role);
        if (!isRoleAllowed || this.state.currentStatus === 'ENDED') return false;
        if (this.state.currentStatus === 'ALL_DELIVERED') return true;

        // SELF_DESIGN cases can end directly from DELIVERED 
        if (
            this.state.patientInfo.case_type === CASE_TYPE.SELF_DESIGN &&
            this.state.currentStatus === 'DELIVERED'
        ) {
            return true;
        }

        const treatmentEndDateMoment = Moment(this.state.patientInfo.treatmentEndDate, 'DD-MMM-YYYY');
        const isTreatmentEndDatePassedValid = treatmentEndDateMoment.isValid();
        if (!isTreatmentEndDatePassedValid) return false;

        return treatmentEndDateMoment.isBefore(Moment());
    }

    isShowEndCaseButtonSmileDesign() {
        if (
            !['SADMIN', 'ADMIN', 'DISTR'].includes(this.state.role) &&
            (['ALL_DELIVERED'].includes(this.state.currentStatus) ||
                ['RESTORATION_TOOL_FORM_SUBMITTED'].includes(this.state.currentStatus)) &&
            // change to check isSmilDesign
            this.state.isSmileDesign
        ) {
            return true;
        }
        return false;
    }

    isEnableFinishingRetainerButton() {
        if (this.state.patientInfo.case_type === 'FLEX') {
            return false;
        } else if (this.state.isShowFinishingRetainer && this.state.enable_requestFinishingRetainer_button) {
            return true;
        } else {
            return false;
        }
    }

    isRenderFinishingRetainerButton() {
        if (process.env.REACT_APP_ENV && process.env.REACT_APP_ENV !== 'INTERNATIONAL') return false;
        const isRoleAllowed = !['SADMIN', 'ADMIN', 'DISTR'].includes(this.state.role);
        const isCaseTypeAllowed = ['SIMPLE', 'TOUCH_UP', 'TOUCHUP_PLUS', 'COMPLETE', 'ULTRA'].includes(
            this.state.patientInfo.case_type
        );
        const isCaseStautsAllowed = ['ALL_DELIVERED'].includes(this.state.currentStatus);
        return (
            isRoleAllowed &&
            isCaseTypeAllowed &&
            isCaseStautsAllowed &&
            this.state.showBleachRetainerButtonByDistributor
        );
    }

    isRenderRetrackButton() {
        if (!this.state.enableRetrack) return false;
        const isRoleAllowed = !['SADMIN', 'ADMIN', 'DISTR'].includes(this.state.role);
        const isCaseTypeAllowed = CASE_TYPE_FOR_RETRACK.includes(this.state.patientInfo.case_type);
        const isCaseStautsAllowed = ['DELIVERED', 'ALL_DELIVERED', 'ENDED'].includes(this.state.currentStatus);
        return (
            isRoleAllowed &&
            isCaseTypeAllowed &&
            isCaseStautsAllowed &&
            this.state.isFirstProductIsNewProduct &&
            this.state.withinTreatmentPeriod &&
            this.state.patientInfo?.package_version === PACKAGE_VERSION.Pre2026 &&
            !this.state.isOldCaseBeforeRetrackRefinementDemployment
        );
    }

    renderPackageDetailsByVersion() {
        const { classes } = this.props;
        switch (this.state.patientInfo?.package_version) {
            case PACKAGE_VERSION.Pre2026:
                return (
                    <>
                        {this.state.enableRetrack && !this.state.isOldCaseBeforeRetrackRefinementDemployment && (
                            <RetrackField
                                title={`${updateParams(
                                    this.get('@PatientInfo.case_info.warranty_record'),
                                    this.get('@PatientInfo.case_info.actionsList.retrack')
                                )}: `}
                                role={this.state.role}
                                retrack_quota_remaining={this.state.patientInfo.retrack_quota_remaining}
                                retrack_quota_total={this.state.patientInfo.retrack_quota_total}
                                classes={classes}
                            />
                        )}
                        {!this.state.isOldCaseBeforeRetrackRefinementDemployment && (
                            <Grid container>
                                <Grid item xs={8} style={{ paddingRight: 8 }}>
                                    <h5 className={classes.infoText}>
                                        {updateParams(
                                            this.get('case_info.warranty_record'),
                                            this.get('@pages.treatmentapproval.refinement')
                                        )}
                                        :
                                    </h5>
                                </Grid>
                                <Grid item xs={4}>
                                    {['SADMIN', 'ADMIN', 'DISTR'].includes(this.state.role) &&
                                    (this.state.patientInfo.refinement_quota_remaining > 0 ||
                                        typeof this.state.patientInfo.refinement_quota_remaining === 'string') ? (
                                        <>
                                            <p className={`${classes.infoText} ${classes.infoTextHighlight}`}>
                                                {this.state.patientInfo.refinement_quota_remaining} /{' '}
                                                {this.state.patientInfo.refinement_quota_total}
                                            </p>
                                            <p className={`${classes.infoText} ${classes.infoTextHighlight}`}>
                                                {this.get('case_info.stepsInTotal').replace(
                                                    '{{steps_number}}',
                                                    this.state.patientInfo.refinement_steps
                                                )}
                                            </p>
                                        </>
                                    ) : (
                                        <p className={`${classes.infoText} ${classes.infoTextHighlight}`}>
                                            {this.state.patientInfo.refinement_quota_remaining ?? '-'} /{' '}
                                            {this.state.patientInfo.refinement_quota_total ?? '-'}
                                        </p>
                                    )}
                                </Grid>
                            </Grid>
                        )}
                    </>
                );
            case PACKAGE_VERSION[2026]:
                return (
                    <>
                        <Grid container>
                            <Grid item xs={8} style={{ paddingRight: 8 }}>
                                <h5 className={classes.infoText}>{this.get('case_info.freeRefinementExpiryDate')}:</h5>
                            </Grid>
                            <Grid item xs={4}>
                                <p className={`${classes.infoText} ${classes.infoTextHighlight}`}>
                                    {this.state.patientInfo.refinement_expiration_date}
                                </p>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={8} style={{ paddingRight: 8 }}>
                                <h5 className={classes.infoText}>
                                    {this.get('case_info.freeRefinementQuotaRemaining')}:
                                </h5>
                            </Grid>
                            <Grid item xs={4}>
                                {['SADMIN', 'ADMIN', 'DISTR', 'DR'].includes(this.state.role) &&
                                (this.state.patientInfo.refinement_quota_remaining > 0 ||
                                    typeof this.state.patientInfo.refinement_quota_remaining === 'string') ? (
                                    <>
                                        <p className={`${classes.infoText} ${classes.infoTextHighlight}`}>
                                            {this.state.patientInfo.refinement_quota_remaining} /{' '}
                                            {this.state.patientInfo.refinement_quota_total}
                                        </p>
                                        <p className={`${classes.infoText} ${classes.infoTextHighlight}`}>
                                            {this.get('case_info.stepsPerFreeRefinement').replace(
                                                '{{steps_number}}',
                                                this.state.patientInfo.refinement_steps
                                            )}
                                        </p>
                                    </>
                                ) : (
                                    <p className={`${classes.infoText} ${classes.infoTextHighlight}`}>
                                        {this.state.patientInfo.refinement_quota_remaining ?? '-'} /{' '}
                                        {this.state.patientInfo.refinement_quota_total ?? '-'}
                                    </p>
                                )}
                            </Grid>
                        </Grid>
                    </>
                );
            default:
                return <></>;
        }
    }

    loadingState = (bool) => {
        this.setState({ loading: bool });
    };
    retrackReloadPage = () => {
        this.reloadPage();
    };
    reloadPageFunctionalProps = () => {
        this.reloadPage();
    };

    showModalError = () => {
        this.setState({ modalError: 'Something Went Wrong Please Connect With Admin' });
    };

    viewRetrackData = () => {
        this.state.retrackDataArray.map((item, index) => {
            let retrackItem = item.case_retrack;
            let retrackCaseFile = retrackItem.case_file;
            let retrackCaseDetail = retrackItem.case_detail;
            let retrackQuestion = retrackItem.case_retrack_detail;
            const photos = Object.entries(retrackCaseFile).filter(
                ([key]) => key.startsWith('photo') && retrackCaseFile[key] !== null
            );
        });
    };

    showRetrackModal = () => {
        if (this.state.isOldCaseBeforeRetrackRefinementDemployment) {
            return this.handleOpen('retrackOldCaseModal');
        } else {
            return this.handleOpen('retrack', 'update');
        }
    };

    showRefinementModal = () => {
        if (this.state.isOldCaseBeforeRetrackRefinementDemployment) {
            return this.handleOpen('refinementOldCaseModal');
        } else {
            return parseInt(this.state.patientInfo.refinement_quota_remaining) === 0
                ? this.handleOpen('viewRefinementQuotaReminderModal')
                : window.open(`/patients/${this.state.caseId}/refinement`);
        }
    };

    isNotCN = () => {
        return !['CN'].includes(process.env.REACT_APP_ENV);
    };

    //ADMIN: RETRACK_REPORT - RETRACK_END
    handleRetrackRemakeSets = (e) => {
        switch (e.target.value) {
            case 'NULL':
                this.setState({ remakeSets: e.target.value });
                this.setState({ param1: null });
                this.setState({ param2: null });
                break;
            case 'FILL':
                this.setState({ remakeSets: e.target.value });
                this.setState({ param1: 1 });
                this.setState({ param2: 2 });
                break;
        }
    };

    latestTreatmentPlan = (treatmentPlan) => {
        const sortedArrayDesc = [...(treatmentPlan || [])].sort((a, b) => b.plan_no - a.plan_no);
        console.log('treatmentPlan latest: ', sortedArrayDesc[0]);

        return sortedArrayDesc[0];
    };

    getLatestApprovedPlanNo = () => {
        const buckets = this.state.treatmentPlanData?.treatment_plan;
        if (!Array.isArray(buckets)) return null;
        const approved = buckets
            .flat()
            .filter((plan) => Number(plan.approved_flag) === 1)
            .sort((a, b) => {
                const aTime = new Date(a.approval_date || a.created_date || 0).getTime();
                const bTime = new Date(b.approval_date || b.created_date || 0).getTime();
                return bTime - aTime || (b.plan_no || 0) - (a.plan_no || 0);
            });
        return approved.length ? approved[0].plan_no : null;
    };

    isNewRetainerCase = () => {
        return (
            this.state.caseType === 'RETAINER' &&
            this.state.retainerRequestData &&
            this.state.retainerRequestData.retainer_request_id
        );
    };

    isSelfDesignWithRetainerRequest = () => {
        return (
            this.state.patientInfo.case_type === CASE_TYPE.SELF_DESIGN &&
            this.state.retainerRequestData?.retainer_request_id
        );
    };

    isRenderViewPrescriptionBtn = () => {
        if (this.state.caseType === 'RETAINER') {
            return this.isNewRetainerCase();
        }
        if (this.state.patientInfo.case_type === CASE_TYPE.SELF_DESIGN) {
            return false;
        }
        return true;
    };

    isRenderRayCaseField() {
        if (smileDesignProductListArray.includes(this.state.patientInfo.case_type)) {
            return false;
        }
        return (
            (!!this.state.patientInfo.ray_info.isRayCase && String(this.state.patientInfo.ray_info.isRayCase).toLocaleLowerCase() !== 'no') ||
            (!!this.state.patientInfo.ray_info.isRayRefinement && String(this.state.patientInfo.ray_info.isRayRefinement).toLocaleLowerCase() !== 'no')
        );
    }

    validateRetainerReqTypeId() {
        let invalidRetainerTypeIds = false;
        if (this.state.retainerRequestData?.impression_type) {
            switch (this.state.retainerRequestData.impression_type) {
                case IMPRESSION_TYPE.UPPER:
                    if (!this.state.retainerRequestData.upper_retainer_type_id) {
                        invalidRetainerTypeIds = true;
                    }
                    break;
                case IMPRESSION_TYPE.LOWER:
                    if (!this.state.retainerRequestData.lower_retainer_type_id) {
                        invalidRetainerTypeIds = true;
                    }
                    break;
                case IMPRESSION_TYPE.UPPER_AND_LOWER:
                    if (
                        !this.state.retainerRequestData.upper_retainer_type_id ||
                        !this.state.retainerRequestData.lower_retainer_type_id
                    ) {
                        invalidRetainerTypeIds = true;
                    }
                    break;
                default:
                    break;
            }
        }
        return invalidRetainerTypeIds;
    }

    isRenderReSubmitRetainerFormBtn = () => {
        if (this.state.caseType === 'RETAINER') {
            const invalidRetainerTypeIds = this.validateRetainerReqTypeId();
            const isInvalidRetainerRequest =
                !this.state.retainerRequestData ||
                !this.state.retainerRequestData.retainer_request_id ||
                !this.state.retainerRequestData.impression_type ||
                invalidRetainerTypeIds;
            const isAfterOrderRetainerLaunch = new Date(this.state.caseCreatedDate) > new Date('2024-10-29');
            if (
                isInvalidRetainerRequest &&
                !['DRAFT', 'ENDED'].includes(this.state.currentStatus) &&
                isAfterOrderRetainerLaunch
            ) {
                return true;
            }
        }
        return false;
    };

    canDoctorUploadAllFiles = () => ['AWAITING'].includes(this.state.currentStatus);

    canDoctorUploadImpressions = () => {
        const doctorImpressionUploadStatuses = ['PLAN_APPROVED', 'PRODUCTION', 'DELIVERED', 'NEXT_SET_REQUEST', 'ALL_DELIVERED'];

        return (
            this.canDoctorUploadAllFiles() ||
            (ALIGNER_CASE_TYPE.includes(this.state.patientInfo.case_type) &&
                doctorImpressionUploadStatuses.includes(this.state.currentStatus))
        );
    };

    isSmileDesignShowUploadTreatmentPlanBtn = () => {
        // console.log('(this.state.isNoNeedUploadIDesign: ', (this.state.isNoNeedUploadIDesign))
        // console.log('this.state.latestTreatmentPlan?.smileDesign_exocad_pre: ', this.state.latestTreatmentPlan?.smileDesign_exocad_pre);
        // console.log('this.state.latestTreatmentPlan?.url: ', this.state.latestTreatmentPlan?.url);
        if (
            !!this.state.currentStatus &&
            ['CHANGE_REQUEST', 'RECEIVED', 'UPGRADE_REQUEST'].includes(this.state.currentStatus) &&
            smileDesignProductListArray.includes(this.state.patientInfo.case_type)
        ) {
            // Smile Design Only
            if (
                this.state.isNoNeedUploadIDesign &&
                (!this.state.latestTreatmentPlan?.smileDesign_exocad_pre ||
                    ['CHANGE_REQUEST', 'RECEIVED'].includes(this.state.currentStatus))
            ) {
                return true;
            } else {
                if (
                    this.state.latestTreatmentPlan?.smileDesign_exocad_pre === null &&
                    this.state.latestTreatmentPlan?.url
                ) {
                    return true;
                }
            }

            return false;
        }
    };

    shouldShowWaitingMessage = () => {
        const { currentStatus, patientInfo, numberOfTreatmentPlan, latestTreatmentPlan } = this.state;
        console.log('this.state.isNoNeedUploadIDesign: ', this.state.isNoNeedUploadIDesign);

        return (
            !!currentStatus &&
            smileDesignProductListArray.includes(patientInfo.case_type) &&
            !this.state.isNoNeedUploadIDesign &&
            // Explain: numberOfTreatmentPlan > 0 is to prevent showing the message when the case is just created
            // Explain: the new Jay treatment plan must have no smileDesign_exocad_pre. However,  have one treatment plan before, latestTreatmentPlan.smileDesign_exocad_pre will not be null
            ((['CHANGE_REQUEST', 'UPGRADE_REQUEST', 'RECEIVED'].includes(currentStatus) &&
                numberOfTreatmentPlan > 0 &&
                this.state.latestTreatmentPlan?.smileDesign_exocad_pre !== null) ||
                (['RECEIVED'].includes(currentStatus) && !latestTreatmentPlan?.url))
        );
    };

    resetCaseSupportingImgs = () => {
        this.setState({ caseSupportingImgs: initCaseSupportingImgs });
    };

    removeCaseSupportingImgs = (index) => {
        const cloned = [...this.state.caseSupportingImgs];
        const filteredList = cloned.map((v, i) => {
            if (i === index) {
                return {
                    ...baseSupportImgObj,
                };
            }
            return v;
        });
        this.setState({ caseSupportingImgs: filteredList });
    };

    setCaseSupportingImgs = (file, index) => {
        if (!file) throw new Error('File is required');
        if (!(file instanceof File)) throw new Error('File is not valid');
        const cloned = [...this.state.caseSupportingImgs];
        // Revoke the old object URL if it exists
        if (cloned[index]?.data_url) {
            URL.revokeObjectURL(cloned[index].data_url);
        }
        const fileURL = URL.createObjectURL(file);
        const updatedList = cloned.map((item, i) => {
            if (i === index) {
                return { ...item, data_url: fileURL, imgData: file };
            }
            return item;
        });
        this.setState({ caseSupportingImgs: updatedList });
    };

    setCaseSupportingImgsSubject = (value, index) => {
        const cloned = [...this.state.caseSupportingImgs];
        const updatedList = cloned.map((item, i) => {
            if (i === index) {
                return { ...item, subject: value };
            }
            return item;
        });
        this.setState({ caseSupportingImgs: updatedList });
    };

    renderDeliveryInfo() {
        return this.state.role !== ROLE_NAMES.super_admin;
    }

    // Open the upsell restoration form and keep the current plan id in redux.
    handleOpenUpsellRestorationFormModal = () => {
        this.props.setUpsellPlanId(this.state.upsellOperationData.plan_id);
        this.setState({ openUpsellRestorationToolFormModal: true });
    };

    // Close the modal and reload the current case after a successful submit.
    onSubmitUpsellRestorationFormSuccess = () => {
        this.props.showSnackbar(this.get('@PatientInfo.smileDesign.approveRestoration'), 'success');
        this.handleCloseUpsellRestorationFormModal();
        this.reloadPage();
    };

    // Show backend validation errors or a default message when submit fails.
    onSubmitUpsellRestorationFormError = (error) => {
        console.log('Upsell Restoration Tool Form Error: ', error);
        const errMsg = this.getErrorMsg(error, 'Please complete the required fields');
        this.props.showSnackbar(errMsg, 'error');
    };

    // Close the upsell restoration form and clear temporary redux data.
    handleCloseUpsellRestorationFormModal = () => {
        this.props.setUpsellRestorationFormData(null);
        this.props.setUpsellPlanId(null);
        this.setState({ openUpsellRestorationToolFormModal: false });
    };

    isDisplayUpdateCaseStatusInput(targetStatus) {
        if (this.state.newStatus !== targetStatus) return false;
        switch (this.state.newStatus) {
            case CASE_STATUS.DELIVERED:
                if (this.state.caseType === CASE_TYPE.RETAINER) return false;
                return this.state.statusListItemName !== 'RETRACK_PRODUCTION_IN_PROGRESS';
            default:
                break;
        }
        return true;
    }

    render() {
        const { classes } = this.props;
        const { role, getDeliveryAddress, selectedDeliveryAddress, requestFinishingRetainerReducer } = this.state;
        const shouldHideMockupAndRestorativePhase = [
            CASE_STATUS.DRAFT,
            CASE_STATUS.SUBMITTED,
            CASE_STATUS.AWAITING,
            CASE_STATUS.DEFECT_UPLOADED,
            CASE_STATUS.DEFECT_RESPONDED,
            CASE_STATUS.RECEIVED,
            CASE_STATUS.PLAN_UPLOADED,
            CASE_STATUS.CHANGE_REQUEST,
            CASE_STATUS.RESTORATION_TOOL_FORM_SUBMITTED,
            CASE_STATUS.ENDED,
            CASE_STATUS.UPGRADE_REQUEST,
        ].includes(this.state.currentStatus);
        if (this.state.patientInfo == null) {
            return <Loader />;
        } else {
            return (
                <>
                    <PercentageProgressRing ref={this.progressBarRef} open={this.state.loading} />

                    <Animated animationIn="fadeIn" isVisible={true}>
                        <Grid
                            container
                            style={{
                                padding: 16,
                                background: '#f2f2f2',
                            }}
                        >
                            <Grid item xs={12}>
                                <Banner />
                                <NewAcceptNotAcceptDialog
                                    disabled={!this.state.RequestRetainerCheckBox}
                                    title=""
                                    open={this.state.RequestFinishingRetainerStep1Modal}
                                    //dialogConfirmation="Confirm"
                                    onClose={() => this.setState({ RequestFinishingRetainerStep1Modal: false })}
                                    onConfirm={() => this.handleFinishingRetainerMessageStep1()}
                                >
                                    {
                                        // Purpose: requestRetainerMessage is false will show chargeable message, vice versea.
                                        // this.isShowFinishingRetainerButton() &&
                                        <>
                                            <div
                                                style={{ marginBottom: 16 }}
                                                dangerouslySetInnerHTML={{
                                                    __html: this.get(
                                                        '@PatientInfo.modals.requestFinishingRetainerMessageStep1.1'
                                                    ),
                                                }}
                                            />

                                            <MyCheckBox
                                                checkBoxState={this.state.RequestRetainerCheckBox}
                                                checkBoxOnChange={() =>
                                                    this.setState({
                                                        RequestRetainerCheckBox: !this.state.RequestRetainerCheckBox,
                                                    })
                                                }
                                            >
                                                <div
                                                    style={{ marginTop: 16 }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: this.get(
                                                            '@PatientInfo.modals.requestFinishingRetainerMessageStep1.2'
                                                        ),
                                                    }}
                                                />
                                            </MyCheckBox>
                                            <div
                                                style={{ marginTop: 16 }}
                                                dangerouslySetInnerHTML={{
                                                    __html: this.get(
                                                        '@PatientInfo.modals.requestFinishingRetainerMessageStep1.3'
                                                    ),
                                                }}
                                            />
                                            <div
                                                style={{ marginTop: 16 }}
                                                dangerouslySetInnerHTML={{
                                                    __html: this.get(
                                                        '@PatientInfo.modals.requestFinishingRetainerMessageStep1.4'
                                                    ),
                                                }}
                                            />
                                        </>
                                    }
                                </NewAcceptNotAcceptDialog>

                                <Modal
                                    className="modal"
                                    modal="caseExpireModal"
                                    title={''}
                                    open={this.state.CaseExpireModal && !this.state.loading}
                                    modalError={this.state.modalError}
                                    handleClose={() => this.setState({ CaseExpireModal: false })}
                                    isAutoFocus={false}
                                    maxWidth="sm"
                                >
                                    {this.state.CaseExpireText ? (
                                        <div>{this.get('@PatientInfo.modals.caseExpired')}</div>
                                    ) : (
                                        <div>{this.get('@PatientInfo.modals.caseExpiredWithinOneMonth')}</div>
                                    )}
                                </Modal>

                                <Modal
                                    className="modal"
                                    modal="request_finishing_retainer_step2"
                                    title={this.get('@PatientInfo.case_info.actionsList.redeemFinishingRetainer')}
                                    open={this.state.RequestFinishingRetainerStep2Modal && !this.state.loading}
                                    PhotoUploadLoadingStatus={this.state.PhotoUploadLoadingStatus}
                                    modalError={this.state.modalError}
                                >
                                    <Grid container>
                                        <Grid item xs={12} sm={12}>
                                            <FinishingRetainerTabs
                                                tabMode={
                                                    this.props.requestFinishingRetainerData
                                                        .request_finishing_retainerOptA === '0'
                                                        ? ['photo', 'impression', 'summary']
                                                        : ['photo', 'impression', 'summary']
                                                }
                                                handleChangeTabLocal={(tab) => this.handleChangeTab(tab)}
                                                handleValidation={(err) => {
                                                    this.handleValidation(err);
                                                }}
                                                selectedTab={this.props.requestFinishingRetainerData.tab}
                                            />
                                            {/* Purpose: furture application in option */}
                                            {/* <FinishingRetainerOptions>
                  </FinishingRetainerOptions> */}
                                            <FinishingRetainerPhotos
                                                mode={this.props.mode}
                                                imageUploaded={(value) => this.checkIfImageExists(value)}
                                                imageData={(value) => this.getImage(value)}
                                                parent={'main'}
                                                uploadLater={false}
                                                handleChange={(value, file) => {
                                                    this.handleUpload(value, file);
                                                }}
                                                invert={(value, invert) => {
                                                    this.invert(value, invert);
                                                }}
                                                handleRoatate={(value, degree) => {
                                                    this.handleRoatate(value, degree);
                                                }}
                                                //handleChoose={(id) => { this.handleChoose(id) }}
                                                checkInvalid={this.checkInvalid.bind(this)}
                                                //draftFileList={this.props.NewPaitientData.draftFileList}
                                                //chosenDraftFile={this.props.NewPaitientData.chosenDraftFile}
                                            />
                                            <div className={externalCss.customButton}>
                                                {
                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            this.handleClose('request_finishing_retainer_step2')
                                                        }
                                                        style={{
                                                            border: 'solid #593687 2px',
                                                            backgroundColor: 'transparent',
                                                            color: '#593687',
                                                        }}
                                                    >
                                                        {this.get('@global.const.close')}
                                                    </button>
                                                }
                                                {
                                                    <button
                                                        type="button"
                                                        onClick={() => this.handleRequestFinishingRetainerStep2Save()}
                                                        className={externalCss.next}
                                                    >
                                                        {this.get('@NewPatient.navBtns.next')}
                                                    </button>
                                                }
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Modal>
                                <Modal
                                    className="modal"
                                    modal="request_finishing_retainer_step3"
                                    open={this.state.RequestFinishingRetainerStep3Modal && !this.state.loading}
                                    modalError={this.state.modalError}
                                >
                                    <Grid container>
                                        <Grid item xs={12} sm={12}>
                                            <FinishingRetainerTabs
                                                tabMode={
                                                    this.props.requestFinishingRetainerData
                                                        .request_finishing_retainerOptA == '0'
                                                        ? ['photo', 'impression', 'summary']
                                                        : ['photo', 'impression', 'summary']
                                                }
                                                handleChangeTabLocal={(tab) => this.handleChangeTab(tab)}
                                                handleValidation={(err) => {
                                                    this.handleValidation(err);
                                                }}
                                                selectedTab={this.props.requestFinishingRetainerData.tab}
                                            />
                                            <RadioGroup
                                                aria-labelledby="demo-radio-buttons-group-label"
                                                value="1"
                                                name="radio-buttons-group"
                                                onChange={this.handleFinishingRetainerSelectOptsB}
                                            >
                                                <div style={{ display: 'flex' }}>
                                                    {/* <FormControlLabel value="0" control={<Radio checked={this.props.requestFinishingRetainerData.request_finishing_retainerOptB === "0"}/>} label={this.get('@RequestFinishingRetainer.usingExistingImpressionFiles')} /> */}
                                                    {/* <FormControlLabel value="1" control={<Radio checked={this.props.requestFinishingRetainerData.request_finishing_retainerOptB === "1"}/>} label={this.get('@RequestFinishingRetainer.newImpressionFiles')} /> */}
                                                </div>
                                            </RadioGroup>
                                            {this.props.requestFinishingRetainerData.request_finishing_retainerOptB ===
                                                '1' && (
                                                <ImpressionTabs
                                                    mode={this.props.mode}
                                                    imageUploaded={(value) => this.checkIfImageExists(value)}
                                                    uploadLater={'other'}
                                                    //uploadLater={this.props.uploadLater == 'patientInfo' ? 'patientInfo' : 'other'}
                                                    imageData={(value) => this.getImage(value)}
                                                    handleChange={(value, file) => {
                                                        this.handleUpload(value, file);
                                                    }}
                                                    checkInvalid={this.checkInvalid.bind(this)}
                                                    {...this.props.requestFinishingRetainerData}
                                                    threeshapeConnected={this.state.threeshapeConnected}
                                                    handleThreeshapeConnected={(value) =>
                                                        this.setState({ threeshapeConnected: value })
                                                    }
                                                />
                                            )}
                                            <div className={externalCss.customButton}>
                                                {
                                                    <button
                                                        style={{
                                                            border: 'solid #593687 2px',
                                                            backgroundColor: 'transparent',
                                                            color: '#593687',
                                                        }}
                                                        type="button"
                                                        onClick={() =>
                                                            this.handleChangeTab(
                                                                this.props.requestFinishingRetainerData.tab - 1
                                                            )
                                                        }
                                                    >
                                                        {this.get('@NewPatient.navBtns.previous')}
                                                    </button>
                                                }
                                                {
                                                    <button
                                                        type="button"
                                                        onClick={() => this.handleRequestFinishingRetainerStep3Save()}
                                                        className={externalCss.next}
                                                    >
                                                        {this.get('@NewPatient.navBtns.next')}
                                                    </button>
                                                }
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Modal>

                                <Modal
                                    className="modal"
                                    modal="request_finishing_retainer_step4"
                                    open={this.state.RequestFinishingRetainerStep4Modal && !this.state.loading}
                                    modalError={this.state.modalError}
                                >
                                    <Grid container>
                                        <Grid item xs={12} sm={12}>
                                            <FinishingRetainerTabs
                                                tabMode={
                                                    this.props.requestFinishingRetainerData
                                                        .request_finishing_retainerOptA == '0'
                                                        ? ['photo', 'impression', 'summary']
                                                        : ['photo', 'impression', 'summary']
                                                }
                                                handleChangeTabLocal={(tab) => this.handleChangeTab(tab)}
                                                handleValidation={(err) => {
                                                    this.handleValidation(err);
                                                }}
                                                selectedTab={this.props.requestFinishingRetainerData.tab}
                                            />
                                            <FinishingRetainerSummary />
                                            <div className={externalCss.customButton}>
                                                {
                                                    <button
                                                        style={{
                                                            border: 'solid #593687 2px',
                                                            backgroundColor: 'transparent',
                                                            color: '#593687',
                                                        }}
                                                        type="button"
                                                        onClick={() =>
                                                            this.handleChangeTab(
                                                                this.props.requestFinishingRetainerData.tab - 1
                                                            )
                                                        }
                                                    >
                                                        {this.get('@NewPatient.navBtns.previous')}
                                                    </button>
                                                }

                                                {
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            let summaryerrors = fromJS(
                                                                this.props.newPatientData.errors
                                                            );
                                                            let boolean = summaryerrors.toJS().map((v, index) => {
                                                                if (
                                                                    this.props.requestFinishingRetainerData
                                                                        .request_finishing_retainerOptB === '0' &&
                                                                    v.id === 'impression'
                                                                )
                                                                    return;
                                                                switch (v.id) {
                                                                    case 'photo': {
                                                                        return v.valid;
                                                                    }
                                                                    case 'impression': {
                                                                        return v.valid;
                                                                    }
                                                                }
                                                            });

                                                            if (!boolean.includes(false)) {
                                                                this.setState({
                                                                    RequestFinishingRetainerSubStep4Modal: true,
                                                                });
                                                            } else {
                                                                this.setState({
                                                                    RequestFinishingRetainerSubmitWarning: true,
                                                                });
                                                            }
                                                        }}
                                                        className={externalCss.submit}
                                                    >
                                                        {this.get('@NewPatient.navBtns.submit')}
                                                    </button>
                                                }
                                            </div>
                                        </Grid>

                                        <NewAcceptNotAcceptDialog
                                            title=""
                                            open={this.state.RequestFinishingRetainerSubStep4Modal}
                                            onClose={() =>
                                                this.setState({ RequestFinishingRetainerSubStep4Modal: false })
                                            }
                                            onConfirm={() => {
                                                this.setState({ RequestFinishingRetainerSubStep4Modal: false });
                                                this.handleRequestFinishingRetainerStep4Save();
                                            }}
                                        >
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: this.get(
                                                        '@PatientInfo.modals.requestFinishingRetainerMessageSubStep4.1'
                                                    ),
                                                }}
                                            />
                                            <div
                                                style={{ marginTop: 16 }}
                                                dangerouslySetInnerHTML={{
                                                    __html: this.get(
                                                        '@PatientInfo.modals.requestFinishingRetainerMessageSubStep4.2'
                                                    ),
                                                }}
                                            />
                                            <div
                                                style={{ marginTop: 16 }}
                                                dangerouslySetInnerHTML={{
                                                    __html: this.get(
                                                        '@PatientInfo.modals.requestFinishingRetainerMessageSubStep4.3'
                                                    ),
                                                }}
                                            />
                                        </NewAcceptNotAcceptDialog>

                                        <AlertDialog
                                            title="Warning"
                                            dialogOpen={this.state.RequestFinishingRetainerSubmitWarning}
                                            handleDialogClose={() =>
                                                this.setState({ RequestFinishingRetainerSubmitWarning: false })
                                            }
                                            content={this.get('@NewPatient.warning.allMandatory')}
                                        />
                                    </Grid>
                                </Modal>

                                {/* Update Status Modal */}
                                <Modal
                                    className="modal"
                                    modal="Status"
                                    title="Case Status"
                                    open={this.state.StatusModal}
                                    handleClose={() => this.handleClose('status')}
                                    handleDataSave={() => this.handleStatusUpdate()}
                                    modalError={this.state.modalError}
                                    PhotoUploadLoadingStatus={this.state.PhotoUploadLoadingStatus}
                                    submitButton={true}
                                >
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={4}>
                                            <label ref={this.statusTitleRef}>
                                                <strong>{this.get('case_info.currentStatus')}</strong>
                                            </label>
                                        </Grid>

                                        <Grid item xs={12} sm={8}>
                                            {this.state.patientInfo.caseStatusLabel}
                                        </Grid>
                                    </Grid>

                                    {this.state.patientInfo.caseStatus !== 'ENDED' &&
                                        this.state.patientInfo.caseStatus !== 'DEFECT_UPLOADED' && (
                                            <Grid container spacing={3}>
                                                <Grid item xs={12} sm={4}>
                                                    <label>
                                                        <strong>{this.get('case_info.chnageStatusTo')}</strong>
                                                    </label>
                                                    :
                                                </Grid>

                                                <Grid item xs={12} sm={8}>
                                                    <Select
                                                        value={this.state.newStatus}
                                                        displayEmpty
                                                        onChange={(event) => {
                                                            this.handleChangeStatus(event.target.value);
                                                        }}
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                    >
                                                        <MenuItem value="" disabled>
                                                            Please select new status
                                                        </MenuItem>

                                                        {this.progressUpdate(this.props)}
                                                    </Select>
                                                </Grid>
                                                {this.state.patientInfo.caseStatus === 'RETRACK_REPORT' && (
                                                    <>
                                                        <Grid item xs={12} sm={4}>
                                                            <label style={{ fontWeight: 600 }}>Delivered Sets:</label>
                                                        </Grid>

                                                        <Grid item xs={12} md={4}>
                                                            <span>{'From Set Number: '}</span>
                                                            <Select
                                                                style={{ width: '50%' }}
                                                                value={this.state.param1}
                                                                onChange={(e) =>
                                                                    this.setState({ param1: e.target.value })
                                                                }
                                                            >
                                                                {this.returnSteps()}
                                                            </Select>
                                                        </Grid>

                                                        <Grid item xs={12} md={4}>
                                                            <span>{'To Set Number: '}</span>
                                                            <Select
                                                                style={{ width: '50%' }}
                                                                value={this.state.param2}
                                                                onChange={(e) =>
                                                                    this.setState({ param2: e.target.value })
                                                                }
                                                            >
                                                                {this.returnSteps()}
                                                            </Select>
                                                        </Grid>
                                                    </>
                                                )}
                                            </Grid>
                                        )}

                                    {this.state.newStatus === 'RECEIVED' ||
                                    this.state.newStatus === 'RETRACK_ALL_MATERIAL_RECEIVED' ? (
                                        <ReceivedGrid
                                            selectedAmPmTxDate={this.state.selectedAmPmTxDate}
                                            selectedExpectedTxDate={this.state.selectedExpectedTxDate}
                                            expectedDateOnChange={(event) =>
                                                this.setState({ selectedExpectedTxDate: event.target.value })
                                            }
                                            expectedAmPmOnChange={(event) =>
                                                this.setState({ selectedAmPmTxDate: event.target.value })
                                            }
                                            newStatus={this.state.newStatus}
                                            classes={classes}
                                            disabled={this.state.disabled}
                                            remarks={this.state.awaitingRemarks}
                                            handleRemarksChange={(event) =>
                                                this.handleChangeInputData('awaitingRemarks', event.target.value)
                                            }
                                            caseSupportingImgs={this.state.caseSupportingImgs}
                                            removeCaseSupportingImgs={this.removeCaseSupportingImgs}
                                            resetCaseSupportingImgs={this.resetCaseSupportingImgs}
                                            setCaseSupportingImgs={this.setCaseSupportingImgs}
                                            setCaseSupportingImgsSubject={this.setCaseSupportingImgsSubject}
                                        />
                                    ) : null}

                                    {this.state.newStatus === 'ALL_DELIVERED' &&
                                    this.state.patientInfo.case_type !== 'RETAINER' ? (
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} md={4}></Grid>
                                            <Grid item xs={12} sm={8}>
                                                <TextField
                                                    className={classnames(classes.textField, classes.dense)}
                                                    margin="dense"
                                                    variant="standard"
                                                    value="ALL"
                                                />
                                                <TextField
                                                    className={classnames(classes.textField, classes.dense)}
                                                    margin="dense"
                                                    variant="outlined"
                                                    required
                                                    value={this.state.awaitingRemarks}
                                                    onChange={(event) =>
                                                        this.handleChangeInputData(
                                                            'awaitingRemarks',
                                                            event.target.value
                                                        )
                                                    }
                                                />
                                                <TextField
                                                    className={classnames(classes.textField, classes.dense)}
                                                    margin="dense"
                                                    variant="standard"
                                                    value="DELIVERED"
                                                />
                                            </Grid>
                                        </Grid>
                                    ) : (
                                        ''
                                    )}

                                    {this.isDisplayUpdateCaseStatusInput(CASE_STATUS.DELIVERED) && (
                                        <Grid container spacing={3}>
                                            {this.state.patientInfo.case_type !== CASE_TYPE.SELF_DESIGN && (
                                                <>
                                                    <Grid item xs={12} md={4}>
                                                        <span style={{ fontWeight: 600 }}>Delivered Sets:</span>
                                                    </Grid>

                                                    <Grid item xs={12} md={4}>
                                                        <span>{'From Set Number: '}</span>
                                                        <Select
                                                            style={{ width: '50%' }}
                                                            value={this.state.param1}
                                                            onChange={(e) => this.setState({ param1: e.target.value })}
                                                        >
                                                            {this.returnSteps()}
                                                        </Select>
                                                    </Grid>

                                                    <Grid item xs={12} md={4}>
                                                        <span>{'To Set Number: '}</span>
                                                        <Select
                                                            style={{ width: '50%' }}
                                                            value={this.state.param2}
                                                            onChange={(e) => this.setState({ param2: e.target.value })}
                                                        >
                                                            {this.returnSteps()}
                                                        </Select>
                                                    </Grid>
                                                </>
                                            )}
                                            {this.state.patientInfo.case_type === CASE_TYPE.SELF_DESIGN &&
                                                this.state.selfDesignDeliveredLoading && (
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        style={{ display: 'flex', alignItems: 'center' }}
                                                    >
                                                        <LoadingSpinner />
                                                        <span style={{ marginLeft: 8 }}>
                                                            Calculating delivered sets...
                                                        </span>
                                                    </Grid>
                                                )}
                                            <Grid item xs={12} md={4}>
                                                <span style={{ fontWeight: 600 }}>Sent On: </span>
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <Select
                                                    value={this.state.selectedExpectedTxDate}
                                                    displayEmpty
                                                    onChange={(event) =>
                                                        this.setState({
                                                            selectedExpectedTxDate: event.target.value,
                                                        })
                                                    }
                                                >
                                                    {GetDates(new Date(), 16).map((nextDate, i) => {
                                                        return <MenuItem value={nextDate}>{nextDate}</MenuItem>;
                                                    })}
                                                </Select>
                                            </Grid>
                                        </Grid>
                                    )}

                                    {this.state.newStatus === 'AWAITING' ||
                                    this.state.newStatus === 'RETRACK_AWAITING' ? (
                                        <AwaitingGrid
                                            disabled={this.state.disabled}
                                            awaitRemarks={this.state.awaitingRemarks}
                                            handleChangeInputData={(event) =>
                                                this.handleChangeInputData('awaitingRemarks', event.target.value)
                                            }
                                            classes={classes}
                                            selectedStatus={this.state.newStatus}
                                            modalOpen={this.state.StatusModal}
                                            caseSupportingImgs={this.state.caseSupportingImgs}
                                            removeCaseSupportingImgs={this.removeCaseSupportingImgs}
                                            resetCaseSupportingImgs={this.resetCaseSupportingImgs}
                                            setCaseSupportingImgs={this.setCaseSupportingImgs}
                                            setCaseSupportingImgsSubject={this.setCaseSupportingImgsSubject}
                                        />
                                    ) : null}

                                    {this.state.newStatus === 'PRODUCTION' &&
                                    this.state.patientInfo.case_type === 'RETAINER' ? (
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={4}>
                                                <label>
                                                    <strong>RETAINER:</strong>
                                                </label>
                                            </Grid>

                                            <Grid item xs={12} sm={8}>
                                                <TextField
                                                    className={classnames(classes.textField, classes.dense)}
                                                    margin="dense"
                                                    variant="outlined"
                                                    required
                                                    value={this.state.awaitingRemarks}
                                                    onChange={(event) =>
                                                        this.handleChangeInputData(
                                                            'awaitingRemarks',
                                                            event.target.value
                                                        )
                                                    }
                                                />
                                                <TextField
                                                    className={classnames(classes.textField, classes.dense)}
                                                    margin="dense"
                                                    variant="standard"
                                                    value="PRODUCTION"
                                                />

                                                <Select
                                                    value={this.state.selectedExpectedTxDate}
                                                    displayEmpty
                                                    onChange={(event) =>
                                                        this.setState({ selectedExpectedTxDate: event.target.value })
                                                    }
                                                >
                                                    {GetDates(new Date(), 16).map((nextDate, i) => {
                                                        return <MenuItem value={nextDate}>{nextDate}</MenuItem>;
                                                    })}
                                                </Select>
                                            </Grid>
                                        </Grid>
                                    ) : (
                                        ''
                                    )}

                                    {this.state.newStatus === 'RETRACK_REPORT' ? (
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={4}>
                                                <span style={{ fontWeight: 600 }}>Remake Sets: </span>
                                            </Grid>

                                            <Grid item xs={12} md={8}>
                                                <Select
                                                    value={this.state.remakeSets}
                                                    onChange={(e) => this.handleRetrackRemakeSets(e)}
                                                >
                                                    <MenuItem value="NULL" key="NULL" selected>
                                                        Null
                                                    </MenuItem>
                                                    <MenuItem value="FILL" key="FILL" selected>
                                                        Fill
                                                    </MenuItem>
                                                </Select>
                                            </Grid>

                                            {this.state.remakeSets === 'FILL' && (
                                                <>
                                                    <Grid item xs={12} sm={4}></Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <span>{'From Set Number: '}</span>
                                                        <Select
                                                            style={{ width: '50%' }}
                                                            value={this.state.param1}
                                                            onChange={(e) => this.setState({ param1: e.target.value })}
                                                        >
                                                            {this.returnSteps()}
                                                        </Select>
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <span>{'To Set Number: '}</span>
                                                        <Select
                                                            style={{ width: '50%' }}
                                                            value={this.state.param2}
                                                            onChange={(e) => this.setState({ param2: e.target.value })}
                                                        >
                                                            {this.returnSteps()}
                                                        </Select>
                                                    </Grid>
                                                </>
                                            )}

                                            <Grid item xs={12} sm={12}>
                                                <span style={{ fontWeight: 600 }}>Fill in Retrack Report: </span>
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <RetrackReport caseId={this.state.caseId} />
                                            </Grid>
                                        </Grid>
                                    ) : (
                                        ''
                                    )}

                                    {this.state.newStatus === 'RETRACK_END' && (
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={4}>
                                                <span style={{ fontWeight: 600 }}>Retrack End Reason:</span>
                                            </Grid>
                                            <Grid item xs={12} md={8}>
                                                <RetrackEndReasonInput />
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <span style={{ fontWeight: 600 }}>Fill in Retrack Report: </span>
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <RetrackReport caseId={this.state.caseId} />
                                            </Grid>
                                        </Grid>
                                    )}
                                </Modal>
                                <RetrackModal
                                    open={this.state.RetrackModal}
                                    handleClose={() => this.handleClose('retrack')}
                                    modalError={this.state.modalError}
                                    PhotoUploadLoadingStatus={this.state.PhotoUploadLoadingStatus}
                                    caseId={this.state.caseId}
                                    handlePhoto={this.handleUpload}
                                    loadingState={this.loadingState}
                                    loadingProgress={this.progressBarRef.current?.onProgressChange}
                                    showModalError={this.showModalError}
                                    reloadPage={this.retrackReloadPage}
                                    props={this.props}
                                />

                                <Modal
                                    className="modal"
                                    modal="Info"
                                    title={this.get('modals.infoModalTitle')}
                                    open={this.state.InfoModal && !this.state.loading}
                                    modalSize="md"
                                    submitButton={true}
                                    submitButtonLabel="Submit"
                                    checkCondition={this.state.tcCheckbox}
                                    handleDataSave={async () => await this.handleInfoSave()}
                                    PhotoUploadLoadingStatus={this.state.PhotoUploadLoadingStatus}
                                    handleClose={() => this.handleClose('info')}
                                    modalError={this.state.modalError}
                                >
                                    <Grid container>
                                        <NewPatientInfo
                                            editNewCase={false}
                                            disabledNewPatientInfoInputObj={this.disabledNewPatientInfoInputObj()}
                                            case_id={this.props.match.params.id}
                                            role={role}
                                            doctor_patient_list={[]}
                                            current_patient_id={null}
                                            isSamePatientCreateNewCaseAction={false}
                                            UpdateNewCaseForExistPatientFunc={() => {}}
                                            isStartedCaseEditPatientInfo={true}
                                            isStartedCaseDrRemarks={false}
                                        />
                                    </Grid>
                                </Modal>

                                <Modal
                                    className="modal"
                                    modal="drRemarks"
                                    title={this.get('modals.drRemarksModalTitle')}
                                    open={this.state.DrRemarksModal && !this.state.loading}
                                    modalSize="md"
                                    submitButton={true}
                                    submitButtonLabel="Submit"
                                    handleClose={() => this.handleClose('drRemarks')}
                                    handleDataSave={async () => await this.handleInfoSave()}
                                >
                                    <NewPatientInfo
                                        editNewCase={false}
                                        disabledNewPatientInfoInputObj={this.disabledNewPatientInfoInputObj()}
                                        case_id={this.props.match.params.id}
                                        role={role}
                                        doctor_patient_list={[]}
                                        current_patient_id={null}
                                        isSamePatientCreateNewCaseAction={false}
                                        UpdateNewCaseForExistPatientFunc={() => {}}
                                        isStartedCaseEditPatientInfo={false}
                                        isStartedCaseDrRemarks={true}
                                    />
                                </Modal>

                                <Modal
                                    className="modal"
                                    modal="Aligner"
                                    title={this.get('modals.lostReplaceAlignersTitle')}
                                    open={this.state.AlignerModal}
                                    modalSize="md"
                                    submitButton={true}
                                    submitButtonLabel="Submit"
                                    checkCondition={this.state.tcCheckbox}
                                    handleDataSave={() => this.handleAlignerSave()}
                                    PhotoUploadLoadingStatus={this.state.PhotoUploadLoadingStatus}
                                    handleClose={() => this.handleClose('aligner')}
                                    modalError={this.state.modalError}
                                >
                                    <Aligner
                                        handleChnageSizeAligner={(value, index) =>
                                            this.handleChnageSizeAligner(value, index)
                                        }
                                        handleChangeArch={(index, value) => this.handleChangeArch(index, value)}
                                        removeAligner={(index, value) => this.removeAligner(index, value)}
                                        addAligner={() => this.addAligner()}
                                        checked={this.state.tcCheckbox}
                                        handleChangeCheckBox={() => this.handleChangetcBox()}
                                        aligner={this.state.aligner}
                                        alignertype={this.state.alignertype}
                                        handleChnageAlignerType={(value) => this.handleChnageAlignerType(value)}
                                    />
                                </Modal>

                                <Modal
                                    className="modal"
                                    modal="refinement"
                                    title={this.state.defect_resubmit ? 'Defect Resubmit' : 'Refinement'}
                                    open={this.state.RefinementModal && !this.state.loading}
                                    handleClose={() => this.handleClose('refinement')}
                                >
                                    {this.state.refinementNewPrescriptionNotesFlag &&
                                        this.state.refinementHasDetail && (
                                            <PrescriptionNotes
                                                readOnly={true}
                                                mode="view"
                                                formType={FORM_TYPE.REFINEMENT}
                                            />
                                        )}
                                    {!this.state.refinementNewPrescriptionNotesFlag &&
                                        this.state.refinementHasDetail && <NewPatientQuestionnaire mode="view" />}
                                    {this.state.refinementHasFile && <Refinement tabMode="photos" mode="view" />}
                                    {!this.state.defect_resubmit &&
                                    this.state.patientInfo.ray_info &&
                                    this.state.patientInfo.ray_info.gallery &&
                                    this.state.patientInfo.ray_info.gallery.length &&
                                    this.state.patientInfo.ray_info.gallery[this.state.currentRefinementNo] ? (
                                        <>
                                            <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                                                {this.get('@NewPatient.3dFile.uploadedFromGallerySentence')}
                                            </div>
                                            <div style={{ padding: '10px', border: '1px dotted grey' }}>
                                                {
                                                    this.state.patientInfo.ray_info.gallery[
                                                        this.state.currentRefinementNo
                                                    ]
                                                }
                                            </div>
                                        </>
                                    ) : (
                                        ''
                                    )}
                                    {this.state.refinementHasFile && <Refinement tabMode="radiography" mode="view" />}
                                    {this.state.refinementHasImpression && (
                                        <Refinement tabMode="impression" mode="view" />
                                    )}
                                    {this.state.refinementHasComment && (
                                        <ul className={NewPatientPhotosStyle.patientImages}>
                                            <TextField
                                                id="outlined-basic"
                                                label={getFromObj(
                                                    this.props.lang,
                                                    'dict.NewPatient.questionnaire.comment'
                                                )}
                                                value={this.props.newPatientData.comment}
                                                variant="outlined"
                                                multiline
                                                rows={3}
                                                style={{ width: '100%' }}
                                            />
                                        </ul>
                                    )}
                                </Modal>

                                {/* View Finishing Retainer Modal */}
                                <Modal
                                    className="modal"
                                    modal="viewFinishingRetainerDataModal"
                                    title={this.get('@PatientInfo.case_info.actionsList.finishing_retainer')}
                                    open={this.state.ViewFinishingRetainerModal && !this.state.loading}
                                    handleClose={() => this.handleClose('viewFinishingRetainerModal')}
                                >
                                    <CaseLogInfo
                                        dataArray={this.state.finishingRetainerArray}
                                        idKey={'finishing_retainer_id'}
                                        caseKey={'case_finishing_retainer'}
                                        idState={this.state.finishingRetainerId}
                                        caseActivityLogIdState={this.state.case_activity_log_id}
                                    />
                                </Modal>

                                <ViewRetrackReportModal
                                    viewRetrackReportModalState={this.state.ViewRetrackReportModal}
                                    loadingState={this.state.loading}
                                    caseRetrackReportId={this.state.caseRetrackReportId}
                                    caseId={this.state.caseId}
                                    handleClose={() => this.handleClose('viewRetrackReportModal')}
                                />
                                <ViewRestorationFormFirstFitModal
                                    open={this.state.ViewRestorationFormFirstFitModal && !this.state.loading}
                                    handleClose={() => this.handleClose('viewRestorationFormFirstFitModal')}
                                    caseId={this.state.caseId}
                                    restorationFormId={this.state.restorationFormId}
                                    caseImpressionId={this.state.restorativePhaseCaseImpressionId}
                                    viewType={this.state.restorativePhaseViewType}
                                    hasMockupOrder={this.state.hasMockupOrder}
                                    caseImpressions={this.state.patientInfo.case_impression}
                                />
                                <ViewRestorationFormModal
                                    open={this.state.ViewRestorationToolFormModal && !this.state.loading}
                                    handleClose={() => this.handleClose('viewRestorationToolFormModal')}
                                    caseId={this.state.caseId}
                                    restorationFormId={this.state.restorationFormId}
                                />
                                <Modal
                                    className="modal"
                                    modal="viewMockupOrderModal"
                                    title={`Mock-up Order #${this.state.mockupRequestId}`}
                                    open={this.state.ViewMockupOrderModal}
                                    handleClose={() => this.handleClose('viewMockupOrderModal')}
                                >
                                    {this.state.mockupOrderLoading ? (
                                        <LoadingSpinner />
                                    ) : (
                                        this.state.mockupOrderData && (
                                            <>
                                                <div style={{ marginBottom: 16 }}>
                                                    <div>{this.get('@PatientInfo.smileDesign.clinicalApprovement.Restoration.typeQuestion')}</div>
                                                    <div style={{ paddingLeft: 12, marginTop: 5  }}>
                                                        {this.getMockupOrderOptionLabel(this.state.mockupOrderData.restorationType)}
                                                    </div>
                                                </div>
                                                <div style={{ marginBottom: 16 }}>
                                                    <div>{this.get('@PatientInfo.smileDesign.clinicalApprovement.Restoration.orderBiofunctionalMockup')}</div>
                                                    <div style={{ paddingLeft: 12, marginTop: 5 }}>
                                                        {this.getMockupOrderOptionLabel(this.state.mockupOrderData.biofunctionalMockupOrder)}
                                                    </div>
                                                    {this.state.mockupOrderData.biofunctionalMockupOrder === 'option.mockupKeyAndMaterial' && (
                                                        <div style={{ paddingLeft: 12, marginTop: 8 }}>
                                                            a. {this.get('@PatientInfo.smileDesign.clinicalApprovement.Restoration.materialShade')}: {this.state.mockupOrderData.materialShade}
                                                        </div>
                                                    )}
                                                </div>
                                                <div style={{ marginBottom: 16 }}>
                                                    <div>{this.get('@PatientInfo.smileDesign.clinicalApprovement.Restoration.orderGingivectomyGuide')}</div>
                                                    <div style={{ paddingLeft: 12, marginTop: 5  }}>
                                                        {this.getMockupOrderOptionLabel(this.state.mockupOrderData.gingivectomyGuide)}
                                                    </div>
                                                </div>
                                                {
                                                    this.state.mockupOrderData.remark && <div>
                                                        <div style={{ marginBottom: 8 }}>{this.get('@PatientInfo.smileDesign.clinicalApprovement.Restoration.Remark')}?</div>
                                                        <div style={{ paddingLeft: 12, marginTop: 5  }}>
                                                            {this.state.mockupOrderData.remark}
                                                        </div>
                                                        {/* <TextField
                                                            value={this.state.mockupOrderData.remark || ''}
                                                            fullWidth
                                                            multiline
                                                            rows={3}
                                                            style={{ color:'rgba(0, 0, 0, 0.87)' }}
                                                            variant="outlined"
                                                            InputProps={{ readOnly: true }}
                                                        /> */}
                                                    </div>
                                                }
                                                
                                            </>
                                        )
                                    )}
                                </Modal>
                                <RestorationToolFormModal
                                    isMarieGroup={this.state.isMarieGroup}
                                    caseId={this.state.caseId}
                                    open={this.state.openUpsellRestorationToolFormModal}
                                    formType={UPSELL_RESTORATION_TOOL_FORM_TYPE.RESTORATION_TOOL_FORM_WITH_NEW_SCAN}
                                    shouldSubmitRestorationFormWithNewScan={
                                        this.state.upsellOperationData.shouldSubmitRestorationFormWithNewScan
                                    }
                                    handleClose={this.handleCloseUpsellRestorationFormModal}
                                    onError={(error) => this.onSubmitUpsellRestorationFormError(error)}
                                    onSuccess={() => this.onSubmitUpsellRestorationFormSuccess()}
                                />

                                <Dialog
                                    open={this.state.viewManufactureDetailModal}
                                    onClose={() => this.handleClose('viewManufactureDetailModal')}
                                    maxWidth="sm"
                                    fullWidth
                                >
                                    <DialogTitle style={{ fontWeight: 700 }}>
                                        {this.get('case_info.manufactureDetail.title')}
                                    </DialogTitle>
                                    <DialogContent>
                                        {this.state.manufactureDetailLoading && (
                                            <div style={{ display: 'flex', justifyContent: 'center', padding: 16 }}>
                                                <LoadingSpinner />
                                            </div>
                                        )}
                                        {this.state.manufactureDetailError && (
                                            <Typography color="error" align="center">
                                                {this.state.manufactureDetailError}
                                            </Typography>
                                        )}
                                        {this.state.manufactureDetailData &&
                                            !this.state.manufactureDetailLoading &&
                                            !this.state.manufactureDetailError && (
                                                <>
                                                    {this.state.manufactureDetailStages ? (
                                                        buildSetList(
                                                            this.state.manufactureDetailStages.upper,
                                                            this.state.manufactureDetailStages.lower
                                                        ).map((set) => (
                                                            <div
                                                                key={`manufacture-set-${set.setNo}`}
                                                                style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    padding: '6px 0',
                                                                }}
                                                            >
                                                                <span style={{ fontSize: 14, color: '#000' }}>
                                                                    {this.get('case_info.manufactureDetail.alignerSet')}{' '}
                                                                    {set.setNo}
                                                                </span>
                                                                <span style={{ fontSize: 14, color: '#000' }}>
                                                                    {this.get('case_info.manufactureDetail.stepNumber')}:{' '}
                                                                    {set.from === set.to
                                                                        ? ` ${set.from}`
                                                                        : ` ${set.from}-${set.to}`}
                                                                    {'  '}
                                                                    {this.get('case_info.manufactureDetail.arch')}:{' '}
                                                                    <u>
                                                                        {this.get(
                                                                            set.arch === 'Upper'
                                                                                ? 'case_info.manufactureDetail.upper'
                                                                                : 'case_info.manufactureDetail.lower'
                                                                        )}
                                                                    </u>
                                                                </span>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <>
                                                            {this.state.manufactureDetailData.upperAligners > 0 && (
                                                                <div
                                                                    style={{
                                                                        display: 'flex',
                                                                        justifyContent: 'space-between',
                                                                        padding: '6px 0',
                                                                    }}
                                                                >
                                                                    <span style={{ fontSize: 14, color: '#000' }}>
                                                                        {this.get(
                                                                            'case_info.manufactureDetail.alignerSet'
                                                                        )}{' '}
                                                                        1
                                                                    </span>
                                                                    <span style={{ fontSize: 14, color: '#000' }}>
                                                                        {this.get(
                                                                            'case_info.manufactureDetail.stepNumber'
                                                                        )}
                                                                        :{' 1-'}
                                                                        {this.state.manufactureDetailData
                                                                            .upperAligners}
                                                                        {'  '}
                                                                        {this.get(
                                                                            'case_info.manufactureDetail.arch'
                                                                        )}
                                                                        :{' '}
                                                                        <u>
                                                                            {this.get(
                                                                                'case_info.manufactureDetail.upper'
                                                                            )}
                                                                        </u>
                                                                    </span>
                                                                </div>
                                                            )}
                                                            {this.state.manufactureDetailData.lowerAligners > 0 && (
                                                                <div
                                                                    style={{
                                                                        display: 'flex',
                                                                        justifyContent: 'space-between',
                                                                        padding: '6px 0',
                                                                    }}
                                                                >
                                                                    <span style={{ fontSize: 14, color: '#000' }}>
                                                                        {this.get(
                                                                            'case_info.manufactureDetail.alignerSet'
                                                                        )}{' '}
                                                                        2
                                                                    </span>
                                                                    <span style={{ fontSize: 14, color: '#000' }}>
                                                                        {this.get(
                                                                            'case_info.manufactureDetail.stepNumber'
                                                                        )}
                                                                        :{' 1-'}
                                                                        {this.state.manufactureDetailData
                                                                            .lowerAligners}
                                                                        {'  '}
                                                                        {this.get(
                                                                            'case_info.manufactureDetail.arch'
                                                                        )}
                                                                        :{' '}
                                                                        <u>
                                                                            {this.get(
                                                                                'case_info.manufactureDetail.lower'
                                                                            )}
                                                                        </u>
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </>
                                                    )}
                                                    {this.state.manufactureDetailData.attachmentTemplatesPresent && (
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                padding: '6px 0',
                                                            }}
                                                        >
                                                            <span style={{ fontSize: 14, color: '#000' }}>
                                                                {this.get(
                                                                    'case_info.manufactureDetail.attachmentTemplates'
                                                                )}
                                                            </span>
                                                            <span style={{ fontSize: 14, color: '#000' }}>
                                                                {this.get('case_info.manufactureDetail.number')}:{' '}
                                                                {
                                                                    this.state.manufactureDetailData
                                                                        .totalAttachmentTemplates
                                                                }
                                                            </span>
                                                        </div>
                                                    )}
                                                    {this.state.manufactureDetailData.passiveAlignersPresent && (
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                padding: '6px 0',
                                                            }}
                                                        >
                                                            <span style={{ fontSize: 14, color: '#000' }}>
                                                                {this.get('case_info.manufactureDetail.passiveAligner')}
                                                            </span>
                                                            <span style={{ fontSize: 14, color: '#000' }}>
                                                                {this.get('case_info.manufactureDetail.number')}:{' '}
                                                                {this.state.manufactureDetailData.totalPassiveAligners}
                                                            </span>
                                                        </div>
                                                    )}
                                                    {this.state.manufactureDetailData.retainersPresent && (
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                padding: '6px 0',
                                                            }}
                                                        >
                                                            <span style={{ fontSize: 14, color: '#000' }}>
                                                                {this.get(
                                                                    'case_info.manufactureDetail.ecodontRetainer'
                                                                )}
                                                            </span>
                                                            <span style={{ fontSize: 14, color: '#000' }}>
                                                                {this.get('case_info.manufactureDetail.number')}:{' '}
                                                                {this.state.manufactureDetailData.totalRetainers}
                                                            </span>
                                                        </div>
                                                    )}
                                                    {this.state.manufactureDetailData.trimmingLineType && (
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                padding: '6px 0',
                                                            }}
                                                        >
                                                            <span style={{ fontSize: 14, color: '#000' }}>
                                                                {this.get('case_info.manufactureDetail.trimline')}
                                                            </span>
                                                            <span style={{ fontSize: 14, color: '#000' }}>
                                                                {this.getTrimlineLabel(
                                                                    this.state.manufactureDetailData.trimmingLineType
                                                                )}
                                                            </span>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                    </DialogContent>
                                    <DialogActions>
                                        <div style={{ width: '100%', textAlign: 'right' }}>
                                            <Button
                                                onClick={() => this.handleClose('viewManufactureDetailModal')}
                                                style={{ color: '#000' }}
                                            >
                                                {this.get('case_info.manufactureDetail.close')}
                                            </Button>
                                        </div>
                                    </DialogActions>
                                </Dialog>

                                <Modal
                                    className="modal"
                                    modal="viewRetrackDataModal"
                                    title={this.get('@PatientInfo.case_info.actionsList.retrack')}
                                    open={this.state.ViewRetrackDataModal && !this.state.loading}
                                    handleClose={() => this.handleClose('viewRetrackDataModal')}
                                >
                                    <>
                                        {this.state.retrackDataArray.length != 0 &&
                                            this.state.retrackDataArray.map((item, index) => {
                                                let retrackItem = item.case_retrack;
                                                let retrackCaseFile = retrackItem.case_file;
                                                let teethNotTrack = retrackItem.teethNotTrack;
                                                let teethIncludedGap = retrackItem.teethIncludedGap;
                                                let retrackQuestion = retrackItem.case_retrack_detail;
                                                const photos = Object.entries(retrackCaseFile).filter(
                                                    ([key]) => key.startsWith('photo') && retrackCaseFile[key] !== null
                                                );

                                                if (
                                                    retrackItem.retrack_id === this.state.retrackId &&
                                                    this.state.case_activity_log_id === item.case_activity_log_id
                                                )
                                                    return (
                                                        <Fragment key={index}>
                                                            <div style={{ display: 'block', width: '100%' }}>
                                                                <p style={{ display: 'inline', marginRight: '15px' }}>
                                                                    <strong>{this.get('modals.uploadedAt')}</strong> :
                                                                    {Moment(item.created_date).format(
                                                                        'YYYY-MM-DD HH:mm'
                                                                    )}
                                                                </p>
                                                                <hr />
                                                            </div>
                                                            {retrackQuestion &&
                                                                retrackQuestion.retrack_id === this.state.retrackId && (
                                                                    <div style={{ marginRight: 40, marginBottom: 12 }}>
                                                                        <div style={{ marginBottom: 8 }}>
                                                                            Upper: {retrackQuestion.aligner_upper}
                                                                        </div>
                                                                        <div>
                                                                            Lower: {retrackQuestion.aligner_lower}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            {teethNotTrack && (
                                                                <TeethSelect
                                                                    defaultTeethArray={teethNotTrack
                                                                        .split(',')
                                                                        .map(Number)}
                                                                    teethConfig={teethConfig}
                                                                    imageNameInPrescriptionNotesFolder="checkFail"
                                                                />
                                                            )}
                                                            {teethIncludedGap && (
                                                                <TeethSelect
                                                                    defaultTeethArray={teethIncludedGap
                                                                        .split(',')
                                                                        .map(Number)}
                                                                    teethConfig={teethGapConfig}
                                                                    imageNameInPrescriptionNotesFolder="Ellipse"
                                                                />
                                                            )}

                                                            {retrackItem.case_file && (
                                                                <>
                                                                    <div style={{ display: 'block', width: '100%' }}>
                                                                        <p
                                                                            style={{
                                                                                display: 'inline',
                                                                                marginRight: '15px',
                                                                            }}
                                                                        >
                                                                            <strong>
                                                                                {this.get('modals.uploadedAt')}
                                                                            </strong>{' '}
                                                                            :
                                                                            {Moment(item.created_date).format(
                                                                                'YYYY-MM-DD HH:mm'
                                                                            )}
                                                                        </p>
                                                                        <hr />
                                                                    </div>
                                                                    <Button
                                                                        onClick={() =>
                                                                            this.downloadImages(
                                                                                retrackCaseFile,
                                                                                'photo'
                                                                            )
                                                                        }
                                                                        variant="outlined"
                                                                    >
                                                                        {this.get('modals.download')}
                                                                    </Button>
                                                                    <Grid container>
                                                                        {photos.map(([key, value]) => (
                                                                            <Grid
                                                                                item
                                                                                xs={6}
                                                                                sm={6}
                                                                                md={4}
                                                                                key={key}
                                                                                style={{
                                                                                    padding: 8,
                                                                                    textAlign: 'center',
                                                                                }}
                                                                            >
                                                                                <Zoom zoomMargin={48}>
                                                                                    <img
                                                                                        src={join(ApiServerUrl, value)}
                                                                                        style={{
                                                                                            maxHeight: 300,
                                                                                            width: 'auto',
                                                                                            marginLeft: 'auto',
                                                                                            marginRight: 'auto',
                                                                                            maxWidth: '100%',
                                                                                        }}
                                                                                    />
                                                                                </Zoom>
                                                                            </Grid>
                                                                        ))}
                                                                    </Grid>
                                                                </>
                                                            )}

                                                            {retrackItem.case_impression && (
                                                                <>
                                                                    <div style={{ display: 'block', width: '100%' }}>
                                                                        <p
                                                                            style={{
                                                                                display: 'inline',
                                                                                marginRight: '15px',
                                                                            }}
                                                                        >
                                                                            <strong>
                                                                                {this.get('modals.uploadedAt')}
                                                                            </strong>{' '}
                                                                            :
                                                                            {Moment(item.created_date).format(
                                                                                'YYYY-MM-DD HH:mm'
                                                                            )}
                                                                        </p>
                                                                        <hr />
                                                                    </div>
                                                                    <Grid
                                                                        item
                                                                        xs={12}
                                                                        sm={12}
                                                                        md={12}
                                                                        style={{ padding: 8, textAlign: 'left' }}
                                                                    >
                                                                        <ImpressionViewer
                                                                            caseImpression={retrackItem.case_impression}
                                                                        />
                                                                    </Grid>
                                                                </>
                                                            )}
                                                        </Fragment>
                                                    );
                                            })}
                                    </>
                                </Modal>

                                <Modal
                                    className="modal"
                                    modal="treatmentPlan"
                                    title="Treatment Plan"
                                    open={this.state.TreatmentModal && !this.state.loading}
                                    handleClose={() => this.handleClose('treatment')}
                                    handleDataSave={() => this.handleTreatmentSave()}
                                    submitButton={true}
                                    PhotoUploadLoadingStatus={this.state.PhotoUploadLoadingStatus}
                                    modalError={this.state.modalError}
                                >
                                    {this.state.ModalState == 'update' ? (
                                        <Treatment
                                            patientInfo={this.state.patientInfo}
                                            treatmentPlan={this.state.treatmentPlan}
                                            handleTreatmentData={(data, stateType, fileName) =>
                                                this.handleTreatmentData(data, stateType, fileName)
                                            }
                                            upsellOperationData={this.state.upsellOperationData}
                                        />
                                    ) : (
                                        ''
                                    )}
                                </Modal>

                                <Modal
                                    className="modal"
                                    modal="rfsmodal"
                                    title={this.get('modals.rfsModalTitle')}
                                    open={this.state.RFSModal && !this.state.loading}
                                    handleClose={() => this.handleClose('rfs')}
                                >
                                    {this.state.rfsFiles.length ? (
                                        this.state.rfsFiles.map((v) => {
                                            return (
                                                <div>
                                                    {v.refinement_no ? <p>Refinement #{v.refinement_no}</p> : ''}
                                                    <p>
                                                        <strong>{this.get('modals.uploadedAt')}</strong> :{' '}
                                                        {Moment(v.created_date).format('YYYY-MM-DD HH:mm')}
                                                    </p>
                                                    <Button
                                                        className={classes.linkBtn}
                                                        onClick={() => this.downloadRFSFile(this.state.caseId, v.rfs)}
                                                    >
                                                        {this.get('case_info.documentsList.downloadRFSFile') ??
                                                            'Download RFS'}
                                                    </Button>
                                                </div>
                                            );
                                        })
                                    ) : (
                                        <></>
                                    )}
                                </Modal>

                                <Modal
                                    className="modal"
                                    modal="photo"
                                    title={this.get('modals.photoModalTitle')}
                                    open={this.state.PhotoModal && !this.state.loading}
                                    handleClose={() => this.handleClose('photo')}
                                    handleDataSave={() => this.handlePhotoDataSave()}
                                    submitButton={this.state.ModalState == 'update' ? true : false}
                                    PhotoUploadLoadingStatus={this.state.PhotoUploadLoadingStatus}
                                    modalError={this.state.modalError}
                                >
                                    {!['INTERNATIONAL'].includes(process.env.REACT_APP_ENV) ||
                                    this.state.ModalState == 'update' ? (
                                        ''
                                    ) : (
                                        <ProgressPhotosCard
                                            progressPhotos={this.state.progress_photos}
                                            progressPhotoAngles={progress_photo_angles}
                                            get={(str) => this.get(str)}
                                        />
                                    )}
                                    {this.state.ModalState == 'update' ? (
                                        <Refinement tabMode="photos" uploadLater="patientInfo" />
                                    ) : (
                                        [...this.state.patientInfo.case_file]
                                            .reverse()
                                            .filter((v) => !!v)
                                            .map((refinement, index, arr) => {
                                                if (this.state.targetId) {
                                                    refinement = refinement.filter(
                                                        (v) => v.case_file_id === this.state.targetId
                                                    );
                                                }
                                                const content = refinement
                                                    .sort((a, b) => new Date(b.created_date) - new Date(a.created_date))
                                                    .map((file, index) => {
                                                        const photos = getPhotosWithRadiographs(file);
                                                        if (photos.length) {
                                                            return (
                                                                <div key={index}>
                                                                    <div style={{ display: 'block', width: '100%' }}>
                                                                        {file.refinement_no ? (
                                                                            <Typography variant="body1">
                                                                                {file.defect_resubmit_flag === true
                                                                                    ? `Defect Resubmit ${file.refinement_no}`
                                                                                    : `Refinement #${file.refinement_no}`}
                                                                            </Typography>
                                                                        ) : (
                                                                            <></>
                                                                        )}
                                                                        <p
                                                                            style={{
                                                                                display: 'inline',
                                                                                marginRight: '15px',
                                                                            }}
                                                                        >
                                                                            <strong>
                                                                                {this.get('modals.uploadedAt')}
                                                                            </strong>{' '}
                                                                            :
                                                                            {Moment(file.created_date).format(
                                                                                'YYYY-MM-DD HH:mm'
                                                                            )}
                                                                        </p>
                                                                        <Button
                                                                            onClick={() => {
                                                                                this.downloadImages(file, 'photo')
                                                                                this.downloadImages(file, 'facial_scan_file')
                                                                            }}
                                                                            variant="outlined"
                                                                        >
                                                                            {this.get('modals.download')}
                                                                        </Button>
                                                                        {file.from_app ? (
                                                                            <p
                                                                                style={{
                                                                                    display: 'inline',
                                                                                    marginLeft: '15px',
                                                                                    color: 'red',
                                                                                }}
                                                                            >
                                                                                <strong>
                                                                                    For internal reference only. No
                                                                                    workflow for production team.
                                                                                </strong>
                                                                            </p>
                                                                        ) : (
                                                                            ''
                                                                        )}
                                                                        <hr />
                                                                    </div>
                                                                    <Grid container>
                                                                        {photos.map(
                                                                            ([key, value]) =>
                                                                                value &&( key === 'facial_scan_file' ? (
                                                                                    <Grid container>
                                                                                        <Grid item xs={4}>
                                                                                            <div>
                                                                                                <img
                                                                                                    src={getWebAbsPath('/img/uploaded.png')}
                                                                                                    style={{
                                                                                                        maxHeight: '300px',
                                                                                                        width: 'auto',
                                                                                                        marginLeft: 'auto',
                                                                                                        marginRight: 'auto',
                                                                                                        maxWidth: '100%',
                                                                                                    }}
                                                                                                />
                                                                                                <Typography variant="subtitle1">3D Facial Scan</Typography>
                                                                                            </div>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                )  :(
                                                                                    <Grid
                                                                                        item
                                                                                        xs={6}
                                                                                        sm={6}
                                                                                        md={4}
                                                                                        key={key}
                                                                                        style={{
                                                                                            padding: 8,
                                                                                            textAlign: 'center',
                                                                                        }}
                                                                                    >
                                                                                        <Zoom zoomMargin={48}>
                                                                                            <img
                                                                                                src={join(
                                                                                                    ApiServerUrl,
                                                                                                    value
                                                                                                )}
                                                                                                style={{
                                                                                                    maxHeight: 300,
                                                                                                    width: 'auto',
                                                                                                    marginLeft: 'auto',
                                                                                                    marginRight: 'auto',
                                                                                                    maxWidth: '100%',
                                                                                                }}
                                                                                            />
                                                                                        </Zoom>
                                                                                    </Grid>
                                                                                ))
                                                                        )}
                                                                    </Grid>
                                                                </div>
                                                            );
                                                        } else {
                                                            return null;
                                                        }
                                                    });
                                                return (
                                                    !!content.length && (
                                                        <Grid container>
                                                            <Grid item xs={12}>
                                                                {content}
                                                            </Grid>
                                                        </Grid>
                                                    )
                                                );
                                            })
                                    )}
                                </Modal>
                                <Modal
                                    className="modal"
                                    modal="replaceMyp"
                                    title={'Upload Converted MYP File Screen'}
                                    open={this.state.ReplaceMypModal && !this.state.loading}
                                    handleClose={() => this.handleClose('replaceMyp')}
                                    handleDataSave={() => this.handleMypDataSave()}
                                    submitButton={true}
                                    replaceMypLoadingStatus={this.state.replaceMypLoadingStatus}
                                    modalError={this.state.modalError}
                                >
                                    {
                                        <ReplaceMyp
                                            ref={this.ReplaceMypDialogRef}
                                            patientInfo={this.state.patientInfo}
                                            TreatmentPlanData={this.state.patientInfo.treatment_plan}
                                            handleMyoFileUploaded={(res) => this.handleMyoFileUploaded(res)}
                                            handleChangeTreatmentPlanId={(value) =>
                                                this.handleChangeTreatmentPlanId(value)
                                            }
                                            handleChangeSmile3d={() => this.handleChangeSmile3d()}
                                        />
                                    }
                                </Modal>
                                <Modal
                                    className="modal"
                                    modal="defect"
                                    title={this.get('modals.viewDefectPhotos')}
                                    open={this.state.DefectModal && !this.state.loading}
                                    handleClose={() => this.handleClose('defect')}
                                    handleDataSave={() => this.handleDefectDataSave()}
                                    modalSize="xl"
                                    //submitButton={this.state.ModalState == 'update' ? true : false}
                                    //PhotoUploadLoadingStatus={this.state.PhotoUploadLoadingStatus}
                                    //modalError={this.state.modalError}
                                >
                                    {this.state.ModalState == 'update' ? (
                                        <Modal
                                            className="modal"
                                            //modal='treatmentPlan'
                                            //title='Treatment Plan'
                                            open={true}
                                            handleClose={() => this.handleClose('defect')}
                                            handleDataSave={() => this.handleDefectSave()}
                                            submitButton={true}
                                            modalSize="xl"
                                            //PhotoUploadLoadingStatus={this.state.PhotoUploadLoadingStatus}
                                            //modalError={this.state.modalError}
                                        >
                                            <Defect
                                                defect={this.state.defect}
                                                handleSelect={(val) => this.handleSelect(val)}
                                                handleDefectData={(data, stateType, fileName) =>
                                                    this.handleDefectData(data, stateType, fileName)
                                                }
                                            />
                                        </Modal>
                                    ) : (
                                        this.state.patientInfo.case_defect
                                            ?.filter((v) => !!v)
                                            .map((defect, index, arr) => {
                                                if (this.state.targetId) {
                                                    defect = defect.filter((v) => v.id === this.state.targetId);
                                                }
                                                let drAction = null;

                                                if (
                                                    defect[index] &&
                                                    defect[index].row_no === 1 &&
                                                    this.state.patientInfo.caseStatus === 'DEFECT_UPLOADED' &&
                                                    ['DR'].includes(role)
                                                ) {
                                                    drAction = (
                                                        <Grid container>
                                                            <Grid
                                                                item
                                                                xs={12}
                                                                style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'flex-start',
                                                                    gap: '20px',
                                                                }}
                                                            ></Grid>
                                                        </Grid>
                                                    );
                                                } else {
                                                    drAction = null;
                                                }
                                                let infoAction = null;
                                                infoAction = (
                                                    <Grid container>
                                                        <Grid item xs={12}>
                                                            <Dialog
                                                                open={this.state.moderateInformationPop}
                                                                aria-labelledby="alert-dialog-title"
                                                                aria-describedby="alert-dialog-description"
                                                            >
                                                                <DialogTitle id="alert-dialog-title">
                                                                    {'Moderate Distortion'}
                                                                </DialogTitle>
                                                                <DialogContent>
                                                                    <DialogContentText id="alert-dialog-description">
                                                                        This data for this case shows moderate
                                                                        distortion.
                                                                        <br />
                                                                        The following images highlight areas of the
                                                                        impression where we found moderate distortion.
                                                                        To proceed further, you can select one of the
                                                                        following:
                                                                        <br />
                                                                        <strong>
                                                                            <u>Option 1</u>
                                                                            <br />
                                                                        </strong>
                                                                        Upload a new impression in the chatbox.
                                                                        <br />
                                                                        <strong>
                                                                            <u>Option 2</u>
                                                                            <br />
                                                                        </strong>
                                                                        Confirm the current impression and process step
                                                                        1 to 2 ONLY at no extra charges for fitting. If
                                                                        the aligners from step 1 to 2 fit correctly,
                                                                        please proceed to order step 3 to 12. If the
                                                                        aligners from step 1 to 2 do not fit correctly,
                                                                        please resubmit the case again through the
                                                                        “Defect: Resubmit Case” button under the
                                                                        “Action” section. No extra charge will be
                                                                        incurred.
                                                                        <br />
                                                                        <strong>
                                                                            <u>Option 3</u>
                                                                            <br />
                                                                        </strong>
                                                                        Confirm the current impression and process step
                                                                        1 to 12. However, if the aligners do not fit
                                                                        correctly, you will need to resubmit the case
                                                                        again through the “Defect: Resubmit Case” button
                                                                        under the “Action” section. An additional charge
                                                                        will be incurred. Should you have any inquiries,
                                                                        please get in touch with your local customer
                                                                        service team.
                                                                        <br />
                                                                    </DialogContentText>
                                                                </DialogContent>
                                                                <DialogActions>
                                                                    <Button
                                                                        onClick={() =>
                                                                            this.handleClose('moderateInformationPop')
                                                                        }
                                                                    >
                                                                        Close
                                                                    </Button>
                                                                </DialogActions>
                                                            </Dialog>
                                                            <Dialog
                                                                open={this.state.severeInformationPop}
                                                                aria-labelledby="alert-dialog-title"
                                                                aria-describedby="alert-dialog-description"
                                                            >
                                                                <DialogTitle id="alert-dialog-title">
                                                                    {'Severe Distortion'}
                                                                </DialogTitle>
                                                                <DialogContent>
                                                                    <DialogContentText id="alert-dialog-description">
                                                                        The data for this case shows severe distortion
                                                                        <br />
                                                                        The following images highlight areas of the
                                                                        impression where we found severe distortion. To
                                                                        proceed further, you can select one of the
                                                                        following:
                                                                        <br />
                                                                        <strong>
                                                                            <u>Option 1</u>
                                                                        </strong>
                                                                        Upload a new impression in the chatbox.
                                                                        <br />
                                                                        <strong>
                                                                            <u>Option 2</u>
                                                                        </strong>
                                                                        Confirm the current impression and process step
                                                                        1 to 2. If aligners from step 1 to 2 fit
                                                                        correctly, please proceed to order step 3 to 12.
                                                                        If the aligners from step 1 to 2 do not fit
                                                                        correctly, please resubmit the case again
                                                                        through the “Defect: Resubmit Case” button under
                                                                        the “Action” section. An additional charge will
                                                                        be incurred. Should you have any enquiries,
                                                                        please get in touch with your local customer
                                                                        service team.
                                                                        <br />
                                                                        <strong>
                                                                            <u>Option 3</u>
                                                                        </strong>
                                                                        Confirm the current impression and process step
                                                                        1 to 12. However, if the aligners do not fit
                                                                        correctly, you may need to resubmit the case
                                                                        again through the “Defect: Resubmit Case” button
                                                                        under the “Action” section. An additional charge
                                                                        will be incurred. Should you have any inquiries,
                                                                        please contact your local customer service team.
                                                                        Reminder: An additional charge will be incurred
                                                                        if the step 1 to 2 do not fit correctly and a
                                                                        new impression is needed for case resubmit.
                                                                        <br />
                                                                        <br />
                                                                    </DialogContentText>
                                                                </DialogContent>
                                                                <DialogActions>
                                                                    <Button
                                                                        onClick={() =>
                                                                            this.handleClose('severeInformationPop')
                                                                        }
                                                                    >
                                                                        Close
                                                                    </Button>
                                                                </DialogActions>
                                                            </Dialog>
                                                        </Grid>
                                                    </Grid>
                                                );
                                                const content = defect
                                                    .sort((a, b) => new Date(b.created_date) - new Date(a.created_date))
                                                    .map((file, index) => {
                                                        const spic = Object.entries(file).filter(([key]) =>
                                                            key.startsWith('spic')
                                                        );
                                                        const mpic = Object.entries(file).filter(([key]) =>
                                                            key.startsWith('mpic')
                                                        );

                                                        const defect_distorted = Object.entries(file).filter(
                                                            ([key]) => key === 'distorted'
                                                        );

                                                        //severely
                                                        if (defect_distorted[0][1] === 'severely') {
                                                            return (
                                                                <div key={index}>
                                                                    {index === 0 && drAction}{' '}
                                                                    {index === 0 && infoAction}
                                                                    <div style={{ display: 'block', width: '100%' }}>
                                                                        <p
                                                                            style={{
                                                                                display: 'inline',
                                                                                marginRight: '15px',
                                                                            }}
                                                                        >
                                                                            <Typography variant="body1">
                                                                                Defect #{file.defect_no}{' '}
                                                                            </Typography>
                                                                            <div
                                                                                style={{
                                                                                    display: 'flex',
                                                                                    justifyContent: 'space-between',
                                                                                }}
                                                                            >
                                                                                <div>
                                                                                    <div
                                                                                        style={{
                                                                                            display: 'flex',
                                                                                            justifyContent:
                                                                                                'flex-start',
                                                                                        }}
                                                                                    >
                                                                                        <div
                                                                                            style={{
                                                                                                paddingTop: '3px',
                                                                                            }}
                                                                                        >
                                                                                            {' '}
                                                                                            <strong>
                                                                                                {this.get(
                                                                                                    'modals.uploadedAt'
                                                                                                )}
                                                                                            </strong>{' '}
                                                                                            :
                                                                                            {Moment(
                                                                                                file.created_date
                                                                                            ).format(
                                                                                                'YYYY-MM-DD HH:mm'
                                                                                            )}{' '}
                                                                                            <ErrorIcon />{' '}
                                                                                        </div>
                                                                                        <div>
                                                                                            {' '}
                                                                                            <Button
                                                                                                onClick={() =>
                                                                                                    this.handleInformation(
                                                                                                        'severeInformationPop'
                                                                                                    )
                                                                                                }
                                                                                            >
                                                                                                {this.get(
                                                                                                    'defect.severeDefect'
                                                                                                )}
                                                                                            </Button>
                                                                                        </div>
                                                                                        <div>
                                                                                            {' '}
                                                                                            <Button
                                                                                                onClick={() =>
                                                                                                    this.downloadImages(
                                                                                                        file,
                                                                                                        'spic'
                                                                                                    )
                                                                                                }
                                                                                                variant="outlined"
                                                                                            >
                                                                                                {this.get(
                                                                                                    'modals.download'
                                                                                                )}
                                                                                            </Button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                <div>
                                                                                    {defect[index].row_no === 1 ? (
                                                                                        <Button
                                                                                            variant="outlined"
                                                                                            onClick={() =>
                                                                                                this.handleOpenDefectCategory()
                                                                                            }
                                                                                        >
                                                                                            {this.get(
                                                                                                'defect.standDefectCat'
                                                                                            )}
                                                                                        </Button>
                                                                                    ) : (
                                                                                        <></>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </p>
                                                                        <hr />
                                                                    </div>
                                                                    <Grid container>
                                                                        {spic.map(
                                                                            ([key, value]) =>
                                                                                value && (
                                                                                    <Grid
                                                                                        item
                                                                                        xs={6}
                                                                                        sm={6}
                                                                                        md={4}
                                                                                        key={key}
                                                                                        style={{
                                                                                            padding: 8,
                                                                                            textAlign: 'center',
                                                                                        }}
                                                                                    >
                                                                                        <Zoom zoomMargin={48}>
                                                                                            <img
                                                                                                src={join(
                                                                                                    ApiServerUrl,
                                                                                                    value
                                                                                                )}
                                                                                                style={{
                                                                                                    maxHeight: 300,
                                                                                                    width: 'auto',
                                                                                                    marginLeft: 'auto',
                                                                                                    marginRight: 'auto',
                                                                                                    maxWidth: '100%',
                                                                                                }}
                                                                                            />
                                                                                        </Zoom>
                                                                                    </Grid>
                                                                                )
                                                                        )}
                                                                    </Grid>
                                                                    {defect[index].row_no === 1 &&
                                                                    ['DR'].includes(role) &&
                                                                    this.state.patientInfo.caseStatus ===
                                                                        'DEFECT_UPLOADED' ? (
                                                                        <>
                                                                            <Grid
                                                                                item
                                                                                xs={12}
                                                                                style={{ marginBottom: '10px' }}
                                                                            >
                                                                                {this.get('defect.actionSelect')}
                                                                            </Grid>

                                                                            <Grid
                                                                                item
                                                                                xs={12}
                                                                                style={{
                                                                                    display: 'flex',
                                                                                    justifyContent: 'flex-start',
                                                                                    gap: '20px',
                                                                                }}
                                                                            >
                                                                                <div
                                                                                    style={{
                                                                                        width: '33%',
                                                                                        display: 'flex',
                                                                                        flexDirection: 'column',
                                                                                    }}
                                                                                >
                                                                                    <Button
                                                                                        onClick={() =>
                                                                                            this.handleDrResponse(
                                                                                                'rescan',
                                                                                                defect[index].distorted,
                                                                                                defect[index].defect_id
                                                                                            )
                                                                                        }
                                                                                        style={{
                                                                                            fontWeight: 'bold',
                                                                                            width: '100%',
                                                                                        }}
                                                                                        variant="outlined"
                                                                                    >
                                                                                        {this.get(
                                                                                            'defect.button.newImpression'
                                                                                        )}
                                                                                    </Button>
                                                                                    <Grid
                                                                                        item
                                                                                        xs={12}
                                                                                        style={{ border: '1px solid ' }}
                                                                                    >
                                                                                        <div
                                                                                            style={{
                                                                                                color: 'rgb(50,191,114)',
                                                                                                padding: '10px',
                                                                                            }}
                                                                                        >
                                                                                            <div>
                                                                                                {this.get(
                                                                                                    'defect.newImpression.wording'
                                                                                                )}
                                                                                            </div>
                                                                                            <div>
                                                                                                -{' '}
                                                                                                {this.get(
                                                                                                    'defect.newImpression.charge'
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </Grid>
                                                                                </div>

                                                                                <div
                                                                                    style={{
                                                                                        width: '33%',
                                                                                        display: 'flex',
                                                                                        flexDirection: 'column',
                                                                                    }}
                                                                                >
                                                                                    <Button
                                                                                        onClick={() =>
                                                                                            this.handleDrResponse(
                                                                                                'sendcycle1',
                                                                                                defect[index].distorted,
                                                                                                defect[index].defect_id
                                                                                            )
                                                                                        }
                                                                                        style={{
                                                                                            fontWeight: 'bold',
                                                                                            width: '100%',
                                                                                        }}
                                                                                        variant="outlined"
                                                                                    >
                                                                                        {this.get(
                                                                                            'defect.button.cycleOneOnly'
                                                                                        )}
                                                                                    </Button>
                                                                                    <Grid
                                                                                        item
                                                                                        xs={12}
                                                                                        style={{ border: '1px solid ' }}
                                                                                    >
                                                                                        <div
                                                                                            style={{ padding: '10px' }}
                                                                                        >
                                                                                            <div>
                                                                                                {this.get(
                                                                                                    'defect.CycleOneOnly.wording'
                                                                                                )}
                                                                                            </div>
                                                                                            <div>
                                                                                                -
                                                                                                {this.get(
                                                                                                    'defect.CycleOneOnly.severeCharge'
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </Grid>
                                                                                </div>

                                                                                <div
                                                                                    style={{
                                                                                        width: '33%',
                                                                                        display: 'flex',
                                                                                        flexDirection: 'column',
                                                                                    }}
                                                                                >
                                                                                    <Button
                                                                                        onClick={() =>
                                                                                            this.handleDrResponse(
                                                                                                'sendcycle1to6',
                                                                                                defect[index].distorted,
                                                                                                defect[index].defect_id
                                                                                            )
                                                                                        }
                                                                                        style={{
                                                                                            fontWeight: 'bold',
                                                                                            width: '100%',
                                                                                        }}
                                                                                        variant="outlined"
                                                                                    >
                                                                                        {this.get(
                                                                                            'defect.button.CycleOneToSix'
                                                                                        )}
                                                                                    </Button>
                                                                                    <Grid
                                                                                        item
                                                                                        xs={12}
                                                                                        style={{ border: '1px solid ' }}
                                                                                    >
                                                                                        <div
                                                                                            style={{ padding: '10px' }}
                                                                                        >
                                                                                            <div>
                                                                                                {this.get(
                                                                                                    'defect.CycleOneToSix.wording1'
                                                                                                )}
                                                                                            </div>
                                                                                            <div>
                                                                                                -
                                                                                                {this.get(
                                                                                                    'defect.CycleOneToSix.wording2'
                                                                                                )}
                                                                                            </div>
                                                                                            <div>
                                                                                                ◝
                                                                                                {this.get(
                                                                                                    'defect.CycleOneToSix.charge'
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </Grid>
                                                                                </div>
                                                                            </Grid>
                                                                        </>
                                                                    ) : (
                                                                        <></>
                                                                    )}
                                                                </div>
                                                            );
                                                        }
                                                        //moderately
                                                        else {
                                                            // ({this.get('modals.distortionLevelModerate')})
                                                            return (
                                                                <div key={index}>
                                                                    {index === 0 && drAction}{' '}
                                                                    {index === 0 && infoAction}
                                                                    <div style={{ display: 'block', width: '100%' }}>
                                                                        <p
                                                                            style={{
                                                                                display: 'inline',
                                                                                marginRight: '15px',
                                                                            }}
                                                                        >
                                                                            <Typography variant="body1">
                                                                                Defect #{file.defect_no}{' '}
                                                                            </Typography>

                                                                            <div
                                                                                style={{
                                                                                    display: 'flex',
                                                                                    justifyContent: 'space-between',
                                                                                }}
                                                                            >
                                                                                <div>
                                                                                    <div
                                                                                        style={{
                                                                                            display: 'flex',
                                                                                            justifyContent:
                                                                                                'flex-start',
                                                                                        }}
                                                                                    >
                                                                                        <div
                                                                                            style={{
                                                                                                paddingTop: '3px',
                                                                                            }}
                                                                                        >
                                                                                            {' '}
                                                                                            <strong>
                                                                                                {this.get(
                                                                                                    'modals.uploadedAt'
                                                                                                )}
                                                                                            </strong>{' '}
                                                                                            :
                                                                                            {Moment(
                                                                                                file.created_date
                                                                                            ).format(
                                                                                                'YYYY-MM-DD HH:mm'
                                                                                            )}{' '}
                                                                                            <ErrorIcon />{' '}
                                                                                        </div>
                                                                                        <div>
                                                                                            {' '}
                                                                                            <Button
                                                                                                onClick={() =>
                                                                                                    this.handleInformation(
                                                                                                        'moderateInformationPop'
                                                                                                    )
                                                                                                }
                                                                                            >
                                                                                                {this.get(
                                                                                                    'defect.moderateDefect'
                                                                                                )}
                                                                                            </Button>
                                                                                        </div>
                                                                                        <div>
                                                                                            {' '}
                                                                                            <Button
                                                                                                onClick={() =>
                                                                                                    this.downloadImages(
                                                                                                        file,
                                                                                                        'mpic'
                                                                                                    )
                                                                                                }
                                                                                                variant="outlined"
                                                                                            >
                                                                                                {this.get(
                                                                                                    'modals.download'
                                                                                                )}
                                                                                            </Button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                {defect[index].row_no === 1 ? (
                                                                                    <Button
                                                                                        variant="outlined"
                                                                                        onClick={() =>
                                                                                            this.handleOpenDefectCategory()
                                                                                        }
                                                                                    >
                                                                                        {this.get(
                                                                                            'defect.standDefectCat'
                                                                                        )}
                                                                                    </Button>
                                                                                ) : (
                                                                                    <></>
                                                                                )}
                                                                            </div>
                                                                        </p>

                                                                        <hr />
                                                                    </div>
                                                                    <Grid container>
                                                                        {mpic.map(
                                                                            ([key, value]) =>
                                                                                value && (
                                                                                    <Grid
                                                                                        item
                                                                                        xs={6}
                                                                                        sm={6}
                                                                                        md={4}
                                                                                        key={key}
                                                                                        style={{
                                                                                            padding: 8,
                                                                                            textAlign: 'center',
                                                                                        }}
                                                                                    >
                                                                                        <Zoom zoomMargin={48}>
                                                                                            <img
                                                                                                src={join(
                                                                                                    ApiServerUrl,
                                                                                                    value
                                                                                                )}
                                                                                                style={{
                                                                                                    maxHeight: 300,
                                                                                                    width: 'auto',
                                                                                                    marginLeft: 'auto',
                                                                                                    marginRight: 'auto',
                                                                                                    maxWidth: '100%',
                                                                                                }}
                                                                                            />
                                                                                        </Zoom>
                                                                                    </Grid>
                                                                                )
                                                                        )}
                                                                    </Grid>
                                                                    {defect[index].row_no === 1 &&
                                                                    ['DR'].includes(role) &&
                                                                    this.state.patientInfo.caseStatus ===
                                                                        'DEFECT_UPLOADED' ? (
                                                                        <>
                                                                            <Grid
                                                                                item
                                                                                xs={12}
                                                                                style={{
                                                                                    display: 'flex',
                                                                                    justifyContent: 'flex-start',
                                                                                    gap: '20px',
                                                                                }}
                                                                            >
                                                                                <div
                                                                                    style={{
                                                                                        width: '33%',
                                                                                        display: 'flex',
                                                                                        flexDirection: 'column',
                                                                                    }}
                                                                                >
                                                                                    <Button
                                                                                        onClick={() =>
                                                                                            this.handleDrResponse(
                                                                                                'rescan',
                                                                                                defect[index].distorted,
                                                                                                defect[index].defect_id
                                                                                            )
                                                                                        }
                                                                                        style={{
                                                                                            fontWeight: 'bold',
                                                                                            width: '100%',
                                                                                        }}
                                                                                        variant="outlined"
                                                                                    >
                                                                                        {this.get(
                                                                                            'defect.button.newImpression'
                                                                                        )}
                                                                                    </Button>
                                                                                    <Grid
                                                                                        item
                                                                                        xs={12}
                                                                                        style={{ border: '1px solid ' }}
                                                                                    >
                                                                                        <div
                                                                                            style={{
                                                                                                color: 'rgb(50,191,114)',
                                                                                                padding: '10px',
                                                                                            }}
                                                                                        >
                                                                                            <div>
                                                                                                {this.get(
                                                                                                    'defect.newImpression.wording'
                                                                                                )}
                                                                                            </div>
                                                                                            <div>
                                                                                                -{' '}
                                                                                                {this.get(
                                                                                                    'defect.newImpression.charge'
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </Grid>
                                                                                </div>

                                                                                <div
                                                                                    style={{
                                                                                        width: '33%',
                                                                                        display: 'flex',
                                                                                        flexDirection: 'column',
                                                                                    }}
                                                                                >
                                                                                    <Button
                                                                                        onClick={() =>
                                                                                            this.handleDrResponse(
                                                                                                'sendcycle1',
                                                                                                defect[index].distorted,
                                                                                                defect[index].defect_id
                                                                                            )
                                                                                        }
                                                                                        style={{
                                                                                            fontWeight: 'bold',
                                                                                            width: '100%',
                                                                                        }}
                                                                                        variant="outlined"
                                                                                    >
                                                                                        {this.get(
                                                                                            'defect.button.cycleOneOnly'
                                                                                        )}
                                                                                    </Button>
                                                                                    <Grid
                                                                                        item
                                                                                        xs={12}
                                                                                        style={{ border: '1px solid ' }}
                                                                                    >
                                                                                        <div
                                                                                            style={{ padding: '10px' }}
                                                                                        >
                                                                                            <div>
                                                                                                {this.get(
                                                                                                    'defect.CycleOneOnly.wording'
                                                                                                )}
                                                                                            </div>
                                                                                            <div>
                                                                                                -
                                                                                                {this.get(
                                                                                                    'defect.CycleOneOnly.moderateCharge'
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </Grid>
                                                                                </div>

                                                                                <div
                                                                                    style={{
                                                                                        width: '33%',
                                                                                        display: 'flex',
                                                                                        flexDirection: 'column',
                                                                                    }}
                                                                                >
                                                                                    <Button
                                                                                        onClick={() =>
                                                                                            this.handleDrResponse(
                                                                                                'sendcycle1to6',
                                                                                                defect[index].distorted,
                                                                                                defect[index].defect_id
                                                                                            )
                                                                                        }
                                                                                        style={{
                                                                                            fontWeight: 'bold',
                                                                                            width: '100%',
                                                                                        }}
                                                                                        variant="outlined"
                                                                                    >
                                                                                        {this.get(
                                                                                            'defect.button.CycleOneToSix'
                                                                                        )}
                                                                                    </Button>
                                                                                    <Grid
                                                                                        item
                                                                                        xs={12}
                                                                                        style={{ border: '1px solid ' }}
                                                                                    >
                                                                                        <div
                                                                                            style={{ padding: '10px' }}
                                                                                        >
                                                                                            <div>
                                                                                                {this.get(
                                                                                                    'defect.CycleOneToSix.wording1'
                                                                                                )}
                                                                                            </div>
                                                                                            <div>
                                                                                                -
                                                                                                {this.get(
                                                                                                    'defect.CycleOneToSix.wording2'
                                                                                                )}
                                                                                            </div>
                                                                                            <div>
                                                                                                ◝
                                                                                                {this.get(
                                                                                                    'defect.CycleOneToSix.charge'
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </Grid>
                                                                                </div>
                                                                            </Grid>
                                                                        </>
                                                                    ) : (
                                                                        <></>
                                                                    )}
                                                                </div>
                                                            );
                                                        }
                                                    });
                                                return (
                                                    !!content.length && (
                                                        <Grid container>
                                                            <Grid item xs={12}></Grid>
                                                            <Grid item xs={12}>
                                                                {content}
                                                            </Grid>
                                                        </Grid>
                                                    )
                                                );
                                            })
                                    )}
                                </Modal>

                                <Dialog
                                    open={this.state.OpenDefectCategory}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle id="alert-dialog-title">
                                        {this.get('defect.standDefectCat')}
                                    </DialogTitle>
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                            {this.getDefectCatalog()}
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={() => this.handleCloseDefectCategory()}>Close</Button>
                                    </DialogActions>
                                </Dialog>

                                <WarningDialog
                                    title="Warning Message"
                                    open={this.state.confirmDrResponse}
                                    setOpen={this.setConfirmDrResponse}
                                    onConfirm={() => this.submitDrResponse()}
                                >
                                    {/* stateTYPe is not defined. */}
                                    Reminder: An additional charge will be incurred if{' '}
                                    {this.state.DrResponse.stateType === `sendcycle1`
                                        ? `the aligners from cycle 1`
                                        : `cycles 1-6 aligners`}{' '}
                                    do not fit correctly and a new impression is needed for case resubmit.
                                </WarningDialog>

                                <Modal
                                    className="modal"
                                    modal="radiograph"
                                    title={this.get('modals.radioModalTitle')}
                                    open={this.state.RadiographsModal && !this.state.loading}
                                    handleClose={() => this.handleClose('radiograph')}
                                    handleDataSave={() => this.handleRadioDataSave()}
                                    submitButton={this.state.ModalState == 'update' ? true : false}
                                    PhotoUploadLoadingStatus={this.state.PhotoUploadLoadingStatus}
                                    modalError={this.state.modalError}
                                >
                                    {this.state.ModalState == 'update' ? (
                                        <Refinement tabMode="radiography" uploadLater="patientInfo" />
                                    ) : (
                                        [...(this.state.patientInfo.case_file || [])]
                                            .reverse()
                                            .filter((v) => !!v)
                                            .map((refinement, index, arr) => {
                                                if (this.state.targetId) {
                                                    refinement = refinement.filter(
                                                        (v) => v.case_file_id === this.state.targetId
                                                    );
                                                }
                                                const content = refinement
                                                    .sort((a, b) => new Date(b.created_date) - new Date(a.created_date))
                                                    .map((file, index) => {
                                                        const radios = Object.entries(file)
                                                            .filter(
                                                                ([key]) =>
                                                                    key.startsWith('radio') && !key.endsWith('later')
                                                            )
                                                            .filter(([key]) => file[`${key}_later`] === false);
                                                        if (radios.length) {
                                                            return (
                                                                <div key={index}>
                                                                    <div style={{ display: 'block', width: '100%' }}>
                                                                        {file.refinement_no ? (
                                                                            <Typography variant="body1">
                                                                                {file.defect_resubmit_flag === true
                                                                                    ? `Defect Resubmit ${file.refinement_no}`
                                                                                    : ` Refinement ${file.refinement_no}`}
                                                                            </Typography>
                                                                        ) : (
                                                                            <></>
                                                                        )}

                                                                        <p
                                                                            style={{
                                                                                display: 'inline',
                                                                                marginRight: '15px',
                                                                            }}
                                                                        >
                                                                            <strong>
                                                                                {this.get('modals.uploadedAt')}
                                                                            </strong>{' '}
                                                                            :
                                                                            {Moment(file.created_date).format(
                                                                                'YYYY-MM-DD HH:mm'
                                                                            )}
                                                                        </p>
                                                                        <Button
                                                                            onClick={() =>
                                                                                this.downloadImages(file, 'radio')
                                                                            }
                                                                            variant="outlined"
                                                                        >
                                                                            {this.get('modals.download')}
                                                                        </Button>
                                                                        <hr />
                                                                    </div>
                                                                    <Grid container>
                                                                        {radios.map(
                                                                            ([key, value]) =>
                                                                                value && (
                                                                                    <Grid
                                                                                        item
                                                                                        xs={6}
                                                                                        sm={6}
                                                                                        md={4}
                                                                                        key={key}
                                                                                        style={{
                                                                                            padding: 8,
                                                                                            textAlign: 'center',
                                                                                        }}
                                                                                    >
                                                                                        {/^dbx::/.test(value) ? (
                                                                                            <CbctDownloadButton
                                                                                                folderValue={value}
                                                                                                caseId={this.state.caseId}
                                                                                                showSnackbar={this.props.showSnackbar}
                                                                                                downloading={this.state.cbctDownloading.includes(value)}
                                                                                                addDownloading={(value) => this.setState({ cbctDownloading: [...this.state.cbctDownloading, value] })}
                                                                                                removeDownloading={(value) => this.setState({ cbctDownloading: this.state.cbctDownloading.filter(item => item !== value) })}
                                                                                            />
                                                                                        ) : join(
                                                                                              ApiServerUrl,
                                                                                              value
                                                                                          ).includes('s3:') ? (
                                                                                            <div>
                                                                                                CBCT files are inside
                                                                                                the RFS file
                                                                                            </div>
                                                                                        ) : (
                                                                                            <Zoom zoomMargin={48}>
                                                                                                <img
                                                                                                    src={join(
                                                                                                        ApiServerUrl,
                                                                                                        value
                                                                                                    )}
                                                                                                    style={{
                                                                                                        maxHeight: 300,
                                                                                                        width: 'auto',
                                                                                                        marginLeft:
                                                                                                            'auto',
                                                                                                        marginRight:
                                                                                                            'auto',
                                                                                                        maxWidth:
                                                                                                            '100%',
                                                                                                    }}
                                                                                                />
                                                                                            </Zoom>
                                                                                        )}
                                                                                    </Grid>
                                                                                )
                                                                        )}
                                                                    </Grid>
                                                                </div>
                                                            );
                                                        } else {
                                                            return null;
                                                        }
                                                    })
                                                    .filter((v) => v);
                                                return (
                                                    !!content.length && (
                                                        <Grid container>
                                                            <Grid item xs={12}>
                                                                {content}
                                                            </Grid>
                                                        </Grid>
                                                    )
                                                );
                                            })
                                    )}
                                </Modal>

                                <Modal
                                    className="modal"
                                    modal="Impression"
                                    title={this.get('modals.impressionModalTitle')}
                                    open={this.state.ImpressionsModal && !this.state.loading}
                                    handleClose={() => this.handleClose('impression')}
                                    handleDataSave={() => this.handleImpressionDataSave()}
                                    submitButton={this.state.ModalState == 'update' ? true : false}
                                    modalError={this.state.modalError}
                                    PhotoUploadLoadingStatus={this.state.PhotoUploadLoadingStatus}
                                >
                                    {this.state.ModalState == 'update' ? (
                                        <Refinement
                                            tabMode="impression"
                                            uploadLater="patientInfo"
                                            threeshapeConnected={this.state.threeshapeConnected}
                                            handleThreeshapeConnected={(value) =>
                                                this.setState({ threeshapeConnected: value })
                                            }
                                        />
                                    ) : (
                                        this.state.patientInfo.case_impression
                                            ?.reverse()
                                            .filter((v) => !!v)
                                            .map((refinement, index, arr) => {
                                                if (this.state.targetId) {
                                                    refinement = refinement.filter(
                                                        (v) => v.case_impression_id === this.state.targetId
                                                    );
                                                }
                                                return (
                                                    !!refinement.length && (
                                                        <Grid container>
                                                            <Grid item xs={12}>
                                                                <Typography
                                                                    variant="body1"
                                                                    style={{
                                                                        display:
                                                                            arr.length === 1 || index === 0
                                                                                ? 'none'
                                                                                : undefined,
                                                                    }}
                                                                ></Typography>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                {refinement
                                                                    .sort(
                                                                        (a, b) =>
                                                                            new Date(b.created_date) -
                                                                            new Date(a.created_date)
                                                                    )
                                                                    .map(
                                                                        (impression) =>
                                                                            !!impression && (
                                                                                <>
                                                                                    <Typography variant="body1">
                                                                                        {impression.refinement_no ? (
                                                                                            impression.defect_resubmit_flag ===
                                                                                            true ? (
                                                                                                `Defect Resubmit ${impression.refinement_no}`
                                                                                            ) : (
                                                                                                ` Refinement ${impression.refinement_no}`
                                                                                            )
                                                                                        ) : (
                                                                                            <></>
                                                                                        )}
                                                                                    </Typography>

                                                                                    <div
                                                                                        style={{
                                                                                            display: 'block',
                                                                                            width: '100%',
                                                                                        }}
                                                                                    >
                                                                                        <p
                                                                                            style={{
                                                                                                display: 'inline',
                                                                                                marginRight: '15px',
                                                                                            }}
                                                                                        >
                                                                                            <strong>
                                                                                                {this.get(
                                                                                                    'modals.uploadedAt'
                                                                                                )}
                                                                                            </strong>{' '}
                                                                                            :
                                                                                            {Moment(
                                                                                                impression.created_date
                                                                                            ).format(
                                                                                                'YYYY-MM-DD HH:mm'
                                                                                            )}
                                                                                        </p>
                                                                                        <hr />
                                                                                    </div>
                                                                                    <Grid
                                                                                        item
                                                                                        xs={12}
                                                                                        sm={12}
                                                                                        md={12}
                                                                                        style={{
                                                                                            padding: 8,
                                                                                            textAlign: 'left',
                                                                                        }}
                                                                                    >
                                                                                        <ImpressionViewer
                                                                                            caseImpression={impression}
                                                                                        />
                                                                                    </Grid>
                                                                                </>
                                                                            )
                                                                    )}
                                                            </Grid>
                                                        </Grid>
                                                    )
                                                );
                                            })
                                    )}
                                </Modal>

                                <Modal
                                    className="prescriptionNotes"
                                    modal="prescriptionNotes"
                                    title={this.get('modals.prescriptionNotesModalTitle')}
                                    open={this.state.PrescriptionNotesModal}
                                    handleClose={() => this.handleClose('prescriptionNotes')}
                                    handleDataSave={() => this.handlePrescriptionNotesSave()}
                                    submitButton={this.state.ModalState === 'update' ? true : false}
                                    modalError={this.state.modalError}
                                >
                                    {this.state.ModalState === 'update' ? (
                                        <>
                                            <NewErrorMessageDialog
                                                title="Error Message"
                                                open={this.state.presDialogOpen}
                                                setOpen={this.handlePresDialog}
                                                onOk={() => {
                                                    this.handlePresDialog();
                                                    this.props.handlePrescriptionErrorScroll();
                                                }}
                                                backgroundColor="#593687"
                                            >
                                                {this.props.newPatientData?.prescriptionError}
                                            </NewErrorMessageDialog>
                                            <PrescriptionNotes formType={FORM_TYPE.ADMIN_UPLOAD_PRESCRIPTION_NOTES} />
                                        </>
                                    ) : this.state.smileDesignPrescriptionFallback ? (
                                        <SmileDesignPrescriptionNotesPreviewMap
                                            defaultValues={this.state.smileDesignPrescriptionFallback}
                                            isSEAGroup={this.state.isSEAGroup}
                                            previewAfterSubmitbyisMarieGroup={
                                                this.state.smileDesignPrescriptionFallback['isMarieGroup']
                                            }
                                        />
                                    ) : (
                                        this.state.patientInfo.case_detail
                                            ?.filter((v) => !!v)
                                            .map((refinement, index, arr) => (
                                                <Grid container>
                                                    <Grid item xs={12}>
                                                        <Typography
                                                            variant="body1"
                                                            style={{
                                                                display:
                                                                    arr.length === 1 || index === 0
                                                                        ? 'none'
                                                                        : undefined,
                                                            }}
                                                        >
                                                            Refinement #{index}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        {refinement
                                                            .sort(
                                                                (a, b) =>
                                                                    new Date(b.created_date) - new Date(a.created_date)
                                                            )
                                                            .map((value) => {
                                                                const {
                                                                    restorative_options,
                                                                    vertical_dimension_upper_posterior,
                                                                    vertical_dimension_lower_posterior,
                                                                    onlay_position,
                                                                } = value;
                                                                const isValidUpsellSmileCase =
                                                                    this.state.patientInfo.case_smile_design !== null &&
                                                                    this.state.patientInfo.case_smile_design !==
                                                                        undefined;
                                                                const auxiliariesUpper = JSON.parse(
                                                                    value.attr43
                                                                )?.filter((value) => value.includes('upper'));
                                                                const auxiliariesLower = JSON.parse(
                                                                    value.attr43
                                                                )?.filter((value) => value.includes('lower'));
                                                                const newExcludedDentition =
                                                                    value.new_excluded_dentition?.split(',');
                                                                const newExcludedAttachments =
                                                                    value.new_excluded_attachments?.split(',');
                                                                const newIncludedAttachments =
                                                                    value.new_included_attachments?.split(',');
                                                                /* const newIncludedDimForces = value.new_included_dim_forces?.split(','); */
                                                                let ray_draft_changed_items = [];
                                                                if (['SADMIN', 'ADMIN'].includes(role)) {
                                                                    let ray_draft_changed =
                                                                        this.state.patientInfo.case_file?.[0]
                                                                            ?.filter(
                                                                                (v) =>
                                                                                    (v?.refinement_no == null
                                                                                        ? 0
                                                                                        : v?.refinement_no) ===
                                                                                    value.refinement_no
                                                                            )
                                                                            ?.sort(
                                                                                (a, b) =>
                                                                                    new Date(a.created_date) -
                                                                                    new Date(b.created_date)
                                                                            )?.[0]?.ray_draft_changed;
                                                                    if (
                                                                        typeof ray_draft_changed === 'string' &&
                                                                        ray_draft_changed !== ''
                                                                    ) {
                                                                        ray_draft_changed_items =
                                                                            JSON.parse(ray_draft_changed).sort();
                                                                    }
                                                                }
                                                                return (
                                                                    value && (
                                                                        <div key={index}>
                                                                            <div
                                                                                style={{
                                                                                    display: 'block',
                                                                                    width: '100%',
                                                                                }}
                                                                            >
                                                                                <Typography variant="body1">
                                                                                    {value.refinement_no ? (
                                                                                        value.defect_resubmit_flag ===
                                                                                        true ? (
                                                                                            `Defect Resubmit ${value.refinement_no}`
                                                                                        ) : (
                                                                                            ` Refinement ${value.refinement_no}`
                                                                                        )
                                                                                    ) : (
                                                                                        <></>
                                                                                    )}
                                                                                </Typography>
                                                                                <p>
                                                                                    <strong>
                                                                                        {this.get('modals.uploadedAt')}
                                                                                    </strong>{' '}
                                                                                    :
                                                                                    {Moment(value.created_date).format(
                                                                                        'YYYY-MM-DD HH:mm'
                                                                                    )}
                                                                                </p>
                                                                                <hr />
                                                                            </div>
                                                                            {value.new_prescription_notes_flag ? (
                                                                                <ol>
                                                                                    <li>
                                                                                        <strong>
                                                                                            {this.getNotes(
                                                                                                'archToTreat'
                                                                                            )}
                                                                                            :{' '}
                                                                                        </strong>
                                                                                        <span
                                                                                            className={
                                                                                                value.attr0 !== 'both'
                                                                                                    ? externalCss.redText
                                                                                                    : ''
                                                                                            }
                                                                                        >
                                                                                            {this.getNotes(value.attr0)}
                                                                                        </span>
                                                                                    </li>
                                                                                    {(!!value.refinement_arch_to_treat_upper_step ||
                                                                                        !!value.refinement_arch_to_treat_lower_step) && (
                                                                                        <ul>
                                                                                            <li>{`${this.getNotes('currentSteps')}:`}</li>
                                                                                            <ul>
                                                                                                {!!value.refinement_arch_to_treat_upper_step && (
                                                                                                    <li>{`${this.getNotes('upper')}: ${value.refinement_arch_to_treat_upper_step}`}</li>
                                                                                                )}
                                                                                                {!!value.refinement_arch_to_treat_lower_step && (
                                                                                                    <li>{`${this.getNotes('lower')}: ${value.refinement_arch_to_treat_lower_step}`}</li>
                                                                                                )}
                                                                                            </ul>
                                                                                        </ul>
                                                                                    )}
                                                                                    <li>
                                                                                        <strong>
                                                                                            {this.getNotes(
                                                                                                'excludedDentition'
                                                                                            ).includes('NOT') ? (
                                                                                                <>
                                                                                                    {
                                                                                                        this.getNotes(
                                                                                                            'excludedDentition'
                                                                                                        ).split(
                                                                                                            'NOT'
                                                                                                        )[0]
                                                                                                    }
                                                                                                    <span
                                                                                                        className={[
                                                                                                            externalCss.redText,
                                                                                                            externalCss.underline,
                                                                                                        ].join(' ')}
                                                                                                    >
                                                                                                        NOT
                                                                                                    </span>
                                                                                                    {
                                                                                                        this.getNotes(
                                                                                                            'excludedDentition'
                                                                                                        ).split(
                                                                                                            'NOT'
                                                                                                        )[1]
                                                                                                    }
                                                                                                </>
                                                                                            ) : (
                                                                                                this.getNotes(
                                                                                                    'excludedDentition'
                                                                                                )
                                                                                            )}
                                                                                        </strong>
                                                                                    </li>
                                                                                    <div
                                                                                        style={{
                                                                                            width: 800,
                                                                                            height: 200,
                                                                                            position: 'relative',
                                                                                            backgroundRepeat:
                                                                                                'no-repeat',
                                                                                            backgroundImage: `url("${getWebAbsPath('/img/prescriptionNotes/smaller_teeth_number_CS.ai.png')}")`,
                                                                                        }}
                                                                                    >
                                                                                        {newExcludedDentition.map(
                                                                                            (toothValue) => {
                                                                                                for (let [
                                                                                                    _,
                                                                                                    objValue,
                                                                                                ] of Object.entries(
                                                                                                    this.teeth
                                                                                                )) {
                                                                                                    for (let {
                                                                                                        value,
                                                                                                        positionX,
                                                                                                        positionY,
                                                                                                    } of objValue.values) {
                                                                                                        if (
                                                                                                            value ===
                                                                                                            parseInt(
                                                                                                                toothValue
                                                                                                            )
                                                                                                        ) {
                                                                                                            return (
                                                                                                                <img
                                                                                                                    src={getWebAbsPath(
                                                                                                                        '/img/prescriptionNotes/checkFail.png'
                                                                                                                    )}
                                                                                                                    alt="checked"
                                                                                                                    style={{
                                                                                                                        position:
                                                                                                                            'absolute',
                                                                                                                        top:
                                                                                                                            positionY -
                                                                                                                            10,
                                                                                                                        left:
                                                                                                                            positionX -
                                                                                                                            12,
                                                                                                                        userSelect:
                                                                                                                            'none',
                                                                                                                    }}
                                                                                                                />
                                                                                                            );
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        )}
                                                                                    </div>
                                                                                    <li>
                                                                                        <strong>
                                                                                            {this.getNotes(
                                                                                                'attachments'
                                                                                            )}
                                                                                        </strong>
                                                                                    </li>
                                                                                    <ul>
                                                                                        <li>
                                                                                            <span
                                                                                                className={
                                                                                                    value.attr1 !==
                                                                                                    'placeAttachmentsAsNeeded'
                                                                                                        ? externalCss.redText
                                                                                                        : ''
                                                                                                }
                                                                                            >
                                                                                                {this.getNotes(
                                                                                                    value.attr1
                                                                                                ).includes('NOT') ? (
                                                                                                    <>
                                                                                                        {
                                                                                                            this.getNotes(
                                                                                                                value.attr1
                                                                                                            ).split(
                                                                                                                'NOT'
                                                                                                            )[0]
                                                                                                        }
                                                                                                        <span
                                                                                                            className={
                                                                                                                externalCss.underline
                                                                                                            }
                                                                                                        >
                                                                                                            NOT
                                                                                                        </span>
                                                                                                        {
                                                                                                            this.getNotes(
                                                                                                                value.attr1
                                                                                                            ).split(
                                                                                                                'NOT'
                                                                                                            )[1]
                                                                                                        }
                                                                                                    </>
                                                                                                ) : (
                                                                                                    this.getNotes(
                                                                                                        value.attr1
                                                                                                    )
                                                                                                )}
                                                                                            </span>
                                                                                        </li>
                                                                                    </ul>
                                                                                    {value.attr1 ===
                                                                                    'includedExcludedAttachments' ? (
                                                                                        <>
                                                                                            &nbsp;&nbsp;&nbsp;{' '}
                                                                                            {this.getNotes(
                                                                                                'excludedAttachments'
                                                                                            )}
                                                                                            <div
                                                                                                style={{
                                                                                                    width: 800,
                                                                                                    height: 200,

                                                                                                    position:
                                                                                                        'relative',
                                                                                                    backgroundRepeat:
                                                                                                        'no-repeat',
                                                                                                    backgroundImage: `url("${getWebAbsPath('/img/prescriptionNotes/smaller_teeth_number_CS.ai.png')}")`,
                                                                                                }}
                                                                                            >
                                                                                                {newExcludedAttachments.map(
                                                                                                    (toothValue) => {
                                                                                                        for (let [
                                                                                                            _,
                                                                                                            objValue,
                                                                                                        ] of Object.entries(
                                                                                                            this.teeth
                                                                                                        )) {
                                                                                                            for (let {
                                                                                                                value,
                                                                                                                positionX,
                                                                                                                positionY,
                                                                                                            } of objValue.values) {
                                                                                                                if (
                                                                                                                    value ===
                                                                                                                    parseInt(
                                                                                                                        toothValue
                                                                                                                    )
                                                                                                                ) {
                                                                                                                    return (
                                                                                                                        <img
                                                                                                                            src={getWebAbsPath(
                                                                                                                                '/img/prescriptionNotes/checkFail.png'
                                                                                                                            )}
                                                                                                                            alt="checked"
                                                                                                                            style={{
                                                                                                                                position:
                                                                                                                                    'absolute',
                                                                                                                                top:
                                                                                                                                    positionY -
                                                                                                                                    10,
                                                                                                                                left:
                                                                                                                                    positionX -
                                                                                                                                    12,
                                                                                                                                userSelect:
                                                                                                                                    'none',
                                                                                                                            }}
                                                                                                                        />
                                                                                                                    );
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                )}
                                                                                            </div>
                                                                                        </>
                                                                                    ) : null}
                                                                                    {value.attr1 ===
                                                                                    'includedExcludedAttachments' ? (
                                                                                        <>
                                                                                            &nbsp;&nbsp;&nbsp;
                                                                                            {this.getNotes(
                                                                                                'includedAttachments'
                                                                                            )}
                                                                                            <div
                                                                                                style={{
                                                                                                    width: 800,
                                                                                                    height: 200,

                                                                                                    position:
                                                                                                        'relative',
                                                                                                    backgroundRepeat:
                                                                                                        'no-repeat',
                                                                                                    backgroundImage: `url("${getWebAbsPath('/img/prescriptionNotes/smaller_teeth_number_CS.ai.png')}")`,
                                                                                                }}
                                                                                            >
                                                                                                {newIncludedAttachments.map(
                                                                                                    (toothValue) => {
                                                                                                        for (let [
                                                                                                            _,
                                                                                                            objValue,
                                                                                                        ] of Object.entries(
                                                                                                            this.teeth
                                                                                                        )) {
                                                                                                            for (let {
                                                                                                                value,
                                                                                                                positionX,
                                                                                                                positionY,
                                                                                                            } of objValue.values) {
                                                                                                                if (
                                                                                                                    value ===
                                                                                                                    parseInt(
                                                                                                                        toothValue
                                                                                                                    )
                                                                                                                ) {
                                                                                                                    return (
                                                                                                                        <img
                                                                                                                            src={getWebAbsPath(
                                                                                                                                '/img/prescriptionNotes/checkSuccess.png'
                                                                                                                            )}
                                                                                                                            alt="checked"
                                                                                                                            style={{
                                                                                                                                position:
                                                                                                                                    'absolute',
                                                                                                                                top:
                                                                                                                                    positionY -
                                                                                                                                    10,
                                                                                                                                left:
                                                                                                                                    positionX -
                                                                                                                                    12,
                                                                                                                                userSelect:
                                                                                                                                    'none',
                                                                                                                            }}
                                                                                                                        />
                                                                                                                    );
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                )}
                                                                                            </div>
                                                                                        </>
                                                                                    ) : null}
                                                                                    <ul>
                                                                                        <li>
                                                                                            {this.getNotes(
                                                                                                'delayStage'
                                                                                            )?.replace('.', '')}
                                                                                            :{' '}
                                                                                            <span
                                                                                                className={
                                                                                                    value.attr2 !==
                                                                                                    'noDelay'
                                                                                                        ? externalCss.redText
                                                                                                        : ''
                                                                                                }
                                                                                            >
                                                                                                {this.getNotes(
                                                                                                    value.attr2
                                                                                                )}{' '}
                                                                                                {value.attr63 || null}
                                                                                            </span>
                                                                                        </li>
                                                                                    </ul>
                                                                                    <li>
                                                                                        <strong>
                                                                                            {this.getNotes(
                                                                                                'alignersMarginPlacement'
                                                                                            )}
                                                                                            :
                                                                                        </strong>{' '}
                                                                                        <span
                                                                                            className={
                                                                                                value.attr3 !==
                                                                                                'coverageExtending'
                                                                                                    ? externalCss.redText
                                                                                                    : ''
                                                                                            }
                                                                                        >
                                                                                            {this.getNotes(value.attr3)}
                                                                                        </span>
                                                                                    </li>
                                                                                    <li>
                                                                                        <strong>
                                                                                            {this.getNotes(
                                                                                                'anteriorPosteriorRelationship'
                                                                                            )}
                                                                                        </strong>
                                                                                    </li>
                                                                                    <ul>
                                                                                        <li>
                                                                                            {this.getNotes('right')}:{' '}
                                                                                            <span
                                                                                                className={
                                                                                                    value.attr4 !==
                                                                                                    'maintain'
                                                                                                        ? externalCss.redText
                                                                                                        : ''
                                                                                                }
                                                                                            >
                                                                                                {this.getNotes(
                                                                                                    value.attr4
                                                                                                )}
                                                                                            </span>
                                                                                        </li>
                                                                                        <li>
                                                                                            {this.getNotes('left')}:{' '}
                                                                                            <span
                                                                                                className={
                                                                                                    value.attr5 !==
                                                                                                    'maintain'
                                                                                                        ? externalCss.redText
                                                                                                        : ''
                                                                                                }
                                                                                            >
                                                                                                {this.getNotes(
                                                                                                    value.attr5
                                                                                                )}
                                                                                            </span>
                                                                                        </li>
                                                                                    </ul>
                                                                                    <li>
                                                                                        <strong>
                                                                                            {this.getNotes(
                                                                                                'spacingAndCrowding'
                                                                                            )}
                                                                                        </strong>
                                                                                    </li>
                                                                                    <ul>
                                                                                        <li>
                                                                                            {this.getNotes('spacing')}:{' '}
                                                                                            <span
                                                                                                className={
                                                                                                    value.attr6 !==
                                                                                                    'closeAllSpaces'
                                                                                                        ? externalCss.redText
                                                                                                        : ''
                                                                                                }
                                                                                            >
                                                                                                {this.getNotes(
                                                                                                    value.attr6
                                                                                                )}{' '}
                                                                                                {value.attr64
                                                                                                    ? ' (' +
                                                                                                      value.attr64 +
                                                                                                      ')'
                                                                                                    : null}
                                                                                            </span>
                                                                                        </li>
                                                                                        <li>
                                                                                            {this.getNotes('crowding')}:
                                                                                        </li>
                                                                                        <li>
                                                                                            {this.getNotes(
                                                                                                'resolveUpper'
                                                                                            )}
                                                                                            :
                                                                                        </li>
                                                                                        <ul>
                                                                                            <li>
                                                                                                {this.getNotes(
                                                                                                    'expand'
                                                                                                )}
                                                                                                :{' '}
                                                                                                <span
                                                                                                    className={
                                                                                                        value.attr7 !==
                                                                                                        'asNeeded'
                                                                                                            ? externalCss.redText
                                                                                                            : ''
                                                                                                    }
                                                                                                >
                                                                                                    {this.getNotes(
                                                                                                        value.attr7
                                                                                                    )}{' '}
                                                                                                    {value.attr48
                                                                                                        ? '(' +
                                                                                                          value.attr48 +
                                                                                                          ')'
                                                                                                        : null}
                                                                                                </span>
                                                                                            </li>
                                                                                            <li>
                                                                                                {this.getNotes(
                                                                                                    'procline'
                                                                                                )}
                                                                                                :{' '}
                                                                                                <span
                                                                                                    className={
                                                                                                        value.attr8 !==
                                                                                                        'asNeeded'
                                                                                                            ? externalCss.redText
                                                                                                            : ''
                                                                                                    }
                                                                                                >
                                                                                                    {this.getNotes(
                                                                                                        value.attr8
                                                                                                    )}{' '}
                                                                                                    {value.attr49
                                                                                                        ? '(' +
                                                                                                          value.attr49 +
                                                                                                          ')'
                                                                                                        : null}
                                                                                                </span>
                                                                                            </li>
                                                                                            <li>
                                                                                                {this.getNotes(
                                                                                                    'IPRAnterior'
                                                                                                )}
                                                                                                :{' '}
                                                                                                <span
                                                                                                    className={
                                                                                                        value.attr9 !==
                                                                                                        'asNeeded'
                                                                                                            ? externalCss.redText
                                                                                                            : ''
                                                                                                    }
                                                                                                >
                                                                                                    {this.getNotes(
                                                                                                        value.attr9
                                                                                                    )}{' '}
                                                                                                    {value.attr50
                                                                                                        ? '(' +
                                                                                                          value.attr50 +
                                                                                                          ')'
                                                                                                        : null}
                                                                                                </span>
                                                                                            </li>
                                                                                            <li>
                                                                                                {this.getNotes(
                                                                                                    'IPRPosteriorRight'
                                                                                                )}
                                                                                                :{' '}
                                                                                                <span
                                                                                                    className={
                                                                                                        value.attr10 !==
                                                                                                        'asNeeded'
                                                                                                            ? externalCss.redText
                                                                                                            : ''
                                                                                                    }
                                                                                                >
                                                                                                    {this.getNotes(
                                                                                                        value.attr10
                                                                                                    )}{' '}
                                                                                                    {value.attr51
                                                                                                        ? '(' +
                                                                                                          value.attr51 +
                                                                                                          ')'
                                                                                                        : null}
                                                                                                </span>
                                                                                            </li>
                                                                                            <li>
                                                                                                {this.getNotes(
                                                                                                    'IPRPosteriorLeft'
                                                                                                )}
                                                                                                :{' '}
                                                                                                <span
                                                                                                    className={
                                                                                                        value.attr11 !==
                                                                                                        'asNeeded'
                                                                                                            ? externalCss.redText
                                                                                                            : ''
                                                                                                    }
                                                                                                >
                                                                                                    {this.getNotes(
                                                                                                        value.attr11
                                                                                                    )}{' '}
                                                                                                    {value.attr52
                                                                                                        ? '(' +
                                                                                                          value.attr52 +
                                                                                                          ')'
                                                                                                        : null}
                                                                                                </span>
                                                                                            </li>
                                                                                            <li>
                                                                                                {this.getNotes(
                                                                                                    'extraction'
                                                                                                )}
                                                                                                :{' '}
                                                                                                <span
                                                                                                    className={
                                                                                                        value.attr12 !==
                                                                                                        'none'
                                                                                                            ? externalCss.redText
                                                                                                            : ''
                                                                                                    }
                                                                                                >
                                                                                                    {this.getNotes(
                                                                                                        value.attr12
                                                                                                    )}{' '}
                                                                                                    {value.attr53
                                                                                                        ? '(' +
                                                                                                          value.attr53 +
                                                                                                          ')'
                                                                                                        : null}
                                                                                                </span>
                                                                                            </li>
                                                                                        </ul>
                                                                                        <li>
                                                                                            {this.getNotes(
                                                                                                'resolveLower'
                                                                                            )}
                                                                                            :
                                                                                        </li>
                                                                                        <ul>
                                                                                            <li>
                                                                                                {this.getNotes(
                                                                                                    'expand'
                                                                                                )}
                                                                                                :{' '}
                                                                                                <span
                                                                                                    className={
                                                                                                        value.attr13 !==
                                                                                                        'asNeeded'
                                                                                                            ? externalCss.redText
                                                                                                            : ''
                                                                                                    }
                                                                                                >
                                                                                                    {this.getNotes(
                                                                                                        value.attr13
                                                                                                    )}{' '}
                                                                                                    {value.attr54
                                                                                                        ? '(' +
                                                                                                          value.attr54 +
                                                                                                          ')'
                                                                                                        : null}
                                                                                                </span>
                                                                                            </li>
                                                                                            <li>
                                                                                                {this.getNotes(
                                                                                                    'procline'
                                                                                                )}
                                                                                                :{' '}
                                                                                                <span
                                                                                                    className={
                                                                                                        value.attr14 !==
                                                                                                        'asNeeded'
                                                                                                            ? externalCss.redText
                                                                                                            : ''
                                                                                                    }
                                                                                                >
                                                                                                    {this.getNotes(
                                                                                                        value.attr14
                                                                                                    )}{' '}
                                                                                                    {value.attr55
                                                                                                        ? '(' +
                                                                                                          value.attr55 +
                                                                                                          ')'
                                                                                                        : null}
                                                                                                </span>
                                                                                            </li>
                                                                                            <li>
                                                                                                {this.getNotes(
                                                                                                    'IPRAnterior'
                                                                                                )}
                                                                                                :{' '}
                                                                                                <span
                                                                                                    className={
                                                                                                        value.attr15 !==
                                                                                                        'asNeeded'
                                                                                                            ? externalCss.redText
                                                                                                            : ''
                                                                                                    }
                                                                                                >
                                                                                                    {this.getNotes(
                                                                                                        value.attr15
                                                                                                    )}{' '}
                                                                                                    {value.attr56
                                                                                                        ? '(' +
                                                                                                          value.attr56 +
                                                                                                          ')'
                                                                                                        : null}
                                                                                                </span>
                                                                                            </li>
                                                                                            <li>
                                                                                                {this.getNotes(
                                                                                                    'IPRPosteriorRight'
                                                                                                )}
                                                                                                :{' '}
                                                                                                <span
                                                                                                    className={
                                                                                                        value.attr16 !==
                                                                                                        'asNeeded'
                                                                                                            ? externalCss.redText
                                                                                                            : ''
                                                                                                    }
                                                                                                >
                                                                                                    {this.getNotes(
                                                                                                        value.attr16
                                                                                                    )}{' '}
                                                                                                    {value.attr57
                                                                                                        ? '(' +
                                                                                                          value.attr57 +
                                                                                                          ')'
                                                                                                        : null}
                                                                                                </span>
                                                                                            </li>
                                                                                            <li>
                                                                                                {this.getNotes(
                                                                                                    'IPRPosteriorLeft'
                                                                                                )}
                                                                                                :{' '}
                                                                                                <span
                                                                                                    className={
                                                                                                        value.attr17 !==
                                                                                                        'asNeeded'
                                                                                                            ? externalCss.redText
                                                                                                            : ''
                                                                                                    }
                                                                                                >
                                                                                                    {this.getNotes(
                                                                                                        value.attr17
                                                                                                    )}{' '}
                                                                                                    {value.attr58
                                                                                                        ? '(' +
                                                                                                          value.attr58 +
                                                                                                          ')'
                                                                                                        : null}
                                                                                                </span>
                                                                                            </li>
                                                                                            <li>
                                                                                                {this.getNotes(
                                                                                                    'extraction'
                                                                                                )}
                                                                                                :{' '}
                                                                                                <span
                                                                                                    className={
                                                                                                        value.attr18 !==
                                                                                                        'none'
                                                                                                            ? externalCss.redText
                                                                                                            : ''
                                                                                                    }
                                                                                                >
                                                                                                    {this.getNotes(
                                                                                                        value.attr18
                                                                                                    )}{' '}
                                                                                                    {value.attr59
                                                                                                        ? '(' +
                                                                                                          value.attr59 +
                                                                                                          ')'
                                                                                                        : null}
                                                                                                </span>
                                                                                            </li>
                                                                                        </ul>
                                                                                    </ul>
                                                                                    <li>
                                                                                        <strong>
                                                                                            {this.getNotes('overjet')}
                                                                                            :{' '}
                                                                                        </strong>
                                                                                        <span
                                                                                            className={
                                                                                                value.attr19 !==
                                                                                                'maintainInitialOverjet'
                                                                                                    ? externalCss.redText
                                                                                                    : ''
                                                                                            }
                                                                                        >
                                                                                            {this.getNotes(
                                                                                                value.attr19
                                                                                            )}{' '}
                                                                                            {value.attr20
                                                                                                ? this.getNotes(
                                                                                                      value.attr20
                                                                                                  )
                                                                                                : null}
                                                                                        </span>
                                                                                    </li>
                                                                                    <li>
                                                                                        <strong>
                                                                                            {this.getNotes('openbite')}
                                                                                        </strong>
                                                                                    </li>
                                                                                    <ul>
                                                                                        <li>
                                                                                            <span
                                                                                                className={
                                                                                                    value.attr21 !==
                                                                                                    'maintainInitialOpenbite'
                                                                                                        ? externalCss.redText
                                                                                                        : ''
                                                                                                }
                                                                                            >
                                                                                                {this.getNotes(
                                                                                                    value.attr21
                                                                                                )}
                                                                                            </span>
                                                                                        </li>
                                                                                        <ul>
                                                                                            {value.attr22 ? (
                                                                                                <li>
                                                                                                    <span
                                                                                                        className={
                                                                                                            externalCss.redText
                                                                                                        }
                                                                                                    >
                                                                                                        {this.getNotes(
                                                                                                            value.attr22
                                                                                                        )}
                                                                                                    </span>
                                                                                                </li>
                                                                                            ) : null}
                                                                                            {JSON.parse(
                                                                                                value.attr23
                                                                                            ).map((mapValue) => {
                                                                                                if (
                                                                                                    mapValue ===
                                                                                                    'extrudeAnteriorTeeth'
                                                                                                ) {
                                                                                                    return (
                                                                                                        <>
                                                                                                            <li>
                                                                                                                <span
                                                                                                                    className={
                                                                                                                        externalCss.redText
                                                                                                                    }
                                                                                                                >
                                                                                                                    {this.getNotes(
                                                                                                                        mapValue
                                                                                                                    )}
                                                                                                                </span>
                                                                                                            </li>
                                                                                                            <ul>
                                                                                                                {JSON.parse(
                                                                                                                    value.attr24
                                                                                                                ).map(
                                                                                                                    (
                                                                                                                        mapValue
                                                                                                                    ) => (
                                                                                                                        <li>
                                                                                                                            <span
                                                                                                                                className={
                                                                                                                                    externalCss.redText
                                                                                                                                }
                                                                                                                            >
                                                                                                                                {
                                                                                                                                    mapValue
                                                                                                                                }
                                                                                                                            </span>
                                                                                                                        </li>
                                                                                                                    )
                                                                                                                )}
                                                                                                            </ul>
                                                                                                        </>
                                                                                                    );
                                                                                                } else if (
                                                                                                    mapValue ===
                                                                                                    'intrudePosteriorTeeth'
                                                                                                ) {
                                                                                                    return (
                                                                                                        <>
                                                                                                            <li>
                                                                                                                <span
                                                                                                                    className={
                                                                                                                        externalCss.redText
                                                                                                                    }
                                                                                                                >
                                                                                                                    {this.getNotes(
                                                                                                                        mapValue
                                                                                                                    )}
                                                                                                                </span>
                                                                                                            </li>
                                                                                                            <ul>
                                                                                                                {JSON.parse(
                                                                                                                    value.attr25
                                                                                                                ).map(
                                                                                                                    (
                                                                                                                        mapValue
                                                                                                                    ) => (
                                                                                                                        <li>
                                                                                                                            <span
                                                                                                                                className={
                                                                                                                                    externalCss.redText
                                                                                                                                }
                                                                                                                            >
                                                                                                                                {
                                                                                                                                    mapValue
                                                                                                                                }
                                                                                                                            </span>
                                                                                                                        </li>
                                                                                                                    )
                                                                                                                )}
                                                                                                            </ul>
                                                                                                        </>
                                                                                                    );
                                                                                                } else {
                                                                                                    return (
                                                                                                        <li>
                                                                                                            <span
                                                                                                                className={
                                                                                                                    externalCss.redText
                                                                                                                }
                                                                                                            >
                                                                                                                {this.getNotes(
                                                                                                                    mapValue
                                                                                                                )}
                                                                                                                :{' '}
                                                                                                                {
                                                                                                                    value.attr60
                                                                                                                }
                                                                                                            </span>
                                                                                                        </li>
                                                                                                    );
                                                                                                }
                                                                                            })}
                                                                                            {}
                                                                                        </ul>
                                                                                    </ul>
                                                                                    <li>
                                                                                        <strong>
                                                                                            {this.getNotes('deepBite')}
                                                                                        </strong>
                                                                                    </li>
                                                                                    <ul>
                                                                                        <li>
                                                                                            <span
                                                                                                className={
                                                                                                    value.attr26 !==
                                                                                                    'maintainExistingDeepBite'
                                                                                                        ? externalCss.redText
                                                                                                        : ''
                                                                                                }
                                                                                            >
                                                                                                {this.getNotes(
                                                                                                    value.attr26
                                                                                                )}
                                                                                            </span>
                                                                                        </li>
                                                                                        <ul>
                                                                                            {value.attr27 ? (
                                                                                                <li>
                                                                                                    <span
                                                                                                        className={
                                                                                                            externalCss.redText
                                                                                                        }
                                                                                                    >
                                                                                                        {this.getNotes(
                                                                                                            value.attr27
                                                                                                        )}
                                                                                                    </span>
                                                                                                </li>
                                                                                            ) : null}
                                                                                            {JSON.parse(
                                                                                                value.attr28
                                                                                            ).map((mapValue) => {
                                                                                                if (
                                                                                                    mapValue ===
                                                                                                    'extrudePosteriorTeeth'
                                                                                                ) {
                                                                                                    return (
                                                                                                        <>
                                                                                                            <li>
                                                                                                                <span
                                                                                                                    className={
                                                                                                                        externalCss.redText
                                                                                                                    }
                                                                                                                >
                                                                                                                    {this.getNotes(
                                                                                                                        mapValue
                                                                                                                    )}
                                                                                                                </span>
                                                                                                            </li>
                                                                                                            <ul>
                                                                                                                {JSON.parse(
                                                                                                                    value.attr30
                                                                                                                ).map(
                                                                                                                    (
                                                                                                                        mapValue
                                                                                                                    ) => (
                                                                                                                        <li>
                                                                                                                            <span
                                                                                                                                className={
                                                                                                                                    externalCss.redText
                                                                                                                                }
                                                                                                                            >
                                                                                                                                {
                                                                                                                                    mapValue
                                                                                                                                }
                                                                                                                            </span>
                                                                                                                        </li>
                                                                                                                    )
                                                                                                                )}
                                                                                                            </ul>
                                                                                                        </>
                                                                                                    );
                                                                                                } else if (
                                                                                                    mapValue ===
                                                                                                    'intrudeAnteriorTeeth'
                                                                                                ) {
                                                                                                    return (
                                                                                                        <>
                                                                                                            <li>
                                                                                                                <span
                                                                                                                    className={
                                                                                                                        externalCss.redText
                                                                                                                    }
                                                                                                                >
                                                                                                                    {this.getNotes(
                                                                                                                        mapValue
                                                                                                                    )}
                                                                                                                </span>
                                                                                                            </li>
                                                                                                            <ul>
                                                                                                                {JSON.parse(
                                                                                                                    value.attr29
                                                                                                                ).map(
                                                                                                                    (
                                                                                                                        mapValue
                                                                                                                    ) => (
                                                                                                                        <li>
                                                                                                                            <span
                                                                                                                                className={
                                                                                                                                    externalCss.redText
                                                                                                                                }
                                                                                                                            >
                                                                                                                                {
                                                                                                                                    mapValue
                                                                                                                                }
                                                                                                                            </span>
                                                                                                                        </li>
                                                                                                                    )
                                                                                                                )}
                                                                                                            </ul>
                                                                                                        </>
                                                                                                    );
                                                                                                } else {
                                                                                                    return (
                                                                                                        <li>
                                                                                                            <span
                                                                                                                className={
                                                                                                                    externalCss.redText
                                                                                                                }
                                                                                                            >
                                                                                                                {this.getNotes(
                                                                                                                    mapValue
                                                                                                                )}
                                                                                                                :{' '}
                                                                                                                {
                                                                                                                    value.attr61
                                                                                                                }
                                                                                                            </span>
                                                                                                        </li>
                                                                                                    );
                                                                                                }
                                                                                            })}
                                                                                            {}
                                                                                        </ul>
                                                                                    </ul>
                                                                                    <li>
                                                                                        <strong>
                                                                                            {this.getNotes('midline')}
                                                                                        </strong>
                                                                                    </li>
                                                                                    <ul>
                                                                                        <li>
                                                                                            <span
                                                                                                className={
                                                                                                    value.attr31 !==
                                                                                                    'maintainInitialMidline'
                                                                                                        ? externalCss.redText
                                                                                                        : ''
                                                                                                }
                                                                                            >
                                                                                                {this.getNotes(
                                                                                                    value.attr31
                                                                                                )}
                                                                                            </span>
                                                                                        </li>
                                                                                        <ul>
                                                                                            {value.attr32 ? (
                                                                                                <li>
                                                                                                    <span
                                                                                                        className={
                                                                                                            externalCss.redText
                                                                                                        }
                                                                                                    >
                                                                                                        {this.getNotes(
                                                                                                            value.attr32
                                                                                                        )}
                                                                                                    </span>
                                                                                                </li>
                                                                                            ) : null}
                                                                                            {JSON.parse(
                                                                                                value.attr33
                                                                                            ).map((mapValue) => {
                                                                                                if (
                                                                                                    mapValue === 'upper'
                                                                                                ) {
                                                                                                    return (
                                                                                                        <>
                                                                                                            <li>
                                                                                                                <span
                                                                                                                    className={
                                                                                                                        externalCss.redText
                                                                                                                    }
                                                                                                                >
                                                                                                                    {this.getNotes(
                                                                                                                        mapValue
                                                                                                                    )}
                                                                                                                    :{' '}
                                                                                                                    {this.getNotes(
                                                                                                                        value.attr34
                                                                                                                    )}
                                                                                                                </span>
                                                                                                            </li>
                                                                                                        </>
                                                                                                    );
                                                                                                } else {
                                                                                                    return (
                                                                                                        <>
                                                                                                            <li>
                                                                                                                <span
                                                                                                                    className={
                                                                                                                        externalCss.redText
                                                                                                                    }
                                                                                                                >
                                                                                                                    {this.getNotes(
                                                                                                                        mapValue
                                                                                                                    )}
                                                                                                                    :{' '}
                                                                                                                    {this.getNotes(
                                                                                                                        value.attr35
                                                                                                                    )}
                                                                                                                </span>
                                                                                                            </li>
                                                                                                        </>
                                                                                                    );
                                                                                                }
                                                                                            })}
                                                                                        </ul>
                                                                                    </ul>
                                                                                    <li>
                                                                                        <strong>
                                                                                            {this.getNotes(
                                                                                                'posteriorCrossbite'
                                                                                            )}
                                                                                        </strong>
                                                                                    </li>
                                                                                    <ul>
                                                                                        <li>
                                                                                            <span
                                                                                                className={
                                                                                                    value.attr36 !==
                                                                                                    'maintainInitialCrossbite'
                                                                                                        ? externalCss.redText
                                                                                                        : ''
                                                                                                }
                                                                                            >
                                                                                                {this.getNotes(
                                                                                                    value.attr36
                                                                                                )}{' '}
                                                                                                {value.attr37
                                                                                                    ? ': ' +
                                                                                                      this.getNotes(
                                                                                                          value.attr37
                                                                                                      )
                                                                                                    : null}{' '}
                                                                                                {value.attr46
                                                                                                    ? value.attr46
                                                                                                    : null}
                                                                                            </span>
                                                                                        </li>
                                                                                        {value.attr38 ? (
                                                                                            <li>
                                                                                                <span
                                                                                                    className={
                                                                                                        externalCss.redText
                                                                                                    }
                                                                                                >
                                                                                                    {this.getNotes(
                                                                                                        value.attr38
                                                                                                    ).includes(
                                                                                                        '2nd'
                                                                                                    ) ? (
                                                                                                        <>
                                                                                                            {
                                                                                                                this.getNotes(
                                                                                                                    value.attr38
                                                                                                                ).split(
                                                                                                                    '2nd'
                                                                                                                )[0]
                                                                                                            }
                                                                                                            2
                                                                                                            <sup>
                                                                                                                nd
                                                                                                            </sup>
                                                                                                            {
                                                                                                                this.getNotes(
                                                                                                                    value.attr38
                                                                                                                ).split(
                                                                                                                    '2nd'
                                                                                                                )[1]
                                                                                                            }
                                                                                                        </>
                                                                                                    ) : (
                                                                                                        this.getNotes(
                                                                                                            value.attr38
                                                                                                        )
                                                                                                    )}
                                                                                                </span>
                                                                                            </li>
                                                                                        ) : null}
                                                                                        {JSON.parse(value.attr39)
                                                                                            .length ? (
                                                                                            <ul>
                                                                                                {JSON.parse(
                                                                                                    value.attr39
                                                                                                ).map((mapValue) => (
                                                                                                    <li>
                                                                                                        <span
                                                                                                            className={
                                                                                                                externalCss.redText
                                                                                                            }
                                                                                                        >
                                                                                                            {this.getNotes(
                                                                                                                mapValue
                                                                                                            )}
                                                                                                        </span>
                                                                                                    </li>
                                                                                                ))}
                                                                                            </ul>
                                                                                        ) : null}
                                                                                        {JSON.parse(value.attr40)
                                                                                            .length ? (
                                                                                            <ul>
                                                                                                {JSON.parse(
                                                                                                    value.attr40
                                                                                                ).map((mapValue) => (
                                                                                                    <li>
                                                                                                        <span
                                                                                                            className={
                                                                                                                externalCss.redText
                                                                                                            }
                                                                                                        >
                                                                                                            {this.getNotes(
                                                                                                                mapValue
                                                                                                            )}
                                                                                                        </span>
                                                                                                    </li>
                                                                                                ))}
                                                                                            </ul>
                                                                                        ) : null}
                                                                                    </ul>
                                                                                    <li>
                                                                                        <strong>
                                                                                            {this.getNotes(
                                                                                                'auxiliaries'
                                                                                            )}
                                                                                        </strong>
                                                                                    </li>
                                                                                    <ul>
                                                                                        <li>
                                                                                            {this.getNotes('elastics')}
                                                                                        </li>
                                                                                        <ul>
                                                                                            <li>
                                                                                                {this.getNotes(
                                                                                                    'classIIElastics'
                                                                                                )}
                                                                                                :{' '}
                                                                                                <span
                                                                                                    className={
                                                                                                        value.attr41 !==
                                                                                                        'No'
                                                                                                            ? externalCss.redText
                                                                                                            : ''
                                                                                                    }
                                                                                                >
                                                                                                    {this.getNotes(
                                                                                                        value.attr41
                                                                                                    )}
                                                                                                </span>
                                                                                            </li>
                                                                                            <li>
                                                                                                {this.getNotes(
                                                                                                    'classIIIElastics'
                                                                                                )}
                                                                                                :{' '}
                                                                                                <span
                                                                                                    className={
                                                                                                        value.attr42 !==
                                                                                                        'No'
                                                                                                            ? externalCss.redText
                                                                                                            : ''
                                                                                                    }
                                                                                                >
                                                                                                    {this.getNotes(
                                                                                                        value.attr42
                                                                                                    )}
                                                                                                </span>
                                                                                            </li>
                                                                                            {auxiliariesUpper.length ||
                                                                                            auxiliariesLower.length ? (
                                                                                                <li>
                                                                                                    <span
                                                                                                        className={
                                                                                                            externalCss.redText
                                                                                                        }
                                                                                                    >
                                                                                                        {this.getNotes(
                                                                                                            'elasticEngagementPreference'
                                                                                                        )}
                                                                                                    </span>
                                                                                                </li>
                                                                                            ) : null}
                                                                                            <ul>
                                                                                                {auxiliariesUpper.length ? (
                                                                                                    <>
                                                                                                        <li>
                                                                                                            <span
                                                                                                                className={
                                                                                                                    externalCss.redText
                                                                                                                }
                                                                                                            >
                                                                                                                {this.getNotes(
                                                                                                                    'upperDentition'
                                                                                                                )}
                                                                                                            </span>
                                                                                                        </li>
                                                                                                        <ul>
                                                                                                            <li>
                                                                                                                <span
                                                                                                                    className={
                                                                                                                        externalCss.redText
                                                                                                                    }
                                                                                                                >
                                                                                                                    {auxiliariesUpper.map(
                                                                                                                        (
                                                                                                                            mapValue
                                                                                                                        ) => {
                                                                                                                            if (
                                                                                                                                mapValue ===
                                                                                                                                'upperFabricate'
                                                                                                                            )
                                                                                                                                return this.getNotes(
                                                                                                                                    'fabricateButtonDirectlyOnAligners'
                                                                                                                                );
                                                                                                                            if (
                                                                                                                                mapValue ===
                                                                                                                                'upperCutout'
                                                                                                                            )
                                                                                                                                return this.getNotes(
                                                                                                                                    'cutoutOnAligner'
                                                                                                                                );
                                                                                                                            return this.getNotes(
                                                                                                                                'slipCutPrecisionCut'
                                                                                                                            );
                                                                                                                        }
                                                                                                                    )}
                                                                                                                </span>
                                                                                                            </li>
                                                                                                        </ul>
                                                                                                    </>
                                                                                                ) : null}
                                                                                                {auxiliariesLower.length ? (
                                                                                                    <>
                                                                                                        <li>
                                                                                                            <span
                                                                                                                className={
                                                                                                                    externalCss.redText
                                                                                                                }
                                                                                                            >
                                                                                                                {this.getNotes(
                                                                                                                    'lowerDentition'
                                                                                                                )}
                                                                                                            </span>
                                                                                                        </li>
                                                                                                        <ul>
                                                                                                            <li>
                                                                                                                <span
                                                                                                                    className={
                                                                                                                        externalCss.redText
                                                                                                                    }
                                                                                                                >
                                                                                                                    {auxiliariesLower.map(
                                                                                                                        (
                                                                                                                            mapValue
                                                                                                                        ) => {
                                                                                                                            if (
                                                                                                                                mapValue ===
                                                                                                                                'lowerFabricate'
                                                                                                                            )
                                                                                                                                return this.getNotes(
                                                                                                                                    'fabricateButtonDirectlyOnAligners'
                                                                                                                                );
                                                                                                                            if (
                                                                                                                                mapValue ===
                                                                                                                                'lowerCutout'
                                                                                                                            )
                                                                                                                                return this.getNotes(
                                                                                                                                    'cutoutOnAligner'
                                                                                                                                );
                                                                                                                            return this.getNotes(
                                                                                                                                'slipCutPrecisionCut'
                                                                                                                            );
                                                                                                                        }
                                                                                                                    )}
                                                                                                                </span>
                                                                                                            </li>
                                                                                                        </ul>
                                                                                                    </>
                                                                                                ) : null}
                                                                                            </ul>
                                                                                        </ul>
                                                                                        <li>
                                                                                            {this.getNotes(
                                                                                                'otherElastics'
                                                                                            )}
                                                                                            :{' '}
                                                                                            <span
                                                                                                className={
                                                                                                    value.attr44 !==
                                                                                                    'No'
                                                                                                        ? externalCss.redText
                                                                                                        : ''
                                                                                                }
                                                                                            >
                                                                                                {value.attr62 ||
                                                                                                    this.getNotes(
                                                                                                        value.attr44
                                                                                                    )}
                                                                                            </span>
                                                                                        </li>
                                                                                    </ul>

                                                                                    <li>
                                                                                        <strong>
                                                                                            {this.getNotes(
                                                                                                'trioDimForcePreference'
                                                                                            )}
                                                                                        </strong>
                                                                                    </li>
                                                                                    <ul>
                                                                                        <li
                                                                                            className={
                                                                                                value?.trio_dim_force &&
                                                                                                value?.trio_dim_force !==
                                                                                                    'true'
                                                                                                    ? externalCss.redText
                                                                                                    : ''
                                                                                            }
                                                                                        >
                                                                                            {value?.trio_dim_force
                                                                                                ? this.getNotes(
                                                                                                      `trioDimForce_${value?.trio_dim_force}`
                                                                                                  )
                                                                                                : 'N/A'}
                                                                                        </li>
                                                                                    </ul>

                                                                                    {value.show_upsell_questions !== 0 &&  (
                                                                                        <>
                                                                                            <li>
                                                                                                <strong>
                                                                                                    {this.getNotes(
                                                                                                        'restorativeOptions'
                                                                                                    )}
                                                                                                </strong>
                                                                                            </li>
                                                                                    <ul>
                                                                                        <ViewRestorativeOptions
                                                                                            restorative_options={
                                                                                                restorative_options
                                                                                            }
                                                                                            vertical_dimension_upper_posterior={
                                                                                                vertical_dimension_upper_posterior
                                                                                            }
                                                                                            vertical_dimension_lower_posterior={
                                                                                                vertical_dimension_lower_posterior
                                                                                            }
                                                                                            onlay_position={
                                                                                                onlay_position
                                                                                            }
                                                                                            teeth={this.teeth}
                                                                                        />
                                                                                    </ul>

                                                                                    <li>
                                                                                        <strong>
                                                                                            {this.getNotes(
                                                                                                'preImplantAligment'
                                                                                            )}
                                                                                        </strong>
                                                                                    </li>
                                                                                    <ul>
                                                                                        {value?.prosthetic_space &&
                                                                                        Array.isArray(
                                                                                            value.prosthetic_space
                                                                                        ) &&
                                                                                        value?.prosthetic_space.length >
                                                                                            0 ? (
                                                                                            <div
                                                                                                style={{
                                                                                                    width: 800,
                                                                                                    height: 200,
                                                                                                    position:
                                                                                                        'relative',
                                                                                                    backgroundRepeat:
                                                                                                        'no-repeat',
                                                                                                    backgroundImage: `url("${getWebAbsPath('/img/prescriptionNotes/smaller_teeth_number_CS.ai.png')}")`,
                                                                                                }}
                                                                                            >
                                                                                                {renderToothMarkers(
                                                                                                    value.prosthetic_space,
                                                                                                    this.teeth,
                                                                                                    '/img/prescriptionNotes/checkSuccess.png'
                                                                                                )}
                                                                                            </div>
                                                                                        ) : (
                                                                                            <li>
                                                                                                {this.get(
                                                                                                    '@global.const.no'
                                                                                                )}
                                                                                            </li>
                                                                                        )}
                                                                                    </ul>

                                                                                    <li>
                                                                                        <strong>
                                                                                            {this.getNotes(
                                                                                                'addOnSmileDesign'
                                                                                            )}{' '}
                                                                                            {this.getNotes(
                                                                                                'additionalFee'
                                                                                            )}
                                                                                        </strong>
                                                                                    </li>
                                                                                    <ul>
                                                                                        <li>
                                                                                            {isValidUpsellSmileCase ? (
                                                                                                <span
                                                                                                    className={
                                                                                                        isValidUpsellSmileCase
                                                                                                            ? externalCss.redText
                                                                                                            : ''
                                                                                                    }
                                                                                                >
                                                                                                    <SmileDesignPrescriptionNotesPreviewMap
                                                                                                        defaultValues={
                                                                                                            this.state
                                                                                                                .patientInfo
                                                                                                                .case_smile_design
                                                                                                        }
                                                                                                        isUpsellTab
                                                                                                        isMarieGroup={
                                                                                                            this.state
                                                                                                                .patientInfo
                                                                                                                .isMarieGroup
                                                                                                        }
                                                                                                        isSEAGroup={
                                                                                                            this.state
                                                                                                                .patientInfo
                                                                                                                .isSEAGroup ?? this.state.isSEAGroup
                                                                                                        }
                                                                                                        schema={createStaticSmileDesignQuestionSchema(
                                                                                                            {
                                                                                                                isMarieGroup:
                                                                                                                    this
                                                                                                                        .state
                                                                                                                        .isMarieGroup,
                                                                                                                isSEAGroup:
                                                                                                                    this.state.isSEAGroup,
                                                                                                                isUpSellTab: true,
                                                                                                                displayFirstFitFlag:
                                                                                                                    this.props.displayFirstFitFlag,
                                                                                                            }
                                                                                                        )}
                                                                                                    />
                                                                                                </span>
                                                                                            ) : (
                                                                                                <li>
                                                                                                    {this.get(
                                                                                                        '@global.const.no'
                                                                                                    )}
                                                                                                </li>
                                                                                            )}
                                                                                        </li>
                                                                                    </ul>
                                                                                        </>
                                                                                    )}

                                                                                    <li>
                                                                                        <strong>
                                                                                            {`${this.getNotes('additionalInstructionsOrSpecialRequests')}: `}
                                                                                        </strong>
                                                                                        <span
                                                                                            className={
                                                                                                value.attr47
                                                                                                    ? externalCss.redText
                                                                                                    : ''
                                                                                            }
                                                                                        >
                                                                                            {value.attr47 || 'N/A'}
                                                                                        </span>
                                                                                    </li>
                                                                                </ol>
                                                                            ) : (
                                                                                <>
                                                                                    <p style={{ paddingBottom: 10 }}>
                                                                                        {getFromObj(
                                                                                            this.props.lang,
                                                                                            'dict.NewPatient.summary.dentitionNotMove'
                                                                                        )}
                                                                                    </p>
                                                                                    <div
                                                                                        style={{
                                                                                            width: 800,
                                                                                            height: 800,
                                                                                            position: 'relative',
                                                                                            backgroundRepeat:
                                                                                                'no-repeat',
                                                                                            backgroundImage: `url("${getWebAbsPath('/img/newTeeth/permanentTeeth.png')}")`,
                                                                                        }}
                                                                                    >
                                                                                        {teethGraph.map((v, i) => (
                                                                                            <div key={i}>
                                                                                                <img
                                                                                                    src={getWebAbsPath(
                                                                                                        `/img/newTeeth/t${i + 1}.png`
                                                                                                    )}
                                                                                                    style={{
                                                                                                        position:
                                                                                                            'absolute',
                                                                                                        margin: v.margin,
                                                                                                        transform: `${v.deg}`,
                                                                                                        transformOrigin:
                                                                                                            '50% 50%',
                                                                                                        width: v.width,
                                                                                                    }}
                                                                                                />
                                                                                                {(
                                                                                                    value[
                                                                                                        'excluded_dentition'
                                                                                                    ]
                                                                                                        ?.split(',')
                                                                                                        .map((v) =>
                                                                                                            parseInt(v)
                                                                                                        ) || []
                                                                                                ).includes(i) && (
                                                                                                    <img
                                                                                                        src={getWebAbsPath(
                                                                                                            '/img/tooth/check.png'
                                                                                                        )}
                                                                                                        style={{
                                                                                                            position:
                                                                                                                'absolute',
                                                                                                            margin: v.margin,
                                                                                                            width: v.width,
                                                                                                        }}
                                                                                                    />
                                                                                                )}
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                    <div
                                                                                        className="questionnaireAttr"
                                                                                        style={{
                                                                                            width: '100%',
                                                                                            fontSize: '16px',
                                                                                            lineHeight: '2',
                                                                                        }}
                                                                                    >
                                                                                        <ul>
                                                                                            {Object.entries(value)
                                                                                                .filter(
                                                                                                    ([k]) =>
                                                                                                        k.startsWith(
                                                                                                            'attr'
                                                                                                        ) &&
                                                                                                        this
                                                                                                            .questionnaire_attr_name[
                                                                                                            k
                                                                                                        ]
                                                                                                )
                                                                                                .map(([k, v]) => {
                                                                                                    try {
                                                                                                        v = JSON.parse(
                                                                                                            v
                                                                                                        )
                                                                                                            .map(
                                                                                                                (
                                                                                                                    vv
                                                                                                                ) => {
                                                                                                                    if (
                                                                                                                        this
                                                                                                                            .attrLabelMapping[
                                                                                                                            k
                                                                                                                        ]
                                                                                                                    ) {
                                                                                                                        const result =
                                                                                                                            this.attrLabelMapping[
                                                                                                                                k
                                                                                                                            ]?.find(
                                                                                                                                (
                                                                                                                                    val
                                                                                                                                ) =>
                                                                                                                                    val.value ===
                                                                                                                                    vv
                                                                                                                            );
                                                                                                                        if (
                                                                                                                            result
                                                                                                                        ) {
                                                                                                                            return result.label;
                                                                                                                        }
                                                                                                                    }
                                                                                                                    return vv;
                                                                                                                }
                                                                                                            )
                                                                                                            .join(', ');
                                                                                                    } catch {
                                                                                                        if (
                                                                                                            this
                                                                                                                .attrLabelMapping[
                                                                                                                k
                                                                                                            ]
                                                                                                        ) {
                                                                                                            const result =
                                                                                                                this.attrLabelMapping[
                                                                                                                    k
                                                                                                                ]?.find(
                                                                                                                    (
                                                                                                                        val
                                                                                                                    ) =>
                                                                                                                        val.value ===
                                                                                                                        v
                                                                                                                );
                                                                                                            if (
                                                                                                                result
                                                                                                            ) {
                                                                                                                v =
                                                                                                                    result.label;
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                    let concat = '';
                                                                                                    if (
                                                                                                        k === 'attr0' &&
                                                                                                        String.isNotBlank(
                                                                                                            value[
                                                                                                                'attr10'
                                                                                                            ]
                                                                                                        )
                                                                                                    ) {
                                                                                                        concat = `(${value['attr10']})`;
                                                                                                    } else if (
                                                                                                        k === 'attr1' &&
                                                                                                        String.isNotBlank(
                                                                                                            value[
                                                                                                                'attr11'
                                                                                                            ]
                                                                                                        )
                                                                                                    ) {
                                                                                                        const keyValPair =
                                                                                                            this.overBiteListButtons.find(
                                                                                                                (v) =>
                                                                                                                    v.value ===
                                                                                                                    value[
                                                                                                                        'attr11'
                                                                                                                    ]
                                                                                                            );
                                                                                                        if (
                                                                                                            keyValPair
                                                                                                        ) {
                                                                                                            concat = `(${keyValPair.label})`;
                                                                                                        }
                                                                                                    }
                                                                                                    if (
                                                                                                        k === 'attr12'
                                                                                                    ) {
                                                                                                        return (
                                                                                                            <li>
                                                                                                                <strong>
                                                                                                                    {
                                                                                                                        this
                                                                                                                            .questionnaire_attr_name[
                                                                                                                            k
                                                                                                                        ]
                                                                                                                    }
                                                                                                                </strong>
                                                                                                                :
                                                                                                                <ul
                                                                                                                    style={{
                                                                                                                        listStyleType:
                                                                                                                            'circle',
                                                                                                                    }}
                                                                                                                >
                                                                                                                    {v
                                                                                                                        ?.split?.(
                                                                                                                            '\n'
                                                                                                                        )
                                                                                                                        .map(
                                                                                                                            (
                                                                                                                                _v
                                                                                                                            ) => (
                                                                                                                                <li>
                                                                                                                                    {
                                                                                                                                        _v
                                                                                                                                    }
                                                                                                                                </li>
                                                                                                                            )
                                                                                                                        )}
                                                                                                                </ul>
                                                                                                            </li>
                                                                                                        );
                                                                                                    } else {
                                                                                                        return (
                                                                                                            <li>
                                                                                                                <strong>
                                                                                                                    {
                                                                                                                        this
                                                                                                                            .questionnaire_attr_name[
                                                                                                                            k
                                                                                                                        ]
                                                                                                                    }
                                                                                                                </strong>
                                                                                                                :{' '}
                                                                                                                {String.isBlank(
                                                                                                                    v
                                                                                                                )
                                                                                                                    ? this.get(
                                                                                                                          ':const.none'
                                                                                                                      )
                                                                                                                    : v}{' '}
                                                                                                                {concat}{' '}
                                                                                                                {}
                                                                                                            </li>
                                                                                                        );
                                                                                                    }
                                                                                                })}
                                                                                        </ul>
                                                                                    </div>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    )
                                                                );
                                                            })}
                                                    </Grid>
                                                </Grid>
                                            ))
                                    )}
                                </Modal>
                                <Modal
                                    className="modal"
                                    modal="request_retainer"
                                    title={this.get('modals.reatinerModalTitle')}
                                    open={this.state.RequestRetainerModal && !this.state.loading}
                                    handleClose={() => this.handleClose('request_retainer')}
                                    handleDataSave={() => this.handleRequestRetainerSave()}
                                    submitButton={this.state.ModalState == 'update' ? true : false}
                                    submitButtonLabel="Submit"
                                    PhotoUploadLoadingStatus={this.state.PhotoUploadLoadingStatus}
                                    modalError={this.state.modalError}
                                >
                                    <Grid container>
                                        <Grid item xs={12} sm={12}>
                                            <Refinement
                                                tabMode="impression"
                                                threeshapeConnected={this.state.threeshapeConnected}
                                                handleThreeshapeConnected={(value) =>
                                                    this.setState({ threeshapeConnected: value })
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                </Modal>
                            </Grid>

                            <Grid item xs={12}>
                                <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
                                    <Link
                                        to="/"
                                        style={{
                                            color: 'black',
                                        }}
                                    >
                                        {this.get('breadcrumbs.caseManagement')}
                                    </Link>
                                    <Typography>{`${this.get('breadcrumbs.patient')}: ${this.state.patientId}`}</Typography>
                                </Breadcrumbs>
                            </Grid>

                            <Grid item xs={12}>
                                <Grid container>
                                    <Grid item xs={12} md={8} className={classes.leftCards}>
                                        <Grid container className={classes.mainInfoContainer}>
                                            <Grid container item xs={12} style={{ padding: '24px 24px 0px 24px' }}>
                                                <Grid item xs={11} style={{ padding: '6px 0px' }}></Grid>
                                                <Grid item xs={1}>
                                                    {['SADMIN', 'ADMIN', 'SADMIN', 'DISTR'].includes(role) && (
                                                        <Button
                                                            style={{ float: 'right' }}
                                                            onClick={() => this.handleOpen('info')}
                                                        >
                                                            {this.get('case_info.editInfo')}
                                                        </Button>
                                                    )}
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <hr />
                                                </Grid>
                                            </Grid>

                                            <Grid item xs={12} sm={3} style={{ display: 'grid', padding: 24 }}>
                                                <img
                                                    src={this.state.patientInfo.image}
                                                    onError={(e) => {
                                                        let u = Url.parse(e.target.src);
                                                        e.target.src =
                                                            u.pathname === '/' || u.pathname.startsWith('/img')
                                                                ? ''
                                                                : this.state.patientInfo.gender === 'Male'
                                                                  ? getWebAbsPath('/img/front_smile.png')
                                                                  : this.state.patientInfo.gender === 'Female'
                                                                    ? getWebAbsPath('/img/front_smile_female.png')
                                                                    : getWebAbsPath('/img/front_smile_other.png');
                                                    }}
                                                    style={{
                                                        width: 'auto',
                                                        // height: "100%",
                                                        maxWidth: '100%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto',
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6} style={{ padding: '24px 0px 24px 24px' }}>
                                                <h3
                                                    style={{
                                                        textAlign: 'left',
                                                        fontWeight: 400,
                                                        //color: '#2eafb6',
                                                        fontSize: '1.5rem',
                                                        marginBlockStart: 0,
                                                        marginBlockEnd: 0,
                                                    }}
                                                >
                                                    {`${this.get('case_info.patientId')}: ${this.state.patientId} | ${this.get('case_info.caseId')}: `}
                                                    <span
                                                        style={{
                                                            fontSize: '1.5rem',
                                                        }}
                                                    >
                                                        {`${this.props.match.params.id}`}
                                                    </span>
                                                </h3>
                                                <h3
                                                    style={{
                                                        textAlign: 'left',
                                                        fontWeight: 600,
                                                        color: '#2eafb6',
                                                        fontSize: 26,
                                                        marginBlockStart: 0,
                                                        marginBlockEnd: 0,
                                                        fontFamily: '"Montserrat Black", "Montserrat", sans-serif',
                                                    }}
                                                >
                                                    {`${this.state.patientInfo.firstName}, ${this.state.patientInfo.lastName}`}
                                                </h3>

                                                <hr
                                                    style={{
                                                        border: 'solid 1px #a8a8a8',
                                                        width: '100%',
                                                        margin: '4px 0 8px 0',
                                                    }}
                                                    align="left"
                                                />

                                                {this.state.patientInfo.new_case_option ? (
                                                    <Grid xs={12}>
                                                        <h5 className={classes.mainTitle}>
                                                            {this.state.patientInfo.new_case_option}
                                                        </h5>
                                                    </Grid>
                                                ) : (
                                                    <></>
                                                )}

                                                <Grid container item xs={12} style={{ rowGap: 16 }}>
                                                    <Grid container>
                                                        <Grid container>
                                                            <Grid item xs={8} sm={8} style={{ paddingRight: 8 }}>
                                                                <h5 className={classes.infoText}>
                                                                    {this.get('case_info.dob')}:
                                                                </h5>
                                                            </Grid>
                                                            <Grid item xs={4} sm={4}>
                                                                <p className={classes.infoText}>
                                                                    {(() => {
                                                                        const m = Moment(
                                                                            this.state.patientInfo.dateOfBirth,
                                                                            [
                                                                                'D-M-YYYY',
                                                                                'D-MM-YYYY',
                                                                                'DD-M-YYYY',
                                                                                'DD-MM-YYYY',
                                                                            ],
                                                                            true
                                                                        );
                                                                        return m.isValid()
                                                                            ? m.format('DD-MMM-YYYY')
                                                                            : null;
                                                                    })() || 'N/A'}
                                                                </p>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid container>
                                                            <Grid item xs={8} sm={8} style={{ paddingRight: 8 }}>
                                                                <h5 className={classes.infoText}>
                                                                    {this.get('case_info.gender')}:
                                                                </h5>
                                                            </Grid>
                                                            <Grid item xs={4} sm={4}>
                                                                <p className={classes.infoText}>
                                                                    {this.state.patientInfo.gender || 'N/A'}
                                                                </p>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid container>
                                                        <Grid container>
                                                            <Grid item xs={8} sm={8} style={{ paddingRight: 8 }}>
                                                                <h5 className={classes.infoText}>
                                                                    {this.get('case_info.treatmentOption')}:
                                                                </h5>
                                                            </Grid>
                                                            <Grid item xs={4} sm={4}>
                                                                <p
                                                                    className={`${classes.infoText} ${classes.infoTextHighlight}`}
                                                                >
                                                                    {this.state.patientInfo?.case_type === CASE_TYPE.SELF_DESIGN
                                                                        ? this.get('@global.caseType.SELF_DESIGN')
                                                                        : this.state.isSmileDesign &&
                                                                          this.state.patientInfo.product_name == null
                                                                            ? this.get('@global.caseType.FULL_SMILE_DESIGN')
                                                                            : this.state.patientInfo.product_name ===
                                                                                'Simple Smile Design'
                                                                              ? this.get(`:caseType.SIMPLE_SMILE_DESIGN`)
                                                                              : this.state.patientInfo.product_name ||
                                                                                'N/A'}
                                                                </p>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid container>
                                                            <Grid item xs={8} sm={8} style={{ paddingRight: 8 }}>
                                                                <h5 className={classes.infoText}>
                                                                    {this.get('case_info.approvalDate')}:
                                                                </h5>
                                                            </Grid>
                                                            <Grid item xs={4} sm={4}>
                                                                <p
                                                                    className={`${classes.infoText} ${classes.infoTextHighlight}`}
                                                                >
                                                                    {this.state.patientInfo.approvalDate}
                                                                </p>
                                                            </Grid>
                                                        </Grid>
                                                        {!smileDesignProductListArray.includes(
                                                            this.state.patientInfo.case_type
                                                        ) && (
                                                            <Grid container>
                                                                <Grid item xs={8} sm={8} style={{ paddingRight: 8 }}>
                                                                    <h5 className={classes.infoText}>
                                                                        {this.get('case_info.treatmentEndDate')}:
                                                                    </h5>
                                                                </Grid>
                                                                <Grid item xs={4} sm={4}>
                                                                    <p
                                                                        className={`${classes.infoText} ${classes.infoTextHighlight}`}
                                                                    >
                                                                        {this.state.patientInfo.treatmentEndDate}
                                                                    </p>
                                                                </Grid>
                                                            </Grid>
                                                        )}

                                                        {this.renderPackageDetailsByVersion()}
                                                    </Grid>

                                                    <Grid container>
                                                        {['SADMIN', 'ADMIN', 'DISTR', 'DR'].includes(role) && (
                                                            <>
                                                                {' '}
                                                                <Grid container>
                                                                    <Grid
                                                                        item
                                                                        xs={8}
                                                                        sm={8}
                                                                        style={{ paddingRight: 8 }}
                                                                    >
                                                                        <h5 className={classes.infoText}>
                                                                            {this.get('case_info.clientCode')}:
                                                                        </h5>
                                                                    </Grid>
                                                                    <Grid item xs={4} sm={4}>
                                                                        <p className={classes.infoText}>
                                                                            {this.state.clientCode
                                                                                ? this.state.clientCode
                                                                                : 'N/A'}
                                                                        </p>
                                                                    </Grid>
                                                                </Grid>
                                                            </>
                                                        )}

                                                        {['SADMIN', 'ADMIN', 'DISTR'].includes(role) && (
                                                            <>
                                                                {' '}
                                                                <Grid container>
                                                                    <Grid
                                                                        item
                                                                        xs={8}
                                                                        sm={8}
                                                                        style={{ paddingRight: 8 }}
                                                                    >
                                                                        <h5 className={classes.infoText}>
                                                                            {this.get('case_info.refCode')}:
                                                                        </h5>
                                                                    </Grid>
                                                                    <Grid item xs={4} sm={4}>
                                                                        <p className={classes.infoText}>
                                                                            {this.state.patientInfo.refCode
                                                                                ? this.state.patientInfo.refCode
                                                                                : 'N/A'}
                                                                        </p>
                                                                    </Grid>
                                                                </Grid>
                                                            </>
                                                        )}
                                                    </Grid>

                                                    <Grid container style={{ rowGap: 16 }}>
                                                        <Grid item xs={12}>
                                                            <h5 className={classes.infoText}>
                                                                {this.get('case_info.remarks')}:
                                                            </h5>
                                                            <ExpandText
                                                                expandLabel={this.get('case_info.readMore')}
                                                                collapseLabel={this.get('case_info.readLess')}
                                                                classes={classes}
                                                                text={this.state.patientInfo.remarks || 'N/A'}
                                                                maxLength={REMARKS_MAX_LENGTH}
                                                            />
                                                        </Grid>

                                                        {['DISTR'].includes(role) && (
                                                            <Grid item xs={12}>
                                                                <h5 className={classes.infoText}>
                                                                    {this.get('case_info.distributorInternalRemarks')}:
                                                                </h5>
                                                                <ExpandText
                                                                    expandLabel={this.get('case_info.readMore')}
                                                                    collapseLabel={this.get('case_info.readLess')}
                                                                    classes={classes}
                                                                    text={
                                                                        this.state.patientInfo.internalRemarks
                                                                            ? this.state.patientInfo.internalRemarks
                                                                            : '/'
                                                                    }
                                                                    maxLength={REMARKS_MAX_LENGTH}
                                                                />
                                                            </Grid>
                                                        )}

                                                        {['DR'].includes(role) && (
                                                            <Grid item xs={12}>
                                                                <h5 className={classes.infoText}>
                                                                    {this.get('case_info.drRemarks')}:
                                                                </h5>
                                                                <p className={classes.infoText}>
                                                                    {this.state.patientInfo.dr_remark
                                                                        ? `${this.state.patientInfo.dr_remark.substring(0, REMARKS_MAX_LENGTH)}${this.state.patientInfo.dr_remark.length > REMARKS_MAX_LENGTH ? '...' : ''}`
                                                                        : 'N/A'}
                                                                    <span
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                            marginLeft: 8,
                                                                            fontSize: 12,
                                                                            fontStyle: 'italic',
                                                                        }}
                                                                        onClick={() => this.handleOpen('drRemarks')}
                                                                    >
                                                                        {this.get('case_info.manageNotes')}
                                                                    </span>
                                                                </p>
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                sm={3}
                                                className={classes.infoCellSection}
                                                style={{
                                                    padding: '10px 10px 5px 24px',
                                                    rowGap: 8,
                                                }}
                                            >
                                                {(() => {
                                                    const otherPatientCases = this.state.patientCases.filter(
                                                        (it) => String(it.case_id) !== String(this.state.caseId)
                                                    );
                                                    if (otherPatientCases.length === 0) return null;
                                                    return (
                                                        <Grid item xs={12} className={classes.infoCell}>
                                                            <h5 className={classes.infoCellTitle}>
                                                                {this.get('case_info.casesList')}:
                                                            </h5>
                                                            <p className={classes.infoText}>
                                                                <Select
                                                                    labelId="patient-cases-select-label-id"
                                                                    id="patient-cases-select"
                                                                    label="Cases"
                                                                    displayEmpty
                                                                    value=""
                                                                    style={{ width: '100%' }} // Adjust the width here
                                                                    onChange={(it) => {
                                                                        if (this.state.caseId !== it.target.value) {
                                                                            const selectedCase = otherPatientCases.find(
                                                                                (icase) =>
                                                                                    icase.case_id === it.target.value
                                                                            );
                                                                            window.location.replace(
                                                                                selectedCase.case_status === 'DRAFT'
                                                                                    ? `/patients/${this.state.patientInfo?.patientId}/${it.target.value}/edit`
                                                                                    : `/patients/${it.target.value}`
                                                                            );
                                                                        }
                                                                    }}
                                                                >
                                                                    {otherPatientCases.map((it) => {
                                                                        const caseTypeLabel = this.get(
                                                                            `:caseType.${it.case_type}`
                                                                        );
                                                                        const smileDesignSuffix =
                                                                            it.smileDesignType !== '' &&
                                                                            !smileDesignProductListArray.includes(
                                                                                it.case_type
                                                                            )
                                                                                ? ` (${this.get(`:caseType.${it.smileDesignType}`)})`
                                                                                : '';
                                                                        const statusLabel =
                                                                            this.get(`:caseStatus.${it.case_status}`) ||
                                                                            it.case_status.replace(/_/g, ' ');
                                                                        return (
                                                                            <MenuItem
                                                                                value={it.case_id}
                                                                                key={`patient-cases-${it.case_id}`}
                                                                            >
                                                                                <div>
                                                                                    <div>
                                                                                        {this.get(
                                                                                            'case_info.casesListCaseId'
                                                                                        )}
                                                                                        : {it.case_id} ({caseTypeLabel}
                                                                                        {smileDesignSuffix})
                                                                                    </div>
                                                                                    <div>
                                                                                        {this.get('case_info.status')}:{' '}
                                                                                        {statusLabel}
                                                                                    </div>
                                                                                </div>
                                                                            </MenuItem>
                                                                        );
                                                                    })}
                                                                </Select>
                                                            </p>
                                                        </Grid>
                                                    );
                                                })()}
                                                {['SADMIN', 'ADMIN', 'DISTR'].includes(role) && (
                                                    <Grid item xs={12} className={classes.infoCell}>
                                                        <h5 className={classes.infoCellTitle}>
                                                            {this.get('case_info.facialScanData')}:
                                                        </h5>
                                                        <p className={classes.infoText}>
                                                            {this.isRenderRayCaseField() ? 'RAYFACE' : 'N/A'}
                                                        </p>
                                                    </Grid>
                                                )}
                                                {!['DR'].includes(role) &&
                                                    this.isRenderRayCaseField() && ( // Explain: the text position need to be here
                                                        <>
                                                            <Grid item xs={12} className={classes.infoCell}>
                                                                <h5 className={classes.infoCellTitle}>
                                                                    {this.get('ray_info.ray_case')}:
                                                                </h5>
                                                                <p className={classes.infoText}>
                                                                    {this.get(
                                                                        `ray_info.is_ray_case_${this.state.patientInfo.ray_info.isRayCase}`
                                                                    )}
                                                                </p>
                                                            </Grid>
                                                            <Grid item xs={12} className={classes.infoCell}>
                                                                <h5 className={classes.infoCellTitle}>
                                                                    {this.get('ray_info.ray_refinement')}:
                                                                </h5>
                                                                <p className={classes.infoText}>
                                                                    {this.get(
                                                                        `ray_info.is_ray_case_${this.state.patientInfo.ray_info.isRayRefinement}`
                                                                    )}
                                                                </p>
                                                            </Grid>
                                                        </>
                                                    )}
                                                {['SADMIN', 'ADMIN', 'DISTR'].includes(role) &&
                                                    this.state.patientCases.some(
                                                        (it) => String(it.case_id) !== String(this.state.caseId)
                                                    ) && (
                                                        <Grid item xs={12} className={classes.infoCell}>
                                                            <h5 className={classes.infoCellTitle}>File Modified:</h5>
                                                            <p className={classes.infoText}>
                                                                {this.state.patientInfo.ray_draft_changed
                                                                    ? 'Yes'
                                                                    : 'No'}
                                                            </p>
                                                        </Grid>
                                                    )}
                                                {!['DR'].includes(role) &&
                                                    !smileDesignProductListArray.includes(
                                                        this.state.patientInfo.case_type
                                                    ) && (
                                                        <Grid item xs={12} className={classes.infoCell}>
                                                            <h5 className={classes.infoCellTitle}>
                                                                {this.get('case_info.promotionCode')}:
                                                            </h5>
                                                            <p className={classes.infoText}>
                                                                {this.state.patientInfo.promotionCode
                                                                    ? this.state.patientInfo.promotionCode
                                                                    : 'N/A'}
                                                            </p>
                                                        </Grid>
                                                    )}
                                                <Grid item xs={12} className={classes.infoCell}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                        <h5 className={classes.infoCellTitle}>
                                                            {this.get('case_info.packageVersion')}:
                                                        </h5>
                                                        <Tooltip
                                                            title={
                                                                <div
                                                                    style={{ fontSize: 14, padding: 12 }}
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: this.get(
                                                                            'case_info.packageVersionTooltip'
                                                                        ),
                                                                    }}
                                                                />
                                                            }
                                                        >
                                                            <InfoIcon fontSize="medium" color="secondary" />
                                                        </Tooltip>
                                                    </div>
                                                    <p className={classes.infoText}>
                                                        {this.state.patientInfo.package_version?.trim() || 'N/A'}
                                                    </p>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid
                                            container
                                            style={{
                                                textAlign: 'left',
                                                boxShadow: '-2px 6px 24px -9px rgba(166,130,166,1)',
                                                marginTop: 16,
                                                padding: 24,
                                            }}
                                        >
                                            <Grid
                                                item
                                                xs={11}
                                                style={{
                                                    padding: '6px 0px',
                                                    wordBreak: 'break-word',
                                                    overflowWrap: 'break-word',
                                                }}
                                            >
                                                {this.get('case_info.caseStatus')}:
                                                <span
                                                    style={{
                                                        fontWeight: 600,
                                                        color: '#406097',
                                                        fontSize: 20,
                                                        marginLeft: '5px',
                                                    }}
                                                >
                                                    {this.state.patientInfo.caseStatusLabel}
                                                </span>
                                            </Grid>
                                            <Grid item xs={12} md={6} style={{ display: 'flex' }}>
                                                <h5 className={classes.rightTitles} style={{ marginTop: '4px' }}>
                                                    {this.get('case_info.caseLog')}
                                                </h5>
                                                {this.state.unreadStatusCount != 0 ? (
                                                    <>
                                                        <Badge
                                                            badgeContent={this.state.unreadStatusCount}
                                                            className={classes.ClearNotificationBadge}
                                                        >
                                                            <Chip
                                                                className={classes.markReadClearNotification}
                                                                label={this.get('markRead')}
                                                                onClick={() => this.handleClickOpen()}
                                                                variant="outlined"
                                                            />
                                                        </Badge>
                                                        <Dialog
                                                            open={this.state.opendMarkReadConfirm}
                                                            onClose={this.markAsReadClose}
                                                        >
                                                            <DialogContent>
                                                                <DialogContentText>
                                                                    Confirm marking read for case status?
                                                                </DialogContentText>
                                                            </DialogContent>
                                                            <DialogActions>
                                                                <Button onClick={this.markAsReadClose}>No</Button>
                                                                <Button onClick={this.markAsRead}>Yes</Button>
                                                            </DialogActions>
                                                        </Dialog>
                                                    </>
                                                ) : (
                                                    ''
                                                )}
                                            </Grid>

                                            {this.state.loading ? <></> : this.returnLogs()}
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} md={4} className={classes.rightCard}>
                                        <Grid
                                            container
                                            style={{
                                                textAlign: 'left',
                                                boxShadow: '-2px 6px 24px -9px rgba(166,130,166,1)',
                                                padding: 8,
                                            }}
                                        >
                                            {this.state.patientInfo.case_type !== CASE_TYPE.SELF_DESIGN ||
                                            ['DR'].includes(role) ||
                                            (['ADMIN', 'DISTR', 'SADMIN'].includes(role) &&
                                                ![CASE_STATUS.SUBMITTED, CASE_STATUS.PLAN_UPLOADED].includes(
                                                    this.state.patientInfo.caseStatus
                                                )) ? (
                                                <Grid item xs={12}>
                                                    <h5 className={classes.rightTitles}>
                                                        {this.get('case_info.actions')}
                                                    </h5>
                                                </Grid>
                                            ) : null}

                                            {this.state.patientInfo.case_type !== CASE_TYPE.SELF_DESIGN ? (
                                                <>
                                                    {['ADMIN', 'DISTR', 'SADMIN'].includes(role) ? (
                                                        <Grid item xs={12}>
                                                            <Button
                                                                className={classes.linkBtn}
                                                                onClick={() => this.handleOpen('status')}
                                                            >
                                                                {this.get('case_info.actionsList.updateStatus')}
                                                            </Button>
                                                        </Grid>
                                                    ) : (
                                                        ''
                                                    )}

                                                    {['DR'].includes(role) ? (
                                                        <>
                                                            <Grid item xs={12}>
                                                                <CreateNewCaseModalButton
                                                                    ClassProps={classes.linkBtn}
                                                                    disable={!this.state.isDisableCreateNewCaseForPatient}
                                                                    determineWhatCaseCanCreate={
                                                                        this.state.determineWhatCaseCanCreate
                                                                    }
                                                                    patientId={this.state.patientId}
                                                                />
                                                            </Grid>
                                                            {this.state.isSmileDesign && (this.state.treatmentTypes.includes('TrioClear') ? ['ALL_DELIVERED'].includes(this.state.currentStatus) : !shouldHideMockupAndRestorativePhase) && this.props.displayFirstFitFlag && (
                                                                <Grid item xs={12}>
                                                                    <Button
                                                                        className={classes.linkBtn}
                                                                        onClick={this.openMockupOrdering}
                                                                    >
                                                                        {this.get(
                                                                            '@PatientInfo.case_info.actionsList.orderNewMockUp'
                                                                        )}
                                                                    </Button>
                                                                </Grid>
                                                            )}
                                                        </>
                                                    ) : (
                                                        ''
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    {['ADMIN', 'DISTR', 'SADMIN'].includes(role) &&
                                                    ![CASE_STATUS.SUBMITTED, CASE_STATUS.PLAN_UPLOADED].includes(
                                                        this.state.patientInfo.caseStatus
                                                    ) ? (
                                                        <Grid item xs={12}>
                                                            <Button
                                                                className={classes.linkBtn}
                                                                onClick={() => this.handleOpen('status')}
                                                            >
                                                                {this.get('case_info.actionsList.updateStatus')}
                                                            </Button>
                                                        </Grid>
                                                    ) : null}
                                                    {['DR'].includes(role) ? (
                                                        <>
                                                            <Grid item xs={12}>
                                                                <CreateNewCaseModalButton
                                                                    ClassProps={classes.linkBtn}
                                                                    disable={
                                                                        !this.state.isDisableCreateNewCaseForPatient
                                                                    }
                                                                    determineWhatCaseCanCreate={
                                                                        this.state.determineWhatCaseCanCreate
                                                                    }
                                                                patientId={this.state.patientId}
                                                                />
                                                            </Grid>
                                                            {this.state.isSmileDesign && (this.state.treatmentTypes.includes('TrioClear') ? ['ALL_DELIVERED'].includes(this.state.currentStatus) : !shouldHideMockupAndRestorativePhase) && this.props.displayFirstFitFlag && (
                                                                <Grid item xs={12}>
                                                                    <Button
                                                                        className={classes.linkBtn}
                                                                        onClick={this.openMockupOrdering}
                                                                    >
                                                                        {this.get(
                                                                            '@PatientInfo.case_info.actionsList.orderNewMockUp'
                                                                        )}
                                                                    </Button>
                                                                </Grid>
                                                            )}
                                                            {this.state.currentStatus !== 'ENDED' &&
                                                            !['PLAN_APPROVED', 'PRODUCTION'].includes(
                                                                this.state.currentStatus
                                                            ) && (
                                                                <Grid item xs={12}>
                                                                    <Button
                                                                        className={classnames(classes.linkBtn, {
                                                                            [externalCss.buttonPulse]:
                                                                                this.state.currentStatus ===
                                                                                'SUBMITTED',
                                                                        })}
                                                                        onClick={async () => {
                                                                            try {
                                                                                const { data } = await axios.post(
                                                                                    `/case/self-design/${this.state.caseId}/auth-link`
                                                                                );
                                                                                if (data.success && data.authorization_url) {
                                                                                    window.open(data.authorization_url, '_blank');
                                                                                } else {
                                                                                    this.props.showSnackbar(
                                                                                        data.message || 'Failed to generate auth link',
                                                                                        'error'
                                                                                    );
                                                                                }
                                                                            } catch (err) {
                                                                                this.props.showSnackbar(
                                                                                    err.response?.data?.message ||
                                                                                        err.message ||
                                                                                        'Failed to generate auth link',
                                                                                    'error'
                                                                                );
                                                                            }
                                                                        }}
                                                                    >
                                                                        {(() => {
                                                                            if (
                                                                                ['DELIVERED', 'ALL_DELIVERED'].includes(
                                                                                    this.state.currentStatus
                                                                                )
                                                                            ) {
                                                                                return this.get(
                                                                                    'case_info.actionsList.orderNextOrReviseSelfDesign'
                                                                                );
                                                                            }
                                                                            if (
                                                                                this.state.currentStatus ===
                                                                                'PLAN_UPLOADED'
                                                                            ) {
                                                                                return this.get(
                                                                                    'case_info.actionsList.reviseDesignSelfDesign'
                                                                                );
                                                                            }
                                                                            return this.get(
                                                                                'case_info.actionsList.startDesigningSelfDesign'
                                                                            );
                                                                        })()}
                                                                    </Button>
                                                                </Grid>
                                                            )}
                                                        </>
                                                    ) : null}
                                                </>
                                            )}

                                            {this.state.patientInfo.case_type !== CASE_TYPE.SELF_DESIGN && (
                                                <Modal
                                                    className="modal"
                                                    modal="NewCaseModal"
                                                    title="New Case Options"
                                                    open={this.state.modalOpen}
                                                    handleClose={() => this.setState({ modalOpen: false })}
                                                    modalSize="md"
                                                    submitButton={false}
                                                >
                                                    <NewCaseModalContent
                                                        productMatrix={this.state.productMatrix}
                                                        caseOptionTypeArr={this.state.caseOptionTypeArr}
                                                        currentPatientId={this.state.patientInfo?.patientId}
                                                        LinkToFunc={this.formatNewCaseLink}
                                                        selectCaseOptionType={this.state.selectCaseOptionType}
                                                        currentCaseId={this.state.caseId}
                                                        handleCaseOptionTypeChange={(e) =>
                                                            this.setState({ selectCaseOptionType: e.target.value })
                                                        }
                                                    />
                                                </Modal>
                                            )}

                                            {!['SADMIN', 'ADMIN', 'DISTR'].includes(role) &&
                                                this.state.patientInfo.case_type != 'RETAINER' &&
                                                [
                                                    'PRODUCTION',
                                                    'DELIVERED',
                                                    'NEXT_SET_REQUEST',
                                                    'ALL_DELIVERED',
                                                    'REFINEMENT',
                                                    'RETRACK_END',
                                                ].includes(this.state.currentStatus) &&
                                                !smileDesignProductListArray.includes(
                                                    this.state.patientInfo.case_type
                                                ) && (
                                                    <Grid item xs={12}>
                                                        <Button
                                                            className={classes.linkBtn}
                                                            onClick={() => this.handleOpen('aligner')}
                                                        >
                                                            {this.get('case_info.actionsList.lostReplace')}
                                                        </Button>
                                                    </Grid>
                                                )}

                                            <Grid item xs={12}>
                                                <Button
                                                    className={classes.linkBtn}
                                                    onClick={() => this.setConfirmOpenArchiveCase(true)}
                                                >
                                                    {this.get(`case_info.actionsList.${this.state.archivedFlag ? 'unarchiveCase' : 'archiveCase'}`)}
                                                </Button>

                                                <ConfirmDialog
                                                    title={this.get(`msg.${this.state.archivedFlag ? 'unarchiveCaseDialogTitle' : 'archiveCaseDialogTitle'}`)}
                                                    open={this.state.confirmOpenArchiveCase}
                                                    setOpen={this.setConfirmOpenArchiveCase}
                                                    onConfirm={() => this.handleArchiveCaseUpdate()}
                                                >
                                                    {this.get(`msg.${this.state.archivedFlag ? 'confirmUnarchiveCase' : 'confirmArchiveCase'}`)}
                                                </ConfirmDialog>
                                            </Grid>

                                            {/* Enter Restoration Phase */}
                                            {!['SADMIN', 'ADMIN', 'DISTR'].includes(role)&& this.state.isSmileDesign &&
                                            (this.props.displayFirstFitFlag ? (this.state.treatmentTypes.includes('TrioClear') ? ['ALL_DELIVERED'].includes(this.state.currentStatus) : !shouldHideMockupAndRestorativePhase) : (['ALL_DELIVERED'].includes(this.state.currentStatus)))
                                                 && ( // Reminder: Only frontend guard, if confirmed, update to backend guard too
                                                    <Grid item xs={12}>
                                                        <RestorativePhaseButton
                                                            className={classnames(
                                                                classes.linkBtn,
                                                                externalCss.buttonPulse
                                                           )}
                                                           displayFirstFitFlag={this.props.displayFirstFitFlag}
                                                            caseId={this.state.caseId}
                                                            treatmentTypes={this.state.treatmentTypes}
                                                            onUploadProgress={
                                                                this.progressBarRef.current?.onProgressChange
                                                            }
                                                            loadingState={this.loadingState}
                                                            reloadPage={this.reloadPageFunctionalProps}
                                                        />
                                                    </Grid>
                                                )
                                            }

                                            {!['SADMIN', 'ADMIN', 'DISTR'].includes(role) && !this.props.displayFirstFitFlag &&
                                                ['ALL_DELIVERED'].includes(this.state.currentStatus) &&
                                                this.state.upsellOperationData
                                                    .shouldSubmitRestorationFormWithNewScan && (
                                                    <Grid item xs={12}>
                                                        <Button
                                                            className={classnames(classes.linkBtn, externalCss.buttonPulse)}
                                                            onClick={this.handleOpenUpsellRestorationFormModal}
                                                        >
                                                            {this.get(
                                                                '@PatientInfo.case_info.actionsList.restorativePhase'
                                                            )}
                                                        </Button>
                                                    </Grid>
                                                )}

                                            

                                            {/* Purpose: show refinement in Admin when retrack_end status */}
                                            {['RETRACK_END'].includes(this.state.currentStatus) && this.props.displayFirstFitFlag &&
                                                ['ADMIN', 'SADMIN'].includes(role) &&
                                                this.state.patientInfo.case_type != 'RETAINER' &&
                                                this.state.patientInfo.case_type != 'SIMPLE' &&
                                                this.state.withinTreatmentPeriod && (
                                                    <Grid item xs={12}>
                                                        <Button
                                                            className={classes.linkBtn}
                                                            onClick={() => this.showRefinementModal()}
                                                        >
                                                            {this.get('case_info.actionsList.refinement')}
                                                        </Button>
                                                    </Grid>
                                                )}

                                            {/* Purpose: show refinement in Dr  */}
                                            {!['SADMIN', 'ADMIN', 'DISTR'].includes(role) &&
                                                ['DELIVERED', 'ALL_DELIVERED', 'RETRACK_END'].includes(
                                                    this.state.currentStatus
                                                ) &&
                                                this.state.withinTreatmentPeriod &&
                                                !['RETAINER', ...smileDesignProductListArray].includes(
                                                    this.state.patientInfo.case_type
                                                ) &&
                                                !(
                                                    this.state.patientInfo.case_type === CASE_TYPE.SELF_DESIGN &&
                                                    ['DELIVERED', 'ALL_DELIVERED'].includes(this.state.currentStatus)
                                                ) && (
                                                    <Grid item xs={12}>
                                                        <Button
                                                            className={classes.linkBtn}
                                                            onClick={() => this.showRefinementModal()}
                                                        >
                                                            {this.get('case_info.actionsList.refinement')}
                                                        </Button>
                                                    </Grid>
                                                )}

                                            {this.isRenderFinishingRetainerButton() && (
                                                <Grid item xs={12}>
                                                    <Button
                                                        className={classes.linkBtn}
                                                        onClick={() =>
                                                            this.handleOpen(
                                                                'request_finishing_retainer_step1',
                                                                'update'
                                                            )
                                                        }
                                                        disabled={!this.isEnableFinishingRetainerButton()}
                                                    >
                                                        {this.get(
                                                            '@PatientInfo.case_info.actionsList.redeemFinishingRetainer'
                                                        )}
                                                    </Button>
                                                </Grid>
                                            )}

                                            <NewAcceptNotAcceptDialog
                                                title={''}
                                                open={this.state.ViewRefinementQuotaReminderModal}
                                                onClose={() => this.handleClose('viewRefinementQuotaReminderModal')}
                                                onConfirm={() =>
                                                    window.open(`/patients/${this.state.caseId}/refinement`)
                                                }
                                            >
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: this.get(
                                                            '@PatientInfo.modals.refinementQuotaReminder.1'
                                                        ),
                                                    }}
                                                />
                                                <div
                                                    style={{ marginTop: 16 }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: this.get(
                                                            '@PatientInfo.modals.refinementQuotaReminder.2'
                                                        ),
                                                    }}
                                                />
                                            </NewAcceptNotAcceptDialog>

                                            <NewAcceptNotAcceptDialog
                                                title={''}
                                                open={this.state.RefinementOldCaseModal}
                                                onClose={() => this.handleClose('refinementOldCaseModal')}
                                                onConfirm={() =>
                                                    window.open(`/patients/${this.state.caseId}/refinement`)
                                                }
                                            >
                                                <div
                                                    style={{ marginBottom: 12, fontWeight: 'bold' }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: this.get('@PatientInfo.modals.refinementOldCase.1'),
                                                    }}
                                                />
                                                <div
                                                    style={{ marginBottom: 12 }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: this.get('@PatientInfo.modals.refinementOldCase.2'),
                                                    }}
                                                />
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: this.get('@PatientInfo.modals.refinementOldCase.3'),
                                                    }}
                                                />
                                            </NewAcceptNotAcceptDialog>

                                            {/* Retrack button */}
                                            {this.isRenderRetrackButton() && (
                                                <>
                                                    {
                                                        <Grid item xs={12}>
                                                            <Button
                                                                className={classes.linkBtn}
                                                                onClick={() => {
                                                                    this.showRetrackModal();
                                                                }}
                                                                // Flex case disable
                                                                disabled={
                                                                    !this.state.withinTreatmentPeriod ||
                                                                    parseInt(
                                                                        this.state.patientInfo?.retrack_quota_remaining
                                                                    ) === 0 ||
                                                                    this.state.patientInfo.case_type === 'FLEX'
                                                                }
                                                            >
                                                                {this.get('@PatientInfo.case_info.actionsList.retrack')}
                                                            </Button>
                                                        </Grid>
                                                    }
                                                </>
                                            )}
                                            <NewAcceptNotAcceptDialog
                                                title={''}
                                                open={this.state.ViewRetrackQuotaReminderModal}
                                                onClose={() => this.handleClose('viewRetrackQuotaReminderModal')}
                                                onConfirm={() => this.handleOpen('retrack', 'update')}
                                            >
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: this.get('@PatientInfo.modals.retrackQuotaReminder.1'),
                                                    }}
                                                />
                                                <div
                                                    style={{ marginTop: 16 }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: this.get('@PatientInfo.modals.retrackQuotaReminder.2'),
                                                    }}
                                                />
                                            </NewAcceptNotAcceptDialog>

                                            <NewAcceptNotAcceptDialog
                                                title={''}
                                                open={this.state.RetrackOldCaseModal}
                                                onClose={() => this.handleClose('retrackOldCaseModal')}
                                                onConfirm={() => this.handleOpen('retrack', 'update')}
                                            >
                                                <div
                                                    style={{ marginBottom: 12, fontWeight: 'bold' }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: this.get('@PatientInfo.modals.retrackOldCase.1'),
                                                    }}
                                                />
                                                <div
                                                    style={{ marginBottom: 12 }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: this.get('@PatientInfo.modals.retrackOldCase.2'),
                                                    }}
                                                />
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: this.get('@PatientInfo.modals.retrackOldCase.3'),
                                                    }}
                                                />
                                            </NewAcceptNotAcceptDialog>

                                            {!['SADMIN', 'ADMIN', 'DISTR'].includes(role) &&
                                            ['DELIVERED', 'ALL_DELIVERED'].includes(this.state.currentStatus) &&
                                            !this.state.isSmileDesign &&
                                            this.state.patientInfo.case_type !== 'SELF_DESIGN' &&
                                            this.state.enableOrderDifferentRetainer ? (
                                                <Grid item xs={12}>
                                                    <Button
                                                        className={classes.linkBtn}
                                                        onClick={() => this.handleOpen('request_retainer', 'update')}
                                                    >
                                                        {this.get(
                                                            '@PatientInfo.case_info.actionsList.orderNewRetainers'
                                                        )}
                                                    </Button>
                                                </Grid>
                                            ) : (
                                                ''
                                            )}

                                            {!['SADMIN', 'ADMIN', 'DISTR'].includes(role) &&
                                            ['DELIVERED', 'ALL_DELIVERED'].includes(this.state.currentStatus) &&
                                            !this.state.isSmileDesign &&
                                            this.state.patientInfo.case_type === 'SELF_DESIGN' &&
                                            this.state.enableOrderDifferentRetainer ? (
                                                <Grid item xs={12}>
                                                    <Button
                                                        className={classes.linkBtn}
                                                        onClick={() => this.handleOpen('request_retainer', 'update')}
                                                    >
                                                        {this.get(
                                                            '@PatientInfo.case_info.actionsList.orderNewRetainers'
                                                        )}
                                                    </Button>
                                                </Grid>
                                            ) : (
                                                ''
                                            )}

                                            {!['SADMIN', 'ADMIN', 'DISTR'].includes(role) &&
                                            ['DELIVERED', 'ALL_DELIVERED'].includes(this.state.currentStatus) &&
                                            this.state.isSmileDesign &&
                                            [
                                                'SIMPLE',
                                                'TOUCH_UP',
                                                'TOUCHUP_PLUS',
                                                'COMPLETE',
                                                'FLEX',
                                                'ULTRA',
                                            ].includes(this.state.patientInfo.case_type) &&
                                            this.state.enableOrderDifferentRetainer ? (
                                                <Grid item xs={12}>
                                                    <Button
                                                        className={classes.linkBtn}
                                                        onClick={() => this.handleOpen('request_retainer', 'update')}
                                                    >
                                                        {this.get(
                                                            '@PatientInfo.case_info.actionsList.orderNewRetainers'
                                                        )}
                                                    </Button>
                                                </Grid>
                                            ) : (
                                                ''
                                            )}

                                            <ViewCaseSupportingFileModal
                                                caseId={this.state.caseId}
                                                open={this.state.caseSupportingModalOpen}
                                                caseActivityLogId={this.state.viewCaseSupportingFileCaseActivityLogId}
                                                handleClose={() =>
                                                    this.setState({
                                                        caseSupportingModalOpen: false,
                                                        viewCaseSupportingFileCaseActivityLogId: null,
                                                        caseLogCreatedDate: null,
                                                    })
                                                }
                                                caseLogCreatedDate={this.state.caseLogCreatedDate}
                                                caseLogStatus={this.state.caseLogStatus}
                                            />

                                            <ConfirmDialog
                                                title="Process Next?"
                                                open={this.state.confirmOpenNextAligner}
                                                setOpen={this.setConfirmOpenNextAligner}
                                                onConfirm={() => this.handleChangeStatusUpdate('NEXT_SET_REQUEST')}
                                            >
                                                Are you sure you want to Process Next Aligner?
                                            </ConfirmDialog>

                                            {!['SADMIN', 'ADMIN', 'DISTR'].includes(role) &&
                                            !['RETAINER', ...smileDesignProductListArray].includes(
                                                this.state.patientInfo.case_type
                                            ) &&
                                            ['DELIVERED', 'RETRACK_END'].includes(this.state.currentStatus) &&
                                            !(
                                                this.state.patientInfo.case_type === CASE_TYPE.SELF_DESIGN &&
                                                ['DELIVERED', 'ALL_DELIVERED'].includes(this.state.currentStatus)
                                            ) ? (
                                                <Grid item xs={12}>
                                                    <Button
                                                        className={classnames(classes.linkBtn, externalCss.buttonPulse)}
                                                        onClick={() => this.setConfirmOpenNextAligner(true)}
                                                    >
                                                        {this.get('case_info.actionsList.processNext')}
                                                    </Button>
                                                </Grid>
                                            ) : (
                                                ''
                                            )}

                                            {/* defect resubmit only occur in DELIVERED and (Send Cycles 1 to 6 or Send Cycle 1 only ) and never request next set , retake impression should not show resubmit  */}

                                            {!['SADMIN', 'ADMIN', 'DISTR'].includes(role) &&
                                            this.state.patientInfo.case_type !== 'RETAINER' &&
                                            ['DELIVERED', 'RETRACK_END'].includes(this.state.currentStatus) &&
                                            (this.state.defectCurrentStatus.currentDefectFlow.dr_response ===
                                                'Send Cycles 1 to 6' ||
                                                this.state.defectCurrentStatus.currentDefectFlow.dr_response ===
                                                    'Send Cycle 1 only') &&
                                            this.state.defectCurrentStatus.currentDefectFlow.haveRequireNextSet ===
                                                false ? (
                                                <Grid item xs={12}>
                                                    <Link
                                                        to={`/patients/${this.state.caseId}/defect_resubmit`}
                                                        style={{ textDecoration: 'none' }}
                                                        target="_blank"
                                                    >
                                                        {/* moderately will not have pop up and reminder when click defect resubmit  */}

                                                        {this.state.defectCurrentStatus.currentDefectFlow
                                                            .defect_type === 'Moderately' &&
                                                        this.state.defectCurrentStatus.currentDefectFlow.dr_response ===
                                                            'Send Cycle 1 only' ? (
                                                            <Button className={classes.linkBtn}>
                                                                {this.get('case_info.actionsList.defectResubmit')}
                                                            </Button>
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </Link>

                                                    {/* 'Send Cycles 1 to 6' will have a pop up and reminder when click defect resubmit , no matter it is severely or moderately*/}

                                                    {this.state.defectCurrentStatus.currentDefectFlow.dr_response ===
                                                        'Send Cycles 1 to 6' ||
                                                    (this.state.defectCurrentStatus.currentDefectFlow.dr_response ===
                                                        'Send Cycle 1 only' &&
                                                        this.state.defectCurrentStatus.currentDefectFlow.defect_type ===
                                                            'Severely') ? (
                                                        <Button
                                                            className={classes.linkBtn}
                                                            onClick={() => this.setConfirmDefectResubmit(true)}
                                                        >
                                                            {this.get('case_info.actionsList.defectResubmit')}
                                                        </Button>
                                                    ) : (
                                                        <></>
                                                    )}
                                                </Grid>
                                            ) : (
                                                <></>
                                            )}

                                            <WarningDialog
                                                title="Warning Message"
                                                open={this.state.confirmDefectResubmit}
                                                setOpen={this.setConfirmDefectResubmit}
                                                onConfirm={() => this.handleEnterDefectResubmit()}
                                            >
                                                Reminder: An additional charge will be incurred if the aligners from{' '}
                                                {this.state.defectCurrentStatus?.currentDefectFlow.dr_response ===
                                                'Send Cycle 1 only'
                                                    ? 'cycle 1'
                                                    : 'cycles 1-6'}{' '}
                                                do not fit correctly and new impression is needed for case resubmit.
                                            </WarningDialog>

                                            <hr
                                                style={{
                                                    border: 'solid 1px #386d9c',
                                                    width: '100%',
                                                    margin: '16px 0px',
                                                }}
                                                align="left"
                                            />

                                            <Grid item xs={12}>
                                                <h5 className={classes.rightTitles}>
                                                    {this.get('case_info.documents')}
                                                </h5>
                                            </Grid>

                                            <Grid item xs={12}>
                                                {this.state.unreadChatCount === 0 ? (
                                                    this.clinicalSimulaitonLiveSupportButton(classes.linkBtn)
                                                ) : (
                                                    <Badge
                                                        badgeContent={this.state.unreadChatCount}
                                                        className={classes.clinicalSimulationBadge}
                                                        style={{ width: '100%' }}
                                                    >
                                                        {this.clinicalSimulaitonLiveSupportButton(classes.linkBtn)}
                                                    </Badge>
                                                )}
                                            </Grid>
                                            {this.state.rfsFiles?.length > 0 && ['ADMIN', 'SADMIN'].includes(role) ? (
                                                <Grid item xs={12}>
                                                    <Button
                                                        className={classes.linkBtn}
                                                        onClick={() => this.handleOpen('RFS')}
                                                    >
                                                        {this.get('case_info.documentsList.downloadRFSFile')}
                                                    </Button>
                                                </Grid>
                                            ) : (
                                                <></>
                                            )}

                                            <Grid item xs={12}>
                                                <Link
                                                    to={`/patients/${this.state.caseId}/treatment`}
                                                    style={{
                                                        textDecoration: 'none',
                                                        pointerEvents:
                                                            this.state.currentStatus === 'SUBMITTED'
                                                                ? 'none'
                                                                : undefined,
                                                    }}
                                                >
                                                    <Button
                                                        className={classes.linkBtn}
                                                        disabled={this.state.currentStatus === 'SUBMITTED'}
                                                    >
                                                        {smileDesignProductListArray.includes(
                                                            this.state.patientInfo.case_type
                                                        )
                                                            ? this.get('case_info.documentsList.viewFullDesignDocument')
                                                            : this.get('case_info.documentsList.viewTreatmentPlan')}
                                                    </Button>
                                                </Link>
                                            </Grid>

                                            {this.state.patientInfo.case_type !== CASE_TYPE.SELF_DESIGN && (
                                                <Grid item xs={12}>
                                                    <Button
                                                        className={classes.linkBtn}
                                                        onClick={() => this.getPhotos()}
                                                    >
                                                        {this.get('case_info.documentsList.viewPhotos')}
                                                    </Button>
                                                </Grid>
                                            )}

                                            {this.state.patientInfo.case_type !== CASE_TYPE.SELF_DESIGN && (
                                                <Grid item xs={12}>
                                                    <Button
                                                        className={classes.linkBtn}
                                                        onClick={() => this.handleOpen('radiograph')}
                                                    >
                                                        {this.get('case_info.documentsList.viewRadiograph')}
                                                    </Button>
                                                </Grid>
                                            )}

                                            {(this.state.patientInfo.case_type !== CASE_TYPE.SELF_DESIGN ||
                                                this.isSelfDesignWithRetainerRequest()) && (
                                                <Grid item xs={12}>
                                                    <Button
                                                        className={classes.linkBtn}
                                                        onClick={() => this.handleOpen('impression')}
                                                    >
                                                        {this.get('case_info.documentsList.viewImpression')}
                                                    </Button>
                                                </Grid>
                                            )}

                                            {(this.state.patientInfo.case_type !== CASE_TYPE.SELF_DESIGN ||
                                                this.isSelfDesignWithRetainerRequest()) && (
                                            <Grid item xs={12}>
                                                {this.state.isShowSmileDesignFeature ? (
                                                    <SmileDesignPrescriptionNotesModalButton
                                                        classes={classes}
                                                        caseId={this.state.caseId}
                                                    />
                                                ) : (
                                                    <>
                                                        {this.isRenderViewPrescriptionBtn() && (
                                                            <Button
                                                                className={classes.linkBtn}
                                                                onClick={() => {
                                                                    if (this.isNewRetainerCase()) {
                                                                        this.handleOpen(
                                                                            'retainer_request_prescription',
                                                                            'view',
                                                                            {
                                                                                id: this.state.retainerRequestData
                                                                                    .retainer_request_id,
                                                                            }
                                                                        );
                                                                    } else {
                                                                        this.handleOpen('prescriptionNotes');
                                                                    }
                                                                }}
                                                            >
                                                                {this.get('case_info.documentsList.viewQuestionnaire')}
                                                            </Button>
                                                        )}
                                                        {this.isRenderReSubmitRetainerFormBtn() && (
                                                            <Button
                                                                className={classes.linkBtn}
                                                                onClick={() => {
                                                                    let retainerRequestId = null;
                                                                    if (
                                                                        this.state.retainerRequestData &&
                                                                        this.state.retainerRequestData
                                                                            .retainer_request_id
                                                                    ) {
                                                                        retainerRequestId =
                                                                            this.state.retainerRequestData
                                                                                .retainer_request_id;
                                                                    }
                                                                    this.handleOpen(
                                                                        'resubmit_retainer_request',
                                                                        'update',
                                                                        { id: retainerRequestId }
                                                                    );
                                                                }}
                                                            >
                                                                Resubmit Retainer Form
                                                            </Button>
                                                        )}
                                                    </>
                                                )}
                                            </Grid>
                                            )}
                                            <Grid item xs={12}>
                                                <Button
                                                    className={classes.linkBtn}
                                                    onClick={() => this.handleOpen('defect')}
                                                    // if there is no defect photo, button will disable
                                                    disabled={
                                                        this.state.patientInfo.case_defect[0]?.length === 0 ||
                                                        this.state.patientInfo.case_defect?.length === 0
                                                    }
                                                >
                                                    {/* admin distributor always show "View Defect Photo. doctors will change to View Defect Photo after admin upload */}
                                                    {['SADMIN', 'ADMIN', 'DISTR'].includes(role)
                                                        ? this.get('case_info.documentsList.viewDefectPhotos')
                                                        : // check defect photo value has value but minor_or_moderately always exist.

                                                              `${
                                                                  // while resubmit and defect again , the structure will reduce 1 array.
                                                                  !['AWAITING', 'DEFECT_UPLOADED'].includes(
                                                                      this.state.currentStatus
                                                                  ) &&
                                                                  (this.state.patientInfo.case_defect[0]?.length >= 1 ||
                                                                      this.state.patientInfo.case_defect?.length > 1)
                                                                      ? this.get(
                                                                            'case_info.documentsList.viewDefectPhotos'
                                                                        )
                                                                      : this.get(
                                                                            'case_info.documentsList.updateDefectiveImpressionAlertImage'
                                                                        )
                                                              }`}
                                                    </Button>
                                                </Grid>

                                            {this.state.patientInfo.case_type !== CASE_TYPE.SELF_DESIGN &&
                                                (this.state.patientInfo.case_detail[0]?.[0]
                                                    ?.new_prescription_notes_flag === true ? (
                                                    ''
                                                ) : (
                                                    <>
                                                        {!this.state.isSmileDesign && (
                                                            <Grid item xs={12}>
                                                                <Link
                                                                    to={`/printData/${this.state.caseId}`}
                                                                    target="_blank"
                                                                    style={{ textDecoration: 'none' }}
                                                                >
                                                                    <Button className={classes.linkBtn}>
                                                                        {this.get('case_info.documentsList.printOrder')}
                                                                    </Button>
                                                                </Link>
                                                            </Grid>
                                                        )}
                                                    </>
                                                ))}

                                            {['DR', 'NR'].includes(role) &&
                                                this.canDoctorUploadImpressions() &&
                                                (this.state.patientInfo.case_type !== CASE_TYPE.SELF_DESIGN ||
                                                    this.isSelfDesignWithRetainerRequest()) && (
                                                    <div style={{ display: 'contents' }}>
                                                        <hr
                                                            style={{
                                                                border: 'solid 1px #386d9c',
                                                                width: '100%',
                                                                margin: '16px 0px',
                                                            }}
                                                            align="left"
                                                        />

                                                        <Grid item xs={12}>
                                                            <h5 className={classes.rightTitles}>
                                                                {this.get('case_info.uploadFiles')}
                                                            </h5>
                                                        </Grid>

                                                        {this.state.patientInfo.case_type !== 'RETAINER' &&
                                                        this.state.patientInfo.case_type !== CASE_TYPE.SELF_DESIGN ? (
                                                            <>
                                                                {this.canDoctorUploadAllFiles() && (
                                                                    <>
                                                                        <Grid item xs={12}>
                                                                            <Button
                                                                                className={classes.uploadBtn}
                                                                                onClick={() =>
                                                                                    this.handleOpen('photo', 'update')
                                                                                }
                                                                            >
                                                                                {this.get('case_info.filesList.uploadPhotos')}
                                                                            </Button>
                                                                        </Grid>

                                                                        <Grid item xs={12}>
                                                                            <Button
                                                                                className={classes.uploadBtn}
                                                                                onClick={() =>
                                                                                    this.handleOpen('radiograph', 'update')
                                                                                }
                                                                            >
                                                                                {this.get(
                                                                                    'case_info.filesList.uploadRadiograph'
                                                                                )}
                                                                            </Button>
                                                                        </Grid>
                                                                    </>
                                                                )}

                                                                <Grid item xs={12}>
                                                                    <Button
                                                                        className={classes.uploadBtn}
                                                                        onClick={() =>
                                                                            this.handleOpen('impression', 'update')
                                                                        }
                                                                    >
                                                                        {this.get(
                                                                            'case_info.filesList.uploadImpression'
                                                                        )}
                                                                    </Button>
                                                                </Grid>
                                                            </>
                                                        ) : (
                                                            <Grid item xs={12}>
                                                                <Button
                                                                    className={classes.uploadBtn}
                                                                    onClick={() =>
                                                                        this.handleOpen('impression', 'update')
                                                                    }
                                                                >
                                                                    {this.get('case_info.filesList.uploadImpression')}
                                                                </Button>
                                                            </Grid>
                                                        )}
                                                    </div>
                                                )}

                                            {['SADMIN', 'ADMIN', 'DISTR'].includes(role) &&
                                            (this.state.patientInfo.case_type !== CASE_TYPE.SELF_DESIGN ||
                                                this.isSelfDesignWithRetainerRequest()) ? (
                                                <div style={{ display: 'contents' }}>
                                                    <hr
                                                        style={{
                                                            border: 'solid 1px #386d9c',
                                                            width: '100%',
                                                            margin: '16px 0px',
                                                        }}
                                                        align="left"
                                                    />

                                                    <Grid item xs={12}>
                                                        <h5 className={classes.rightTitles}>
                                                            {this.get('case_info.uploadFiles')}
                                                        </h5>
                                                    </Grid>

                                                    {this.state.currentStatus === 'ENDED' ? (
                                                        <p>{this.get('msg.caseHasBeenEnded')}</p>
                                                    ) : (
                                                        <div style={{ display: 'contents' }}>
                                                            {this.isSmileDesignShowUploadTreatmentPlanBtn() && (
                                                                <Grid item xs={12}>
                                                                    <Button
                                                                        className={classes.uploadBtn}
                                                                        onClick={() =>
                                                                            this.handleOpen('treatment', 'update')
                                                                        }
                                                                    >
                                                                        {this.get(
                                                                            'case_info.filesList.uploadTreatmentPlan'
                                                                        )}
                                                                    </Button>
                                                                </Grid>
                                                            )}

                                                            {this.shouldShowWaitingMessage() && (
                                                                <Grid item xs={12}>
                                                                    <div
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            borderStyle: 'dashed',
                                                                            padding: '10px',
                                                                            margin: '10px 0px',
                                                                        }}
                                                                    >
                                                                        Waiting upload IDESIGN 2.0 from Jay
                                                                    </div>
                                                                </Grid>
                                                            )}
                                                            {!!this.state.currentStatus &&
                                                                [
                                                                    'CHANGE_REQUEST',
                                                                    'RECEIVED',
                                                                    'UPGRADE_REQUEST',
                                                                ].includes(this.state.currentStatus) &&
                                                                // purpose: All case types are allowed except smile design case
                                                                !smileDesignProductListArray.includes(
                                                                    this.state.patientInfo.case_type
                                                                ) && (
                                                                    <Grid item xs={12}>
                                                                        {this.state.upsellOperationData
                                                                            ?.shouldWaitIdesignTp ? (
                                                                            <WaitingUploadIdesignGrid />
                                                                        ) : (
                                                                            <Button
                                                                                className={classes.uploadBtn}
                                                                                onClick={() =>
                                                                                    this.handleOpen('treatment', 'update')
                                                                                }
                                                                            >
                                                                                {this.get(
                                                                                    'case_info.filesList.uploadTreatmentPlan'
                                                                                )}
                                                                            </Button>
                                                                        )}
                                                                    </Grid>
                                                                )}

                                                            {this.state.patientInfo.case_type !==
                                                                CASE_TYPE.SELF_DESIGN && (
                                                                <Grid item xs={12}>
                                                                    <Button
                                                                        className={classes.uploadBtn}
                                                                        onClick={() =>
                                                                            this.handleOpen('photo', 'update')
                                                                        }
                                                                    >
                                                                        {this.get('case_info.filesList.uploadPhotos')}
                                                                    </Button>
                                                                </Grid>
                                                            )}

                                                            {this.state.patientInfo.case_type !==
                                                                CASE_TYPE.SELF_DESIGN && (
                                                                <Grid item xs={12}>
                                                                    <Button
                                                                        className={classes.uploadBtn}
                                                                        onClick={() =>
                                                                            this.handleOpen('radiograph', 'update')
                                                                        }
                                                                    >
                                                                        {this.get(
                                                                            'case_info.filesList.uploadRadiograph'
                                                                        )}
                                                                    </Button>
                                                                </Grid>
                                                            )}

                                                            <Grid item xs={12}>
                                                                <Button
                                                                    className={classes.uploadBtn}
                                                                    onClick={() =>
                                                                        this.handleOpen('impression', 'update')
                                                                    }
                                                                >
                                                                    {this.get('case_info.filesList.uploadImpression')}
                                                                </Button>
                                                            </Grid>

                                                            {this.state.patientInfo.case_type !==
                                                                CASE_TYPE.SELF_DESIGN && (
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    style={{
                                                                        display:
                                                                            this.state.caseType === 'RETAINER' &&
                                                                            'none',
                                                                    }}
                                                                >
                                                                    <Button
                                                                        className={classes.uploadBtn}
                                                                        onClick={() =>
                                                                            this.handleOpen(
                                                                                'prescriptionNotes',
                                                                                'update'
                                                                            )
                                                                        }
                                                                    >
                                                                        {this.get(
                                                                            'case_info.filesList.uploadQuestionnaire'
                                                                        )}
                                                                    </Button>
                                                                </Grid>
                                                            )}
                                                            {this.state.patientInfo.treatment_plan[0].length >= 1 ||
                                                            this.state.patientInfo.treatment_plan?.length > 1 ? (
                                                                <Grid item xs={12}>
                                                                    <Button
                                                                        className={classes.uploadBtn}
                                                                        onClick={() => this.handleOpen('replaceMyp')}
                                                                    >
                                                                        {this.get(
                                                                            'case_info.filesList.uploadConvertedMyp'
                                                                        )}
                                                                    </Button>
                                                                </Grid>
                                                            ) : (
                                                                <></>
                                                            )}

                                                            {!!this.state.currentStatus &&
                                                            [
                                                                'SUBMITTED',
                                                                'AWAITING',
                                                                'REFINEMENT',
                                                                'DEFECT_RESUBMIT',
                                                            ].includes(this.state.currentStatus) &&
                                                            ['SADMIN', 'ADMIN', 'DISTR'].includes(role) &&
                                                            this.state.patientInfo.case_type != 'RETAINER' ? (
                                                                <Grid item xs={12}>
                                                                    <Button
                                                                        className={classes.uploadBtn}
                                                                        onClick={() =>
                                                                            this.handleOpen('defect', 'update')
                                                                        }
                                                                    >
                                                                        {this.get(
                                                                            'case_info.filesList.uploadDefectPhotos'
                                                                        )}
                                                                    </Button>
                                                                </Grid>
                                                            ) : (
                                                                <></>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                ''
                                            )}

                                            <hr
                                                style={{
                                                    border: 'solid 1px #386d9c',
                                                    width: '100%',
                                                    margin: '16px 0px',
                                                }}
                                                align="left"
                                            />
                                            {this.state.getDeliveryAddress == [] ? (
                                                <Loader />
                                            ) : (
                                                <>
                                                    <PercentageProgressRing
                                                        ref={this.progressBarRef}
                                                        open={this.state.loading}
                                                    />
                                                    <Modal
                                                        className="modal"
                                                        modal="deliveryAddress"
                                                        title="Change Delivery Address"
                                                        open={this.state.deliveryAddressModal}
                                                        handleClose={() => this.handleClose('deliveryAddress')}
                                                        handleDataSave={() => this.DeliveryAddressSave()}
                                                        modalError={this.state.modalError}
                                                        submitButton={true}
                                                        modalSize="md"
                                                    >
                                                        <Grid container>
                                                            <div style={{ display: 'contents' }}>
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    md={12}
                                                                    style={{ textAlign: 'center' }}
                                                                >
                                                                    <FormControl component="fieldset">
                                                                        <RadioGroup
                                                                            aria-label="deliveryAddress"
                                                                            name="deliveryAddress"
                                                                            value={selectedDeliveryAddress}
                                                                            onChange={this.handleDeliveryAddress}
                                                                        >
                                                                            {getDeliveryAddress.map(function (result) {
                                                                                return (
                                                                                    <FormControlLabel
                                                                                        checked={
                                                                                            result.delivery_address_id ==
                                                                                            selectedDeliveryAddress
                                                                                        }
                                                                                        value={
                                                                                            result.delivery_address_id
                                                                                        }
                                                                                        control={<Radio />}
                                                                                        label={
                                                                                            Object.getFromObj(
                                                                                                result,
                                                                                                'address_1',
                                                                                                ''
                                                                                            ) +
                                                                                            ' ' +
                                                                                            Object.getFromObj(
                                                                                                result,
                                                                                                'address_2',
                                                                                                ''
                                                                                            )
                                                                                        }
                                                                                    />
                                                                                );
                                                                            })}
                                                                        </RadioGroup>
                                                                    </FormControl>
                                                                </Grid>
                                                            </div>
                                                        </Grid>
                                                    </Modal>
                                                </>
                                            )}
                                            <ViewPrescriptionModal
                                                retainerRequestId={this.state.retainerRequestId}
                                                open={this.state.ViewPrescriptionModal}
                                                handleClose={() =>
                                                    this.setState({
                                                        ViewPrescriptionModal: false,
                                                        retainerRequestId: 0,
                                                    })
                                                }
                                            />
                                            <ReSubmitRetainerFormModal
                                                open={this.state.ReSubmitRetainerFormModal}
                                                handleClose={() => this.setState({ ReSubmitRetainerFormModal: false })}
                                                caseId={this.state.caseId}
                                                retainerRequestId={this.state.retainerRequestId}
                                                caseImpressionId={this.state.caseImpressionId}
                                            />
                                            <Grid container>
                                                <Grid item xs={6}>
                                                    <h5 className={classes.rightTitles} style={{ paddingTop: '6px' }}>
                                                        {this.get(':fields.deliveryAddress')}
                                                    </h5>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    {['ADMIN', 'DISTR'].includes(role) && (
                                                        <Button
                                                            style={{ float: 'right' }}
                                                            onClick={this.deliveryAddressChangeModalOpen}
                                                        >
                                                            Select Address
                                                        </Button>
                                                    )}
                                                </Grid>
                                            </Grid>
                                            <p className={classes.accountInfo}>
                                                {this.get(':fields.doctorName')}:{' '}
                                                {this.state.doctorName ?? this.get(':const.none')}
                                            </p>
                                            {this.renderDeliveryInfo() && (
                                                <p className={classes.accountInfo}>
                                                    {this.get(':fields.devlieryName') + ': '}
                                                    {String.isNotBlank(
                                                        Object.getFromObj(
                                                            this.state.patientInfo,
                                                            'delivery_address.first_name',
                                                            ''
                                                        ) +
                                                            ' ' +
                                                            Object.getFromObj(
                                                                this.state.patientInfo,
                                                                'delivery_address.last_name',
                                                                ''
                                                            )
                                                    )
                                                        ? Object.getFromObj(
                                                              this.state.patientInfo,
                                                              'delivery_address.first_name',
                                                              ''
                                                          ) +
                                                          ' ' +
                                                          Object.getFromObj(
                                                              this.state.patientInfo,
                                                              'delivery_address.last_name',
                                                              ''
                                                          )
                                                        : this.get(':const.none')}
                                                </p>
                                            )}

                                            {this.renderDeliveryInfo() && (
                                                <>
                                                    <p className={classes.accountInfo}>
                                                        {Object.getFromObj(
                                                            this.state.patientInfo,
                                                            'delivery_address.address_1',
                                                            this.get(':const.none')
                                                        )}
                                                    </p>
                                                    <p className={classes.accountInfo}>
                                                        {this.get(':fields.city')}:{' '}
                                                        {Object.getFromObj(
                                                            this.state.patientInfo,
                                                            'delivery_address.city',
                                                            this.get(':const.none')
                                                        )}
                                                    </p>
                                                    {this.state.patientInfo.delivery_address && (
                                                        <p className={classes.accountInfo}>
                                                            {this.get(':fields.country')}:
                                                            {this.state.patientInfo.delivery_address.country_name}
                                                        </p>
                                                    )}
                                                </>
                                            )}

                                            {this.renderDeliveryInfo() && (
                                                <p className={classes.accountInfo}>
                                                    {this.get(':fields.phoneNo')}:{' '}
                                                    {Object.getFromObj(
                                                        this.state.patientInfo,
                                                        'delivery_address.phone_no',
                                                        this.get(':const.none')
                                                    )}
                                                </p>
                                            )}

                                            {this.renderDeliveryInfo() && (
                                                <p className={classes.accountInfo}>
                                                    {this.get(':fields.faxNo')}:{' '}
                                                    {Object.getFromObj(
                                                        this.state.patientInfo,
                                                        'delivery_address.fax_no',
                                                        this.get(':const.none')
                                                    )}
                                                </p>
                                            )}

                                            <hr
                                                style={{
                                                    border: 'solid 1px #386d9c',
                                                    width: '100%',
                                                    margin: '16px 0px',
                                                }}
                                                align="left"
                                            />
                                            {['ADMIN', 'SADMIN'].includes(role) && (
                                                <>
                                                    <Grid item xs={6}>
                                                        <h5 className={classes.rightTitles}>
                                                            {this.get(':fields.distributor')}
                                                        </h5>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <span style={{ float: 'right' }}>
                                                            {this.state.patientInfo.distrName},{' '}
                                                            {this.state.patientInfo.country_name}
                                                        </span>
                                                    </Grid>

                                                    {this.state.patientInfo?.distr?.map(({ email, phone }, i) => (
                                                        <Chip
                                                            key={i}
                                                            variant="outlined"
                                                            size="medium"
                                                            style={{
                                                                margin: 3,
                                                                padding: 5,
                                                                paddingTop: 8,
                                                                paddingBottom: 8,
                                                                // backgroundColor: 'rgb(106 186 246)',
                                                                color: 'black',
                                                                borderColor: 'black',
                                                                height: '48px',
                                                                fontSize: 16,
                                                            }}
                                                            label={
                                                                <p>
                                                                    <strong>{email}</strong>
                                                                    <br />
                                                                    {this.get(':fields.phoneNo')}:{' '}
                                                                    {phone ?? this.get(':const.none')}
                                                                </p>
                                                            }
                                                            color="primary"
                                                        />
                                                    ))}
                                                </>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Animated>
                </>
            );
        }
    }
}

/**
 * Maps Redux state to Patient Info props.
 */
const mapStateToProps = (store) => {
    return {
        newPatientData: store.newPatientReducer,
        requestFinishingRetainerData: store.requestFinishingRetainerReducer.toJS(),
        files: store.newPatientReducer.files,
        config: store.config.config,
        isLoading: store.loading.isLoading,
        lang: store.lang,
        res: store.res,
        requestComment: store.requestComment,
        retrack: store.retrack,
        smileDesign: store.smileDesign,
        diffRetainer: store.diffRetainer,
        auth: store.auth,
        displayFirstFitFlag: store.globalReducer.displayFirstFitFlag,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleDataFileUpload: (id, value) =>
            dispatch({ type: newPatientActionTypes.NEW_PATIENT_FILES, id: id, value: value }),
        handleInvertImage: (id, value) =>
            dispatch({ type: newPatientActionTypes.NEW_PATIENT_FILE_INVERT, id: id, value: value }),
        handleRoatateImage: (id, value) =>
            dispatch({ type: newPatientActionTypes.NEW_PATIENT_FILE_ROTATE, id: id, value: value }),
        showSnackbar: (message, variant, queue = false) => dispatch(easySnackbar(message, variant, queue)),
        setTempData: (newPatientData) => dispatch(saveAction.tempSave(newPatientData)),
        initData: () => dispatch({ type: 'NEW_PATIENT_INIT_TEMP' }),
        updateStep2SelectOpts: (value) => dispatch(requestFinishingRetainerSelectOpts(value)),
        updateRes: (resName) => dispatch(updateRes(resName)),

        startLoading: () => dispatch(uiStartLoading()),
        stopLoading: () => dispatch(uiStopLoading()),

        requestFinishingRetainerChangeTab: (value) => dispatch(requestFinishingRetainerChangeTab(value)),
        updateStep3SelectOpts: (value) => dispatch(requestFinishingRetainerSelectOptsB(value)),
        ErrorData: (errorMsg) => dispatch({ type: 'NEW_PATIENT_DATA_ERROR', errorMsg: errorMsg }),

        tracelog: (PLATFORM, MODULE, ACTION, paraDetail, caseId) =>
            dispatch(
                postTraceLog({
                    platform: PLATFORM,
                    module: MODULE,
                    action: ACTION,
                    detail: paraDetail,
                    para1: caseId,
                    para2: '',
                    para3: '',
                    para4: '',
                    para5: '',
                })
            ),

        handlePrescriptionError: (error) => dispatch({ type: 'NEW_PATIENT_PRES_ERROR', error }),
        handlePrescriptionErrorQuestion: (value) => dispatch({ type: 'NEW_PATIENT_PRES_ERROR_QUESTION', value }),
        handlePrescriptionErrorScrollId: (value) => dispatch({ type: 'NEW_PATIENT_PRES_ERROR_SCROLL_ID', value }),
        handlePrescriptionErrorScroll: () => dispatch({ type: 'NEW_PATIENT_PRES_ERROR_SCROLL' }),
        handleInitDraftFileList: (draftFileList, chosenDraftFile) =>
            dispatch({ type: 'NEW_PATIENT_INIT_DRAFT_FILE', draftFileList, chosenDraftFile }),

        setRetrackReportFormData: (form) => dispatch(setRetrackReportFormData(form)),
        setRetrackEndReasonData: (form) => dispatch(setRetrackEndReasonData(form)),

        setCaseType: (value) => dispatch(setCaseType(value)),
        setProductMatrixArray: (value) => dispatch(setProductMatrixArray(value)),
        openRedirectUserModal: (value) =>
            dispatch(
                openModal({
                    modalTitle: value.title,
                    modalMessage: value.message,
                    modalCallbackFunc: value.modalCallbackFunc,
                    modalOnCloseCallbackFunc: value.modalOnCloseCallbackFunc,
                    showOk: value.showOk,
                })
            ),
        fetchScannerPlatform: () => dispatch(fetchConnectPlatformData()),
        setDisplayFirstFitFlag: (value) => dispatch(setDisplayFirstFitFlag(value)),
        setUpsellPlanId: (value) => dispatch(setUpsellPlanId(value)),
        setUpsellRestorationFormData: (value) => dispatch(setUpsellRestorationFormData(value)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(withRouter(withLang(PatientInfo, 'PatientInfo'))));
